//@ts-ignore
import imageDieSW from '/website/img/craps-simulator/die_sw.png';
//@ts-ignore
import imageDieNE from '/website/img/craps-simulator/die_ne.png';
//@ts-ignore
import imageDie1 from '/website/img/craps-simulator/die_1.jpg';
//@ts-ignore
import imageDie2 from '/website/img/craps-simulator/die_2.jpg';
//@ts-ignore
import imageDie3 from '/website/img/craps-simulator/die_3.jpg';
//@ts-ignore
import imageDie4 from '/website/img/craps-simulator/die_4.jpg';
//@ts-ignore
import imageDie5 from '/website/img/craps-simulator/die_5.jpg';
//@ts-ignore
import imageDie6 from '/website/img/craps-simulator/die_6.jpg';

function $<T = HTMLElement>(id: string): T {
  return document.getElementById(id) as T;
}
const darkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

let thePoint = 0;
const thePoints = [4, 5, 6, 8, 9, 10];
const crapNumbers = [2, 3, 12];

let allGood = false, tableMaxComma = 0;
let roll: object, rollTotal = 0, rollHard = false, theFirstDie = 0, theSecondDie = 0;
let isAPointNum = false, markingPoint = false, pointMade = false, sevenOut = false;
let comeoutRoll = true, intermediateRoll = false;
let boxRolled = false, crapRolled = false, naturalWinner = false, naturalLoser = false;
let brokeAsAJoke = false, haveEnough = false, overMaxOdds = false, underMinOdds = false, overMaxBet = false, underMinBet = false;
let hasPassLine = false, passLineWasPaid = false, pointWasJustMade = false;
let doubleDipWinner = false;
let totalAcrossIncluding = 0, totalAcrossPointFour = 0, totalAcrossPointFive = 0, totalAcrossPointSix = 0, totalAcrossPointEight = 0, totalAcrossPointNine = 0, totalAcrossPointTen = 0;
let totalUptownCr = 0, totalDowntownCr = 0;;
let fieldWasPaid = false, aRollHappened = false, rail = 0, table = 0, bank = 0, fieldWon = false, singleField = false, doubleField = false;
let placeNumRolled = false, yoRolled = false, sevenRolled = false, thePaymentAmount = 0, wasSingle = false, theJuice = 0, placeOutsideMaxBuy = 0;
let totalToBuyFour = 0, totalToBuyTen = 0, thirdOfBet = 0, existingSixEightMoney = 0, existingFiveNineMoney = 0, tryFor = 0, juiceNeeded = 0, amountNeeded = 0;
let properPlaceOutside = false, properPlaceSixEight = false, safeAmount = 0, halfPayment = 0, totalInsideCr = 0, totalInsidePointFour = 0, totalInsidePointFive = 0, totalInsidePointSix = 0, totalInsidePointEight = 0, totalInsidePointNine = 0, totalInsidePointTen = 0;
let totalOutsidePointFour = 0, totalOutsidePointFive = 0, totalOutsidePointSix = 0, totalOutsidePointEight = 0, totalOutsidePointNine = 0, totalOutsidePointTen = 0, nextUnitBet = 0, pressedBet = 0, leftOverAmt = 0, totalMoney = 0, newPlaceAmt = 0, currentVigCharge = 0, totalFourTen = 0;
let totalOutsideCr = 0, correctVigCharge = 0, totalBuyTenCost = 0, fixedTruePayment = 0, sixEight = false, totalAllInBuyAmount = 0; 

function numCommas (x) {
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

// Create
const money = {
  inRail: 800,
  inPlaceLimbo: 0,
  extraVig: 0,
  bankPlaceLimbo: function () {
    this.inRail += this.inPlaceLimbo;
    this.inPlaceLimbo = 0;
    this.adjustBank();
  },
  get onTable () {
    return total.placeBets + this.inPlaceLimbo + total.passLine + total.passLineOdds + total.fieldMoney;
  },
  get bankRoll () {
    return this.onTable + this.inRail;
  },
  adjustBank: function () {
    rail = numCommas(this.inRail);
    table = numCommas(this.onTable);
    bank = numCommas(this.bankRoll);
    $('money_in_rail').innerHTML = "$" + rail;
    $('money_on_table').innerHTML = "$" + table;
    $('total_bankroll').innerHTML = "$" + bank;
  }
}
const limit = {
  oddsType: 345,
  maxOdds: 0,
  tableMin: 5,
  tableMax: 5000,
  placeSixEightMin: 6,
  placeSixEightMax: 6000,
  placeOutsideMin: 5,
  placeOutsideMax: 5000,
}

// Bets
const thePassLine = {
  betCode: 1,
  lineBet: 0,
  linePayment: 0,
  get totalUnits () {
    return Math.floor(this.lineBet / 5);
  }, 
  betIt: function (amt) {
    if (isNaN(amt) || amt <= 0) {
      return
    } else {
      this.checkIt(amt); 
      if (allGood) {
          bet.remove(1);
          hasPassLine = true;
          underMinBet = false;
          overMaxBet = false;
          money.inRail -= amt;
          this.lineBet += amt;
          money.adjustBank();
          hideBetMenu(1);
          show.cheques(1, this.lineBet);
          alert.remove();
          letsHide('button_two'); letsHide('button_three');
          $('button_four').innerHTML = "Change Line Bet";
          guide.sayDiceAreOut();
      }
    }
  },
  checkIt: function (amt) {
    check.ifEnoughMoney(amt, this.lineBet);
    check.minBet(1, amt);
    check.maxBet(1, amt);
    allGood = haveEnough && !underMinBet && !overMaxBet;
  },
  payIt: function () {
    passLineWasPaid = true;
    this.linePayment += this.lineBet;
    show.cheques(2, this.linePayment);
    money.adjustBank();
    letsHide('show_pl_btn');
    hide.betButtons();
    letsShow('button_three');
  $('button_three').onclick = collectPassLine;
  $('button_three').innerHTML = "Collect";
    comeoutRoll ? notify.crWinner() : notify.pointWinner();
  },
  takeIt: function () {
    hasPassLine = false;
    this.lineBet = 0;
    money.adjustBank();
    hide.cheques(1);
    $('guide_calls').style.color = "rgb(248, 79, 49, 97)"; 
    $('alert_to_do').style.border = "1px solid rgb(248, 79, 49, 97)";
    check.forBroke();
    if (brokeAsAJoke) {
      hide.betButtons();
      guide.sayYourBroke();
    } else if (crapRolled) {
      show.passLineBetBtns();
      $('guide_calls').innerHTML = "You rolled a Crap and lost your Pass Line bet but you're still the shooter. Please make another Pass Line bet.";
    }
  },
  collectIt: function () {
    passLineWasPaid = false;
    money.inRail += this.linePayment;
    this.linePayment = 0;
    money.adjustBank();
    hide.cheques(2);
    show.passLineBetBtns();
    darkMode ? $('guide_calls').style.color = "#EEEEEE" : $('guide_calls').style.color = "#282829";
    $('alert_to_do').style.border =  "none"
    $('guide_calls').innerHTML = "You can shoot anytime you're ready.";
    if (pointWasJustMade) {
      guide.sayCrStickCall();
      pointWasJustMade = false;
    }
    passLineOdds.collectIt();
    letsShow('show_pl_btn');
  }
}
const passLineOdds = {
  betCode: 3,
  oddsBet: 0,
  oddsPayment: 0,
  betIt: function (amt){
    this.checkIt(amt);
    if(allGood) {
      bet.remove(3);
      alert.remove();
      money.inRail -= amt;
      this.oddsBet += amt;
      inform.passLineOdds(amt);
      switch (thePoint) {
        case 6: case 8: (amt % 5 !=0) && alert.improperOdds(amt); break;
        case 5: case 9: (amt % 2 == 1) && alert.unevenOdds(amt); break;
        case 4: case 10: break;
        default: return
      }
      money.adjustBank();
      show.cheques(3, this.oddsBet);
    }
    hideBetMenu(3);
  },
  checkIt: function (amt) {
    check.ifEnoughMoney(amt, this.oddsBet);
    check.maxBet (3, amt);
    check.minBet(3, amt);
    allGood = haveEnough && !overMaxOdds && !underMinOdds;
  },
  payIt: function () {
    if(this.oddsBet === 0) {
      return
    } else {
      switch (thePoint) {
        case 6: case 8:
          let totalUnits = Math.floor(this.oddsBet / 5);
          let correctBetPymt = totalUnits * 6; let improperAmount = this.oddsBet % 5;
          this.oddsPayment = correctBetPymt + improperAmount;
          show.cheques(4, this.oddsPayment);
          break;
        case 5: case 9:
          this.oddsPayment = Math.floor((this.oddsBet / 2) * 3);
          show.cheques(4, this.oddsPayment);
          break;
        case 4: case 10:
          this.oddsPayment = this.oddsBet * 2;
          show.cheques(4, this.oddsPayment);
          break;
        default: return
      }
      money.adjustBank();
    }
    letsHide('show_pl_odds_btn');
  },
  takeIt: function () {
    this.oddsBet = 0;
    hide.cheques(3)
    money.adjustBank();
  },
  collectIt: function () {
    if (passLineOdds.oddsBet === 0) {
      return
    } else {
      money.inRail += this.oddsBet;
      money.inRail += this.oddsPayment;
      this.oddsBet = 0;
      this.oddsPayment = 0;
      hide.cheques(3);
      hide.cheques(4);
      money.adjustBank();
    }
  },
  turnOn: function () {
    letsShow('show_pl_odds_btn');
    letsShow('button_three');
    $('button_three').onclick = function () {show.betMenu(3)};
    $('button_three').innerHTML = "Bet Odds";
  },
  setOddsType: function (type) {
    switch (type) {
      case 1: limit.maxOdds = thePassLine.lineBet; break;
      case 2: limit.maxOdds = 2 * thePassLine.lineBet; break;
      case 5: limit.maxOdds = 5 * thePassLine.lineBet; break;
      case 10: limit.maxOdds = 10 * thePassLine.lineBet; break;
      case 100: limit.maxOdds = 100 * thePassLine.lineBet; break;
      case 345:
        switch (thePoint) {
          case 6:
          case 8: limit.maxOdds = 5 * thePassLine.lineBet; break;
          case 5:
          case 9: limit.maxOdds = 4 * thePassLine.lineBet; break;
          case 4:
          case 10: limit.maxOdds = 3 * thePassLine.lineBet; break;
          default: return
        }
        break;
      default: return
    }
  }
}
const theFour = {
  betCode: 5,
  placeBet: 0,
  placePymnt: 0,
  onButton: 'place_four_on_btn',
  onStatus: false,
  offMenu: 'place_four_off_menu',
  offButton: 'place_four_off_btn',
  hasOffBtn: false,
  placeMenuBtn: 'show_place_four_btn',
  placePayMenu: 'place_four_pay_menu',
  vigCost: 0,
  vig: 0, // What's built into the bet
  oldVig: 0,
  buyButton: 'place_four_buy_btn',
  hasBuy: false,
  amtBox: 'place_four_amt_box',
  cheque1: 'place_four_1',
  cheque5: 'place_four_5',
  cheque25: 'place_four_25',
  cheque100: 'place_four_100',
  cheque500: 'place_four_500',
  cheque1000: 'place_four_1000',
  get betPlusVig () {
    return this.placeBet + this.vig + money.extraVig;
  },
  get getPlaceBetAmt () {
    return this.placeBet;
  },
  payIt: function () {
    if (this.placeBet == 0) {
      return
    } else if (this.hasBuy) {
      this.placePymnt = this.placeBet * 2;
      $('place_four_pay_header').innerHTML = "Your $" + this.placeBet + " Buy Four won $" + this.placePymnt + ".";
    } else {
      let totalUnits = Math.floor(this.placeBet / 5); 
      let correctBetPymt = totalUnits * 9; let improperAmount = this.placeBet % 5; 
      this.placePymnt = correctBetPymt + improperAmount;
      $('place_four_pay_header').innerHTML = "Your $" + this.placeBet + " Four won $" + this.placePymnt + ".";
    }
    money.inPlaceLimbo = this.placePymnt; // To be included with money in the rail for betting purposes but user to see as money on table until decision is made. You can't use money on the table to make bets. Plus check.ifEnoughMoney as universal bet payouts.
    letsShow(this.placePayMenu);
    showPlaceFourBtns(this.placeBet);
    disable.rollButtons(); disable.placeBetMenus();  
    money.adjustBank();
  },
  takeIt: function () {
    this.placeBet = 0;
    this.vig = 0; money.extraVig = 0;
    this.onStatus = false;
    this.hasBuy = false;
    money.adjustBank();
    hide.cheques(this.betCode);
    letsHide(this.onButton);
    letsHide(this.buyButton);
    $(this.placeMenuBtn).onclick = function () {show.offMenu(5)};
    //testMe.onStates();
  },
  sameBetIt: function () {
    money.inRail += this.placePymnt - this.vig;
    this.placePymnt = 0; money.inPlaceLimbo = 0;
  },
  placeIt: function (amt) {
    this.sameBetIt();
    if (isNaN(amt) || amt <= 0) {
      return;
    } else {
      this.checkIt(amt);
      if (allGood) {
        bet.remove(this.betCode);
        money.inRail -= amt;
        this.placeBet += amt;
        this.onStatus= true;
        show.cheques(this.betCode, this.placeBet);
        comeoutRoll && this.turnOn();
        playerAsksFor.placeFour(amt);
        hide.allMenus();
        money.adjustBank();
      }
    }
    //testMe.onStates();
  },
  buyIt: function (amt) {
    if (this.placePymnt > 0) {
      this.sameBetIt();
    }
    if (isNaN(amt) || amt <= 0) {
      return
    } else if (amt < 20){
      alert.buyFourMin();
      money.bankPlaceLimbo();
      hideAllMenus();
    } else { 
      this.checkBuy(amt);
      if (allGood) {
        bet.remove(this.betCode);
        this.placeBet += amt;
        this.vig = this.vigCost;
        money.inRail -= totalToBuyFour;
        this.hasBuy = true; 
        letsShow(this.buyButton);
        this.onStatus = true;
        comeoutRoll && thePlaceBets.turnOn(this.betCode);
        !aRollHappened && check.forExtraVig(this.betCode);
        show.cheques(this.betCode, amt);
        this.moveBack();
        playerAsksFor.buyFour(amt);
        hide.allMenus();
        money.adjustBank();
      }
    }
    //testMe.onStates();
  },
  moveBack: function () {
    $(this.cheque1000).style.top = '19.8%';
    $(this.cheque500).style.top = '20.4%';
    $(this.cheque100).style.top = '21.2%';
    $(this.cheque25).style.top = '22%';
    $(this.cheque5).style.top = '23%';
    $(this.cheque1).style.top = '24%';
    $(this.onButton).style.top = '23%';
    $(this.offButton).style.top = '23%';
    $(this.buyButton).style.top = '23%';
    $(this.amtBox).style.top = '30%';
  },
  turnOn: function () {
    letsShow(this.onButton); 
    letsHide(this.offButton);
    $(this.placeMenuBtn).onclick = function () {show.betMenu(5)};
    //testMe.onStates();
  },
  checkIt: function (amt) {
    check.ifEnoughMoney(amt, this.placeBet);
    check.properPlace(this.betCode, amt);
    check.minBet(this.betCode, amt);
    check.maxBet(this.betCode, amt);
    allGood = haveEnough && !underMinBet && !overMaxBet && properPlaceOutside;
  },
  checkBuy: function (amt) {
    this.vigCost = Math.floor(amt / 20);
    totalToBuyFour = amt + this.vigCost;
    check.ifEnoughMoney(totalToBuyFour, this.betPlusVig);
    check.minBet(this.betCode, amt);
    check.maxBet(this.betCode, amt);
    allGood = haveEnough && !underMinBet && !overMaxBet;
  }
}
const theFive = {
  betCode: 6,
  placeBet: 0,
  placePymnt: 0,
  onButton: 'place_five_on_btn',
  onStatus: false,
  offMenu: 'place_five_off_menu',
  offButton: 'place_five_off_btn',
  hasOffBtn: false,
  placeMenuBtn: 'show_place_five_btn',
  placePayMenu: 'place_five_pay_menu',
  get getPlaceBetAmt() {
    return this.placeBet;
  },
  payIt: function () {
    if (this.placeBet == 0) {
      return
    } else {
      let totalUnits = Math.floor(this.placeBet / 5); 
      let correctBetPymt = totalUnits * 7; let improperAmount = this.placeBet % 5; 
      this.placePymnt = correctBetPymt + improperAmount;
      money.inPlaceLimbo = this.placePymnt;
      letsShow(this.placePayMenu); 
      $('place_five_pay_header').innerHTML = "Your $" + this.placeBet + " Five won $" + this.placePymnt + ".";
      showPlaceFiveBtns(this.placeBet);
      disable.rollButtons(); disable.placeBetMenus();
      money.adjustBank();
    }
  },
  takeIt: function () {
    this.placeBet = 0;
    this.onStatus = false;
    hide.cheques(this.betCode);
    letsHide(this.onButton);
    $(this.placeMenuBtn).onclick = function () {show.offMenu(6)};
    money.adjustBank();
    //testMe.onStates();
  },
  sameBetIt: function () {
    money.inRail += this.placePymnt;
    this.placePymnt = 0; money.inPlaceLimbo = 0;
  },
  placeIt: function (amt) {
    this.sameBetIt();
    if (isNaN(amt) || amt <= 0) {
      return;
    } else {
      this.checkIt(amt);
      if (allGood) {
        bet.remove(this.betCode);
        money.inRail -= amt;
        this.placeBet += amt;
        this.onStatus= true;
        show.cheques(this.betCode, this.placeBet);
        comeoutRoll && this.turnOn();
        playerAsksFor.placeFive(amt);
        hide.allMenus();
        money.adjustBank();
      }
    }
    //testMe.onStates();
  },
  turnOn: function () {
    letsShow(this.onButton); 
    letsHide(this.offButton);
    $(this.placeMenuBtn).onclick = function () {show.betMenu(6)};
    //testMe.onStates();
  },
  checkIt: function (amt) {
    check.ifEnoughMoney(amt, this.placeBet);
    check.properPlace(this.betCode, amt);
    check.minBet(this.betCode, amt);
    check.maxBet(this.betCode, amt);
    allGood = haveEnough && !underMinBet && !overMaxBet && properPlaceOutside;
  }
}
const theSix = {
  betCode: 7,
  placeBet: 0,
  placePymnt: 0,
  onButton: 'place_six_on_btn',
  onStatus: false,
  offMenu: 'place_six_off_menu',
  offButton: 'place_six_off_btn',
  hasOffBtn: false,
  placeMenuBtn: 'show_place_six_btn',
  placePayMenu: 'place_six_pay_menu',
  get getPlaceBetAmt() {
    return this.placeBet;
  },
  payIt: function () {
    if (this.placeBet == 0) {
      return
    } else {
      let totalUnits = Math.floor(this.placeBet / 6); 
      let correctBetPymt = totalUnits * 7; let improperAmount = this.placeBet % 6; 
      this.placePymnt = correctBetPymt + improperAmount;
      money.inPlaceLimbo = this.placePymnt;
      letsShow(this.placePayMenu);
      showPlaceSixBtns(this.placeBet);
      $('place_six_pay_header').innerHTML = "Your $" + this.placeBet + " Six won $" + this.placePymnt + ".";
      disable.rollButtons(); disable.placeBetMenus();
      money.adjustBank();
    }
  },
  takeIt: function () {
    this.placeBet = 0;
    this.onStatus = false;
    hide.cheques(this.betCode);
    letsHide(this.onButton);
    $(this.placeMenuBtn).onclick = function () {show.offMenu(7)};
    money.adjustBank();
    //testMe.onStates();
  },
  sameBetIt: function () {
    money.inRail += this.placePymnt;
    this.placePymnt = 0; money.inPlaceLimbo = 0;
  },
  placeIt: function (amt) {
    this.sameBetIt();
    if (isNaN(amt) || amt <= 0) {
      return;
    } else {
      this.checkIt(amt);
      if (allGood) {
        bet.remove(this.betCode);
        money.inRail -= amt;
        this.placeBet += amt;
        this.onStatus= true;
        show.cheques(this.betCode, this.placeBet);
        comeoutRoll && this.turnOn();
        playerAsksFor.placeSix(amt);
        hide.allMenus();
        money.adjustBank();
      }
    }
    //testMe.onStates();
  },
  turnOn: function () {
    letsShow(this.onButton); 
    letsHide(this.offButton);
    $(this.placeMenuBtn).onclick = function () {show.betMenu(7)};
    //testMe.onStates();
  },
  checkIt: function (amt) {
    check.ifEnoughMoney(amt, this.placeBet);
    check.properPlace(this.betCode, amt);
    check.minBet(this.betCode, amt);
    check.maxBet(this.betCode, amt);
    allGood = haveEnough && !underMinBet && !overMaxBet && properPlaceSixEight;
  }
}
const theEight = {
  betCode: 8,
  placeBet: 0,
  placePymnt: 0,
  onButton: 'place_eight_on_btn',
  onStatus: false,
  offMenu: 'place_eight_off_menu',
  offButton: 'place_eight_off_btn',
  hasOffBtn: false,
  placeMenuBtn: 'show_place_eight_btn',
  placePayMenu: 'place_eight_pay_menu',
  get getPlaceBetAmt() {
    return this.placeBet;
  },
  payIt: function () {
    if (this.placeBet == 0) {
      return
    } else {
      let totalUnits = Math.floor(this.placeBet / 6); 
      let correctBetPymt = totalUnits * 7; let improperAmount = this.placeBet % 6; 
      this.placePymnt = correctBetPymt + improperAmount;
      money.inPlaceLimbo = this.placePymnt;
      letsShow(theEight.placePayMenu);
      showPlaceEightBtns(this.placeBet);
      $('place_eight_pay_header').innerHTML = "Your $" + this.placeBet + " Eight won $" + this.placePymnt + ".";
      disable.rollButtons(); disable.placeBetMenus();
      money.adjustBank();
    }
  },
  takeIt: function () {
    this.placeBet = 0;
    this.onStatus = false;
    hide.cheques(this.betCode);
    letsHide(this.onButton);
    $(this.placeMenuBtn).onclick = function () {show.offMenu(8)};
    money.adjustBank();
    //testMe.onStates();
  },
  sameBetIt: function () {
    money.inRail += this.placePymnt;
    this.placePymnt = 0; money.inPlaceLimbo = 0;
  },
  placeIt: function (amt) {
    this.sameBetIt();
    if (isNaN(amt) || amt <= 0) {
      return;
    } else {
      this.checkIt(amt);
      if (allGood) {
        bet.remove(this.betCode);
        money.inRail -= amt;
        this.placeBet += amt;
        this.onStatus= true;
        show.cheques(this.betCode, this.placeBet);
        comeoutRoll && this.turnOn();
        playerAsksFor.placeEight(amt);
        hide.allMenus();
        money.adjustBank();
        //testMe.onStates();
      }
    }
    //testMe.onStates();
  },
  turnOn: function () {
    letsShow(this.onButton); 
    letsHide(this.offButton);
    $(this.placeMenuBtn).onclick = function () {show.betMenu(8)};
    //testMe.onStates();
  },
  checkIt: function (amt) {
    check.ifEnoughMoney(amt, this.placeBet);
    check.properPlace(this.betCode, amt);
    check.minBet(this.betCode, amt);
    check.maxBet(this.betCode, amt);
    allGood = haveEnough && !underMinBet && !overMaxBet && properPlaceSixEight;
  }
}
const theNine = {
  betCode: 9,
  placeBet: 0,
  placePymnt: 0,
  onButton: 'place_nine_on_btn',
  onStatus: false,
  offMenu: 'place_nine_off_menu',
  offButton: 'place_nine_off_btn',
  hasOffBtn: false,
  placeMenuBtn: 'show_place_nine_btn',
  placePayMenu: 'place_nine_pay_menu',
  get getPlaceBetAmt() {
    return this.placeBet;
  },
  payIt: function () {
    if (this.placeBet == 0) {
      return
    } else {
      let totalUnits = Math.floor(this.placeBet / 5); 
      let correctBetPymt = totalUnits * 7; let improperAmount = this.placeBet % 5; 
      this.placePymnt = correctBetPymt + improperAmount;
      money.inPlaceLimbo = this.placePymnt;
      letsShow(this.placePayMenu); 
      $('place_nine_pay_header').innerHTML = "Your $" + this.placeBet + " Nine won $" + this.placePymnt + ".";
      showPlaceNineBtns(this.placeBet);
      disable.rollButtons(); disable.placeBetMenus();
      money.adjustBank();
    }
  },
  takeIt: function () {
    this.placeBet = 0;
    this.onStatus = false;
    hide.cheques(this.betCode);
    letsHide(this.onButton);
    $(this.placeMenuBtn).onclick = function () {show.offMenu(9)};
    money.adjustBank();
    //testMe.onStates();
  },
  sameBetIt: function () {
    money.inRail += this.placePymnt;
    this.placePymnt = 0; money.inPlaceLimbo = 0;
  },
  placeIt: function (amt) {
    this.sameBetIt();
    if (isNaN(amt) || amt <= 0) {
      return;
    } else {
      this.checkIt(amt);
      if (allGood) {
        bet.remove(this.betCode);
        money.inRail -= amt;
        this.placeBet += amt;
        this.onStatus= true;
        show.cheques(this.betCode, this.placeBet);
        comeoutRoll && this.turnOn();
        playerAsksFor.placeNine(amt);
        hide.allMenus();
        money.adjustBank();
      }
    }
    //testMe.onStates();
  },
  turnOn: function () {
    letsShow(this.onButton); 
    letsHide(this.offButton);
    $(this.placeMenuBtn).onclick = function () {show.betMenu(9)};
    //testMe.onStates();
  },
  checkIt: function (amt) {
    check.ifEnoughMoney(amt, this.placeBet);
    check.properPlace(this.betCode, amt);
    check.minBet(this.betCode, amt);
    check.maxBet(this.betCode, amt);
    allGood = haveEnough && !underMinBet && !overMaxBet && properPlaceOutside;
  }
}
const theTen = {
  betCode: 10,
  placeBet: 0,
  placePymnt: 0,
  onButton: 'place_ten_on_btn',
  onStatus: false,
  offMenu: 'place_ten_off_menu',
  offButton: 'place_ten_off_btn',
  hasOffBtn: false,
  placeMenuBtn: 'show_place_ten_btn',
  vigCost: 0,
  vig: 0,
  oldVig: 0,
  placePayMenu: 'place_ten_pay_menu',
  buyButton: 'place_ten_buy_btn',
  hasBuy: false,
  amtBox: 'place_ten_amt_box',
  cheque1: 'place_ten_1',
  cheque5: 'place_ten_5',
  cheque25: 'place_ten_25',
  cheque100: 'place_ten_100',
  cheque500: 'place_ten_500',
  cheque1000: 'place_ten_1000',
  get getPlaceBetAmt() {
    return this.placeBet;
  },
  get betPlusVig () {
    return this.placeBet + this.vig + money.extraVig;
  },
  payIt: function () {
    if (this.placeBet == 0) {
      return
    } else if (this.hasBuy) {
      this.placePymnt = this.placeBet * 2;
      $('place_ten_pay_header').innerHTML = "Your $" + this.placeBet + " Buy Ten won $" + this.placePymnt + ".";
    } else {
      let totalUnits = Math.floor(this.placeBet / 5); 
      let correctBetPymt = totalUnits * 9; let improperAmount = this.placeBet % 5; 
      this.placePymnt = correctBetPymt + improperAmount;
      $('place_ten_pay_header').innerHTML = "Your $" + this.placeBet + " Ten won $" + this.placePymnt + ".";
    }
    money.inPlaceLimbo = this.placePymnt;
    letsShow(this.placePayMenu);
    showPlaceTenBtns(this.placeBet);
    disable.rollButtons(); disable.placeBetMenus();
    money.adjustBank();
  },
  takeIt: function () {
    this.placeBet = 0;
    this.vig = 0; money.extraVig = 0;
    this.onStatus = false;
    this.hasBuy = false;
    money.adjustBank();
    hide.cheques(this.betCode);
    letsHide(this.onButton);
    letsHide(this.buyButton);
    $(this.placeMenuBtn).onclick = function () {show.offMenu(10)};
    //testMe.onStates();
  },
  sameBetIt: function () {
    money.inRail += this.placePymnt - this.vig;
    this.placePymnt = 0; money.inPlaceLimbo = 0;
  },
  placeIt: function (amt) {
    this.sameBetIt();
    if (isNaN(amt) || amt <= 0) {
      return;
    } else {
      this.checkIt(amt);
      if (allGood) {
        bet.remove(this.betCode);
        money.inRail -= amt;
        this.placeBet += amt;
        this.onStatus= true;
        show.cheques(this.betCode, this.placeBet);
        comeoutRoll && this.turnOn();
        playerAsksFor.placeTen(amt);
        hide.allMenus();
        money.adjustBank();
      }
    }
    //testMe.onStates();
  },
  buyIt: function (amt) {
    if (this.placePymnt > 0) {
      this.sameBetIt();
    }
    if (isNaN(amt) || amt < 20) {
      return
    } else {
      this.checkBuy(amt);
      if (allGood) {
        bet.remove(this.betCode);
        this.placeBet += amt;
        this.vig = this.vigCost;
        money.inRail -= totalToBuyTen;
        this.hasBuy = true; 
        letsShow(this.buyButton);
        this.onStatus = true;
        comeoutRoll && thePlaceBets.turnOn(this.betCode);
        total.fourTenBets == 0 && (aRollHappened = false);
        !aRollHappened && check.forExtraVig(this.betCode);
        show.cheques(this.betCode, amt);
        this.moveBack();
        playerAsksFor.buyTen(amt);
        hide.allMenus();
        money.adjustBank();
      }
    }
    //testMe.onStates();
  },
  moveBack: function () {
    $(this.cheque1000).style.top = '19.8%';
    $(this.cheque500).style.top = '20.4%';
    $(this.cheque100).style.top = '21.2%';
    $(this.cheque25).style.top = '22%';
    $(this.cheque5).style.top = '23%';
    $(this.cheque1).style.top = '24%';
    $(this.onButton).style.top = '23%';
    $(this.offButton).style.top = '23%';
    $(this.buyButton).style.top = '23%';
    $(this.amtBox).style.top = '30%';
  },
  turnOn: function () {
    letsShow(this.onButton); 
    letsHide(this.offButton);
    $(this.placeMenuBtn).onclick = function () {show.betMenu(10)};
    //testMe.onStates();
  },
  checkIt: function (amt) {
    check.ifEnoughMoney(amt, this.placeBet);
    check.properPlace(this.betCode, amt);
    check.minBet(this.betCode, amt);
    check.maxBet(this.betCode, amt);
    allGood = haveEnough && !underMinBet && !overMaxBet && properPlaceOutside;
  },
  checkBuy: function (amt) {
    this.vigCost = Math.floor(amt / 20);
    totalToBuyTen = amt + this.vigCost;
    check.ifEnoughMoney(totalToBuyTen, this.betPlusVig);
    check.minBet(this.betCode, amt);
    check.maxBet(this.betCode, amt);
    allGood = haveEnough && !underMinBet && !overMaxBet; 
  }
}
const thePlaceBets = {
  get werePaid () {
    return money.inPlaceLimbo > 0;
  },
  areOn: function () {
    theFour.hasOffBtn ? this.turnOff(5) : this.turnOn(5);
    theFive.hasOffBtn ? this.turnOff(6) : this.turnOn(6);
    theEight.hasOffBtn ? this.turnOff(8) : this.turnOn(8);
    theSix.hasOffBtn ? this.turnOff(7) : this.turnOn(7);
    theNine.hasOffBtn ? this.turnOff(9) : this.turnOn(9);
    theTen.hasOffBtn ? this.turnOff(10) : this.turnOn(10);
  },
  areOff: function () {
    theFour.onStatus = false; letsHide(theFour.onButton); $(theFour.placeMenuBtn).onclick = function () {show.offMenu(5)};
    theFive.onStatus = false; letsHide(theFive.onButton); $(theFive.placeMenuBtn).onclick = function () {show.offMenu(6)};
    theSix.onStatus = false; letsHide(theSix.onButton); $(theSix.placeMenuBtn).onclick = function () {show.offMenu(7)};
    theEight.onStatus = false; letsHide(theEight.onButton); $(theEight.placeMenuBtn).onclick = function () {show.offMenu(8)};
    theNine.onStatus = false; letsHide(theNine.onButton); $(theNine.placeMenuBtn).onclick = function () {show.offMenu(9)};
    theTen.onStatus = false; letsHide(theTen.onButton); $(theTen.placeMenuBtn).onclick = function () {show.offMenu(10)};
  },
  turnOnAll: function () {
    var placeBets =  getPlaceBets();
    for (let i = 0; i < 6; i++) {
      placeBets[i] > 0 && thePlaceBets.turnOn(i + 5);
    }
    intermediateRoll && hide.onButtons();
    inform.turnOnAllPlace();
    //testMe.onStates();
  },
  turnOffAll: function () {
    var placeBets =  getPlaceBets();
    for (let i = 0; i < 6; i++) {
      placeBets[i] > 0 && thePlaceBets.turnOff(i + 5);
    }
    total.placeBets !== 0 ? inform.turnOffAllPlace() : hide.allMenus();
    //testMe.onStates();
  },
  turnOn: function (betCode) {
    switch (betCode) {
      case 5: 
        theFour.onStatus = true;
        $(theFour.placeMenuBtn).onclick = function () {show.betMenu(5)};
        if (theFour.placeBet > 0) {
          comeoutRoll && letsShow(theFour.onButton);
          theFour.hasOffBtn = false;
          letsHide(theFour.offButton);
          letsHide(theFour.offMenu);
          theFour.hasBuy ? inform.turnOnBuyFour() : inform.turnOnPlaceFour();
          if(theFour.hasBuy) {
            $("place_four_on_btn").style.top = '23%';
          }
        }
        break;
      case 6: 
        theFive.onStatus = true;
        $(theFive.placeMenuBtn).onclick = function () {show.betMenu(6)};
        if (theFive.placeBet > 0) {
          comeoutRoll && letsShow(theFive.onButton);
          theFive.hasOffBtn = false;
          letsHide(theFive.offButton);
          letsHide(theFive.offMenu);
          inform.turnOnPlaceFive();
        }
        break;
      case 7:
        theSix.onStatus = true;
        $(theSix.placeMenuBtn).onclick = function () {show.betMenu(7)};
        if (theSix.placeBet > 0) {
          comeoutRoll && letsShow(theSix.onButton);
          theSix.hasOffBtn = false;
          letsHide(theSix.offButton);
          letsHide(theSix.offMenu);
          inform.turnOnPlaceSix();
        }
        break;
      case 8:
        theEight.onStatus = true;
        $(theEight.placeMenuBtn).onclick = function () {show.betMenu(8)};
        if (theEight.placeBet > 0) {
          comeoutRoll && letsShow(theEight.onButton);
          theEight.hasOffBtn = false;
          letsHide(theEight.offButton);
          letsHide(theEight.offMenu);
          inform.turnOnPlaceEight();
        }
        break;
      case 9:
        theNine.onStatus = true;
        $(theNine.placeMenuBtn).onclick = function () {show.betMenu(9)};
        if (theNine.placeBet > 0) {
          comeoutRoll && letsShow(theNine.onButton);
          theNine.hasOffBtn = false;
          letsHide(theNine.offButton);
          letsHide(theNine.offMenu);
          inform.turnOnPlaceNine();
        }
        break;
      case 10:
        theTen.onStatus = true;
        $(theTen.placeMenuBtn).onclick = function () {show.betMenu(10)};
        if (theTen.placeBet > 0) {
          comeoutRoll && letsShow(theTen.onButton);
          theTen.hasOffBtn = false;
          letsHide(theTen.offButton);
          letsHide(theTen.offMenu);
          theTen.hasBuy ? inform.turnOnBuyTen() : inform.turnOnPlaceTen();
          if (theTen.hasBuy) {
            $("place_ten_on_btn").style.top = '23%';
          }
        }
        break;
      default: return
    }
    enable.allButtons();
    //testMe.onStates();
  },
  turnOff: function (betCode) {
    var placeBets =  getPlaceBets();
    if (placeBets[betCode - 5] == 0) {
      hideBetMenu(betCode);
      return;
    } else {
      switch (betCode) {
        case 5: 
          theFour.onStatus= false;
          theFour.hasOffBtn = true;
          $(theFour.placeMenuBtn).onclick = function () {show.offMenu(5)};
          letsShow(theFour.offButton);
          letsHide(theFour.onButton);
          theFour.hasBuy ? inform.turnOffBuyFour() : inform.turnOffPlaceFour();
          theFour.hasBuy ? $("place_four_off_btn").style.top = "22.5%" : $("place_four_off_btn").style.top = "26%";
          break;
        case 6:
          theFive.onStatus= false;
          theFive.hasOffBtn = true;
          $(theFive.placeMenuBtn).onclick = function () {show.offMenu(6)};
          letsShow(theFive.offButton);
          letsHide(theFive.onButton);
          inform.turnOffPlaceFive();
          break;
        case 7:
          theSix.onStatus = false;
          theSix.hasOffBtn = true;
          $(theSix.placeMenuBtn).onclick = function () {show.offMenu(7)};
          letsShow(theSix.offButton);
          letsHide(theSix.onButton);
          inform.turnOffPlaceSix();
          break;
        case 8:
          theEight.onStatus = false;
          theEight.hasOffBtn = true;
          $(theEight.placeMenuBtn).onclick = function () {show.offMenu(8)};
          letsShow(theEight.offButton);
          letsHide(theEight.onButton);
          inform.turnOffPlaceEight();
          break;
        case 9:
          theNine.onStatus = false;
          theNine.hasOffBtn = true;
          $(theNine.placeMenuBtn).onclick = function () {show.offMenu(9)};
          letsShow(theNine.offButton);
          letsHide(theNine.onButton);
          inform.turnOffPlaceNine();
          break;
        case 10:
          theTen.onStatus = false;
          theTen.hasOffBtn = true;
          $(theTen.placeMenuBtn).onclick = function () {show.offMenu(10)};
          letsShow(theTen.offButton);
          letsHide(theTen.onButton);
          theTen.hasBuy ? inform.turnOffBuyTen() : inform.turnOffPlaceTen();
          theTen.hasBuy ? $("place_ten_off_btn").style.top = "22.5%" : $("place_ten_off_btn").style.top = "26%";
          break;
        default: return
      }
    }
    hideBetMenu(betCode);
    //testMe.onStates();
  },
  allDown: function () {
    for (let i = 0; i < 6; i++) {
      bet.remove(i + 5);
      inform.allBetsDown();
      comeoutRoll ? $(placeMenuBtns[i]).onclick = function () {show.offMenu(i + 5)} : $(placeMenuBtns[i]).onclick = function () {show.betMenu(i + 5)};
    }
    //testMe.onStates();
  },
}
const theField = {
  betCode: 11,
  doubleOneBetCode: 12,
  doubleTwoBetCode: 13,
  tripleBetCode: 14,
  bet: 0,
  payment: 0,
  doublePayment: 0,
  allNumbers: [2, 3, 4, 9, 10, 11, 12],
  evenFieldNumbers: [3, 4, 9, 10, 11],
  dbleFieldNumbers: [2, 12],
  get isOverMax () {
    return total.fieldMoney > limit.tableMax;
  },
  betIt: function (amt) {
    if(isNaN(amt) || amt <= 0) {
      return 
    } else {
      this.checkIt(amt);
      if(allGood) {
        bet.remove(this.betCode);
        alert.remove();
        money.inRail -= amt;
        this.bet += amt;
        money.adjustBank();
        hide.allMenus();
        show.cheques(this.betCode, this.bet)
        $('show_field_btn').onclick = function () {show.betMenu(11)};
      }
    }
  },
  collectAll: function () {
    if (this.bet == 0) {
      return
    } else {
      fieldWasPaid = false;
      money.inRail += this.bet + this.payment + this.doublePayment;
      this.bet = 0; this.payment = 0; this.doublePayment = 0;
      money.adjustBank();
      hide.cheques(11);
      hide.cheques(12);
      hide.cheques(13); 
      hideBetMenu(11);
      $('show_field_btn').onclick = function () {show.betMenu(11)};
      alert.remove();
    }
  },
  takeIt: function () {
    fieldWasPaid = false;
    this.bet = 0;
    this.payment = 0;
    this.doublePayment = 0;
    hide.cheques(11);
    hide.cheques(12);
    hide.cheques(13);
    $('show_field_btn').onclick = function () {show.betMenu(11)};
  },
  settleIt: function () {
    fieldWon = this.allNumbers.includes(rollTotal);
    singleField = this.evenFieldNumbers.includes(rollTotal);
    doubleField = this.dbleFieldNumbers.includes(rollTotal);
    if (this.bet == 0) {
      return
    } else {
      if (!fieldWon) {
        this.takeIt();
      } else if (!fieldWasPaid && singleField) {
          wasSingle = true;
          fieldWasPaid = true;
          this.payment += this.bet;
          show.cheques(12, this.payment);
          $('show_field_btn').onclick = function () {show.fieldPayMenu()};
      } else if (!fieldWasPaid && doubleField) {
          fieldWasPaid = true;
          wasSingle = false;
          this.payment += this.bet;
          this.doublePayment += this.bet;
          show.cheques(12, this.bet);
          show.cheques(13, this.bet);
          $('show_field_btn').onclick = function () {show.fieldPayMenu()};
      } else if (fieldWasPaid && singleField) {
          wasSingle = true;
          this.bet += this.payment + this.doublePayment;
          this.payment = this.bet;
          this.doublePayment = 0;
          show.cheques(11, this.bet);
          show.cheques(12, this.payment);
          hide.cheques(13);
          $('show_field_btn').onclick = function () {show.fieldPayMenu()};
      } else if (fieldWasPaid && doubleField) {
          wasSingle = false;
          hide.cheques(13);
          this.bet += this.payment + this.doublePayment;
          this.payment = this.bet;
          this.doublePayment = this.bet;
          show.cheques(11, this.bet);
          show.cheques(12, this.bet);
          show.cheques(13, this.bet);
          $('show_field_btn').onclick = function () {show.fieldPayMenu()};
      } else {return}
    }
    money.adjustBank();
  },
  rebetIt: function (amt) {
    this.collectAll();
    this.betIt(amt);
  },
  stackIt: function () {
    check.maxBet(11, total.fieldMoney);
    if (!overMaxBet) {
      safeAmount = total.fieldMoney
      this.collectAll();
      this.betIt(safeAmount);
    }
  },
  collectHalf: function () {
    halfPayment = this.bet;
    this.collectAll();
    this.betIt(halfPayment)
  },
  collectThird: function () {
    check.maxBet(11, this.bet + this.payment);
    if (!overMaxBet) {
      safeAmount = this.bet * 2;
      this.collectAll();
      this.betIt(safeAmount);
    }
  },
  collectTwoThird: function () {
    thirdOfBet = this.bet;
    this.collectAll()
    this.betIt(thirdOfBet);

  }, 
  checkIt: function (amt) {
    check.ifEnoughMoney(amt, this.bet);
    check.minBet(this.betCode, amt);
    check.maxBet(this.betCode, amt);
    allGood = haveEnough && !underMinBet && !overMaxBet;
  }
}
const bet = {
  all: function (betCode) {
    if (money.inRail == 0) {
      hideBetMenu(betCode);
      alert.noMoreMoney()
      return;
    } else {
      switch (betCode) {
        case 1:
          bet.remove(betCode);
          var allIn = thePassLine.lineBet + money.inRail;
          if (allIn > limit.tableMax) {
            alert.gaveMaxInstead();
            thePassLine.lineBet += limit.tableMax;
            money.inRail -= limit.tableMax;
          } else {
            thePassLine.lineBet += money.inRail;
            money.inRail -= money.inRail;
            inform.allIn();
          }
          hasPassLine = true;
          money.adjustBank()
          show.cheques(betCode, thePassLine.lineBet);
          break;
        case 3:
          bet.remove(betCode);
          passLineOdds.setOddsType(limit.oddsType);
          var allIn = passLineOdds.oddsBet + money.inRail;
          if (allIn > limit.maxOdds) {
            alert.gaveMaxInstead();
            passLineOdds.oddsBet += limit.maxOdds;
            money.inRail -= limit.maxOdds;
          } else {
            passLineOdds.oddsBet += money.inRail;
            money.inRail -= money.inRail;
            alert.remove();
          }
          $('button_three').innerHTML = "Adjust Odds Bet";
          money.adjustBank();
          show.cheques(betCode, passLineOdds.oddsBet);
          break;
        case 5:
          bet.remove(betCode);
          theJuice = Math.floor(limit.placeOutsideMax / 20);
          placeOutsideMaxBuy = limit.placeOutsideMax + theJuice;
          if (money.inRail == 0) {
            alert.noMoreMoney();
          } else if (money.inRail <= 20) {
            theFour.placeBet += money.inRail;
            money.inRail -= money.inRail;
            money.adjustBank()
            show.cheques(betCode, theFour.placeBet);
            thePlaceBets.turnOn(betCode);
            inform.allIn();
          } else if ((money.inRail >= 21) && (money.inRail <= placeOutsideMaxBuy)) {
            let totalUnitsWithVig = Math.floor(money.inRail / 21);
            let minRequiredPurchase = totalUnitsWithVig * 20;
            let extraDollars = money.inRail % 21;
            if (extraDollars == 20) {
              totalAllInBuyAmount = minRequiredPurchase + extraDollars - 1;
            } else {
              totalAllInBuyAmount = minRequiredPurchase + extraDollars;
            }
            theFour.buyIt(totalAllInBuyAmount);
            thePlaceBets.turnOn(betCode);
            inform.allIn();
          } else if (money.inRail > placeOutsideMaxBuy) {
            betMax(betCode);
            alert.gaveMaxInstead();
          }
          break;
        case 6:
          bet.remove(betCode);
          var allIn = theFive.placeBet + money.inRail;
          if (allIn > limit.placeOutsideMax) {
            theFive.placeBet += limit.placeOutsideMax;
            money.inRail -= limit.placeOutsideMax;
            thePlaceBets.turnOn(betCode);
            alert.gaveMaxInstead();
          } else {
            theFive.placeBet += money.inRail;
            money.inRail -= money.inRail;
            thePlaceBets.turnOn(betCode);
            inform.allIn();
          }
          money.adjustBank()
          show.cheques(betCode, theFive.placeBet);
          break;
        case 7:
          bet.remove(betCode);
          var allIn = theSix.placeBet + money.inRail;
          if (allIn > limit.placeSixEightMax) {
            theSix.placeBet += limit.placeSixEightMax;
            money.inRail -= limit.placeSixEightMax;
            thePlaceBets.turnOn(betCode);
            alert.gaveMaxInstead();
          } else {
            theSix.placeBet += money.inRail;
            money.inRail -= money.inRail;
            thePlaceBets.turnOn(betCode);
            inform.allIn();
          }
          money.adjustBank()
          show.cheques(betCode, theSix.placeBet);
          break;
        case 8:
          bet.remove(betCode);
          var allIn = theEight.placeBet + money.inRail;
          if (allIn > limit.placeSixEightMax) {
            theEight.placeBet += limit.placeSixEightMax;
            money.inRail -= limit.placeSixEightMax;
            thePlaceBets.turnOn(betCode);
            alert.gaveMaxInstead();
          } else {
            theEight.placeBet += money.inRail;
            money.inRail -= money.inRail;
            thePlaceBets.turnOn(betCode);
            inform.allIn();
          }
          money.adjustBank()
          show.cheques(betCode, theEight.placeBet);
          break;
        case 9:
          bet.remove(betCode);
          var allIn = theNine.placeBet + money.inRail;
          if (allIn > limit.placeOutsideMax) {
            theNine.placeBet += limit.placeOutsideMax;
            money.inRail -= limit.placeOutsideMax;
            thePlaceBets.turnOn(betCode);
            alert.gaveMaxInstead();
          } else {
            theNine.placeBet += money.inRail;
            money.inRail -= money.inRail;
            thePlaceBets.turnOn(betCode);
            inform.allIn();
          }
          money.adjustBank()
          show.cheques(betCode, theNine.placeBet);
          break;
        case 10:
          bet.remove(betCode);
          theJuice = Math.floor(limit.placeOutsideMax / 20);
          placeOutsideMaxBuy = limit.placeOutsideMax + theJuice;
          if (money.inRail == 0) {
            alert.noMoreMoney();
          } else if (money.inRail <= 20) {
            theTen.placeBet += money.inRail;
            money.inRail -= money.inRail;
            money.adjustBank()
            show.cheques(betCode, theTen.placeBet);
            thePlaceBets.turnOn(betCode);
            inform.allIn();
          } else if ((money.inRail >= 21) && (money.inRail <= placeOutsideMaxBuy)) {
            let totalUnitsWithVig = Math.floor(money.inRail / 21);
            let minRequiredPurchase = totalUnitsWithVig * 20;
            let extraDollars = money.inRail % 21;
            if (extraDollars == 20) {
              totalAllInBuyAmount = minRequiredPurchase + extraDollars - 1;
            } else {
              totalAllInBuyAmount = minRequiredPurchase + extraDollars;
            }
            theTen.buyIt(totalAllInBuyAmount);
            thePlaceBets.turnOn(betCode);
            inform.allIn();
          } else if (money.inRail > placeOutsideMaxBuy) {
            betMax(betCode);
            alert.gaveMaxInstead();
          }
          break;
        case 11:
          theField.collectAll();
          var allIn = theField.bet + money.inRail;
          if (allIn > limit.tableMax) {
            alert.gaveMaxInstead();
            theField.bet += limit.tableMax;
            money.inRail -= limit.tableMax;
          } else {
            theField.bet += money.inRail;
            money.inRail -= money.inRail;
            inform.allIn();
          }
          money.adjustBank();
          hideBetMenu(11);
          show.cheques(betCode, theField.bet);
          break;
        default:return
      }
    }
    hideBetMenu(betCode);
  },
  max: function (betCode) {
    switch (betCode) {
      case 1: 
      check.ifEnoughMoney(limit.tableMax, thePassLine.lineBet)
        if (haveEnough) {
          bet.remove(betCode);
          thePassLine.lineBet += limit.tableMax;
          money.inRail -= limit.tableMax;
          inform.betMaxPassLine();
          hasPassLine = true;
          money.adjustBank();
          show.cheques(betCode, thePassLine.lineBet);
        }
        break;
      case 3:
        passLineOdds.setOddsType(limit.oddsType);
        check.ifEnoughMoney(limit.maxOdds, passLineOdds.oddsBet)
        if (haveEnough) {
          bet.remove(betCode);
          passLineOdds.oddsBet += limit.maxOdds;
          money.inRail -= limit.maxOdds;
          inform.betMaxOdds(limit.maxOdds);
          $('button_three').innerHTML = "Adjust Odds Bet";
          money.adjustBank();
          show.cheques(betCode, passLineOdds.oddsBet);
        }
        break;
      case 5:
        theJuice = Math.floor(limit.placeOutsideMax / 20);
        placeOutsideMaxBuy = limit.placeOutsideMax + theJuice;
        check.ifEnoughMoney(placeOutsideMaxBuy, theFour.placeBet)
          if (haveEnough) {
            bet.remove(betCode);
            theFour.buyIt(limit.placeOutsideMax);
            inform.betMaxPlaceFour();
          }
        break;
      case 6: 
        check.ifEnoughMoney(limit.placeOutsideMax, theFive.placeBet)
          if (haveEnough) {
            bet.remove(betCode);
            theFive.placeBet += limit.placeOutsideMax;
            money.inRail -= limit.placeOutsideMax;
            inform.betMaxPlaceFive();
            money.adjustBank();
            show.cheques(betCode, theFive.placeBet);
            if (comeoutRoll) {
              theFive.onStatus= true;
              letsShow(theFive.onButton); letsHide(theFive.offButton);
              $(theFive.placeMenuBtn).onclick = function () {show.betMenu(6)};
            }
          }
        break;
      case 7: 
        check.ifEnoughMoney(limit.placeSixEightMax, theSix.placeBet)
          if (haveEnough) {
            bet.remove(betCode);
            theSix.placeBet += limit.placeSixEightMax;
            money.inRail -= limit.placeSixEightMax;
            inform.betMaxPlaceSix();
            money.adjustBank();
            show.cheques(betCode, theSix.placeBet);
            if (comeoutRoll) {
              theSix.onStatus = true;
              letsShow(theSix.onButton); letsHide(theSix.offButton);
              $(theSix.placeMenuBtn).onclick = function () {show.betMenu(7)};
            }
          }
        break;
      case 8: 
        check.ifEnoughMoney(limit.placeSixEightMax, theEight.placeBet)
          if (haveEnough) {
            bet.remove(betCode);
            theEight.placeBet += limit.placeSixEightMax;
            money.inRail -= limit.placeSixEightMax;
            inform.betMaxPlaceEight();
            money.adjustBank();
            show.cheques(betCode, theEight.placeBet);
            if (comeoutRoll) {
              theEight.onStatus = true;
              letsShow(theEight.onButton); letsHide(theEight.offButton);
              $(theEight.placeMenuBtn).onclick = function () {show.betMenu(8)};
            }
          }
        break;
      case 9: 
        check.ifEnoughMoney(limit.placeOutsideMax, theNine.placeBet)
          if (haveEnough) {
            bet.remove(betCode);
            theNine.placeBet += limit.placeOutsideMax;
            money.inRail -= limit.placeOutsideMax;
            inform.betMaxPlaceNine();
            money.adjustBank();
            show.cheques(betCode, theNine.placeBet);
            if (comeoutRoll) {
              theNine.onStatus = true;
              letsShow(theNine.onButton); letsHide(theNine.offButton);
              $(theNine.placeMenuBtn).onclick = function () {show.betMenu(9)};
            }
          }
        break;
      case 10: 
        theJuice = Math.floor(limit.placeOutsideMax / 20);
        placeOutsideMaxBuy = limit.placeOutsideMax + theJuice;
        check.ifEnoughMoney(placeOutsideMaxBuy, theTen.placeBet)
          if (haveEnough) {
            bet.remove(betCode);
            theTen.buyIt(limit.placeOutsideMax);
            inform.betMaxPlaceTen();
          }
        break;
      case 11:
        check.ifEnoughMoney(limit.tableMax, total.fieldMoney)
        if (haveEnough) {
          theField.collectAll();
          theField.bet += limit.tableMax;
          money.inRail -= limit.tableMax;
          inform.betMaxField();
          money.adjustBank();
          show.cheques(betCode, theField.bet);
        }
        break;
      default: return
    }
    hideBetMenu(betCode);
  },
  somethingElse: function (betCode) {
    playerDoes.sameBet(betCode);
    switch (betCode) {
      case 5: 
        let theFourInput = parseInt((<HTMLInputElement>$('place_pay_four_amount')).value);
        theFour.placeIt(theFourInput); 
        break;
      case 6: 
        let theFiveInput = parseInt((<HTMLInputElement>$('place_pay_five_amount')).value);
        theFive.placeIt(theFiveInput); 
        break;
      case 7: 
        let theSixInput = parseInt((<HTMLInputElement>$('place_pay_six_amount')).value);
        theSix.placeIt(theSixInput); 
        break;
      case 8: 
        let theEightInput = parseInt((<HTMLInputElement>$('place_pay_eight_amount')).value);
        theEight.placeIt(theEightInput); 
        break;
      case 9: 
        let theNineInput = parseInt((<HTMLInputElement>$('place_pay_nine_amount')).value);
        theNine.placeIt(theNineInput); 
        break;
      case 10: 
        let theTenInput = parseInt((<HTMLInputElement>$('place_pay_ten_amount')).value);
        theTen.placeIt(theTenInput); 
        break;
    default: return
   }
  },
  each: function (betCode, amt) {
    switch (betCode) {
      case 68: 
        existingSixEightMoney = theSix.placeBet + theEight.placeBet;
        check.ifEnoughMoney(amt * 2, existingSixEightMoney)
        if (haveEnough) {
          theSix.placeIt(amt); theEight.placeIt(amt);
          haveEnough && playerAsksFor.placeEachSixEight(amt);
        }
        break;
      case 59: 
        existingFiveNineMoney = theFive.placeBet + theNine.placeBet;
        check.ifEnoughMoney(amt * 2, existingFiveNineMoney)
        if (haveEnough) {
          theFive.placeIt(amt); theNine.placeIt(amt);
          haveEnough && playerAsksFor.placeEachFiveNine(amt);
        }
        break;
      case 410: 
        tryFor = amt * 2;
        juiceNeeded = Math.floor(tryFor / 20);
        amountNeeded = tryFor + juiceNeeded
        if (amt <= 15) {
          check.ifEnoughMoney(amt * 2, total.fourTenBets)
          if (haveEnough) {
            theFour.placeIt(amt); theTen.placeIt(amt);
            haveEnough && playerAsksFor.placeEachFourTen(amt);
          }
        } else {
          check.ifEnoughMoney(amountNeeded, total.fourTenBets)
          if (haveEnough) {
            theFour.buyIt(amt); theTen.buyIt(amt);
            haveEnough && playerAsksFor.buyEachFourTen(amt);
          }
        }
        break;
      default: return
    }
  },
  acrossIncluding: function (amt) {
    totalAcrossIncluding = theFour.placeBet + theEight.placeBet + theSix.placeBet + theEight.placeBet + theNine.placeBet + theTen.placeBet  + theFour.vig + theTen.vig + money.extraVig;
    check.ifEnoughMoney(amt, totalAcrossIncluding)
    if (haveEnough) {
      switch (amt) {
        case 32: theFour.placeIt(5); theFive.placeIt(5); theSix.placeIt(6); theEight.placeIt(6); theNine.placeIt(5); theTen.placeIt(5); break;
        case 64: theFour.placeIt(10); theFive.placeIt(10); theSix.placeIt(12); theEight.placeIt(12); theNine.placeIt(10); theTen.placeIt(10); break;
        case 96: theFour.placeIt(15); theFive.placeIt(15); theSix.placeIt(18); theEight.placeIt(18); theNine.placeIt(15); theTen.placeIt(15); break;
        case 162: theFour.buyIt(25); theFive.placeIt(25); theSix.placeIt(30); theEight.placeIt(30); theNine.placeIt(25); theTen.buyIt(25); break;
        case 325: theFour.buyIt(50); theFive.placeIt(50); theSix.placeIt(60); theEight.placeIt(60); theNine.placeIt(50); theTen.buyIt(50); break;
        case 650: theFour.buyIt(100); theFive.placeIt(100); theSix.placeIt(120); theEight.placeIt(120); theNine.placeIt(100); theTen.buyIt(100); break;
        default: return
      }
    }
    haveEnough && playerAsksFor.acrossIncluding(amt);
  },
  across: function (amt) {
    switch (thePoint) {
      case 4:
        totalAcrossPointFour = theFive.placeBet + theSix.placeBet + theEight.placeBet + theNine.placeBet + theTen.placeBet + theTen.vig + money.extraVig;
        check.ifEnoughMoney(amt, totalAcrossPointFour);
        if (haveEnough) {
          switch (amt) {
            case 27: theFive.placeIt(5); theSix.placeIt(6); theEight.placeIt(6); theNine.placeIt(5); theTen.placeIt(5); break;
            case 54: theFive.placeIt(10); theSix.placeIt(12); theEight.placeIt(12); theNine.placeIt(10); theTen.placeIt(10); break;
            case 81: theFive.placeIt(15); theSix.placeIt(18); theEight.placeIt(18); theNine.placeIt(15); theTen.placeIt(15); break;
            case 136: theFive.placeIt(25); theSix.placeIt(30); theEight.placeIt(30); theNine.placeIt(25); theTen.buyIt(25); break;
            case 272: theFive.placeIt(50); theSix.placeIt(60); theEight.placeIt(60); theNine.placeIt(50); theTen.buyIt(50); break;
            case 545: theFive.placeIt(100); theSix.placeIt(120); theEight.placeIt(120); theNine.placeIt(100); theTen.buyIt(100); break;
            default: return
          }
        }
        break;
      case 5:
        totalAcrossPointFive = theFour.placeBet + theSix.placeBet + theEight.placeBet + theNine.placeBet + theTen.placeBet + theFour.vig + theTen.vig + money.extraVig;
        check.ifEnoughMoney(amt, totalAcrossPointFive);
        if (haveEnough) {
          switch (amt) {
            case 27: theFour.placeIt(5); theSix.placeIt(6); theEight.placeIt(6); theNine.placeIt(5); theTen.placeIt(5); break;
            case 54: theFour.placeIt(10); theSix.placeIt(12); theEight.placeIt(12); theNine.placeIt(10); theTen.placeIt(10); break;
            case 81: theFour.placeIt(15); theSix.placeIt(18); theEight.placeIt(18); theNine.placeIt(15); theTen.placeIt(15); break;
            case 137: theFour.buyIt(25); theSix.placeIt(30); theEight.placeIt(30); theNine.placeIt(25); theTen.buyIt(25); break;
            case 275: theFour.buyIt(50); theSix.placeIt(60); theEight.placeIt(60); theNine.placeIt(50); theTen.buyIt(50); break;
            case 550: theFour.buyIt(100); theSix.placeIt(120); theEight.placeIt(120); theNine.placeIt(100); theTen.buyIt(100); break;
            default: return
          }
        }
        break;
      case 6:
        totalAcrossPointSix = theFour.placeBet + theFive.placeBet + theEight.placeBet + theNine.placeBet + theTen.placeBet + theFour.vig + theTen.vig + money.extraVig;
        check.ifEnoughMoney(amt, totalAcrossPointSix);
        if (haveEnough) {
          switch (amt) {
            case 26: theFour.placeIt(5); theFive.placeIt(5); theEight.placeIt(6); theNine.placeIt(5); theTen.placeIt(5); break;
            case 52: theFour.placeIt(10); theFive.placeIt(10); theEight.placeIt(12); theNine.placeIt(10); theTen.placeIt(10); break;
            case 78: theFour.placeIt(15); theFive.placeIt(15); theEight.placeIt(18); theNine.placeIt(15); theTen.placeIt(15); break;
            case 132: theFour.buyIt(25); theFive.placeIt(25); theEight.placeIt(30); theNine.placeIt(25); theTen.buyIt(25); break;
            case 265: theFour.buyIt(50); theFive.placeIt(50); theEight.placeIt(60); theNine.placeIt(50); theTen.buyIt(50); break;
            case 530: theFour.buyIt(100); theFive.placeIt(100); theEight.placeIt(120); theNine.placeIt(100); theTen.buyIt(100); break;
            default: return
          }
        }
        break;
      case 8:
        totalAcrossPointEight = theFour.placeBet + theFive.placeBet + theSix.placeBet + theNine.placeBet + theTen.placeBet + theFour.vig + theTen.vig + money.extraVig;
        check.ifEnoughMoney(amt, totalAcrossPointEight);
        if (haveEnough) {
          switch (amt) {
            case 26: theFour.placeIt(5); theFive.placeIt(5); theSix.placeIt(6); theNine.placeIt(5); theTen.placeIt(5); break;
            case 52: theFour.placeIt(10); theFive.placeIt(10); theSix.placeIt(12); theNine.placeIt(10); theTen.placeIt(10); break;
            case 78: theFour.placeIt(15); theFive.placeIt(15); theSix.placeIt(18); theNine.placeIt(15); theTen.placeIt(15); break;
            case 132: theFour.buyIt(25); theFive.placeIt(25); theSix.placeIt(30); theNine.placeIt(25); theTen.buyIt(25); break;
            case 265: theFour.buyIt(50); theFive.placeIt(50); theSix.placeIt(60); theNine.placeIt(50); theTen.buyIt(50); break;
            case 530: theFour.buyIt(100); theFive.placeIt(100); theSix.placeIt(120); theNine.placeIt(100); theTen.buyIt(100); break;
            default: return
          }
        }
        break;
      case 9:
        totalAcrossPointNine = theFour.placeBet + theFive.placeBet + theSix.placeBet + theEight.placeBet + theTen.placeBet + theFour.vig + theTen.vig + money.extraVig;
        check.ifEnoughMoney(amt, totalAcrossPointNine);
        if (haveEnough) {
          switch (amt) {
            case 27: theFour.placeIt(5); theFive.placeIt(5); theSix.placeIt(6); theEight.placeIt(6); theTen.placeIt(5); break;
            case 54: theFour.placeIt(10); theFive.placeIt(10); theSix.placeIt(12); theEight.placeIt(12); theTen.placeIt(10); break;
            case 81: theFour.placeIt(15); theFive.placeIt(15); theSix.placeIt(18); theEight.placeIt(18); theTen.placeIt(15); break;
            case 137: theFour.buyIt(25); theFive.placeIt(25); theSix.placeIt(30); theEight.placeIt(30); theTen.buyIt(25); break;
            case 275: theFour.buyIt(50); theFive.placeIt(50); theSix.placeIt(60); theEight.placeIt(60); theTen.buyIt(50); break;
            case 550: theFour.buyIt(100); theFive.placeIt(100); theSix.placeIt(120); theEight.placeIt(120); theTen.buyIt(100); break;
            default: return
          }
        }
        break;
      case 10:
        totalAcrossPointTen = theFour.placeBet + theFive.placeBet + theSix.placeBet + theEight.placeBet + theNine.placeBet + theFour.vig + money.extraVig;
        check.ifEnoughMoney(amt, totalAcrossPointTen);
        if (haveEnough) {
          switch (amt) {
            case 27: theFour.placeIt(5); theFive.placeIt(5); theSix.placeIt(6); theEight.placeIt(6); theNine.placeIt(5); break;
            case 54: theFour.placeIt(10); theFive.placeIt(10); theSix.placeIt(12); theEight.placeIt(12); theNine.placeIt(10); break;
            case 81: theFour.placeIt(15); theFive.placeIt(15); theSix.placeIt(18); theEight.placeIt(18); theNine.placeIt(15); break;
            case 136: theFour.buyIt(25); theFive.placeIt(25); theSix.placeIt(30); theEight.placeIt(30); theNine.placeIt(25); break;
            case 272: theFour.buyIt(50); theFive.placeIt(50); theSix.placeIt(60); theEight.placeIt(60); theNine.placeIt(50); break;
            case 545: theFour.buyIt(100); theFive.placeIt(100); theSix.placeIt(120); theEight.placeIt(120); theNine.placeIt(100); break;
            default: return
          }
        }
        break;
      default: return
    }
    haveEnough && playerAsksFor.across(amt);

  },
  inside: function (amt) {
    switch (thePoint) {
      case 0:
        totalInsideCr = theFive.placeBet + theSix.placeBet + theEight.placeBet + theNine.placeBet;
        check.ifEnoughMoney(amt, totalInsideCr);
        if (haveEnough) {
          switch (amt) {
            case 22: theFive.placeIt(5); theSix.placeIt(6); theEight.placeIt(6); theNine.placeIt(5); break;
            case 44: theFive.placeIt(10); theSix.placeIt(12); theEight.placeIt(12); theNine.placeIt(10); break;
            case 66: theFive.placeIt(15); theSix.placeIt(18); theEight.placeIt(18); theNine.placeIt(15); break;
            case 110: theFive.placeIt(25); theSix.placeIt(30); theEight.placeIt(30); theNine.placeIt(25); break;
            case 220: theFive.placeIt(50); theSix.placeIt(60); theEight.placeIt(60); theNine.placeIt(50); break;
            case 440: theFive.placeIt(100); theSix.placeIt(120); theEight.placeIt(120); theNine.placeIt(100); break;
            default: return
          }
        }
        break;
      case 4:
        totalInsidePointFour = theFive.placeBet + theSix.placeBet + theEight.placeBet + theNine.placeBet;
        check.ifEnoughMoney(amt, totalInsidePointFour);
        if (haveEnough) {
          switch (amt) {
            case 22: theFive.placeIt(5); theSix.placeIt(6); theEight.placeIt(6); theNine.placeIt(5); break;
            case 44: theFive.placeIt(10); theSix.placeIt(12); theEight.placeIt(12); theNine.placeIt(10); break;
            case 66: theFive.placeIt(15); theSix.placeIt(18); theEight.placeIt(18); theNine.placeIt(15); break;
            case 110: theFive.placeIt(25); theSix.placeIt(30); theEight.placeIt(30); theNine.placeIt(25); break;
            case 220: theFive.placeIt(50); theSix.placeIt(60); theEight.placeIt(60); theNine.placeIt(50); break;
            case 440: theFive.placeIt(100); theSix.placeIt(120); theEight.placeIt(120); theNine.placeIt(100); break;
            default: return
          }
        }
        break;
      case 5:
        totalInsidePointFive = theSix.placeBet + theEight.placeBet + theNine.placeBet;
        check.ifEnoughMoney(amt, totalInsidePointFive);
        if (haveEnough) {
          switch (amt) {
            case 17: theSix.placeIt(6); theEight.placeIt(6); theNine.placeIt(5); break;
            case 34: theSix.placeIt(12); theEight.placeIt(12); theNine.placeIt(10); break;
            case 51: theSix.placeIt(18); theEight.placeIt(18); theNine.placeIt(15); break;
            case 85: theSix.placeIt(30); theEight.placeIt(30); theNine.placeIt(25); break;
            case 170: theSix.placeIt(60); theEight.placeIt(60); theNine.placeIt(50); break;
            case 340: theSix.placeIt(120); theEight.placeIt(120); theNine.placeIt(100); break;
            default: return
          }
        }
        break;
      case 6:
        totalInsidePointSix = theFive.placeBet + theEight.placeBet + theNine.placeBet;
        check.ifEnoughMoney(amt, totalInsidePointSix);
        if (haveEnough) {
          switch (amt) {
            case 16: theFive.placeIt(5); theEight.placeIt(6); theNine.placeIt(5); break;
            case 32: theFive.placeIt(10); theEight.placeIt(12); theNine.placeIt(10); break;
            case 48: theFive.placeIt(15); theEight.placeIt(18); theNine.placeIt(15); break;
            case 80: theFive.placeIt(25); theEight.placeIt(30); theNine.placeIt(25); break;
            case 160: theFive.placeIt(50); theEight.placeIt(60); theNine.placeIt(50); break;
            case 320: theFive.placeIt(100); theEight.placeIt(120); theNine.placeIt(100); break;
            default: return
          }
        }
        break;
      case 8:
        totalInsidePointEight = theFive.placeBet + theSix.placeBet + theNine.placeBet;
        check.ifEnoughMoney(amt, totalInsidePointEight);
        if (haveEnough) {
          switch (amt) {
            case 16: theFive.placeIt(5); theSix.placeIt(6); theNine.placeIt(5); break;
            case 32: theFive.placeIt(10); theSix.placeIt(12); theNine.placeIt(10); break;
            case 48: theFive.placeIt(15); theSix.placeIt(18); theNine.placeIt(15); break;
            case 80: theFive.placeIt(25); theSix.placeIt(30); theNine.placeIt(25); break;
            case 160: theFive.placeIt(50); theSix.placeIt(60); theNine.placeIt(50); break;
            case 320: theFive.placeIt(100); theSix.placeIt(120); theNine.placeIt(100); break;
            default: return
          }
        }
        break;
      case 9:
        totalInsidePointNine = theFive.placeBet + theSix.placeBet + theEight.placeBet;
        check.ifEnoughMoney(amt, totalInsidePointNine);
        if (haveEnough) {
          switch (amt) {
            case 17: theFive.placeIt(5); theSix.placeIt(6); theEight.placeIt(6); break;
            case 34: theFive.placeIt(10); theSix.placeIt(12); theEight.placeIt(12); break;
            case 51: theFive.placeIt(15); theSix.placeIt(18); theEight.placeIt(18); break;
            case 85: theFive.placeIt(25); theSix.placeIt(30); theEight.placeIt(30); break;
            case 170: theFive.placeIt(50); theSix.placeIt(60); theEight.placeIt(60); break;
            case 340: theFive.placeIt(100); theSix.placeIt(120); theEight.placeIt(120); break;
            default: return
          }
        }
        break;
      case 10:
        totalInsidePointTen = theFive.placeBet + theSix.placeBet + theEight.placeBet + theNine.placeBet;
        check.ifEnoughMoney(amt, totalInsidePointTen);
        if (haveEnough) {
          switch (amt) {
            case 22: theFive.placeIt(5); theSix.placeIt(6); theEight.placeIt(6); theNine.placeIt(5); break;
            case 44: theFive.placeIt(10); theSix.placeIt(12); theEight.placeIt(12); theNine.placeIt(10); break;
            case 66: theFive.placeIt(15); theSix.placeIt(18); theEight.placeIt(18); theNine.placeIt(15); break;
            case 110: theFive.placeIt(25); theSix.placeIt(30); theEight.placeIt(30); theNine.placeIt(25); break;
            case 220: theFive.placeIt(50); theSix.placeIt(60); theEight.placeIt(60); theNine.placeIt(50); break;
            case 440: theFive.placeIt(100); theSix.placeIt(120); theEight.placeIt(120); theNine.placeIt(100); break;
            default: return
          }
        }
        break;
      default: return
    }
    haveEnough && playerAsksFor.inside(amt);
  },
  outside: function (amt) {
    switch (thePoint) {
      case 0:
        totalOutsideCr = theFour.placeBet + theFive.placeBet + theNine.placeBet + theTen.placeBet + theFour.vig + theTen.vig + money.extraVig;
        check.ifEnoughMoney(amt, totalOutsideCr);
        if (haveEnough) {
          switch (amt) {
            case 20: theFour.placeIt(5); theFive.placeIt(5); theNine.placeIt(5); theTen.placeIt(5); break;
            case 40: theFour.placeIt(10); theFive.placeIt(10); theNine.placeIt(10); theTen.placeIt(10); break;
            case 60: theFour.placeIt(15); theFive.placeIt(15); theNine.placeIt(15); theTen.placeIt(15); break;
            case 102: theFour.buyIt(25); theFive.placeIt(25); theNine.placeIt(25); theTen.buyIt(25); break;
            case 205: theFour.buyIt(50); theFive.placeIt(50); theNine.placeIt(50); theTen.buyIt(50); break;
            case 410: theFour.buyIt(100); theFive.placeIt(100); theNine.placeIt(100); theTen.buyIt(100); break;
            default: return
          }
        }
        break;
      case 4:
        totalOutsidePointFour = theFive.placeBet + theNine.placeBet + theTen.placeBet + theTen.vig + money.extraVig;
        check.ifEnoughMoney(amt, totalOutsidePointFour);
        if (haveEnough) {
          switch (amt) {
            case 15: theFive.placeIt(5); theNine.placeIt(5); theTen.placeIt(5); break;
            case 30: theFive.placeIt(10); theNine.placeIt(10); theTen.placeIt(10); break;
            case 45: theFive.placeIt(15); theNine.placeIt(15); theTen.placeIt(15); break;
            case 76: theFive.placeIt(25); theNine.placeIt(25); theTen.buyIt(25); break;
            case 152: theFive.placeIt(50); theNine.placeIt(50); theTen.buyIt(50); break;
            case 305: theFive.placeIt(100); theNine.placeIt(100); theTen.buyIt(100); break;
            default: return
          }
        }
        break;
      case 5:
        totalOutsidePointFive = theFour.placeBet + theNine.placeBet + theTen.placeBet + theFour.vig + theTen.vig + money.extraVig;
        check.ifEnoughMoney(amt, totalOutsidePointFive);
        if (haveEnough) {
          switch (amt) {
            case 15: theFour.placeIt(5);theNine.placeIt(5); theTen.placeIt(5); break;
            case 30: theFour.placeIt(10);theNine.placeIt(10); theTen.placeIt(10); break;
            case 45: theFour.placeIt(15);theNine.placeIt(15); theTen.placeIt(15); break;
            case 77: theFour.buyIt(25);theNine.placeIt(25); theTen.buyIt(25); break;
            case 155: theFour.buyIt(50);theNine.placeIt(50); theTen.buyIt(50); break;
            case 310: theFour.buyIt(100);theNine.placeIt(100); theTen.buyIt(100); break;
            default: return
          }
        }
        break;
      case 6:
        totalOutsidePointSix = theFour.placeBet + theFive.placeBet + theNine.placeBet + theTen.placeBet + theFour.vig + theTen.vig + money.extraVig;
        check.ifEnoughMoney(amt, totalOutsidePointSix);
        if (haveEnough) {
          switch (amt) {
            case 20: theFour.placeIt(5); theFive.placeIt(5); theNine.placeIt(5); theTen.placeIt(5); break;
            case 40: theFour.placeIt(10); theFive.placeIt(10); theNine.placeIt(10); theTen.placeIt(10); break;
            case 60: theFour.placeIt(15); theFive.placeIt(15); theNine.placeIt(15); theTen.placeIt(15); break;
            case 102: theFour.buyIt(25); theFive.placeIt(25); theNine.placeIt(25); theTen.buyIt(25); break;
            case 205: theFour.buyIt(50); theFive.placeIt(50); theNine.placeIt(50); theTen.buyIt(50); break;
            case 410: theFour.buyIt(100); theFive.placeIt(100); theNine.placeIt(100); theTen.buyIt(100); break;
            default: return
          }
        }
        break;
      case 8:
        totalOutsidePointEight = theFour.placeBet + theFive.placeBet + theNine.placeBet + theTen.placeBet + theFour.vig + theTen.vig + money.extraVig;
        check.ifEnoughMoney(amt, totalOutsidePointEight);
        if (haveEnough) {
          switch (amt) {
            case 20: theFour.placeIt(5); theFive.placeIt(5);theNine.placeIt(5); theTen.placeIt(5); break;
            case 40: theFour.placeIt(10); theFive.placeIt(10);theNine.placeIt(10); theTen.placeIt(10); break;
            case 60: theFour.placeIt(15); theFive.placeIt(15);theNine.placeIt(15); theTen.placeIt(15); break;
            case 102: theFour.buyIt(25); theFive.placeIt(25);theNine.placeIt(25); theTen.buyIt(25); break;
            case 205: theFour.buyIt(50); theFive.placeIt(50);theNine.placeIt(50); theTen.buyIt(50); break;
            case 410: theFour.buyIt(100); theFive.placeIt(100);theNine.placeIt(100); theTen.buyIt(100); break;
            default: return
          }
        }
        break;
      case 9:
        totalOutsidePointNine = theFour.placeBet + theFive.placeBet + theTen.placeBet + theFour.vig + theTen.vig + money.extraVig;
        check.ifEnoughMoney(amt, totalOutsidePointNine);
        if (haveEnough) {
          switch (amt) {
            case 15: theFour.placeIt(5); theFive.placeIt(5); theTen.placeIt(5); break;
            case 30: theFour.placeIt(10); theFive.placeIt(10); theTen.placeIt(10); break;
            case 45: theFour.placeIt(15); theFive.placeIt(15); theTen.placeIt(15); break;
            case 77: theFour.buyIt(25); theFive.placeIt(25); theTen.buyIt(25); break;
            case 155: theFour.buyIt(50); theFive.placeIt(50); theTen.buyIt(50); break;
            case 310: theFour.buyIt(100); theFive.placeIt(100); theTen.buyIt(100); break;
            default: return
          }
        }
        break;
      case 10:
        totalOutsidePointTen = theFour.placeBet + theFive.placeBet + theNine.placeBet + theFour.vig + money.extraVig;
        check.ifEnoughMoney(amt, totalOutsidePointTen);
        if (haveEnough) {
          switch (amt) {
            case 15: theFour.placeIt(5); theFive.placeIt(5); theNine.placeIt(5); break;
            case 30: theFour.placeIt(10); theFive.placeIt(10); theNine.placeIt(10); break;
            case 45: theFour.placeIt(15); theFive.placeIt(15); theNine.placeIt(15); break;
            case 76: theFour.buyIt(25); theFive.placeIt(25); theNine.placeIt(25); break;
            case 152: theFour.buyIt(50); theFive.placeIt(50); theNine.placeIt(50); break;
            case 305: theFour.buyIt(100); theFive.placeIt(100); theNine.placeIt(100); break;
            default: return
          }
        }
        break;
      default: return
    }
    haveEnough && playerAsksFor.outside(amt);

  },
  uptown: function (amt) {
    switch (thePoint) {
      case 0:
        totalUptownCr = theEight.placeBet + theNine.placeBet + theTen.placeBet + theTen.vig + money.extraVig;
        check.ifEnoughMoney(amt, totalUptownCr);
        if (haveEnough) {
          switch (amt) {
            case 16: theEight.placeIt(6); theNine.placeIt(5); theTen.placeIt(5); break;
            case 32: theEight.placeIt(12); theNine.placeIt(10); theTen.placeIt(10); break;
            case 48: theEight.placeIt(18); theNine.placeIt(15); theTen.placeIt(15); break;
            case 81: theEight.placeIt(30); theNine.placeIt(25); theTen.buyIt(25); break;
            case 162: theEight.placeIt(60); theNine.placeIt(50); theTen.buyIt(50); break;
            case 325: theEight.placeIt(120); theNine.placeIt(100); theTen.buyIt(100); break;
            default: return
          }
        }
        break;
      case 4:
        totalUptownCr = theEight.placeBet + theNine.placeBet + theTen.placeBet + theTen.vig + money.extraVig;
        check.ifEnoughMoney(amt, totalUptownCr);
        if (haveEnough) {
          switch (amt) {
            case 16: theEight.placeIt(6); theNine.placeIt(5); theTen.placeIt(5); break;
            case 32: theEight.placeIt(12); theNine.placeIt(10); theTen.placeIt(10); break;
            case 48: theEight.placeIt(18); theNine.placeIt(15); theTen.placeIt(15); break;
            case 81: theEight.placeIt(30); theNine.placeIt(25); theTen.buyIt(25); break;
            case 162: theEight.placeIt(60); theNine.placeIt(50); theTen.buyIt(50); break;
            case 325: theEight.placeIt(120); theNine.placeIt(100); theTen.buyIt(100); break;
            default: return
          }
        }
        break;
      case 5:
        totalUptownCr = theEight.placeBet + theNine.placeBet + theTen.placeBet + theTen.vig + money.extraVig;
        check.ifEnoughMoney(amt, totalUptownCr);
        if (haveEnough) {
          switch (amt) {
            case 16: theEight.placeIt(6); theNine.placeIt(5); theTen.placeIt(5); break;
            case 32: theEight.placeIt(12); theNine.placeIt(10); theTen.placeIt(10); break;
            case 48: theEight.placeIt(18); theNine.placeIt(15); theTen.placeIt(15); break;
            case 81: theEight.placeIt(30); theNine.placeIt(25); theTen.buyIt(25); break;
            case 162: theEight.placeIt(60); theNine.placeIt(50); theTen.buyIt(50); break;
            case 325: theEight.placeIt(120); theNine.placeIt(100); theTen.buyIt(100); break;
            default: return
          }
        }
        break;
      case 6:
        totalUptownCr = theEight.placeBet + theNine.placeBet + theTen.placeBet + theTen.vig + money.extraVig;
        check.ifEnoughMoney(amt, totalUptownCr);
        if (haveEnough) {
          switch (amt) {
            case 16: theEight.placeIt(6); theNine.placeIt(5); theTen.placeIt(5); break;
            case 32: theEight.placeIt(12); theNine.placeIt(10); theTen.placeIt(10); break;
            case 48: theEight.placeIt(18); theNine.placeIt(15); theTen.placeIt(15); break;
            case 81: theEight.placeIt(30); theNine.placeIt(25); theTen.buyIt(25); break;
            case 162: theEight.placeIt(60); theNine.placeIt(50); theTen.buyIt(50); break;
            case 325: theEight.placeIt(120); theNine.placeIt(100); theTen.buyIt(100); break;
            default: return
          }
        }
        break;
      default: return
    }
    haveEnough && playerAsksFor.uptown(amt);

  },
  downtown: function (amt) {
    switch (thePoint) {
      case 0:
        totalDowntownCr = theFour.placeBet + theFive.placeBet + theSix.placeBet + theFour.vig + money.extraVig;
        check.ifEnoughMoney(amt, totalDowntownCr);
        if (haveEnough) {
          switch (amt) {
            case 16: theFour.placeIt(5); theFive.placeIt(5); theSix.placeIt(6); break;
            case 32: theFour.placeIt(10); theFive.placeIt(10); theSix.placeIt(12); break;
            case 48: theFour.placeIt(15); theFive.placeIt(15); theSix.placeIt(18); break;
            case 81: theFour.buyIt(25); theFive.placeIt(25); theSix.placeIt(30); break;
            case 162: theFour.buyIt(50); theFive.placeIt(50); theSix.placeIt(60); break;
            case 325: theFour.buyIt(100); theFive.placeIt(100); theSix.placeIt(120); break;
            default: return
          }
        }
        break;
      case 8:
        totalDowntownCr = theFour.placeBet + theFive.placeBet + theSix.placeBet + theFour.vig + money.extraVig;
        check.ifEnoughMoney(amt, totalDowntownCr);
        if (haveEnough) {
          switch (amt) {
            case 16: theFour.placeIt(5); theFive.placeIt(5); theSix.placeIt(6); break;
            case 32: theFour.placeIt(10); theFive.placeIt(10); theSix.placeIt(12); break;
            case 48: theFour.placeIt(15); theFive.placeIt(15); theSix.placeIt(18); break;
            case 81: theFour.buyIt(25); theFive.placeIt(25); theSix.placeIt(30); break;
            case 162: theFour.buyIt(50); theFive.placeIt(50); theSix.placeIt(60); break;
            case 325: theFour.buyIt(100); theFive.placeIt(100); theSix.placeIt(120); break;
            default: return
          }
        }
        break;
      case 9:
        totalDowntownCr = theFour.placeBet + theFive.placeBet + theSix.placeBet + theFour.vig + money.extraVig;
        check.ifEnoughMoney(amt, totalDowntownCr);
        if (haveEnough) {
          switch (amt) {
            case 16: theFour.placeIt(5); theFive.placeIt(5); theSix.placeIt(6); break;
            case 32: theFour.placeIt(10); theFive.placeIt(10); theSix.placeIt(12); break;
            case 48: theFour.placeIt(15); theFive.placeIt(15); theSix.placeIt(18); break;
            case 81: theFour.buyIt(25); theFive.placeIt(25); theSix.placeIt(30); break;
            case 162: theFour.buyIt(50); theFive.placeIt(50); theSix.placeIt(60); break;
            case 325: theFour.buyIt(100); theFive.placeIt(100); theSix.placeIt(120); break;
            default: return
          }
        }
        break;
      case 10:
        totalDowntownCr = theFour.placeBet + theFive.placeBet + theSix.placeBet + theFour.vig + money.extraVig;
        check.ifEnoughMoney(amt, totalDowntownCr);
        if (haveEnough) {
          switch (amt) {
            case 16: theFour.placeIt(5); theFive.placeIt(5); theSix.placeIt(6); break;
            case 32: theFour.placeIt(10); theFive.placeIt(10); theSix.placeIt(12); break;
            case 48: theFour.placeIt(15); theFive.placeIt(15); theSix.placeIt(18); break;
            case 81: theFour.buyIt(25); theFive.placeIt(25); theSix.placeIt(30); break;
            case 162: theFour.buyIt(50); theFive.placeIt(50); theSix.placeIt(60); break;
            case 325: theFour.buyIt(100); theFive.placeIt(100); theSix.placeIt(120); break;
            default: return
          }
        }
        break;
      default: return
    }
    haveEnough && playerAsksFor.downtown(amt);
  },
  remove: function (betCode) {
    hide.cheques(betCode);
    switch (betCode) {
      case 1:
        if(thePassLine.lineBet != 0) {
          money.inRail += thePassLine.lineBet;
          thePassLine.lineBet = 0;
          hasPassLine = false;
          inform.removePassLine();
        }
        break;
      case 3:
        if(passLineOdds.oddsBet != 0) {
          money.inRail += passLineOdds.oddsBet;
          passLineOdds.oddsBet = 0;
          inform.removeOdds();
        }
        break;
      case 5:
        if(theFour.placeBet != 0 && theFour.hasBuy) {
          money.inRail += theFour.placeBet + theFour.vig + money.extraVig;
          theFour.placeBet = 0; theFour.vig = 0; money.extraVig = 0;
          theFour.hasBuy = false;
          inform.removeBuyFour();
        } else if (theFour.placeBet != 0 && !theFour.hasBuy) {
          money.inRail += theFour.placeBet;
          theFour.placeBet = 0;
          inform.removePlaceFour();
        }
        letsHide(theFour.onButton);
        letsHide(theFour.offButton);
        theFour.hasOffBtn = false;
        letsHide(theFour.buyButton);
        total.fourTenBets == 0 && (aRollHappened = false);
        comeoutRoll ? theFour.onStatus = false : theFour.onStatus = true;
        comeoutRoll ? $(theFour.placeMenuBtn).onclick = function () {show.offMenu(5)} : $(theFour.placeMenuBtn).onclick = function () {show.betMenu(5)};
        break;
      case 6:
        if(theFive.placeBet != 0) {
          money.inRail += theFive.placeBet;
          theFive.placeBet = 0;
          inform.removePlaceFive();
        }
        letsHide(theFive.onButton);
        letsHide(theFive.offButton);
        theFive.onStatus= false;
        theFive.hasOffBtn = false;
        comeoutRoll ? $(theFive.placeMenuBtn).onclick = function () {show.offMenu(6)} : $(theFive.placeMenuBtn).onclick = function () {show.betMenu(6)};
        break;
      case 7:
        if(theSix.placeBet != 0) {
          money.inRail += theSix.placeBet;
          theSix.placeBet = 0;
          inform.removePlaceSix();
        }
        letsHide(theSix.onButton);
        letsHide(theSix.offButton);
        theSix.hasOffBtn = false;
        theSix.onStatus = false;
        comeoutRoll ? $(theSix.placeMenuBtn).onclick = function () {show.offMenu(7)} : $(theSix.placeMenuBtn).onclick = function () {show.betMenu(7)};
        break;
      case 8:
        if(theEight.placeBet != 0) {
          money.inRail += theEight.placeBet;
          theEight.placeBet = 0;
          inform.removePlaceEight();
        }
        letsHide(theEight.onButton);
        letsHide(theEight.offButton);
        theEight.hasOffBtn = false;
        theEight.onStatus = false;
        comeoutRoll ? $(theEight.placeMenuBtn).onclick = function () {show.offMenu(8)} : $(theEight.placeMenuBtn).onclick = function () {show.betMenu(8)};
        break;
      case 9:
        if(theNine.placeBet != 0) {
          money.inRail += theNine.placeBet;
          theNine.placeBet = 0;
          inform.removePlaceNine();
        }
        letsHide(theNine.onButton);
        letsHide(theNine.offButton);
        theNine.hasOffBtn = false;
        theNine.onStatus = false;
        comeoutRoll ? $(theNine.placeMenuBtn).onclick = function () {show.offMenu(9)} : $(theNine.placeMenuBtn).onclick = function () {show.betMenu(9)};
        break;
      case 10:
        if(theTen.placeBet != 0 && theTen.hasBuy) {
          money.inRail += theTen.placeBet + theTen.vig + money.extraVig;
          theTen.placeBet = 0; theTen.vig = 0; money.extraVig = 0;
          theTen.hasBuy = false;
          inform.removeBuyTen();
        } else if (theTen.placeBet != 0 && !theTen.hasBuy) {
          money.inRail += theTen.placeBet;
          theTen.placeBet = 0;
          inform.removePlaceTen();
        }
        letsHide(theTen.onButton);
        letsHide(theTen.offButton);
        theTen.hasOffBtn = false;
        letsHide(theTen.buyButton);
        total.fourTenBets == 0 && (aRollHappened = false);
        comeoutRoll ? theTen.onStatus = false : theTen.onStatus = true;
        comeoutRoll ? $(theTen.placeMenuBtn).onclick = function () {show.offMenu(10)} : $(theTen.placeMenuBtn).onclick = function () {show.betMenu(10)};
        break;
      case 11:
        if(theField.bet != 0) {
          money.inRail += theField.bet;
          theField.bet = 0;
          inform.removeField();
        }
        break;
      default: return
    }
    if (intermediateRoll) {
      for (let i = 0; i < 6; i++) {
        if (i + 5 != betCode) { continue;}
          $(placeMenuBtns[i]).onclick = function () {show.betMenu(i + 5)};
        }
    };
    money.adjustBank();
    hideBetMenu(betCode);
    //testMe.onStates();
  }

}
const playerDoes = {
  sameBet: function (betCode) {
    switch (betCode) {
      case 5:  theFour.sameBetIt(); break;
      case 6: theFive.sameBetIt(); break;
      case 7: theSix.sameBetIt(); break;
      case 8: theEight.sameBetIt(); break;
      case 9: theNine.sameBetIt(); break;
      case 10:  theTen.sameBetIt(); break;
      default: return
    }
    hide.allMenus();
    money.adjustBank();
    playerAsksFor.sameBet();
  },
  sameBetAndDown: function (betCode) {
    this.sameBet(betCode);
    bet.remove(betCode);
    playerAsksFor.sameBetAndDown();
  },
  pressOneUnit: function (betCode) {
    this.sameBet(betCode);
    switch (betCode) {
      case 5:
        nextUnitBet = theFour.placeBet + 5;
        nextUnitBet <= 15 ? theFour.placeIt(nextUnitBet) : theFour.buyIt(nextUnitBet);
        break;
      case 6:
        nextUnitBet = theFive.placeBet + 5;
        theFive.placeIt(nextUnitBet);
        break;
      case 7:
        nextUnitBet = theSix.placeBet + 6;
        theSix.placeIt(nextUnitBet);
        break;
      case 8:
        nextUnitBet = theEight.placeBet + 6;
        theEight.placeIt(nextUnitBet);
        break;
      case 9:
        nextUnitBet = theNine.placeBet + 5;
        theNine.placeIt(nextUnitBet);
        break;
      case 10:
        nextUnitBet = theTen.placeBet + 5;
        nextUnitBet <= 15 ? theTen.placeIt(nextUnitBet) : theTen.buyIt(nextUnitBet);
        break;
      default: return
    }
    this.checkWinnerPress();
    playerAsksFor.oneUnit();
  },
  pressFiveUnits: function (betCode) {
    this.sameBet(betCode);
    switch (betCode) {
      case 5:
        nextUnitBet = theFour.placeBet + 25;
        theFour.buyIt(nextUnitBet);
        break;
      case 6:
        nextUnitBet = theFive.placeBet + 25;
        theFive.placeIt(nextUnitBet);
        break;
      case 7:
        nextUnitBet = theSix.placeBet + 30;
        theSix.placeIt(nextUnitBet);
        break;
      case 8:
        nextUnitBet = theEight.placeBet + 30;
        theEight.placeIt(nextUnitBet);
        break;
      case 9:
        nextUnitBet = theNine.placeBet + 25;
        theNine.placeIt(nextUnitBet);
        break;
      case 10:
        nextUnitBet = theTen.placeBet + 25;
        theTen.buyIt(nextUnitBet);
        break;
      default: return
    }
    this.checkWinnerPress();
    playerAsksFor.fiveUnits();
  },
  pressIt: function (betCode) {
    this.sameBet(betCode);
    switch (betCode) {
      case 5:
        check.maxBet(betCode, theFour.placeBet * 2);
        if (!overMaxBet) {
          theFour.placeBet == 5 ? theFour.placeIt(10) : theFour.buyIt(theFour.placeBet * 2);
          playerAsksFor.press();
        }
        break;
      case 6:
        check.maxBet(betCode, theFive.placeBet * 2);
        if (!overMaxBet) {
          pressedBet = theFive.placeBet * 2;
          theFive.placeIt(pressedBet);
          playerAsksFor.press();
        }
        break;
      case 7:
        check.maxBet(betCode, theSix.placeBet * 2);
        if (!overMaxBet) {
          pressedBet = theSix.placeBet * 2;
          theSix.placeIt(pressedBet);
          playerAsksFor.press();
        }
        break;
      case 8:
        check.maxBet(betCode, theEight.placeBet * 2);
        if (!overMaxBet) {
          pressedBet = theEight.placeBet * 2;
          theEight.placeIt(pressedBet);
          playerAsksFor.press();
        }
        break;
      case 9:
        check.maxBet(betCode, theNine.placeBet * 2);
        if (!overMaxBet) {
          pressedBet = theNine.placeBet * 2;
          theNine.placeIt(pressedBet);
          playerAsksFor.press();
        }
        break;
      case 10:
        check.maxBet(betCode, theTen.placeBet * 2);
        if (!overMaxBet) {
          theTen.placeBet == 5 ? theTen.placeIt(10) : theTen.buyIt(theTen.placeBet * 2);
          playerAsksFor.press();
        }
        break;
      default: return
    }
    hideBetMenu(betCode);
    this.checkWinnerPress();
  },
  fullPress: function (betCode) {
    switch (betCode) {
      case 6:
        totalMoney = theFive.placeBet + theFive.placePymnt;
        leftOverAmt = totalMoney % 5;
        newPlaceAmt = totalMoney - leftOverAmt;
        check.maxBet(betCode, newPlaceAmt);
        if (!overMaxBet) {
          this.sameBet(betCode);
          theFive.placeIt(newPlaceAmt);
          playerAsksFor.fullPress();
        }
        break;
      case 7:
        totalMoney = theSix.placeBet + theSix.placePymnt;
        leftOverAmt = totalMoney % 6;
        newPlaceAmt = totalMoney - leftOverAmt;
        check.maxBet(betCode, newPlaceAmt);
        if (!overMaxBet) {
          this.sameBet(betCode);
          theSix.placeIt(newPlaceAmt);
          playerAsksFor.fullPress();
        }
        break;
      case 8:
        totalMoney = theEight.placeBet + theEight.placePymnt;
        leftOverAmt = totalMoney % 6;
        newPlaceAmt = totalMoney - leftOverAmt;
        check.maxBet(betCode, newPlaceAmt);
        if (!overMaxBet) {
          this.sameBet(betCode);
          theEight.placeIt(newPlaceAmt);
          playerAsksFor.fullPress();
        }
        break;
      case 9:
        totalMoney = theNine.placeBet + theNine.placePymnt;
        leftOverAmt = totalMoney % 5;
        newPlaceAmt = totalMoney - leftOverAmt;
        check.maxBet(betCode, newPlaceAmt);
        if (!overMaxBet) {
          this.sameBet(betCode);
          theNine.placeIt(newPlaceAmt);
          playerAsksFor.fullPress();
        }
        break;
      default: return
    }
    hideBetMenu(betCode);
    this.checkWinnerPress();
    
  },
  doubleUnitPress: function (betCode, amt) {
    switch (betCode) {
      case 5:
        tryFor = amt * 2; 
        juiceNeeded = Math.floor(tryFor / 20);
        amountNeeded = tryFor + juiceNeeded;
        if (amt <= 15) {
          check.ifEnoughMoney(amt * 2, total.fourTenBets);
          check.maxBet(betCode, amt);
          allGood = haveEnough && !overMaxBet;
          if (allGood) {
            theFour.sameBetIt();
            betEach(410, amt);
            playerAsksFor.doubleUnitPress(betCode, amt);
          }
        } else {
          check.ifEnoughMoney(amountNeeded, total.fourTenBets);
          check.maxBet(betCode, amt);
          if (haveEnough && !overMaxBet) {
            theFour.sameBetIt();
            betEach(410, amt);
            playerAsksFor.doubleUnitPress(betCode, amt);
          }
        }
        break;
      case 6:
        existingFiveNineMoney = theFive.placeBet + theNine.placeBet;
        check.ifEnoughMoney(amt * 2, existingFiveNineMoney);
        check.maxBet(betCode, amt);
        allGood = haveEnough && !overMaxBet;
        if (allGood) {
          this.sameBet(betCode);
          theFive.placeIt(amt);
          theNine.placeIt(amt);
          hideBetMenu(betCode);
          playerAsksFor.doubleUnitPress(betCode, amt);
        }
        break;
      case 7:
        existingSixEightMoney = theSix.placeBet + theEight.placeBet;
        check.ifEnoughMoney(amt * 2, existingSixEightMoney);
        check.maxBet(betCode, amt);
        allGood = haveEnough && !overMaxBet;
        if (allGood) {
          this.sameBet(betCode);
          theSix.placeIt(amt);
          theEight.placeIt(amt);
          hideBetMenu(betCode);
          playerAsksFor.doubleUnitPress(betCode, amt);
        }
        break;
      case 8:
        existingSixEightMoney =  theSix.placeBet + theEight.placeBet;
        check.ifEnoughMoney(amt * 2, existingSixEightMoney);
        check.maxBet(betCode, amt);
        allGood = haveEnough && !overMaxBet;
        if (allGood) {
          this.sameBet(betCode);
          theSix.placeIt(amt);
          theEight.placeIt(amt);
          hideBetMenu(betCode);
          playerAsksFor.doubleUnitPress(betCode, amt);
        }
        break;
      case 9:
        existingFiveNineMoney = theFive.placeBet + theNine.placeBet;
        check.ifEnoughMoney(amt * 2, existingFiveNineMoney);
        check.maxBet(betCode, amt);
        allGood = haveEnough && !overMaxBet;
        if (allGood) {
          this.sameBet(betCode);
          theFive.placeIt(amt);
          theNine.placeIt(amt);
          hideBetMenu(betCode);
          playerAsksFor.doubleUnitPress(betCode, amt);
        }
        break;
      case 10:
        tryFor = amt * 2; 
        juiceNeeded = Math.floor(tryFor / 20);
        amountNeeded = tryFor + juiceNeeded;
        if (amt <= 15) {
          check.ifEnoughMoney(amt * 2, total.fourTenBets);
          check.maxBet(betCode, amt);
          allGood = haveEnough && !overMaxBet;
          if (allGood) {
            theTen.sameBetIt();
            betEach(410, amt);
            playerAsksFor.doubleUnitPress(betCode, amt);
          }
        } else {
          check.ifEnoughMoney(amountNeeded, total.fourTenBets);
          check.maxBet(betCode, amt);
          allGood = haveEnough && !overMaxBet;
          if (allGood) {
            theTen.sameBetIt();
            betEach(410, amt);
            playerAsksFor.doubleUnitPress(betCode, amt);
          }
        }
        break;
      default: return
    }
    hideBetMenu(betCode);
    this.checkWinnerPress();
  },
  goTo: function (betCode, amt) {
    switch (betCode) {
      case 5:
        theFour.vigCost = Math.floor(amt / 20);
        totalToBuyFour = amt + theFour.vigCost;
        check.ifEnoughMoney(totalToBuyFour, theFour.betPlusVig);
        check.maxBet(betCode, amt);
        if (haveEnough && !overMaxBet) {
          this.sameBet(betCode);
          amt < 20 ? theFour.placeIt(amt) : theFour.buyIt(amt);
          playerAsksFor.goTo(amt);
        }
        break;
      case 6:
        check.ifEnoughMoney(amt, theFive.placeBet);
        check.maxBet(betCode, amt);
        if (haveEnough && !overMaxBet) {
          theFive.sameBetIt();
          theFive.placeIt(amt);
          playerAsksFor.goTo(amt);
        }
        break;
      case 7:
        check.ifEnoughMoney(amt, theSix.placeBet);
        check.maxBet(betCode, amt);
        if (haveEnough && !overMaxBet) {
          theSix.sameBetIt();
          theSix.placeIt(amt);
          playerAsksFor.goTo(amt);
        }
        break;
      case 8:
        check.ifEnoughMoney(amt, theEight.placeBet);
        check.maxBet(betCode, amt);
        if (haveEnough && !overMaxBet) {
          theEight.sameBetIt();
          theEight.placeIt(amt);
          playerAsksFor.goTo(amt);
        }
        break;
      case 9:
        check.ifEnoughMoney(amt, theNine.placeBet);
        check.maxBet(betCode, amt);
        if (haveEnough && !overMaxBet) {
          theNine.sameBetIt();
          theNine.placeIt(amt);
          playerAsksFor.goTo(amt);
        }
        break;
      case 10:
        theTen.vig = Math.floor(amt / 20);
        totalBuyTenCost = amt + theTen.vig;
        check.ifEnoughMoney(totalBuyTenCost, theTen.betPlusVig);
        check.maxBet(betCode, amt);
        if (haveEnough && !overMaxBet) {
          this.sameBet(betCode);
          amt < 20 ? theTen.placeIt(amt) : theTen.buyIt(amt);
          playerAsksFor.goTo(amt);
        }
        break;
      default: return
    }
    this.checkWinnerPress();
  },
  checkWinnerPress: function () {
    if (pointWasJustMade) {
      thePlaceBets.areOff();
    }
  }
}
const sixNumbers = {
  betMenus: ['place_four_bet_menu', 'place_five_bet_menu', 'place_six_bet_menu', 'place_eight_bet_menu', 'place_nine_bet_menu', 'place_ten_bet_menu'],
  spreadMenus: ['place_four_spread_menu', 'place_five_spread_menu', 'place_six_spread_menu', 'place_eight_spread_menu', 'place_nine_spread_menu', 'place_ten_spread_menu'],
}

// Culminations
const total = {
  get passLine () {
    return thePassLine.lineBet + thePassLine.linePayment;
  },
  get passLineOdds () {
    return passLineOdds.oddsBet + passLineOdds.oddsPayment;
  },
  get placeBets () {
    return theFour.placeBet + theFour.vig + theFive.placeBet + theSix.placeBet + theEight.placeBet + theNine.placeBet + theTen.placeBet + theTen.vig + money.extraVig;
  },
  get fourTenBets () {
    return theFour.placeBet + theFour.vig + theTen.placeBet + theTen.vig + money.extraVig;
  },
  get fieldMoney () {
    return theField.bet + theField.payment + theField.doublePayment
  }
}
const theSixEight = {
  placeUnit: 6,
  OddsUnit: 5,
  largeUnit: 30,
  get singleUnit () {
    return thePassLine.totalUnits * this.OddsUnit;
  },
  get doubleUnit () {
    return thePassLine.totalUnits * 2 * this.OddsUnit;
  },
  get tripleUnit () {
    return thePassLine.totalUnits * 3 * this.OddsUnit;
  },
  get quadUnit () {
    return thePassLine.totalUnits * 4 * this.OddsUnit;
  }
}
const theFiveNine = {
  placeUnit: 5,
  OddsUnit: 2,
  largeUnit: 25,
  get unitOddsBet () {
    return thePassLine.totalUnits * 5;
  },
  get singleUnit () {
    if (this.unitOddsBet % 2 == 1) {
    return this.unitOddsBet + 1;
    } else {
      return this.unitOddsBet;
    }
  }, 
  get doubleUnit () {
    return this.unitOddsBet * 2;
  }, 
  get tripleUnit () {
    if (this.unitOddsBet % 2 == 1) {
      return this.unitOddsBet * 3 + 1;
      } else {
        return this.unitOddsBet * 3;
      }
  },
  get quadUnit () {
        return this.unitOddsBet * 4;
  }
}
const theFourTen = {
  placeUnit: 5,
  OddsUnit: 1,
  largeUnit: 25,
  get singleUnit () {
    return thePassLine.totalUnits * 5;
  },
  get doubleUnit () {
    return thePassLine.totalUnits * 2 * 5;
  },
  get tripleUnit () {
    return thePassLine.totalUnits * 3 * 5;
  }
}

// Actions
const check = {
  forBroke: function () {
    if (money.bankRoll < limit.tableMin) {
      brokeAsAJoke = true;
    }
  },
  ifEnoughMoney: function (amt, existingBet) {
    haveEnough = amt <= (existingBet + money.inRail + money.inPlaceLimbo);
    if (!haveEnough) {
      alert.notEnoughMoney();
      money.bankPlaceLimbo();
    } else {
      alert.remove();
    };
    hide.allMenus();
  },
  minBet: function (betCode, amt) {
    switch (betCode) {
      case 1:
        underMinBet = amt < limit.tableMin;
        if (underMinBet) {
          alert.passLineMin();
        }
        break;
      case 3: 
        if (thePoint == 5 || thePoint == 9) {
          underMinOdds = amt < 2;
        } else if (thePoint == 6 || thePoint == 8) {
          underMinOdds = amt < 5;
        }
        if (underMinOdds) {
          switch (thePoint) {
            case 6: case 8: alert.sixEightMinOdds(); break;
            case 5: case 9: alert.fiveNineMinOdds(); break;
            default: return
          }
        } else {
          underMinOdds = false;
        }
        break;
      case 5:
        underMinBet = amt < limit.placeOutsideMin;
        if (underMinBet) {
          alert.placeFourMin();
          money.bankPlaceLimbo();
        }
        break;
      case 6:
        underMinBet = amt < limit.placeOutsideMin;
        if (underMinBet) {
          alert.placeFiveMin();
          money.bankPlaceLimbo();
        }
        break;
      case 7:
        underMinBet = amt < limit.placeSixEightMin;
        if (underMinBet) {
          alert.placeSixMin();
          money.bankPlaceLimbo();
        }
        break;
      case 8:
        underMinBet = amt < limit.placeSixEightMin;
        if (underMinBet) {
          alert.placeEightMin();
          money.bankPlaceLimbo();
        }
        break;
      case 9:
        underMinBet = amt < limit.placeOutsideMin;
        if (underMinBet) {
          alert.placeNineMin();
          money.bankPlaceLimbo();
        }
        break;
      case 10:
        underMinBet = amt < limit.placeOutsideMin;
        if (underMinBet) {
          alert.placeTenMin();
          money.bankPlaceLimbo();
        }
        break;
      case 11:
        underMinBet = amt < limit.tableMin;
        underMinBet && alert.fieldMin();
        break;
      default: return
    }
    hide.allMenus();
  },
  maxBet: function (betCode, amt) {
    switch (betCode) {
      case 1:
        overMaxBet = amt > limit.tableMax;
        if(overMaxBet) {
          alert.passLineMax();
        }
        break;
      case 3: 
        passLineOdds.setOddsType(limit.oddsType);
        overMaxOdds = amt > limit.maxOdds;
        if (overMaxOdds) {
          switch (thePoint) {
            case 6: 
            case 8: 
              alert.sixEightMaxOdds();
              break;
            case 5:
            case 9:
              alert.fiveNineMaxOdds();
              break;
            case 4:
            case 10:
              alert.fourTenMaxOdds();
              break;
            default: return
          }
        }
        break;
      case 5:
        overMaxBet = amt > limit.placeOutsideMax;
        if(overMaxBet) {
          alert.placeFourMax();
          money.bankPlaceLimbo();
        }
        break;
      case 6:
        overMaxBet = amt > limit.placeOutsideMax;
        if(overMaxBet) {
          alert.placeFiveMax();
          money.bankPlaceLimbo();
        }
        break;
      case 7:
        overMaxBet = amt > limit.placeSixEightMax;
        if(overMaxBet) {
          alert.placeSixMax();
          money.bankPlaceLimbo();
        }
        break;
      case 8:
        overMaxBet = amt > limit.placeSixEightMax;
        if(overMaxBet) {
          alert.placeEightMax();
          money.bankPlaceLimbo();
        }
        break;
      case 9:
        overMaxBet = amt > limit.placeOutsideMax;
        if(overMaxBet) {
          alert.placeNineMax();
          money.bankPlaceLimbo();
        }
        break;
      case 10:
        overMaxBet = amt > limit.placeOutsideMax;
        if(overMaxBet) {
          alert.placeTenMax();
          money.bankPlaceLimbo();
        }
        break;
      case 11:
        overMaxBet = amt > limit.tableMax;
        if (overMaxBet) {
          alert.fieldMax();
        }
        break;
      default: return
    }
    hide.allMenus();
  },
  properPlace: function (betCode, amt) {
    switch (betCode) {
      case 5: case 6: case 9: case 10:
        properPlaceOutside = (amt % 5 == 0);
        if (!properPlaceOutside) {
          alert.placeProperFiveNine();
          money.bankPlaceLimbo();
        }
        break;
      case 7: case 8:
        properPlaceSixEight = (amt % 6 == 0);
        if (!properPlaceSixEight){
          alert.placeProperSixEight();
          money.bankPlaceLimbo();
        }
        break;
      default: return
    }
  },
  forWorkingPlaceBet: function () {
    placeNumRolled = thePoints.includes(rollTotal);
    yoRolled = rollTotal == 11;
    sevenRolled = rollTotal == 7;
    if (crapRolled || yoRolled) {
      return
    } else if (sevenRolled) {
      theFour.onStatus && theFour.takeIt();
      theFive.onStatus && theFive.takeIt();
      theSix.onStatus && theSix.takeIt();
      theEight.onStatus && theEight.takeIt();
      theNine.onStatus && theNine.takeIt();
      theTen.onStatus && theTen.takeIt();
    } else {
      switch (rollTotal) {
        case 4: theFour.onStatus && theFour.payIt(); break;
        case 5: theFive.onStatus && theFive.payIt(); break;
        case 6: theSix.onStatus && theSix.payIt(); break;
        case 8: theEight.onStatus && theEight.payIt(); break;
        case 9: theNine.onStatus && theNine.payIt(); break;
        case 10: theTen.onStatus && theTen.payIt(); break;
        default: return
      }
    }
  },
  forExtraVig: function (betCode) {
    switch (betCode) {
      case 5: 
        if (!theTen.hasBuy) {
          return
        } else {
          totalFourTen = theFour.placeBet + theTen.placeBet;
          correctVigCharge = Math.floor(totalFourTen / 20);
          currentVigCharge = theFour.vig + theTen.vig;
          money.extraVig = correctVigCharge - currentVigCharge;
          money.inRail -= money.extraVig;
        }
        break;
      case 10: 
        if (!theFour.hasBuy) {
          return
        } else {
          totalFourTen = theFour.placeBet + theTen.placeBet;
          correctVigCharge = Math.floor(totalFourTen / 20);
          currentVigCharge = theFour.vig + theTen.vig;
          money.extraVig = correctVigCharge - currentVigCharge;
          money.inRail -= money.extraVig;
        }
        break;
      default: return
    }
  },
  forDoubleDip: function () {
    switch (thePoint) {
      case 4 : if (theFour.placeBet > 0 && theFour.onStatus) {doubleDipWinner = true;} else {doubleDipWinner = false} break;
      case 5 : if (theFive.placeBet > 0 && theFive.onStatus) {doubleDipWinner = true;} else {doubleDipWinner = false} break;
      case 6 : if (theSix.placeBet > 0 && theSix.onStatus) {doubleDipWinner = true;} else {doubleDipWinner = false} break;
      case 8 : if (theEight.placeBet > 0 && theEight.onStatus) {doubleDipWinner = true;} else {doubleDipWinner = false} break;
      case 9 : if (theNine.placeBet > 0 && theNine.onStatus) {doubleDipWinner = true;} else {doubleDipWinner = false} break;
      case 10 : if (theTen.placeBet > 0 && theTen.onStatus) {doubleDipWinner = true;} else {doubleDipWinner = false} break;
      default: return
    }
  }
}
const count = {
  totalRolls: 0,
  totalPoints: 0,
  twos: 0,
  threes: 0,
  fours: 0,
  fives: 0,
  sixes: 0,
  sevens: 0,
  eights: 0,
  nines: 0,
  tens: 0,
  elevens: 0,
  twelves: 0,
  crCraps: 0,
  crWinners: 0,
  irCraps: 0,
  irBoxes: 0,
  previousRolls: [],
}
const reset = {
  headerInfo: function () {
    thePoint = 0;
    $('the_point').innerHTML = "&#8211";
    count.previousRolls.length = 0;
    $('the_previous_rolls').innerHTML = "&nbsp;";
  },
  diceAndBtns: function () {
    $<HTMLInputElement>('die_one').src = imageDieSW;
    $<HTMLInputElement>('die_two').src = imageDieNE;
    $('button_one').innerHTML = 'Start Roll';
    $('button_one').onclick = shootDice;
  },
  counters: function () {
    count.totalPoints = 0; count.totalRolls = 0; count.irBoxes = 0; count.crCraps = 0; count.irCraps = 0; count.crWinners = 0; 
    count.twos = 0; count.threes = 0; count.fours = 0; count.fives = 0; count.sixes = 0; count.sevens = 0; count.eights = 0; count.nines = 0; count.tens = 0; count.elevens = 0; count.twelves = 0;
    $('total_points').innerHTML = "0";
    $('roll_count').innerHTML = '0';
    $('box_count').innerHTML = '0';
    $('twosCounter').innerHTML = '0';
    $('threesCounter').innerHTML = '0';
    $('foursCounter').innerHTML = '0';
    $('fivesCounter').innerHTML = '0';
    $('sixesCounter').innerHTML = '0';
    $('sevensCounter').innerHTML = '0';
    $('eightsCounter').innerHTML = '0';
    $('ninesCounter').innerHTML = '0';
    $('tensCounter').innerHTML = '0';
    $('elevensCounter').innerHTML = '0';
    $('twelvesCounter').innerHTML = '0';
  }
}
const disable = {
  rollButtons: function () {
    (<HTMLInputElement> $("button_one")).disabled = true;
    (<HTMLInputElement> $("button_two")).disabled = true;
    (<HTMLInputElement> $("button_three")).disabled = true;
    (<HTMLInputElement> $("button_four")).disabled = true;
    /*$('button_one').disabled = true;
    $('button_two').disabled = true;
    $('button_three').disabled = true;
    $('button_four').disabled = true;*/
  },
  placeBetMenus: function () {
    $(theFour.placeMenuBtn).style.pointerEvents = 'none';
    $(theFour.placeMenuBtn).style.pointerEvents = 'none';
    $(theFive.placeMenuBtn).style.pointerEvents = 'none';
    $(theSix.placeMenuBtn).style.pointerEvents = 'none';
    $(theEight.placeMenuBtn).style.pointerEvents = 'none';
    $(theNine.placeMenuBtn).style.pointerEvents = 'none';
    $(theTen.placeMenuBtn).style.pointerEvents = 'none';
  },
  allButtons: function () {
    this.rollButtons(); this.placeBetMenus();
  }
}
const enable = {
  rollButtons: function () {
    (<HTMLInputElement> $("button_one")).disabled = false;
    (<HTMLInputElement> $("button_two")).disabled = false;
    (<HTMLInputElement> $("button_three")).disabled = false;
    (<HTMLInputElement> $("button_four")).disabled = false;
    /*$('button_one').disabled = false;
    $('button_two').disabled = false;
    $('button_three').disabled = false;
    $('button_four').disabled = false;*/
  },
  placeBetMenus: function () {
    $(theTen.placeMenuBtn).style.pointerEvents = 'auto';
    $(theFour.placeMenuBtn).style.pointerEvents = 'auto';
    $(theFive.placeMenuBtn).style.pointerEvents = 'auto';
    $(theSix.placeMenuBtn).style.pointerEvents = 'auto';
    $(theEight.placeMenuBtn).style.pointerEvents = 'auto';
    $(theNine.placeMenuBtn).style.pointerEvents = 'auto';
  }, 
  allButtons: function () {
    this.rollButtons(); this.placeBetMenus();
  }
}
const alert = {
changeState: function () {
  $('guide_calls').style.color = "rgb(248, 79, 49, 97)"; 
  $('alert_to_do').style.border = "1px solid rgb(248, 79, 49, 97)";
},
noMoreMoney: function () {this.changeState(); $('guide_calls').innerHTML = "You don't have any more money.";},
removePassLine: function () {this.changeState(); $('guide_calls').innerHTML = "You still need a Pass Line bet to shoot the dice.";},
needPassLine: function () {this.changeState(); $('guide_calls').innerHTML = "Please place a bet on the Pass Line in order to shoot the dice.";},
notEnoughMoney: function () {this.changeState(); $('guide_calls').innerHTML = "You don't have enough money for that bet.";},
passLineMin: function () {this.changeState(); $('guide_calls').innerHTML = "Sorry, but the minimum on the Pass Line is $" + limit.tableMin + ".";},
passLineMax: function () {this.changeState(); $('guide_calls').innerHTML = "I know you're excited, but we got limits here. Max bet on the Pass Line is $" + limit.tableMax + ". Try again.";},
sixEightMinOdds: function () {this.changeState(); $('guide_calls').innerHTML = "The min Odds bet on the 6 & 8 is $5.";},
sixEightMaxOdds: function () {this.changeState(); $('guide_calls').innerHTML = "Max odds on the 6 & 8 are 5x your bet or $" + limit.maxOdds + ". Try double dipping instead.";},
fiveNineMinOdds: function () {this.changeState(); $('guide_calls').innerHTML = "The min Odds bet on the 5 & 9 is $2";},
fiveNineMaxOdds: function () {this.changeState(); $('guide_calls').innerHTML = "Max odds on the 5 & 9 are 4x your bet or $" + limit.maxOdds + ". Try double dipping instread.";},
fourTenMaxOdds: function () {this.changeState(); $('guide_calls').innerHTML = "Max odds on the 4 & 10 are 3x your bet or $" + limit.maxOdds + ". Try double dipping instread.";},
unevenOdds: function (amt) {
  this.changeState();
  let thePaymentAmount = Math.floor((amt / 2) * 3);
  let theTruePayment = (amt / 2) * 3;
  fixedTruePayment = + (theTruePayment.toFixed(2));
  $('guide_calls').innerHTML = "Uneven odds will cost you 50 cents when the Point is 5 or 9. Your Odds pay $" + fixedTruePayment + ", but your payment will be rounded down to $" + thePaymentAmount + ".";
},
improperOdds: function (amt) {
  this.changeState();
  let totalUnits = Math.floor(amt / 5);
  let correctBetPymt = totalUnits * 6; let improperAmount = amt % 5;
  let thePaymentAmount = correctBetPymt + improperAmount;
  $('guide_calls').innerHTML = "You should bet Odds in multiples of 5. Every dollar above a multiple of five will get paid even money. Your Odds pay $" + thePaymentAmount + ".";
},
placeProperFiveNine: function () {this.changeState(); $('guide_calls').innerHTML = "You must bet Place bets on the 4, 5, 9, or 10 in increments of $5.";},
placeProperSixEight: function () {this.changeState(); $('guide_calls').innerHTML = "You must bet Place bets on the 6 or 8 in increments of $6.";},
buyFourMin: function () {this.changeState(); $('guide_calls').innerHTML = "The minimum buy on the Four is $20 for $1 commission.";},
placeFourMin: function () {this.changeState(); $('guide_calls').innerHTML = "The minimum Place bet on the Four is $" + limit.placeOutsideMin + ".";},
placeFourMax: function () {this.changeState(); $('guide_calls').innerHTML = "I know you're excited, but we got limits here. Max bet on the Four is $" + limit.placeOutsideMax + ". Try again.";},
placeFiveMin: function () {this.changeState(); $('guide_calls').innerHTML = "The minimum Place bet on the Five is $" + limit.placeOutsideMin + ".";},
placeFiveMax: function () {this.changeState(); $('guide_calls').innerHTML = "I know you're excited, but we got limits here. Max bet on the Five is $" + limit.placeOutsideMax + ". Try again.";},
placeSixMin: function () {this.changeState(); $('guide_calls').innerHTML = "The minimum Place bet on the Six is $" + limit.placeSixEightMin + ".";},
placeSixMax: function () {this.changeState(); $('guide_calls').innerHTML = "I know you're excited, but we got limits here. Max bet on the Six is $" + limit.placeSixEightMax + ". Try again.";},
placeEightMin: function () {this.changeState(); $('guide_calls').innerHTML = "The minimum Place bet on the Eight is $" + limit.placeSixEightMin + ".";},
placeEightMax: function () {this.changeState(); $('guide_calls').innerHTML = "I know you're excited, but we got limits here. Max bet on the Eight is $" + limit.placeSixEightMax + ". Try again.";},
placeNineMin: function () {this.changeState(); $('guide_calls').innerHTML = "The minimum Place bet on the Nine is $" + limit.placeOutsideMin + ".";},
placeNineMax: function () {this.changeState(); $('guide_calls').innerHTML = "I know you're excited, but we got limits here. Max bet on the Nine is $" + limit.placeOutsideMax + ". Try again.";},
buyTenMin: function () {this.changeState(); $('guide_calls').innerHTML = "The minimum buy on the Ten is $20 for $1 commission.";},
placeTenMin: function () {this.changeState(); $('guide_calls').innerHTML = "The minimum Place bet on the Ten is $" + limit.placeOutsideMin + ".";},
placeTenMax: function () {this.changeState(); $('guide_calls').innerHTML = "I know you're excited, but we got limits here. Max bet on the Ten is $" + limit.placeOutsideMax + ". Try again.";},
fieldMin: function () {this.changeState(); $('guide_calls').innerHTML = "The minimum in the Field is $" + limit.tableMin + ". Try again.";},
fieldMax: function () {this.changeState(); $('guide_calls').innerHTML = "Table max in the Field is $" + limit.tableMax + ". Try again.";},
overInField: function () {this.changeState(); $('guide_calls').innerHTML = "You are over over the max bet in the Field, please pick up your money.";},
gaveMaxInstead: function () {this.changeState(); $('guide_calls').innerHTML = "That's a little too much. We gave you the max instead.";},
remove: function () {
  $('alert_to_do').style.border = "none";
  if (!comeoutRoll) {
    thePoint == 8 ? $('guide_calls').innerHTML = "Roll an " + thePoint + " to win." : $('guide_calls').innerHTML = "Roll a " + thePoint + " to win.";
  } else {
    hasPassLine ? $('guide_calls').innerHTML = "You're good to shoot the dice." : $('guide_calls').innerHTML = "You need a Pass Line bet to shoot the dice.";
  }
  darkMode ? $('guide_calls').style.color = "#EEEEEE" : $('guide_calls').style.color = "#282829";
}
}
const notify = {
changeState: function () {
  $('guide_calls').style.color = "rgb(0, 158, 86, 62)";
  $('alert_to_do').style.border = "2px solid rgb(0, 158, 86, 62)";
},
crWinner: function () {this.changeState(); $('guide_calls').innerHTML = "You won on the Pass Line! Grab your money and shoot again.";},
pointWinner: function () {this.changeState(); $('guide_calls').innerHTML = "You made your Point! Grab your money cause' you need to establish another Point.";},
}
const inform = {
  changeState: function () {
    $('alert_to_do').style.border = "1px solid rgb(8, 142, 158, 62)";
    $('guide_calls').style.color = "rgb(8, 142, 158, 62)";
  }, 
  oddsAvailable: function () {
    switch (thePoint) {
      case 4: $('guide_calls').innerHTML = "You can now add the Odds bet. Minimum Odds are $1 on the 4 and 10. You need a 4 to win the Pass Line and Odds."; break;
      case 5: $('guide_calls').innerHTML = "You can now add the Odds bet. Minimum Odds are $2 on the 5 and 9. You need a 5 to win the Pass Line and Odds."; break;
      case 6: $('guide_calls').innerHTML = "You can now add the Odds bet. Minimum Odds are $5 on the 6 and 8. You need a 6 to win the Pass Line and Odds."; break;
      case 8: $('guide_calls').innerHTML = "You can now add the Odds bet. Minimum Odds are $5 on the 6 and 8. You need an 8 to win the Pass Line and Odds."; break;
      case 9: $('guide_calls').innerHTML = "You can now add the Odds bet. Minimum Odds are $2 on the 5 and 9. You need a 9 to win the Pass Line and Odds."; break;
      case 10: $('guide_calls').innerHTML = "You can now add the Odds bet. Minimum Odds are $1 on the 4 and 10. You need a 10 to win the Pass Line and Odds."; break;
      default: return;}
  },
  allBetsDown: function () {this.changeState(); $('guide_calls').innerHTML = "You're down on all your Place bets.";},
  allIn: function () {this.changeState(); $('guide_calls').innerHTML = "All in! Good luck.";},
  betMaxPassLine: function () {this.changeState(); $('guide_calls').innerHTML = "Table max on the Pass Line!";},
  betMaxPlaceFour: function () {this.changeState(); $('guide_calls').innerHTML = "Max bet on the Four!";},
  betMaxPlaceFive: function () {this.changeState(); $('guide_calls').innerHTML = "Max bet on the Five!";},
  betMaxPlaceSix: function () {this.changeState(); $('guide_calls').innerHTML = "Max bet on the Six!";},
  betMaxPlaceEight: function () {this.changeState(); $('guide_calls').innerHTML = "Max bet on the Eight!";},
  betMaxPlaceNine: function () {this.changeState(); $('guide_calls').innerHTML = "Max bet on the Nine!";},
  betMaxPlaceTen: function () {this.changeState(); $('guide_calls').innerHTML = "Max bet on the Ten!";},
  betMaxField: function () {this.changeState(); $('guide_calls').innerHTML = "Table max in the Field!";},
  removePassLine: function () {this.changeState(); $('guide_calls').innerHTML = "You picked up your Pass Line bet.";},
  removeOdds: function () {this.changeState(); $('guide_calls').innerHTML = "You picked up your Odds.";},
  removeBuyFour: function () {this.changeState(); $('guide_calls').innerHTML = "Your Buy is down on the Four.";},
  removePlaceFour: function () {this.changeState(); $('guide_calls').innerHTML = "You're down on the Four.";},
  removePlaceFive: function () {this.changeState(); $('guide_calls').innerHTML = "You're down on the Five.";},
  removePlaceSix: function () {this.changeState(); $('guide_calls').innerHTML = "You're down on the Six.";},
  removePlaceEight: function () {this.changeState(); $('guide_calls').innerHTML = "You're down on the Eight.";},
  removePlaceNine: function () {this.changeState(); $('guide_calls').innerHTML = "You're down on the Nine.";},
  removePlaceTen: function () {this.changeState(); $('guide_calls').innerHTML = "You're down on the Ten.";},
  removeBuyTen: function () {this.changeState(); $('guide_calls').innerHTML = "Your Buy is down on the Ten.";},
  removeAllPlaceBets: function () {this.changeState(); $('guide_calls').innerHTML = "All your Place bets are down.";},
  removeField: function () {this.changeState(); $('guide_calls').innerHTML = "You picked up your Field Bet.";},
  turnOnAllPlace: function () {this.changeState(); $('guide_calls').innerHTML = "Your Place bets have been turned ON.";},
  turnOnPlaceFour: function () {this.changeState(); $('guide_calls').innerHTML = "Your Place Four is ON.";},
  turnOnBuyFour: function () {this.changeState(); $('guide_calls').innerHTML = "Your Buy Four is ON.";},
  turnOnPlaceFive: function () {this.changeState(); $('guide_calls').innerHTML = "Your Place Five is ON.";},
  turnOnPlaceSix: function () {this.changeState(); $('guide_calls').innerHTML = "Your Place Six is ON.";},
  turnOnPlaceEight: function () {this.changeState(); $('guide_calls').innerHTML = "Your Place Eight is ON.";},
  turnOnPlaceNine: function () {this.changeState(); $('guide_calls').innerHTML = "Your Place Nine is ON.";},
  turnOnPlaceTen: function () {this.changeState(); $('guide_calls').innerHTML = "Your Place Ten is ON.";},
  turnOnBuyTen: function () {this.changeState(); $('guide_calls').innerHTML = "Your Buy Ten is ON.";},
  turnOffAllPlace: function () {this.changeState(); $('guide_calls').innerHTML = "Your Place bets have been turned OFF. Bets are OFF until you turn them back ON.";},
  turnOffPlaceFour: function () {this.changeState(); $('guide_calls').innerHTML = "Your Place 4 is OFF. It is OFF until you turn it back ON.";},
  turnOffBuyFour: function () {this.changeState(); $('guide_calls').innerHTML = "Your Buy 4 is OFF. It is OFF until you turn it back ON.";},
  turnOffPlaceFive: function () {this.changeState(); $('guide_calls').innerHTML = "Your Place 5 is OFF. It is OFF until you turn it back ON.";},
  turnOffPlaceSix: function () {this.changeState(); $('guide_calls').innerHTML = "Your Place 6 is OFF. It is OFF until you turn it back ON.";},
  turnOffPlaceEight: function () {this.changeState(); $('guide_calls').innerHTML = "Your Place 8 is OFF. It is OFF until you turn it back ON.";},
  turnOffPlaceNine: function () {this.changeState(); $('guide_calls').innerHTML = "Your Place 9 is OFF. It is OFF until you turn it back ON.";},
  turnOffPlaceTen: function () {this.changeState(); $('guide_calls').innerHTML = "Your Place 10 is OFF. It is OFF until you turn it back ON.";},
  turnOffBuyTen: function () {this.changeState(); $('guide_calls').innerHTML = "Your Buy 10 is OFF. It is OFF until you turn it back ON.";},
  betMaxOdds: function (amt) {
    this.changeState();
    switch (thePoint) {
      case 6: case 8: 
        let totalUnits = Math.floor(amt / 5); 
        let correctBetPymt = totalUnits * 6; let improperAmount = amt % 5; 
        thePaymentAmount = correctBetPymt + improperAmount;
        break;
        case 5: case 9: 
        thePaymentAmount = Math.floor((amt / 2) * 3);
        break;
        case 4: case 10: 
        thePaymentAmount = amt * 2;
        break;
        default: return
      }
      $('guide_calls').innerHTML = "Max Odds play! With 3x4x5x Odds, the total payment of your Pass Line \& Odds will always be 7x your Pass Line bet or $" + (7 * thePassLine.lineBet) + ".";
  },
  passLineOdds: function (amt) {
    this.changeState();
    switch (thePoint) {
      case 6: case 8: 
        let totalUnits = Math.floor(amt / 5); 
        let correctBetPymt = totalUnits * 6; let improperAmount = amt % 5; 
        thePaymentAmount = correctBetPymt + improperAmount;
        $('guide_calls').innerHTML = "$" + amt + " Odds play. They pay 6:5 and will win $" + thePaymentAmount + " if you roll the Point."
        break;
        case 5: case 9: 
        thePaymentAmount = Math.floor((amt / 2) * 3);
        $('guide_calls').innerHTML = "$" + amt + " Odds play. They pay 3:2 and will win $" + thePaymentAmount + " if you roll the Point."
        break;
        case 4: case 10: 
        thePaymentAmount = amt * 2;
        $('guide_calls').innerHTML = "$" + amt + " Odds play. They pay 2:1 and will win $" + thePaymentAmount + " if you roll the Point."
        break;
      default: return
    }
  },
  
}
const playerAsksFor = {
  changeState: function () {
    $('alert_to_do').style.border = "1px solid rgb(158, 114, 24, 62)";
    $('guide_calls').style.color = "rgb(158, 114, 24, 62)";
  }, 
  acrossIncluding: function (amt) {
    this.changeState();
    comeoutRoll ? $('guide_calls').innerHTML = "$" + amt + " Across, working on the Comeout Roll." : $('guide_calls').innerHTML = "$" + amt + " Across, including the Point.";
  },
  
  across: function (amt) {
    this.changeState();
    comeoutRoll ? $('guide_calls').innerHTML = "$" + amt + " Across, working on the Comeout Roll." : $('guide_calls').innerHTML = "$" + amt + " Across.";
  },
  inside: function (amt) {
    this.changeState();
    comeoutRoll ? $('guide_calls').innerHTML = "$" + amt + " Inside, working on the Comeout Roll." : $('guide_calls').innerHTML = "$" + amt + " Inside.";
  },
  outside: function (amt) {
    this.changeState();
    comeoutRoll ? $('guide_calls').innerHTML = "$" + amt + " Outside, working on the Comeout Roll." : $('guide_calls').innerHTML = "$" + amt + " Outside.";
  },
  uptown: function (amt) {
    this.changeState();
    comeoutRoll ? $('guide_calls').innerHTML = "$" + amt + " Uptown, working on the Comeout Roll." : $('guide_calls').innerHTML = "$" + amt + " Uptown.";
  },
  downtown: function (amt) {
    this.changeState();
    comeoutRoll ? $('guide_calls').innerHTML = "$" + amt + " Downtown, working on the Comeout Roll." : $('guide_calls').innerHTML = "$" + amt + " Downtown.";
  },
  placeEachSixEight: function (amt) {
    this.changeState();
    comeoutRoll ? $('guide_calls').innerHTML = "Place $" + amt + " each 6 \& 8, working on the Comeout Roll." : $('guide_calls').innerHTML = "Place $" + amt + " each 6 \& 8."
  },
  placeEachFiveNine: function (amt) {
    this.changeState();
    comeoutRoll ? $('guide_calls').innerHTML = "Place $" + amt + " each 5 \& 9, working on the Comeout Roll." : $('guide_calls').innerHTML = "Place $" + amt + " each 5 \& 9."
  },
  placeEachFourTen: function (amt) {
    this.changeState();
    comeoutRoll ? $('guide_calls').innerHTML = "Place $" + amt + " each 4 \& 10, working on the Comeout Roll." : $('guide_calls').innerHTML = "Place $" + amt + " each 4 \& 10."
  },
  buyEachFourTen: function (amt) {
    this.changeState();
    comeoutRoll ? $('guide_calls').innerHTML = "Buy $" + amt + " each 4 \& 10, working on the Comeout Roll." : $('guide_calls').innerHTML = "Buy $" + amt + " each 4 \& 10."
  },
  placeFour: function (amt) {
    this.changeState();
    comeoutRoll ? $('guide_calls').innerHTML = "Place the Four for  $" + amt + ", working on the Comeout Roll." : $('guide_calls').innerHTML = "Place the Four for  $" + amt + "."
  },
  buyFour: function (amt) {
    this.changeState();
    comeoutRoll ? $('guide_calls').innerHTML = "Buy the Four for  $" + amt + ", working on the Comeout Roll." : $('guide_calls').innerHTML = "Buy the Four for  $" + amt + "."
  },
  placeFive: function (amt) {
    this.changeState();
    comeoutRoll ? $('guide_calls').innerHTML = "Place the Five for  $" + amt + ", working on the Comeout Roll." : $('guide_calls').innerHTML = "Place the Five for  $" + amt + "."
  },
  placeSix: function (amt) {
    this.changeState();
    comeoutRoll ? $('guide_calls').innerHTML = "Place the Six for  $" + amt + ", working on the Comeout Roll." : $('guide_calls').innerHTML = "Place the Six for  $" + amt + "."
  },
  placeEight: function (amt) {
    this.changeState();
    comeoutRoll ? $('guide_calls').innerHTML = "Place the Eight for  $" + amt + ", working on the Comeout Roll." : $('guide_calls').innerHTML = "Place the Eight for  $" + amt + "."
  },
  placeNine: function (amt) {
    this.changeState();
    comeoutRoll ? $('guide_calls').innerHTML = "Place the Nine for  $" + amt + ", working on the Comeout Roll." : $('guide_calls').innerHTML = "Place the Nine for  $" + amt + "."
  },
  placeTen: function (amt) {
    this.changeState();
    comeoutRoll ? $('guide_calls').innerHTML = "Place the Ten for  $" + amt + ", working on the Comeout Roll." : $('guide_calls').innerHTML = "Place the Ten for  $" + amt + "."
  },
  buyTen: function (amt) {
    this.changeState();
    comeoutRoll ? $('guide_calls').innerHTML = "Buy the Ten for  $" + amt + ", working on the Comeout Roll." : $('guide_calls').innerHTML = "Buy the Ten for  $" + amt + "."
  },
  sameBet: function () {this.changeState(); $('guide_calls').innerHTML = "Same bet.";},
  sameBetAndDown: function () {this.changeState(); $('guide_calls').innerHTML = "Same bet and down.";},
  oneUnit: function () {this.changeState(); $('guide_calls').innerHTML = "Press one unit.";},
  fiveUnits: function () {
    this.changeState();
    sixEight = rollTotal == 6 || rollTotal == 8
    sixEight ? $('guide_calls').innerHTML = "Press it $30." : $('guide_calls').innerHTML = "Press it $25.";
  },
  press: function () {this.changeState(); $('guide_calls').innerHTML = "Press it.";},
  fullPress: function () {this.changeState(); $('guide_calls').innerHTML = "Full press.";},
  doubleUnitPress: function (betCode, amt) {
    this.changeState(); 
    switch (betCode) {
      case 7: case 8: $('guide_calls').innerHTML = "Go to $" + amt + " each 6 \& 8."; break;
      case 6: case 9: $('guide_calls').innerHTML = "Go to $" + amt + " each 5 \& 9."; break;
      case 5: case 10: $('guide_calls').innerHTML = "Go to $" + amt + " each 4 \& 10."; break;
      default: return;
    }
  },
  goTo: function (amt) {
    this.changeState();
    switch(roll.total) {
      case 4: $('guide_calls').innerHTML = "Go to $" + amt + " on my Four."; break;
      case 5: $('guide_calls').innerHTML = "Go to $" + amt + " on my Five."; break;
      case 6: $('guide_calls').innerHTML = "Go to $" + amt + " on my Six."; break;
      case 8: $('guide_calls').innerHTML = "Go to $" + amt + " on my Eight."; break;
      case 9: $('guide_calls').innerHTML = "Go to $" + amt + " on my Nine."; break;
      case 10: $('guide_calls').innerHTML = "Go to $" + amt + " on my Ten."; break;
    }
    
  },
}
const hide = {
  allMenus: function () {
    letsHide('pass_line_bet_menu');
    letsHide('pass_line_odds_bet_menu');
    letsHide('place_four_bet_menu'); letsHide(theFour.offMenu); letsHide(theFour.placePayMenu);
    letsHide('place_five_bet_menu'); letsHide(theFive.offMenu); letsHide(theFive.placePayMenu);
    letsHide('place_six_bet_menu'); letsHide(theSix.offMenu); letsHide(theSix.placePayMenu);
    letsHide('place_eight_bet_menu'); letsHide(theEight.offMenu); letsHide(theEight.placePayMenu);
    letsHide('place_nine_bet_menu'); letsHide(theNine.offMenu); letsHide(theNine.placePayMenu);
    letsHide('place_ten_bet_menu'); letsHide(theTen.offMenu); letsHide(theTen.placePayMenu);
    letsHide('comeout_roll_spread_menu');
    letsHide('point_four_spread_menu');
    letsHide('point_five_spread_menu');
    letsHide('point_six_spread_menu');
    letsHide('point_eight_spread_menu');
    letsHide('point_nine_spread_menu');
    letsHide('point_ten_spread_menu');
    letsHide('bet_each_menu');
    letsHide('the_field_bet_menu'); letsHide('the_field_pay_menu');
    enable.allButtons();
  },
  betMenu: function (betCode) {
    switch (betCode) {
      case 1: letsHide('pass_line_bet_menu'); break;
      case 3: letsHide('pass_line_odds_bet_menu'); break;
      case 5: letsHide('place_four_bet_menu'); letsHide(theFour.offMenu); letsHide(theFour.placePayMenu); break;
      case 6: letsHide('place_five_bet_menu'); letsHide(theFive.offMenu); letsHide(theFive.placePayMenu); break;
      case 7: letsHide('place_six_bet_menu'); letsHide(theSix.offMenu); letsHide(theSix.placePayMenu); break;
      case 8: letsHide('place_eight_bet_menu'); letsHide(theEight.offMenu); letsHide(theEight.placePayMenu); break;
      case 9: letsHide('place_nine_bet_menu'); letsHide(theNine.offMenu); letsHide(theNine.placePayMenu); break;
      case 10: letsHide('place_ten_bet_menu'); letsHide(theTen.offMenu); letsHide(theTen.placePayMenu); break;
      case 11: letsHide('the_field_bet_menu'); letsHide('the_field_pay_menu'); break;
      case 12: letsHide('bet_each_menu'); break;
      default: return
    }
    enable.allButtons();

  }, 
  crSpreadMenu: function () {
    letsHide('comeout_roll_spread_menu');
  },
  betButtons: function () {
    letsHide('button_two'); 
    letsHide('button_three'); 
    letsHide('button_four');
  },
  betAmtBox: function (betCode) {
    switch (betCode) {
      case 1: 
        letsHide('pl_amt_box');
        break;
      case 2: 
        letsHide('pl_pymnt_amt_box');
        break;
      case 3: 
        letsHide('pl_odds_amt_box');
        break;
      case 4: 
        letsHide('pl_odds_pymnt_amt_box');
        break;
      case 5: 
        letsHide('place_four_amt_box');
        break;
      case 6: 
        letsHide('place_five_amt_box');
        break;
      case 7: 
        letsHide('place_six_amt_box');
        break;
      case 8: 
        letsHide('place_eight_amt_box');
        break;
      case 9: 
        letsHide('place_nine_amt_box');
        break;
      case 10: 
        letsHide('place_ten_amt_box');
        break;
      case 11: 
        letsHide('field_amt_box');
        break;
      case 12: 
        letsHide('field_pymnt_amt_box');
        break;
      case 13: 
        letsHide('field_dble_pymnt_amt_box');
        break;
      default: return
    }
  },
  cheques: function (betCode) {
    this.betAmtBox(betCode);
    switch (betCode) {
      case 1: 
        letsHide('pass_line_1');
        letsHide('pass_line_5');
        letsHide('pass_line_25');
        letsHide('pass_line_100');
        letsHide('pass_line_500');
        letsHide('pass_line_1000');
        break;
      case 2: 
        letsHide('pass_line_payment_1');
        letsHide('pass_line_payment_5');
        letsHide('pass_line_payment_25');
        letsHide('pass_line_payment_100');
        letsHide('pass_line_payment_500');
        letsHide('pass_line_payment_1000');
        break;
      case 3: 
        letsHide('pass_line_odds_1');
        letsHide('pass_line_odds_5');
        letsHide('pass_line_odds_25');
        letsHide('pass_line_odds_100');
        letsHide('pass_line_odds_500');
        letsHide('pass_line_odds_1000');
        break;
      case 4: 
        letsHide('pass_line_odds_payment_1');
        letsHide('pass_line_odds_payment_5');
        letsHide('pass_line_odds_payment_25');
        letsHide('pass_line_odds_payment_100');
        letsHide('pass_line_odds_payment_500');
        letsHide('pass_line_odds_payment_1000');
        break;
      case 5: 
        letsHide('place_four_1');
        letsHide('place_four_5');
        letsHide('place_four_25');
        letsHide('place_four_100');
        letsHide('place_four_500');
        letsHide('place_four_1000');
        break;
      case 6: 
        letsHide('place_five_1');
        letsHide('place_five_5');
        letsHide('place_five_25');
        letsHide('place_five_100');
        letsHide('place_five_500');
        letsHide('place_five_1000');
        break;
      case 7: 
        letsHide('place_six_1');
        letsHide('place_six_5');
        letsHide('place_six_25');
        letsHide('place_six_100');
        letsHide('place_six_500');
        letsHide('place_six_1000');
        break;
      case 8: 
        letsHide('place_eight_1');
        letsHide('place_eight_5');
        letsHide('place_eight_25');
        letsHide('place_eight_100');
        letsHide('place_eight_500');
        letsHide('place_eight_1000');
        break;
      case 9: 
        letsHide('place_nine_1');
        letsHide('place_nine_5');
        letsHide('place_nine_25');
        letsHide('place_nine_100');
        letsHide('place_nine_500');
        letsHide('place_nine_1000');
        break;
      case 10: 
        letsHide('place_ten_1');
        letsHide('place_ten_5');
        letsHide('place_ten_25');
        letsHide('place_ten_100');
        letsHide('place_ten_500');
        letsHide('place_ten_1000');
        break;
      case 11: 
        letsHide('bet_field_1');
        letsHide('bet_field_5');
        letsHide('bet_field_25');
        letsHide('bet_field_100');
        letsHide('bet_field_500');
        letsHide('bet_field_1000');
        break;
      case 12: 
        letsHide('field_payment_1');
        letsHide('field_payment_5');
        letsHide('field_payment_25');
        letsHide('field_payment_100');
        letsHide('field_payment_500');
        letsHide('field_payment_1000');
        break;
      case 13: 
        letsHide('field_double_payment_1');
        letsHide('field_double_payment_5');
        letsHide('field_double_payment_25');
        letsHide('field_double_payment_100');
        letsHide('field_double_payment_500');
        letsHide('field_double_payment_1000');
        break;
      default: 
        return
    }
  },
  onButtons: function () {
    letsHide(theFour.onButton);
    letsHide(theFive.onButton);
    letsHide(theSix.onButton);
    letsHide(theEight.onButton);
    letsHide(theNine.onButton);
    letsHide(theTen.onButton);
  },
  offButtons: function () {
    letsHide(theFour.offButton);
    letsHide(theFive.offButton);
    letsHide(theSix.offButton);
    letsHide(theEight.offButton);
    letsHide(theNine.offButton);
    letsHide(theTen.offButton);
  },
  disclaimer: function () {
    letsHide('the_disclaimer');
    $('show_hide_button').innerHTML = "Show"
    $('show_hide_button').onclick = show.disclaimer;
  }
}
const show = {
  puckOn: function () {
    switch (thePoint) {
      case 4: 
        $('puck_on').style.display = "block";
        $('puck_on').style.left = "5%";
        break;
      case 5: 
        $('puck_on').style.display = "block";
        $('puck_on').style.left = "18%";
        break;
      case 6: 
        $('puck_on').style.display = "block";
        $('puck_on').style.left = "31.6%";
        break;
      case 8: 
        $('puck_on').style.display = "block";
        $('puck_on').style.left = "45%";
        break;
      case 9: 
        $('puck_on').style.display = "block";
        $('puck_on').style.left = "58.5%";
        break;
      case 10: 
        $('puck_on').style.display = "block";
        $('puck_on').style.left = "72.1%";
        break;
      default: return; }
  },
  betEachMenu: function (betCode) {
    let prevMenu = sixNumbers.betMenus[betCode - 5];
    hideAllMenus();
    letsShow('bet_each_menu');
    $('bet_each_bck_btn').onclick = function () {letsHide('bet_each_menu'); letsShow(prevMenu)};
  },
  spreadBetMenu: function (betCode) {
    let prevMenu = sixNumbers.betMenus[betCode - 5];
    hideAllMenus();
    switch (thePoint) {
      case 0: hide.allMenus(); letsShow('comeout_roll_spread_menu'); $('crSprdBckBtn').onclick = function () {letsHide('comeout_roll_spread_menu'); letsShow(prevMenu)}; break;
      case 4: letsShow('point_four_spread_menu'); $('fourSprdBckBtn').onclick = function () {letsHide('point_four_spread_menu'); letsShow(prevMenu)}; break;
      case 5: letsShow('point_five_spread_menu'); $('fiveSprdBckBtn').onclick = function () {letsHide('point_five_spread_menu'); letsShow(prevMenu)}; break;
      case 6: letsShow('point_six_spread_menu'); $('sixSprdBckBtn').onclick = function () {letsHide('point_six_spread_menu'); letsShow(prevMenu)}; break;
      case 8: letsShow('point_eight_spread_menu'); $('eightSprdBckBtn').onclick = function () {letsHide('point_eight_spread_menu'); letsShow(prevMenu)}; break;
      case 9: letsShow('point_nine_spread_menu'); $('nineSprdBckBtn').onclick = function () {letsHide('point_nine_spread_menu'); letsShow(prevMenu)}; break;
      case 10: letsShow('point_ten_spread_menu'); $('tenSprdBckBtn').onclick = function () {letsHide('point_ten_spread_menu'); letsShow(prevMenu)}; break;
      default: return
    }
  },
  disclaimer: function () {
    letsShow('the_disclaimer');
    $('show_hide_button').innerHTML = "Hide"
    $('show_hide_button').onclick = hide.disclaimer;
  },
  fieldPayMenu: function () {
    letsShow('the_field_pay_menu'); 
    if(wasSingle) {
      letsShow('halfBtn');
      letsHide('thirdBtn');
      letsHide('twoThirdBtn');
    } else {
      letsShow('thirdBtn');
      letsShow('twoThirdBtn');
      letsHide('halfBtn');
    }
    disable.rollButtons();
  },
  offMenu: function (betCode) {
    hide.allMenus();
    disable.rollButtons();
    let offMenuHeaders = ['off_header_four', 'off_header_five', 'off_header_six', 'off_header_eight', 'off_header_nine', 'off_header_ten'];
    let offMenuParas = ['off_para_four', 'off_para_five', 'off_para_six', 'off_para_eight', 'off_para_nine', 'off_para_ten'];
    let offMenuBtnOnes = ['four_off_menu_btn_one', 'five_off_menu_btn_one', 'six_off_menu_btn_one', 'eight_off_menu_btn_one', 'nine_off_menu_btn_one', 'ten_off_menu_btn_one'];
    let offMenuBtnTwos = ['four_off_menu_btn_two', 'five_off_menu_btn_two', 'six_off_menu_btn_two', 'eight_off_menu_btn_two', 'nine_off_menu_btn_two', 'ten_off_menu_btn_two'];
    let offMenuBtnThrees = ['four_off_menu_btn_three', 'five_off_menu_btn_three', 'six_off_menu_btn_three', 'eight_off_menu_btn_three', 'nine_off_menu_btn_three', 'ten_off_menu_btn_three'];
    var getPlaceBetAmounts = [theFour.getPlaceBetAmt, theFive.getPlaceBetAmt, theSix.getPlaceBetAmt, theEight.getPlaceBetAmt, theNine.getPlaceBetAmt, theTen.getPlaceBetAmt];
    for (let i = 0; i < 6; i++) {
      if (i + 5 != betCode) { continue;}
        letsShow(placeOffMenus[i]);
    }
    if (comeoutRoll) {
      let emptyBet = getPlaceBetAmounts[betCode - 5] == 0;
      if (emptyBet) {
        for (let i = 0; i < 6; i++) {
          if (i + 5 != betCode) { continue;}
            $(offMenuHeaders[i]).innerHTML = "Place Bets are OFF.";
            $(offMenuParas[i]).innerHTML = "Place bets are OFF during the Comeout Roll. You can turn any number of Place bets ON by asking the dealer.";
            $(offMenuBtnOnes[i]).innerHTML = "Place " + thePoints[i] + " and work it.";
            $(offMenuBtnOnes[i]).onclick = function () {show.betMenu(i + 5)};
            letsHide(offMenuBtnTwos[i]);
            letsHide(offMenuBtnThrees[i]);
        }
      } else {
        for (let i = 0; i < 6; i++) {
          if (i + 5 != betCode) { continue;}
            $(offMenuHeaders[i]).innerHTML = "Place Bets are OFF.";
            $(offMenuParas[i]).innerHTML = "Place bets are OFF during the Comeout Roll. You can turn any number of Place bets ON by asking the dealer.";
            $(offMenuBtnOnes[i]).innerHTML = "Turn my " + thePoints[i] + " ON.";
            $(offMenuBtnOnes[i]).onclick = function () {thePlaceBets.turnOn(i + 5)};
            letsShow(offMenuBtnTwos[i]);
            $(offMenuBtnTwos[i]).innerHTML = "All bets ON";
            $(offMenuBtnTwos[i]).onclick = function () {thePlaceBets.turnOnAll()};
            letsShow(offMenuBtnThrees[i]);
            $(offMenuBtnThrees[i]).innerHTML = "Pick up bet.";
            $(offMenuBtnThrees[i]).onclick = function () {removeBet(i + 5)};
        }
      }
    } 
    if (intermediateRoll) {
      for (let i = 0; i < 6; i++) {
        if (i + 5 != betCode) { continue;}
        $(offMenuHeaders[i]).innerHTML = "Your Place " + thePoints[i] + " is OFF.";
        $(offMenuParas[i]).innerHTML = "Your bet is OFF until you turn it back ON. You can turn OFF or take down any of your Place bets at any time.";
        $(offMenuBtnOnes[i]).innerHTML = "Turn on my " + thePoints[i] + ".";
        $(offMenuBtnOnes[i]).onclick = function () {thePlaceBets.turnOn(i + 5)};
        letsShow(offMenuBtnTwos[i]);
        $(offMenuBtnTwos[i]).innerHTML = "All bets ON";
        $(offMenuBtnTwos[i]).onclick = function () {thePlaceBets.turnOnAll()};
        letsShow(offMenuBtnThrees[i]);
        $(offMenuBtnThrees[i]).innerHTML = "Pick up bet.";
        $(offMenuBtnThrees[i]).onclick = function () {removeBet(i + 5)};
      }
    }
  },
  betMenu: function (betCode) {
    hide.allMenus();
    switch (betCode) {
      case 1: letsShow('pass_line_bet_menu'); break;
      case 3: 
        const stepInput = (<HTMLInputElement>$('pl_odds_bet_amount'));
        letsShow('pass_line_odds_bet_menu');
        if (thePoint == 6 || thePoint == 8){
          stepInput.step = "5";
          $('pl_odds_bet_btn_1').innerHTML = "$" + theSixEight.singleUnit + " Odds";
          $('pl_odds_bet_btn_1').onclick = function () {betPassLineOdds(theSixEight.singleUnit)};
          $('pl_odds_bet_btn_2').innerHTML = "$" + theSixEight.doubleUnit + " Odds";
          $('pl_odds_bet_btn_2').onclick = function () {betPassLineOdds(theSixEight.doubleUnit)};
          $('pl_odds_bet_btn_3').innerHTML = "$" + theSixEight.tripleUnit + " Odds";
          $('pl_odds_bet_btn_3').onclick = function () {betPassLineOdds(theSixEight.tripleUnit)};
          letsShow('pl_odds_bet_btn_4');
          $('pl_odds_bet_btn_4').innerHTML = "$" + theSixEight.quadUnit + " Odds";
          $('pl_odds_bet_btn_4').onclick = function () {betPassLineOdds(theSixEight.quadUnit)};
        } else if (thePoint == 5 || thePoint == 9) {
          stepInput.step = "2";
          $('pl_odds_bet_btn_1').innerHTML = "$" + theFiveNine.singleUnit + " Odds";
          $('pl_odds_bet_btn_1').onclick = function () {betPassLineOdds(theFiveNine.singleUnit)};
          $('pl_odds_bet_btn_2').innerHTML = "$" + theFiveNine.doubleUnit + " Odds";
          $('pl_odds_bet_btn_2').onclick = function () {betPassLineOdds(theFiveNine.doubleUnit)};
          $('pl_odds_bet_btn_3').innerHTML = "$" + theFiveNine.tripleUnit + " Odds";
          $('pl_odds_bet_btn_3').onclick = function () {betPassLineOdds(theFiveNine.tripleUnit)};
          letsShow('pl_odds_bet_btn_4');
          $('pl_odds_bet_btn_4').innerHTML = "$" + theFiveNine.quadUnit + " Odds";
          $('pl_odds_bet_btn_4').onclick = function () {betPassLineOdds(theFiveNine.quadUnit)};
        } else {
          stepInput.step = "5";
          $('pl_odds_bet_btn_1').innerHTML = "$" + theFourTen.singleUnit + " Odds";
          $('pl_odds_bet_btn_1').onclick = function () {betPassLineOdds(theFourTen.singleUnit)};
          $('pl_odds_bet_btn_2').innerHTML = "$" + theFourTen.doubleUnit + " Odds";
          $('pl_odds_bet_btn_2').onclick = function () {betPassLineOdds(theFourTen.doubleUnit)};
          $('pl_odds_bet_btn_3').innerHTML = "$" + theFourTen.tripleUnit + " Odds";
          $('pl_odds_bet_btn_3').onclick = function () {betPassLineOdds(theFourTen.tripleUnit)};
          letsHide('pl_odds_bet_btn_4');
        }
        break;
      case 5: letsShow('place_four_bet_menu'); break;
      case 6: letsShow('place_five_bet_menu'); break;
      case 7: letsShow('place_six_bet_menu'); break;
      case 8: letsShow('place_eight_bet_menu'); break;
      case 9: letsShow('place_nine_bet_menu'); break;
      case 10: letsShow('place_ten_bet_menu'); break;
      case 11: letsShow('the_field_bet_menu'); break;
      default: return
    }
    disable.rollButtons();
  },
  cheques: function (betCode, amt) {
    let num = amt.toString(); let len = num.length;
    let onesDig = num[len - 1]; let tensDig = num[len - 2]; let hundredsDig = num[len - 3]; 
    let isAtLeastTwoDigNum = len >= 2; let isAtLeastThreeDigNum = len >= 3;
    let theTwoDigNum = parseInt(tensDig + onesDig); 
    let hasOrangeCheque = amt >= 1000; 
    let hasPurpleCheque = isAtLeastThreeDigNum && hundredsDig >= 5;
    let hasBlackCheque = isAtLeastThreeDigNum && hundredsDig != 0 && hundredsDig != 5;
    let hasGreenCheque = isAtLeastTwoDigNum && theTwoDigNum >= 25;
    const bannedRedNum = [25,26,27,28,29,50,51,52,53,54,75,76,77,78,79]
    const lowRedNum = [5,6,7,8,9]
    var isBannedNum = bannedRedNum.includes(theTwoDigNum);
    var isLowNum = lowRedNum.includes(amt);
    let hasRedCheque = isLowNum || (theTwoDigNum >= 10 && !isBannedNum);
    let hasWhiteCheque = amt > 0 && onesDig != 0  && onesDig != 5;
    hide.cheques(betCode);
    show.betAmtBox(betCode);
    switch (betCode) {
      case 1: 
        if (hasWhiteCheque) {letsShow('pass_line_1');}
        if (hasRedCheque) {letsShow('pass_line_5');}
        if (hasGreenCheque) {letsShow('pass_line_25');}
        if (hasBlackCheque) {letsShow('pass_line_100');}
        if (hasPurpleCheque) {letsShow('pass_line_500');}
        if (hasOrangeCheque) {letsShow('pass_line_1000');}
        break;
      case 2: 
        if (hasWhiteCheque) {letsShow('pass_line_payment_1');}
        if (hasRedCheque) {letsShow('pass_line_payment_5');}
        if (hasGreenCheque) {letsShow('pass_line_payment_25');}
        if (hasBlackCheque) {letsShow('pass_line_payment_100');}
        if (hasPurpleCheque) {letsShow('pass_line_payment_500');}
        if (hasOrangeCheque) {letsShow('pass_line_payment_1000');}
        break;
      case 3: 
        if (hasWhiteCheque) {letsShow('pass_line_odds_1');}
        if (hasRedCheque) {letsShow('pass_line_odds_5');}
        if (hasGreenCheque) {letsShow('pass_line_odds_25');}
        if (hasBlackCheque) {letsShow('pass_line_odds_100');}
        if (hasPurpleCheque) {letsShow('pass_line_odds_500');}
        if (hasOrangeCheque) {letsShow('pass_line_odds_1000');}
        break;
      case 4: 
        if (hasWhiteCheque) {letsShow('pass_line_odds_payment_1');}
        if (hasRedCheque) {letsShow('pass_line_odds_payment_5');}
        if (hasGreenCheque) {letsShow('pass_line_odds_payment_25');}
        if (hasBlackCheque) {letsShow('pass_line_odds_payment_100');}
        if (hasPurpleCheque) {letsShow('pass_line_odds_payment_500');}
        if (hasOrangeCheque) {letsShow('pass_line_odds_payment_1000');}
        break;
      case 5: 
        if (hasWhiteCheque) {letsShow('place_four_1');}
        if (hasRedCheque) {letsShow('place_four_5');}
        if (hasGreenCheque) {letsShow('place_four_25');}
        if (hasBlackCheque) {letsShow('place_four_100');}
        if (hasPurpleCheque) {letsShow('place_four_500');}
        if (hasOrangeCheque) {letsShow('place_four_1000');}
        break;
      case 6: 
        if (hasWhiteCheque) {letsShow('place_five_1');}
        if (hasRedCheque) {letsShow('place_five_5');}
        if (hasGreenCheque) {letsShow('place_five_25');}
        if (hasBlackCheque) {letsShow('place_five_100');}
        if (hasPurpleCheque) {letsShow('place_five_500');}
        if (hasOrangeCheque) {letsShow('place_five_1000');}
        break;
      case 7: 
        if (hasWhiteCheque) {letsShow('place_six_1');}
        if (hasRedCheque) {letsShow('place_six_5');}
        if (hasGreenCheque) {letsShow('place_six_25');}
        if (hasBlackCheque) {letsShow('place_six_100');}
        if (hasPurpleCheque) {letsShow('place_six_500');}
        if (hasOrangeCheque) {letsShow('place_six_1000');}
        break;
      case 8: 
        if (hasWhiteCheque) {letsShow('place_eight_1');}
        if (hasRedCheque) {letsShow('place_eight_5');}
        if (hasGreenCheque) {letsShow('place_eight_25');}
        if (hasBlackCheque) {letsShow('place_eight_100');}
        if (hasPurpleCheque) {letsShow('place_eight_500');}
        if (hasOrangeCheque) {letsShow('place_eight_1000');}
        break;
      case 9: 
        if (hasWhiteCheque) {letsShow('place_nine_1');}
        if (hasRedCheque) {letsShow('place_nine_5');}
        if (hasGreenCheque) {letsShow('place_nine_25');}
        if (hasBlackCheque) {letsShow('place_nine_100');}
        if (hasPurpleCheque) {letsShow('place_nine_500');}
        if (hasOrangeCheque) {letsShow('place_nine_1000');}
        break;
      case 10: 
        if (hasWhiteCheque) {letsShow('place_ten_1');}
        if (hasRedCheque) {letsShow('place_ten_5');}
        if (hasGreenCheque) {letsShow('place_ten_25');}
        if (hasBlackCheque) {letsShow('place_ten_100');}
        if (hasPurpleCheque) {letsShow('place_ten_500');}
        if (hasOrangeCheque) {letsShow('place_ten_1000');}
        break;
      case 11: 
        if (hasWhiteCheque) {letsShow('bet_field_1');}
        if (hasRedCheque) {letsShow('bet_field_5');}
        if (hasGreenCheque) {letsShow('bet_field_25');}
        if (hasBlackCheque) {letsShow('bet_field_100');}
        if (hasPurpleCheque) {letsShow('bet_field_500');}
        if (hasOrangeCheque) {letsShow('bet_field_1000');}
        break;
      case 12: 
        if (hasWhiteCheque) {letsShow('field_payment_1');}
        if (hasRedCheque) {letsShow('field_payment_5');}
        if (hasGreenCheque) {letsShow('field_payment_25');}
        if (hasBlackCheque) {letsShow('field_payment_100');}
        if (hasPurpleCheque) {letsShow('field_payment_500');}
        if (hasOrangeCheque) {letsShow('field_payment_1000');}
        break;
      case 13: 
        if (hasWhiteCheque) {letsShow('field_double_payment_1');}
        if (hasRedCheque) {letsShow('field_double_payment_5');}
        if (hasGreenCheque) {letsShow('field_double_payment_25');}
        if (hasBlackCheque) {letsShow('field_double_payment_100');}
        if (hasPurpleCheque) {letsShow('field_double_payment_500');}
        if (hasOrangeCheque) {letsShow('field_double_payment_1000');}
        break;
      default: return
    }
  },
  betAmtBox: function (betCode) {
    switch (betCode) {
      case 1:
        let thePassLineLineBet = thePassLine.lineBet.toString();
        $('pl_amt_box').innerHTML = thePassLineLineBet;
        letsShow('pl_amt_box');
        break;
      case 2:
        let thePassLineLinePayment = thePassLine.linePayment.toString();
        $('pl_pymnt_amt_box').innerHTML = thePassLineLinePayment;
        letsShow('pl_pymnt_amt_box');
        break;
      case 3:
        let passLineOddsBet = passLineOdds.oddsBet.toString();
        $('pl_odds_amt_box').innerHTML = passLineOddsBet;
        letsShow('pl_odds_amt_box');
        break;
      case 4:
        let passLineOddsPayment = passLineOdds.oddsPayment.toString();
        $('pl_odds_pymnt_amt_box').innerHTML = passLineOddsPayment;
        letsShow('pl_odds_pymnt_amt_box');
        break;
      case 5:
        let theFourPlaceBet = theFour.placeBet.toString();
        $('place_four_amt_box').innerHTML = theFourPlaceBet;
        letsShow('place_four_amt_box');
        break;
      case 6: 
        let theFivePlaceBet = theFive.placeBet.toString();
        $('place_five_amt_box').innerHTML = theFivePlaceBet;
        letsShow('place_five_amt_box');
        break;
      case 7:
        let theSixPlaceBet = theSix.placeBet.toString();
        $('place_six_amt_box').innerHTML = theSixPlaceBet;
        letsShow('place_six_amt_box');
        break;
      case 8:
        let theEightPlaceBet = theEight.placeBet.toString();
        $('place_eight_amt_box').innerHTML = theEightPlaceBet;
        letsShow('place_eight_amt_box');
        break;
      case 9:
        let theNinePlaceBet = theNine.placeBet.toString();
        $('place_nine_amt_box').innerHTML = theNinePlaceBet;
        letsShow('place_nine_amt_box');
        break;
      case 10:
        let theTenPlaceBet = theTen.placeBet.toString();
        $('place_ten_amt_box').innerHTML = theTenPlaceBet;
        letsShow('place_ten_amt_box');
        break;
      case 11:
        let theFieldBet = theField.bet.toString();
        $('field_amt_box').innerHTML = theFieldBet;
        letsShow('field_amt_box');
        break;
      case 12:
        let theFieldPayment = theField.payment.toString();
        $('field_pymnt_amt_box').innerHTML = theFieldPayment;
        letsShow('field_pymnt_amt_box');
        break;
      case 13:
        let theFieldDoublePayment = theField.doublePayment.toString();
        $('field_dble_pymnt_amt_box').innerHTML = theFieldDoublePayment;
        letsShow('field_dble_pymnt_amt_box');
        break;
      default: return
    }
  },
  passLineBetBtns: function () {
    letsShow('button_two'); 
    letsShow('button_three'); 
    letsShow('button_four');
    $('button_two').onclick = function() {betPassLine(5)};
    $('button_two').innerHTML = "$5 Pass Line"
    $('button_three').onclick = function () {betPassLine(10)};
    $('button_three').innerHTML = "$10 Pass Line";
    $('button_four').onclick = function () {show.betMenu(1)};
    $('button_four').innerHTML = "Bet Other";
  }
}
// Calls
const guide = {
  sayStickCall: function () {
    if (comeoutRoll) {
      if (rollHard) {
        switch (rollTotal) {
          case 2: $('stick_person').innerHTML = stickCall.comeoutRollStickCalls.two; break;
          case 4: $('stick_person').innerHTML = stickCall.comeoutRollStickCalls.fourHard; break;
          case 6: $('stick_person').innerHTML = stickCall.comeoutRollStickCalls.sixHard; break;
          case 8: $('stick_person').innerHTML = stickCall.comeoutRollStickCalls.eightHard; break;
          case 10: $('stick_person').innerHTML = stickCall.comeoutRollStickCalls.tenHard; break;
          case 12: $('stick_person').innerHTML = stickCall.comeoutRollStickCalls.twelve; break;
        }
      } else {
        switch (rollTotal) {
          case 3: $('stick_person').innerHTML = stickCall.comeoutRollStickCalls.three; break;
          case 4: $('stick_person').innerHTML = stickCall.comeoutRollStickCalls.fourEasy; break;
          case 5: $('stick_person').innerHTML = stickCall.comeoutRollStickCalls.five; break;
          case 6: $('stick_person').innerHTML = stickCall.comeoutRollStickCalls.sixEasy; break;
          case 7: $('stick_person').innerHTML = stickCall.comeoutRollStickCalls.seven; break;
          case 8: $('stick_person').innerHTML = stickCall.comeoutRollStickCalls.eightEasy; break;
          case 9: $('stick_person').innerHTML = stickCall.comeoutRollStickCalls.nine; break;
          case 10: $('stick_person').innerHTML = stickCall.comeoutRollStickCalls.tenEasy; break;
          case 11: $('stick_person').innerHTML = stickCall.comeoutRollStickCalls.eleven; break;
        }
      }
    } else if (pointMade){
      if (rollHard) {
        switch (rollTotal) {
          case 4: $('stick_person').innerHTML = stickCall.decisionRollStickCalls.fourHard; break;
          case 6: $('stick_person').innerHTML = stickCall.decisionRollStickCalls.sixHard; break;
          case 8: $('stick_person').innerHTML = stickCall.decisionRollStickCalls.eightHard; break;
          case 10: $('stick_person').innerHTML = stickCall.decisionRollStickCalls.tenHard; break;
        }
      } else {
        switch (rollTotal) {
          case 4: $('stick_person').innerHTML = stickCall.decisionRollStickCalls.fourEasy; break;
          case 5: $('stick_person').innerHTML = stickCall.decisionRollStickCalls.five; break;
          case 6: $('stick_person').innerHTML = stickCall.decisionRollStickCalls.sixEasy; break;
          case 8: $('stick_person').innerHTML = stickCall.decisionRollStickCalls.eightEasy; break;
          case 9: $('stick_person').innerHTML = stickCall.decisionRollStickCalls.nine; break;
          case 10: $('stick_person').innerHTML = stickCall.decisionRollStickCalls.tenEasy; break;
        }
      }
    } else if (sevenOut){
      $('stick_person').innerHTML = stickCall.decisionRollStickCalls.seven;
    } else {
      if (rollHard) {
        switch (rollTotal) {
          case 2: $('stick_person').innerHTML = stickCall.intermediateRollStickCalls.two; break;
          case 4: $('stick_person').innerHTML = stickCall.intermediateRollStickCalls.fourHard; break;
          case 6: $('stick_person').innerHTML = stickCall.intermediateRollStickCalls.sixHard; break;
          case 8: $('stick_person').innerHTML = stickCall.intermediateRollStickCalls.eightHard; break;
          case 10: $('stick_person').innerHTML = stickCall.intermediateRollStickCalls.tenHard; break;
          case 12: $('stick_person').innerHTML = stickCall.intermediateRollStickCalls.twelve; break;
        }
      } else {
        switch (rollTotal) {
          case 3: $('stick_person').innerHTML = stickCall.intermediateRollStickCalls.three; break;
          case 4: $('stick_person').innerHTML = stickCall.intermediateRollStickCalls.fourEasy; break;
          case 5: $('stick_person').innerHTML = stickCall.intermediateRollStickCalls.five; break;
          case 6: $('stick_person').innerHTML = stickCall.intermediateRollStickCalls.sixEasy; break;
          case 8: $('stick_person').innerHTML = stickCall.intermediateRollStickCalls.eightEasy; break;
          case 9: $('stick_person').innerHTML = stickCall.intermediateRollStickCalls.nine; break;
          case 10: $('stick_person').innerHTML = stickCall.intermediateRollStickCalls.tenEasy; break;
          case 11: $('stick_person').innerHTML = stickCall.intermediateRollStickCalls.eleven; break;
        }
      }
    }
  },
  sayCrStickCall: function () {
    switch (count.totalPoints) {
      case 1: $('stick_person').innerHTML = crStickCall.cr2; break;
      case 2: $('stick_person').innerHTML = crStickCall.cr3; break;
      case 3: $('stick_person').innerHTML = crStickCall.cr4; break;
      case 4: $('stick_person').innerHTML = crStickCall.cr5; break;
      case 5: $('stick_person').innerHTML = crStickCall.cr6; break;
      case 6: $('stick_person').innerHTML = crStickCall.cr7; break;
      case 7: $('stick_person').innerHTML = crStickCall.cr8; break;
      case 8: $('stick_person').innerHTML = crStickCall.cr9; break;
      default: $('stick_person').innerHTML = crStickCall.cr10;
    }
  },
  sayDiceAreOut: function () {
    var diceOutCall = diceAreOutCalls[Math.floor(Math.random() * diceAreOutCalls.length)];
    $('guide_calls').innerHTML = diceOutCall;
  },
  saySevenOutCall: function () {
    switch (count.totalPoints) {
      case 0: $('guide_calls').innerHTML = sevenOutCall.pts0; break;
      case 1: $('guide_calls').innerHTML = sevenOutCall.pts1; break;
      case 2: $('guide_calls').innerHTML = sevenOutCall.pts2; break;
      case 3: $('guide_calls').innerHTML = sevenOutCall.pts3; break;
      case 4: $('guide_calls').innerHTML = sevenOutCall.pts4; break;
      case 5: $('guide_calls').innerHTML = sevenOutCall.pts5; break;
      case 6: $('guide_calls').innerHTML = sevenOutCall.pts6; break;
      case 7: $('guide_calls').innerHTML = sevenOutCall.pts7; break;
      case 8: $('guide_calls').innerHTML = sevenOutCall.pts8; break;
      case 9: $('guide_calls').innerHTML = sevenOutCall.pts9; break;
      default: $('guide_calls').innerHTML = sevenOutCall.pts10; break;
    }
  },
  sayYourBroke: function () {
    $('guide_calls').innerHTML = "You don't have enough money to shoot. Try refreshing the page.";
    $('button_one').innerHTML = "Refresh the page?";
    $('button_one').onclick = function () {window.location.replace(window.location.pathname + window.location.search + window.location.hash);};  
  },
  cheerForPlayer: function () {
    return;
  }
}
const stickCall = {
  comeoutRollStickCalls: {
    two: "Two Craps two, Line em in, the Don'ts win, double the Field.",
    three: "Three Craps three, Line em in, the Don'ts win, single the Field.",
    fourEasy: "Four easy four, mark the four, the Point is four. Single the Field, it came easy, bet it back hard",
    fourHard: "Four hard four, mark the four, the Point is four. Single the Field, it came hard, bet it back hard.",
    five: "Five, no Field five, mark the five, the Point is five. Place the nine, even Odds in the back.",
    sixEasy: "Six easy six, mark the six, the Point is six. No Field, it came easy, bet it back hard.",
    sixHard: "Six hard six, mark the six, the Point is six. No Field, it came hard, bet it back hard.",
    seven: "Seven winner seven, front Line winner! Take the Don'ts, pay the Line, save Odds, pay behind.",
    eightEasy: "Eight easy eight, mark the eight, the Point is eight. No Field, it came easy, bet it back hard.",
    eightHard: "Eight hard eight, mark the eight, the Point is eight. No Field, it came hard, bet it back hard.",
    nine: "Nine, center Field nine, mark the nine, the Point is nine. Place the five, even Odds in the back.",
    tenEasy: "Ten, easy ten, mark the ten, the Point is ten. Single the Field, it came easy, bet it back hard.",
    tenHard: "Ten, hard ten, mark the ten, the Point is ten. Single the Field, it came hard, bet it back hard.",
    eleven: "Yo eleven Yo, front Line winner! Take the Don'ts, pay the Line, single the Field.",
    twelve: "Twelve Craps Twelve, Line em in, bar the Don'ts, double the Field."
  },
  intermediateRollStickCalls: {
    two: "Two Craps two, take the Come, pay the Don’t Come, double the Field.",
    three: "Three Craps three, take the Come, pay the Don’t Come, single the Field.",
    fourEasy: "Four easy four, down behind four, single the Field, Don'ts and Come’s to the four.",
    fourHard: "Four hard four, down behind four, single the Field, Don'ts and Come’s to the four.",
    five: "Five, no Field five, down behind five, Don'ts and Come’s to the five.",
    sixEasy: "Six easy six, down behind six, no Field, Don'ts and Come’s to the six.",
    sixHard: "Six hard six, down behind six, no Field, Don'ts and Come’s to the six.",
    eightEasy: "Eight, easy eight, down behind eight, no Field, Don'ts and Come’s to the eight.",
    eightHard: "Eight, hard eight, down behind eight, no Field, Don'ts and Come’s to the eight.",
    nine: "Nine, center Field nine, down behind nine, Don'ts and Come’s to the nine.",
    tenEasy: "Ten, easy ten, down behind ten, single the Field, Don'ts and Come’s to the ten.",
    tenHard: "Ten, hard ten, down behind ten, single the Field, Don'ts and Come’s to the ten.",
    eleven: "Yo eleven Yo, take the Don’t Come, good in the Field, good in the Come.",
    twelve: "Twelve Craps Twelve, take the Come, Bar the Don’t Come, double the Field."
  },
  decisionRollStickCalls: {
    fourEasy: "Four winner four, front Line winner! Take the Don'ts, pay the Line, Don'ts and Come’s to the four, it came easy.",
    fourHard: "Four winner four, front Line winner! Take the Don'ts, pay the Line, Don'ts and Come’s to the four, it came hard.",
    five: "Five winner five, front Line winner! Take the Don'ts, pay the Line, Don'ts and Come’s to the five.",
    sixEasy: "Six winner six, front Line winner! Take the Don'ts, pay the Line, Don'ts and Come’s to the six, it came easy.",
    sixHard: "Six winner six, front Line winner! Take the Don'ts, pay the Line, Don'ts and Come's to the six, it came hard.",
    seven: "Seven out seven. Line em in, the Don'ts win, last Come get some, pay behind.",
    eightEasy: "Eight winner eight, front Line winner! Take the Don'ts, pay the Line, Don'ts and Come’s to the eight, it came easy.",
    eightHard: "Eight winner eight, front Line winner! Take the Don'ts, pay the Line, Don'ts and Come's to the eight, it came hard.",
    nine: "Nine winner nine, front Line winner! Take the Don'ts, pay the Line, Don'ts and Come’s to the nine.",
    tenEasy: "Ten winner ten, front Line winner! Take the Don'ts, pay the Line, Don'ts and Come’s to the ten, it came easy.",
    tenHard: "Ten winner ten, front Line winner! Take the Don'ts, pay the Line, Don'ts and Come's to the ten, it came hard."
  }
};
const crStickCall = {
  cr2: "Alright folks, we’re coming out again, same shooter. Center bets while the dice are in the middle. We’re goin for point number two.",
  cr3: "Ok, we got a roll goin. We’re coming out a third time. Center bets, World’s, Horn’s, Yo’s, Hi Low’s. While the dice are in the middle please.",
  cr4: "We found a shooter ladies and gentleman. We’re coming out and looking for Point number four. Throw in your center bets now while the dice are in the middle.",
  cr5: "The shooter is hot and we’re coming out! Get em now while the dice are in the middle. World’s, Horn’s Yo’s, Hi’s and Low’s, C’s and E’s.",
  cr6: "Hot shooter coming out again!. We’re looking for point number six. Get your bets while the dice are in the middle. Center bets?",
  cr7: "The Shooter is on fire!. We’re coming out! World’s, Horn’s, Yo’, Hi Low’s, C & E’s, get em while the dice are in the middle.",
  cr8: "The shooter has the magic hands tonight! They’ve made 7 Points and we’re goin for Point number 8! Center bets while the dice are in the middle!",
  cr9: "This is gonna be the roll of the night ladies and gentleman! Pick up your winnings and let’s get those center bets in right now!",
  cr10: "We can’t slow the shooter down! Get your prop bets in now!"
};
const sevenOutCall = {
  pts0: "The game is over. You didn’t make any Points but that’s ok, it happens all the time.",
  pts1: "The game is over. You made one Point. If you make at least one Point while you’re shooting the dice then you did your job for the table.",
  pts2: "The game is over. You made two Points. Good job. No one is gonna be mad about that.",
  pts3: "The game is over. You made three Points which is a really good. You should be happy with this roll.",
  pts4: "The game is over. You made four Points. That was a great roll! You should be proud.",
  pts5: "The game is over. You made five Points. That was a really great roll. The table should be really happy!",
  pts6: "The game is over. You made six Points! That roll was fantastic! You probably won't see anybody beat that roll while playing at the tables!",
  pts7: "The game is over. You made seven Points! That’s tremendous! You should get a standing ovation for that!",
  pts8: "The game is over. You made eight Points! That’s just incredible. You may never do that again in your dice career.",
  pts9: "The game is over. You made nine Points! If someone hasn’t given you money for this role then something is wrong.",
  pts10: "The game is over. " + count.totalPoints + " Points is insane! This is a story you could tell your family for years to come."
};
const rulesOfTheGame = {
  theObject: "The object of Craps is to establish a Point (4, 5, 6, 8, 9, or 10) and then roll that Point again before a 7 to win.",
  crSetup: "When the puck is OFF, this is the Comeout Roll and the time to bet the Pass Line.",
  crRule1: "If you roll 7 or 11 during the Comeout Roll you automatically win on the Pass Line.",
  crRule2: "If you roll a 2, 3, or 12 during the Comeout Roll, you automatically lose on the Pass Line.",
  crRule3: "Otherwise, you Establish a Point.",
  irSetup: "When the puck is On, this is the Intermediate Roll.",
  irRule1: "If you roll your Point before you roll a 7, you win on the Pass Line.",
  irRule2: "If you roll a 7 before you roll your Point, you lose."
};
const diceAreOutCalls = [
  "Dice are moving, watch your hands, and no fingers over the edge!", 
  "Dice are goin! Hands up!", 
  "Ok, dice are out, watch your hands, and no throwing bets in front of the shooter!", 
  "Alright, the dice are moving. Get your hands up!",
  "Ok, dice are goin, watch the hands, use your words!",
  "Dice are out, hands high!",
  "Dice are movin, watch those hands, dice hurt!",
  "We gotta go, dice are out, watch your mittens!",
  "Dice are goin, pick up your hands!"
]

let getPlaceBetAmounts = [theFour.getPlaceBetAmt, theFour.betPlusVig, theSix.getPlaceBetAmt, theEight.getPlaceBetAmt, theNine.getPlaceBetAmt, theTen.getPlaceBetAmt]
let placeOffMenus = [theFour.offMenu, theFive.offMenu, theSix.offMenu, theEight.offMenu, theNine.offMenu, theTen.offMenu];
let onButtons = [theFour.onButton, theFive.onButton, theSix.onButton, theEight.onButton, theNine.onButton, theTen.onButton];
let placeMenuBtns = [theFour.placeMenuBtn, theFive.placeMenuBtn, theSix.placeMenuBtn, theEight.placeMenuBtn, theNine.placeMenuBtn, theTen.placeMenuBtn];
let placeOnStates = [theFour.onStatus, theFive.onStatus, theSix.onStatus, theEight.onStatus, theNine.onStatus, theTen.onStatus];
let hasOffBtns = [theFour.hasOffBtn, theFive.hasOffBtn, theSix.hasOffBtn, theEight.hasOffBtn, theNine.hasOffBtn, theTen.hasOffBtn];

function shootDice() {
  check.forBroke();
  if (brokeAsAJoke) {
    letsHide('buttonTwo');
    guide.sayYourBroke();
  } else {
    if (!hasPassLine) {
      alert.needPassLine();
    } else if (passLineWasPaid) {
      comeoutRoll ? notify.crWinner() : notify.pointWinner();
    } else if (theField.isOverMax) {
      alert.overInField();
    } else {
      createRollObject();
      incrementRoll();
      changeDice();
      guide.sayStickCall();
      determineRoll();
    }
  }
}

function createRollObject() {
  roll = rollTwoDice();
  rollTotal = roll.total;
  rollHard = roll.hard;
  theFirstDie = roll.firstDie;
  theSecondDie = roll.secondDie;
  isAPointNum = thePoints.includes(rollTotal);
  markingPoint = comeoutRoll && isAPointNum;
  pointMade = rollTotal === thePoint;
  boxRolled = !pointMade && intermediateRoll && isAPointNum;
  crapRolled = crapNumbers.includes(rollTotal);
  sevenOut = intermediateRoll && rollTotal === 7;
  naturalWinner = comeoutRoll && (rollTotal === 7 || rollTotal === 11);
  naturalLoser = comeoutRoll && crapRolled;
}

function rollTwoDice() {
  aRollHappened = true;
  let dieA = Math.floor(Math.random() * 6) + 1;
  let dieB = Math.floor(Math.random() * 6) + 1;
  return {
    firstDie: dieA,
    secondDie: dieB,
    total: dieA + dieB,
    hard: dieA === dieB,
  };
}
function changeDice() {
  switch (theFirstDie) {
    case 1:
      $<HTMLInputElement>('die_one').src = imageDie1;
      break;
    case 2:
      $<HTMLInputElement>('die_one').src = imageDie2;
      break;
    case 3:
      $<HTMLInputElement>('die_one').src = imageDie3;
      break;
    case 4:
      $<HTMLInputElement>('die_one').src = imageDie4;
      break;
    case 5:
      $<HTMLInputElement>('die_one').src = imageDie5;
      break;
    default:
      $<HTMLInputElement>('die_one').src = imageDie6;
  }
  switch (theSecondDie) {
    case 1:
      $<HTMLInputElement>('die_two').src = imageDie1;
      break;
    case 2:
      $<HTMLInputElement>('die_two').src = imageDie2;
      break;
    case 3:
      $<HTMLInputElement>('die_two').src = imageDie3;
      break;
    case 4:
      $<HTMLInputElement>('die_two').src = imageDie4;
      break;
    case 5:
      $<HTMLInputElement>('die_two').src = imageDie5;
      break;
    default:
      $<HTMLInputElement>('die_two').src = imageDie6;
  }
}
function determineRoll() {
  if (markingPoint) {
    markPoint();
    theField.settleIt();
  } else if (naturalWinner) {
    thePassLine.payIt();
    theField.settleIt();
    check.forWorkingPlaceBet();
  } else if (naturalLoser) {
    thePassLine.takeIt();
    theField.settleIt();
  } else if (pointMade) {
    ++count.totalPoints;
    let countTotalPoints = count.totalPoints.toString();
    pointWasJustMade = true;
    $('total_points').innerHTML = countTotalPoints;
    thePassLine.payIt();
    passLineOdds.payIt();
    theField.settleIt();
    check.forDoubleDip();
    check.forWorkingPlaceBet();
    unmarkPoint();
    //guide.cheerForPlayer();
  } else if (sevenOut) {
    theField.settleIt();
    check.forWorkingPlaceBet();
    endRoll();
  } else { // Intermediate Roll Crap's, Yo's, and Boxes
    theField.settleIt();
    check.forWorkingPlaceBet();
    alert.remove();
  }
}
function incrementRoll() {
  ++count.totalRolls;
  count.previousRolls.push(rollTotal);
  $('the_previous_rolls').innerHTML = count.previousRolls.join(", ");
  let countTotalRolls = count.totalRolls.toString();
  $('roll_count').innerHTML = countTotalRolls;
  $('button_one').innerHTML = "Roll";
  switch (rollTotal) {
    case 2:
      let countTwos = count.twos.toString();
      ++count.twos;
      $('twosCounter').innerHTML = countTwos;
      break;
    case 3:
      let countThrees = count.threes.toString();
      ++count.threes;
      $('threesCounter').innerHTML = countThrees;
      break;
    case 4:
      let countFours = count.fours.toString();
      ++count.fours;
      $('foursCounter').innerHTML = countFours;
      break;
    case 5:
      let countFives = count.fives.toString();
      ++count.fives;
      $('fivesCounter').innerHTML = countFives;
      break;
    case 6:
      let countSixes = count.sixes.toString();
      ++count.sixes;
      $('sixesCounter').innerHTML = countSixes;
      break;
    case 7:
      let countSevens = count.sevens.toString();
      ++count.sevens;
      $('sevensCounter').innerHTML = countSevens;
      break;
    case 8:
      let countEights = count.eights.toString();
      ++count.eights;
      $('eightsCounter').innerHTML = countEights;
      break;
    case 9:
      let countNines = count.nines.toString();
      ++count.nines;
      $('ninesCounter').innerHTML = countNines;
      break;
    case 10:
      let countTens = count.tens.toString();
      ++count.tens;
      $('tensCounter').innerHTML = countTens;
      break;
    case 11:
      let countElevens = count.elevens.toString();
      ++count.elevens;
      $('elevensCounter').innerHTML = countElevens;
      break;
    default:
      let countTwelves = count.twelves.toString();
      ++count.twelves;
      $('twelvesCounter').innerHTML = countTwelves;
  }
  if (comeoutRoll) {
    if (crapRolled) {
      ++count.crCraps;
    } else if (naturalWinner) {
      ++count.crWinners;
    }
  } else if (intermediateRoll) {
    if (crapRolled) {
      ++count.irCraps;
    } else if (boxRolled) {
      let countIrBoxes = count.irBoxes.toString();
      ++count.irBoxes;
      $('box_count').innerHTML = countIrBoxes;
    }
  }
}
function endRoll() {
  guide.saySevenOutCall();
  hide.betButtons();
  thePassLine.takeIt();
  passLineOdds.takeIt();
  theField.settleIt();
  letsHide('show_field_btn');
  unmarkPoint();
  money.adjustBank();
  $('button_one').innerHTML = 'Try again';
  $('button_one').onclick = resetGame;
}
function resetGame() {
  check.forBroke();
  if (brokeAsAJoke) {
    guide.sayYourBroke();
  } else {
    $('puck_off').style.display = "block";
    reset.headerInfo();
    reset.diceAndBtns();
    reset.counters();
    $('stick_person').innerHTML = "We’re coming out. World’s, Horn’s, Yo’s, Hi Low’s, C&E’s. Get em while the dice are in the middle. Dice are goin! Watch your hands!";
    $('guide_calls').innerHTML = "Bet the Pass Line in order to shoot the dice.";
    $('alert_to_do').style.border = "none";
    darkMode ? $('guide_calls').style.color = "#EEEEEE" : $('guide_calls').style.color = "#282829";
    show.passLineBetBtns();
    letsShow('show_pl_btn');
    letsShow('show_field_btn');
  }
}

                                                                                        // Stages

function markPoint() {
  alert.remove();
  thePoint = rollTotal;
  $('stage_of_game').innerHTML = 'Intermediate Roll';
  $('stage_of_game').style.color = 'rgb(8, 142, 158)';
  let showPoint = thePoint.toString();
  $('the_point').innerHTML = showPoint;
  check.forWorkingPlaceBet();
  turnOnIntermediateBets();
  $('puck_off').style.display = "none";
  letsHide('show_pl_btn');
  hide.betButtons();
  total.fourTenBets == 0 && (aRollHappened = false);
  show.puckOn();
  inform.oddsAvailable();
  //testMe.onStates();
}
function turnOnIntermediateBets() {
  intermediateRoll = true;
  comeoutRoll = false;
  thePlaceBets.areOn();
  passLineOdds.turnOn();
  hide.onButtons();
  var hasOffBtns = [theFour.hasOffBtn, theFive.hasOffBtn, theSix.hasOffBtn, theEight.hasOffBtn, theNine.hasOffBtn, theTen.hasOffBtn];
  for (let i = 0; i < 6; i++) {
    hasOffBtns[i] && thePlaceBets.turnOff(i + 5);
  }
  thePlaceBets.werePaid && disable.allButtons();
}
function unmarkPoint() {
  thePoint = 0;
  comeoutRoll = true;
  intermediateRoll = false;
  $('puck_on').style.display = "none";
  $('puck_off').style.display = "block";
  $('stage_of_game').innerHTML = 'The Comeout Roll';
  darkMode ? $('stage_of_game').style.color = '#eee' : $('stage_of_game').style.color = '#282829';
  $('the_point').innerHTML = "&#8211";
  letsHide('show_pl_odds_btn');
  thePlaceBets.areOff();
  for (let i = 0; i < 6; i++) {
    $(placeMenuBtns[i]).onclick = function () {show.offMenu(i + 5)};
  }
  //testMe.onStates();
}
// Hide
function hideBetMenu(betCode) {hide.betMenu(betCode);}
function hideAllMenus() {hide.allMenus();}
function showPreviousMenu(betCode) {
  letsShow(sixNumbers.betMenus[betCode - 5]);
  letsHide('comeout_roll_spread_menu');
}

// Show
function showBetMenu(betCode) {show.betMenu(betCode);}
function showOffMenu(betCode) {show.offMenu(betCode);}
function showDisclaimer() {show.disclaimer();}

// Universal Bet Actions
function betAll(betCode) {bet.all(betCode);}
function betMax(betCode) {bet.max(betCode);}
function removeBet(betCode) {bet.remove(betCode);}
function betSomethingElse(betCode) {bet.somethingElse(betCode);}

// Pass Line
function betPassLine(amt) {thePassLine.betIt(amt);}
function collectPassLine() {thePassLine.collectIt();}

// Pass Line Odds
function betPassLineOdds(amt) {passLineOdds.betIt(amt);}

// Place Bets
function turnOnAllPlaceBets() {thePlaceBets.turnOnAll();}
function turnOffAllPlaceBets() {thePlaceBets.turnOffAll();}
function turnOnPlace(betCode) {thePlaceBets.turnOn(betCode);}
function turnOffPlace(betCode) {thePlaceBets.turnOff(betCode);}
function allPlaceBetsDown() {thePlaceBets.allDown();}

function placeFour(amt) {theFour.placeIt(amt);}
function buyFour(amt) {theFour.buyIt(amt);}
function placeFive(amt) {theFive.placeIt(amt);}
function placeSix(amt) {theSix.placeIt(amt);}
function placeEight(amt) {theEight.placeIt(amt);}
function placeNine(amt) {theNine.placeIt(amt);}
function placeTen(amt) {theTen.placeIt(amt);}
function buyTen(amt) {theTen.buyIt(amt);}

function openBetEachMenu(betCode) {show.betEachMenu(betCode);}
function betEach(betCode, amt) {bet.each(betCode, amt);}

function openSpreadBetMenu(betCode) {show.spreadBetMenu(betCode);}
function betAcrossIncluding(amt) {bet.acrossIncluding(amt);}
function betAcross(amt) {bet.across(amt);}
function betInside(amt) {bet.inside(amt);}
function betOutside(amt) {bet.outside(amt);}
function betUptown(amt) {bet.uptown(amt);}
function betDowntown(amt) {bet.downtown(amt);}

// Place Pay Menu Options
function sameBet(betCode) {playerDoes.sameBet(betCode);}
function sameAndDown(betCode) {playerDoes.sameBetAndDown(betCode);}
function pressOneUnit(betCode) {playerDoes.pressOneUnit(betCode);}
function pressFiveUnits(betCode) {playerDoes.pressFiveUnits(betCode);}
function pressIt(betCode) {playerDoes.pressIt(betCode);}
function fullPress(betCode) {playerDoes.fullPress(betCode);}
function doubleUnitPress(betCode, amt) {playerDoes.doubleUnitPress(betCode, amt);}
function goTo(betCode, amt) {playerDoes.goTo(betCode, amt);}

// The Field
function betField(amt) {theField.betIt(amt);}
function collectAllField() {theField.collectAll();}
function rebetField(amt) {theField.rebetIt(amt);}
function stackField() {theField.stackIt();}
function collectHalfField() {theField.collectHalf();}
function collectThirdField() {theField.collectThird();}
function collectTwoThirdField() {theField.collectTwoThird();}

//Place Pay Menus
function showPlaceFourBtns (amt) {
  letsShow('four_pay_disclaimer');
  $('four_pay_disclaimer').innerHTML = "Try and stick to bets in normal increments. Use the 'Go to ' menu for normal betting amounts.";
  letsHide('four_press_buttons');
  letsHide('four_press_btn_1'); letsHide('four_press_btn_2'); letsHide('four_press_btn_3'); letsHide('four_press_btn_4');
  lineUp('four_go_to_btn_3'); lineUp('four_go_to_btn_4');
  letsHide('four_tbl_max_btn');
  letsHide('place_four_dble_box');
  letsMask('four_dbl_press_btn_2');
  letsHide('four_dble_btn_box_two');
  letsMask('four_dbl_press_btn_4');
  var equalUnits = theFour.placeBet == theTen.placeBet;
  if (theFour.hasBuy) {
    $('four_same_bet_btn').innerHTML = "$" + (amt * 2) + " for $" + theFour.vig + " - Same Bet";
  }
  switch (true) {
    case (amt == 5):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons');
      lineUp('four_press_btn_1'); lineUp('four_press_btn_3');
      letsHide('four_go_to_btn_3'); letsHide('four_go_to_btn_4');
      $('four_go_to_btn_1').innerHTML = "$10"; $('four_go_to_btn_1').onclick = function () {goTo(5, 10)};
      $('four_go_to_btn_2').innerHTML = "+1 to $15"; $('four_go_to_btn_2').onclick = function () {goTo(5, 15)};
      if(equalUnits) {
        letsShow('place_four_dble_box');
        $('four_dbl_press_btn_1').innerHTML = "+1 to $10e 4 &amp; 10"; $('four_dbl_press_btn_1').onclick = function () {doubleUnitPress(5, 10)};
      }
      break;
    case (amt == 10):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons');
      lineUp('four_press_btn_1');
      letsHide('four_go_to_btn_4');
      $('four_go_to_btn_1').innerHTML = "$15"; $('four_go_to_btn_1').onclick = function () {goTo(5, 15)};
      $('four_go_to_btn_2').innerHTML = "b$20"; $('four_go_to_btn_2').onclick = function () {goTo(5, 20)};
      $('four_go_to_btn_3').innerHTML = "b$25"; $('four_go_to_btn_3').onclick = function () {goTo(5, 25)};
      if(equalUnits) {
        letsShow('place_four_dble_box');
        $('four_dbl_press_btn_1').innerHTML = "$15e 4 &amp; 10"; $('four_dbl_press_btn_1').onclick = function () {doubleUnitPress(5, 15)};
      }
      break;
    case (amt == 15): 
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons');
      lineUp('four_press_btn_1');
      $('four_go_to_btn_1').innerHTML = "b$20"; $('four_go_to_btn_1').onclick = function () {goTo(5, 20)};
      $('four_go_to_btn_2').innerHTML = "b$25"; $('four_go_to_btn_2').onclick = function () {goTo(5, 25)};
      $('four_go_to_btn_3').innerHTML = "b$35"; $('four_go_to_btn_3').onclick = function () {goTo(5, 35)};
      $('four_go_to_btn_4').innerHTML = "b$40"; $('four_go_to_btn_4').onclick = function () {goTo(5, 40)};
      if(equalUnits) {
        letsShow('place_four_dble_box'); letsUnmask('four_dbl_press_btn_2');
        $('four_dbl_press_btn_1').innerHTML = "b$20e 4 &amp; 10"; $('four_dbl_press_btn_1').onclick = function () {doubleUnitPress(5, 20)};
        $('four_dbl_press_btn_2').innerHTML = "b$25e 4 &amp; 10"; $('four_dbl_press_btn_2').onclick = function () {doubleUnitPress(5, 25)};
      }
      break;
    case (amt == 20):
      letsHide('four_pay_disclaimer'); 
      letsShow('four_press_buttons');
      lineUp('four_press_btn_1'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$25"; $('four_go_to_btn_1').onclick = function () {goTo(5, 25)};
      $('four_go_to_btn_2').innerHTML = "b$35"; $('four_go_to_btn_2').onclick = function () {goTo(5, 35)};
      $('four_go_to_btn_3').innerHTML = "b$50"; $('four_go_to_btn_3').onclick = function () {goTo(5, 50)};
      $('four_go_to_btn_4').innerHTML = "+3 to b$60"; $('four_go_to_btn_4').onclick = function () {goTo(5, 60)};
      if(equalUnits) {
        letsShow('place_four_dble_box'); letsUnmask('four_dbl_press_btn_2');
        $('four_dbl_press_btn_1').innerHTML = "$25e 4 &amp; 10"; $('four_dbl_press_btn_1').onclick = function () {doubleUnitPress(5, 25)};
        $('four_dbl_press_btn_2').innerHTML = "$30e 4 &amp; 10"; $('four_dbl_press_btn_2').onclick = function () {doubleUnitPress(5, 30)};
        letsShow('four_dble_btn_box_two'); letsUnmask('four_dbl_press_btn_4');
        $('four_dbl_press_btn_3').innerHTML = "$35e 4 &amp; 10"; $('four_dbl_press_btn_3').onclick = function () {doubleUnitPress(5, 35)};
        $('four_dbl_press_btn_4').innerHTML = "+3 to $40e 4 &amp; 10"; $('four_dbl_press_btn_4').onclick = function () {doubleUnitPress(5, 40)};
      }
      break;
    case ((amt >= 21) && (amt <= 24)):
      $('four_go_to_btn_1').innerHTML = "b$25"; $('four_go_to_btn_1').onclick = function () {goTo(5, 25)};
      $('four_go_to_btn_2').innerHTML = "b$30"; $('four_go_to_btn_2').onclick = function () {goTo(5, 30)};
      $('four_go_to_btn_3').innerHTML = "b$40"; $('four_go_to_btn_3').onclick = function () {goTo(5, 40)};
      $('four_go_to_btn_4').innerHTML = "b$50"; $('four_go_to_btn_4').onclick = function () {goTo(5, 50)};
      break;
    case (amt == 25):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons');
      lineUp('four_press_btn_1'); lineUp('four_press_btn_2'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$30"; $('four_go_to_btn_1').onclick = function () {goTo(5, 30)};
      $('four_go_to_btn_2').innerHTML = "b$35"; $('four_go_to_btn_2').onclick = function () {goTo(5, 35)};
      $('four_go_to_btn_3').innerHTML = "b$50"; $('four_go_to_btn_3').onclick = function () {goTo(5, 50)};
      $('four_go_to_btn_4').innerHTML = "+3 to b$75"; $('four_go_to_btn_4').onclick = function () {goTo(5, 75)};
      if(equalUnits) {
        letsShow('place_four_dble_box'); letsUnmask('four_dbl_press_btn_2');
        $('four_dbl_press_btn_1').innerHTML = "$30e 4 &amp; 10"; $('four_dbl_press_btn_1').onclick = function () {doubleUnitPress(5, 30)};
        $('four_dbl_press_btn_2').innerHTML = "$35e 4 &amp; 10"; $('four_dbl_press_btn_2').onclick = function () {doubleUnitPress(5, 35)};
        letsShow('four_dble_btn_box_two'); letsUnmask('four_dbl_press_btn_4');
        $('four_dbl_press_btn_3').innerHTML = "$40e 4 &amp; 10"; $('four_dbl_press_btn_3').onclick = function () {doubleUnitPress(5, 40)};
        $('four_dbl_press_btn_4').innerHTML = "+3 to $50e 4 &amp; 10"; $('four_dbl_press_btn_4').onclick = function () {doubleUnitPress(5, 50)};
      }
      break;
    case ((amt >= 26) && (amt <= 29)):
      $('four_go_to_btn_1').innerHTML = "b$30"; $('four_go_to_btn_1').onclick = function () {goTo(5, 30)};
      $('four_go_to_btn_2').innerHTML = "b$35"; $('four_go_to_btn_2').onclick = function () {goTo(5, 35)};
      $('four_go_to_btn_3').innerHTML = "b$50"; $('four_go_to_btn_3').onclick = function () {goTo(5, 50)};
      $('four_go_to_btn_4').innerHTML = "b$60"; $('four_go_to_btn_4').onclick = function () {goTo(5, 60)};
      break;
    case (amt == 30):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons');
      lineUp('four_press_btn_1'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$35"; $('four_go_to_btn_1').onclick = function () {goTo(5, 35)};
      $('four_go_to_btn_2').innerHTML = "b$50"; $('four_go_to_btn_2').onclick = function () {goTo(5, 50)};
      $('four_go_to_btn_3').innerHTML = "b$75"; $('four_go_to_btn_3').onclick = function () {goTo(5, 75)};
      $('four_go_to_btn_4').innerHTML = "+3 to b$90"; $('four_go_to_btn_4').onclick = function () {goTo(5, 90)};
      if(equalUnits) {
        letsShow('place_four_dble_box'); letsUnmask('four_dbl_press_btn_2');
        $('four_dbl_press_btn_1').innerHTML = "$35e 4 &amp; 10"; $('four_dbl_press_btn_1').onclick = function () {doubleUnitPress(5, 35)};
        $('four_dbl_press_btn_2').innerHTML = "$40e 4 &amp; 10"; $('four_dbl_press_btn_2').onclick = function () {doubleUnitPress(5, 40)};
        letsShow('four_dble_btn_box_two');
        $('four_dbl_press_btn_3').innerHTML = "$50e 4 &amp; 10"; $('four_dbl_press_btn_3').onclick = function () {doubleUnitPress(5, 50)};
      }
      break;
    case ((amt >= 31) && (amt <= 34)):
      $('four_go_to_btn_1').innerHTML = "b$35"; $('four_go_to_btn_1').onclick = function () {goTo(5, 35)};
      $('four_go_to_btn_2').innerHTML = "b$50"; $('four_go_to_btn_2').onclick = function () {goTo(5, 50)};
      $('four_go_to_btn_3').innerHTML = "b$60"; $('four_go_to_btn_3').onclick = function () {goTo(5, 60)};
      $('four_go_to_btn_4').innerHTML = "b$75"; $('four_go_to_btn_4').onclick = function () {goTo(5, 75)};
      break;
    case (amt == 35):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons');
      lineUp('four_press_btn_1'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$40"; $('four_go_to_btn_1').onclick = function () {goTo(5, 40)};
      $('four_go_to_btn_2').innerHTML = "b$50"; $('four_go_to_btn_2').onclick = function () {goTo(5, 50)};
      $('four_go_to_btn_3').innerHTML = "b$75"; $('four_go_to_btn_3').onclick = function () {goTo(5, 75)};
      $('four_go_to_btn_4').innerHTML = "b$100"; $('four_go_to_btn_4').onclick = function () {goTo(5, 100)};
      if(equalUnits) {
        letsShow('place_four_dble_box'); letsUnmask('four_dbl_press_btn_2');
        $('four_dbl_press_btn_1').innerHTML = "$40e 4 &amp; 10"; $('four_dbl_press_btn_1').onclick = function () {doubleUnitPress(5, 40)};
        $('four_dbl_press_btn_2').innerHTML = "$50e 4 &amp; 10"; $('four_dbl_press_btn_2').onclick = function () {doubleUnitPress(5, 50)};
      }
      break;
    case ((amt >= 36) && (amt <= 39)):
      $('four_go_to_btn_1').innerHTML = "b$40"; $('four_go_to_btn_1').onclick = function () {goTo(5, 40)};
      $('four_go_to_btn_2').innerHTML = "b$50"; $('four_go_to_btn_2').onclick = function () {goTo(5, 50)};
      $('four_go_to_btn_3').innerHTML = "b$75"; $('four_go_to_btn_3').onclick = function () {goTo(5, 75)};
      $('four_go_to_btn_4').innerHTML = "b$100"; $('four_go_to_btn_4').onclick = function () {goTo(5, 100)};
      break;
    case (amt == 40):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons');
      lineUp('four_press_btn_1'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$50"; $('four_go_to_btn_1').onclick = function () {goTo(5, 50)};
      $('four_go_to_btn_2').innerHTML = "b$75"; $('four_go_to_btn_2').onclick = function () {goTo(5, 75)};
      $('four_go_to_btn_3').innerHTML = "b$100"; $('four_go_to_btn_3').onclick = function () {goTo(5, 100)};
      $('four_go_to_btn_4').innerHTML = "+6 to b$120"; $('four_go_to_btn_4').onclick = function () {goTo(5, 120)};
      if(equalUnits) {
        letsShow('place_four_dble_box'); letsUnmask('four_dbl_press_btn_2');
        $('four_dbl_press_btn_1').innerHTML = "$50e 4 &amp; 10"; $('four_dbl_press_btn_1').onclick = function () {doubleUnitPress(5, 50)};
        $('four_dbl_press_btn_2').innerHTML = "$75e 4 &amp; 10"; $('four_dbl_press_btn_2').onclick = function () {doubleUnitPress(5, 75)};
      }
      break;
    case ((amt >= 41) && (amt <= 44)):
      $('four_go_to_btn_1').innerHTML = "b$50"; $('four_go_to_btn_1').onclick = function () {goTo(5, 50)};
      $('four_go_to_btn_2').innerHTML = "b$60"; $('four_go_to_btn_2').onclick = function () {goTo(5, 60)};
      $('four_go_to_btn_3').innerHTML = "b$75"; $('four_go_to_btn_3').onclick = function () {goTo(5, 75)};
      $('four_go_to_btn_4').innerHTML = "b$100"; $('four_go_to_btn_4').onclick = function () {goTo(5, 100)};
      break;
    case (amt == 45):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons');
      lineUp('four_press_btn_1'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$50"; $('four_go_to_btn_1').onclick = function () {goTo(5, 50)};
      $('four_go_to_btn_2').innerHTML = "b$75"; $('four_go_to_btn_2').onclick = function () {goTo(5, 75)};
      $('four_go_to_btn_3').innerHTML = "b$100"; $('four_go_to_btn_3').onclick = function () {goTo(5, 100)};
      $('four_go_to_btn_4').innerHTML = "b$125"; $('four_go_to_btn_4').onclick = function () {goTo(5, 125)};
      break;
    case ((amt >= 46) && (amt <= 49)):
      $('four_go_to_btn_1').innerHTML = "b$50"; $('four_go_to_btn_1').onclick = function () {goTo(5, 50)};
      $('four_go_to_btn_2').innerHTML = "b$75"; $('four_go_to_btn_2').onclick = function () {goTo(5, 75)};
      $('four_go_to_btn_3').innerHTML = "b$100"; $('four_go_to_btn_3').onclick = function () {goTo(5, 100)};
      $('four_go_to_btn_4').innerHTML = "b$125"; $('four_go_to_btn_4').onclick = function () {goTo(5, 125)};
      break;
    case (amt == 50):
      letsHide('four_pay_disclaimer'); 
      letsShow('four_press_buttons');
      lineUp('four_press_btn_2'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$75"; $('four_go_to_btn_1').onclick = function () {goTo(5, 75)};
      $('four_go_to_btn_2').innerHTML = "b$100"; $('four_go_to_btn_2').onclick = function () {goTo(5, 100)};
      $('four_go_to_btn_3').innerHTML = "b$125"; $('four_go_to_btn_3').onclick = function () {goTo(5, 125)};
      if (money.extraVig == 0) {
        $('four_go_to_btn_4').innerHTML = "+7 to b$150"; $('four_go_to_btn_4').onclick = function () {goTo(5, 150)};
      } else {
        $('four_go_to_btn_4').innerHTML = "+6 to b$150"; $('four_go_to_btn_4').onclick = function () {goTo(5, 150)};
      }
      if(equalUnits) {
        letsShow('place_four_dble_box'); letsUnmask('four_dbl_press_btn_2');
        $('four_dbl_press_btn_1').innerHTML = "$75e 4 &amp; 10"; $('four_dbl_press_btn_1').onclick = function () {doubleUnitPress(5, 75)};
        if (money.extraVig == 0) {
          $('four_dbl_press_btn_2').innerHTML = "+8 to $100e 4 &amp; 10"; $('four_dbl_press_btn_2').onclick = function () {doubleUnitPress(5, 100)};
        } else {
          $('four_dbl_press_btn_2').innerHTML = "+7 to $100e 4 &amp; 10"; $('four_dbl_press_btn_2').onclick = function () {doubleUnitPress(5, 100)};
        }
      }
      break;
    case ((amt >= 51) && (amt <= 54)):
      $('four_go_to_btn_1').innerHTML = "b$60"; $('four_go_to_btn_1').onclick = function () {goTo(5, 60)};
      $('four_go_to_btn_2').innerHTML = "b$75"; $('four_go_to_btn_2').onclick = function () {goTo(5, 75)};
      $('four_go_to_btn_3').innerHTML = "b$100"; $('four_go_to_btn_3').onclick = function () {goTo(5, 100)};
      $('four_go_to_btn_4').innerHTML = "b$125"; $('four_go_to_btn_4').onclick = function () {goTo(5, 125)};
      break;
    case (amt == 55):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons');
      lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$75"; $('four_go_to_btn_1').onclick = function () {goTo(5, 75)};
      $('four_go_to_btn_2').innerHTML = "b$100"; $('four_go_to_btn_2').onclick = function () {goTo(5, 100)};
      $('four_go_to_btn_3').innerHTML = "b$125"; $('four_go_to_btn_3').onclick = function () {goTo(5, 125)};
      $('four_go_to_btn_4').innerHTML = "b$150"; $('four_go_to_btn_4').onclick = function () {goTo(5, 150)};
      break;
    case ((amt >= 56) && (amt <= 59)):
      $('four_go_to_btn_1').innerHTML = "b$75"; $('four_go_to_btn_1').onclick = function () {goTo(5, 75)};
      $('four_go_to_btn_2').innerHTML = "b$100"; $('four_go_to_btn_2').onclick = function () {goTo(5, 100)};
      $('four_go_to_btn_3').innerHTML = "b$125"; $('four_go_to_btn_3').onclick = function () {goTo(5, 125)};
      $('four_go_to_btn_4').innerHTML = "b$150"; $('four_go_to_btn_4').onclick = function () {goTo(5, 150)};
      break;
    case (amt == 60):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons');
      lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$75"; $('four_go_to_btn_1').onclick = function () {goTo(5, 75)};
      $('four_go_to_btn_2').innerHTML = "b$100"; $('four_go_to_btn_2').onclick = function () {goTo(5, 100)};
      $('four_go_to_btn_3').innerHTML = "b$125"; $('four_go_to_btn_3').onclick = function () {goTo(5, 125)};
      $('four_go_to_btn_4').innerHTML = "b$150"; $('four_go_to_btn_4').onclick = function () {goTo(5, 150)};
      break;
    case ((amt >= 61) && (amt <= 64)):
      $('four_go_to_btn_1').innerHTML = "b$75"; $('four_go_to_btn_1').onclick = function () {goTo(5, 75)};
      $('four_go_to_btn_2').innerHTML = "b$100"; $('four_go_to_btn_2').onclick = function () {goTo(5, 100)};
      $('four_go_to_btn_3').innerHTML = "b$125"; $('four_go_to_btn_3').onclick = function () {goTo(5, 125)};
      $('four_go_to_btn_4').innerHTML = "b$150"; $('four_go_to_btn_4').onclick = function () {goTo(5, 150)};
      break;
    case (amt == 65):
      letsHide('four_pay_disclaimer');
      $('four_go_to_btn_1').innerHTML = "b$75"; $('four_go_to_btn_1').onclick = function () {goTo(5, 75)};
      $('four_go_to_btn_2').innerHTML = "b$100"; $('four_go_to_btn_2').onclick = function () {goTo(5, 100)};
      $('four_go_to_btn_3').innerHTML = "b$125"; $('four_go_to_btn_3').onclick = function () {goTo(5, 125)};
      $('four_go_to_btn_4').innerHTML = "b$150"; $('four_go_to_btn_4').onclick = function () {goTo(5, 150)};
      break;
    case ((amt >= 66) && (amt <= 69)):
      $('four_go_to_btn_1').innerHTML = "b$75"; $('four_go_to_btn_1').onclick = function () {goTo(5, 75)};
      $('four_go_to_btn_2').innerHTML = "b$100"; $('four_go_to_btn_2').onclick = function () {goTo(5, 100)};
      $('four_go_to_btn_3').innerHTML = "b$125"; $('four_go_to_btn_3').onclick = function () {goTo(5, 125)};
      $('four_go_to_btn_4').innerHTML = "b$150"; $('four_go_to_btn_4').onclick = function () {goTo(5, 150)};
      break;
    case (amt == 70):
      letsHide('four_pay_disclaimer');
      $('four_go_to_btn_1').innerHTML = "b$100"; $('four_go_to_btn_1').onclick = function () {goTo(5, 100)};
      $('four_go_to_btn_2').innerHTML = "b$125"; $('four_go_to_btn_2').onclick = function () {goTo(5, 125)};
      $('four_go_to_btn_3').innerHTML = "b$150"; $('four_go_to_btn_3').onclick = function () {goTo(5, 150)};
      $('four_go_to_btn_4').innerHTML = "b$200"; $('four_go_to_btn_4').onclick = function () {goTo(5, 200)};
      break;
    case ((amt >= 71) && (amt <= 74)):
      $('four_go_to_btn_1').innerHTML = "b$100"; $('four_go_to_btn_1').onclick = function () {goTo(5, 100)};
      $('four_go_to_btn_2').innerHTML = "b$125"; $('four_go_to_btn_2').onclick = function () {goTo(5, 125)};
      $('four_go_to_btn_3').innerHTML = "b$150"; $('four_go_to_btn_3').onclick = function () {goTo(5, 150)};
      $('four_go_to_btn_4').innerHTML = "b$200"; $('four_go_to_btn_4').onclick = function () {goTo(5, 200)};
      break;
    case (amt == 75):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons');
      lineUp('four_press_btn_2'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$100"; $('four_go_to_btn_1').onclick = function () {goTo(5, 100)};
      $('four_go_to_btn_2').innerHTML = "b$125"; $('four_go_to_btn_2').onclick = function () {goTo(5, 125)};
      $('four_go_to_btn_3').innerHTML = "b$150"; $('four_go_to_btn_3').onclick = function () {goTo(5, 150)};
      $('four_go_to_btn_4').innerHTML = "b$200"; $('four_go_to_btn_4').onclick = function () {goTo(5, 200)};
      if(equalUnits) {
        letsShow('place_four_dble_box'); letsUnmask('four_dbl_press_btn_2');
        $('four_dbl_press_btn_1').innerHTML = "$100e 4 &amp; 10"; $('four_dbl_press_btn_1').onclick = function () {doubleUnitPress(5, 100)};
        $('four_dbl_press_btn_2').innerHTML = "$125e 4 &amp; 10"; $('four_dbl_press_btn_2').onclick = function () {doubleUnitPress(5, 125)};
        letsShow('four_dble_btn_box_two');
        $('four_dbl_press_btn_3').innerHTML = "+10 to $150e 4 &amp; 10"; $('four_dbl_press_btn_3').onclick = function () {doubleUnitPress(5, 150)};
      }
      break;
    case ((amt >= 76) && (amt <= 79)):
      $('four_go_to_btn_1').innerHTML = "b$100"; $('four_go_to_btn_1').onclick = function () {goTo(5, 100)};
      $('four_go_to_btn_2').innerHTML = "b$125"; $('four_go_to_btn_2').onclick = function () {goTo(5, 125)};
      $('four_go_to_btn_3').innerHTML = "b$150"; $('four_go_to_btn_3').onclick = function () {goTo(5, 150)};
      $('four_go_to_btn_4').innerHTML = "b$200"; $('four_go_to_btn_4').onclick = function () {goTo(5, 200)};
      break;
    case ((amt == 80) || (amt == 85)):
      letsHide('four_pay_disclaimer');
      $('four_go_to_btn_1').innerHTML = "b$100"; $('four_go_to_btn_1').onclick = function () {goTo(5, 100)};
      $('four_go_to_btn_2').innerHTML = "b$125"; $('four_go_to_btn_2').onclick = function () {goTo(5, 125)};
      $('four_go_to_btn_3').innerHTML = "b$150"; $('four_go_to_btn_3').onclick = function () {goTo(5, 150)};
      $('four_go_to_btn_4').innerHTML = "b$200"; $('four_go_to_btn_4').onclick = function () {goTo(5, 200)};
      break;
    case ((amt >= 81) && (amt <= 84)):
    case ((amt >= 86) && (amt <= 89)):
      $('four_go_to_btn_1').innerHTML = "b$100"; $('four_go_to_btn_1').onclick = function () {goTo(5, 100)};
      $('four_go_to_btn_2').innerHTML = "b$125"; $('four_go_to_btn_2').onclick = function () {goTo(5, 125)};
      $('four_go_to_btn_3').innerHTML = "b$150"; $('four_go_to_btn_3').onclick = function () {goTo(5, 150)};
      $('four_go_to_btn_4').innerHTML = "b$200"; $('four_go_to_btn_4').onclick = function () {goTo(5, 200)};
      break;
    case ((amt == 90) || (amt == 95)):
      letsHide('four_pay_disclaimer');
      $('four_go_to_btn_1').innerHTML = "b$100"; $('four_go_to_btn_1').onclick = function () {goTo(5, 100)};
      $('four_go_to_btn_2').innerHTML = "b$125"; $('four_go_to_btn_2').onclick = function () {goTo(5, 125)};
      $('four_go_to_btn_3').innerHTML = "b$200"; $('four_go_to_btn_3').onclick = function () {goTo(5, 200)};
      $('four_go_to_btn_4').innerHTML = "b$250"; $('four_go_to_btn_4').onclick = function () {goTo(5, 250)};
      break;
    case ((amt >= 91) && (amt <= 94)):
    case ((amt >= 96) && (amt <= 99)):
      $('four_go_to_btn_1').innerHTML = "b$100"; $('four_go_to_btn_1').onclick = function () {goTo(5, 100)};
      $('four_go_to_btn_2').innerHTML = "b$125"; $('four_go_to_btn_2').onclick = function () {goTo(5, 125)};
      $('four_go_to_btn_3').innerHTML = "b$200"; $('four_go_to_btn_3').onclick = function () {goTo(5, 200)};
      $('four_go_to_btn_4').innerHTML = "b$250"; $('four_go_to_btn_4').onclick = function () {goTo(5, 250)};
      break;
    case (amt == 100):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons');
      lineUp('four_press_btn_2'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$125"; $('four_go_to_btn_1').onclick = function () {goTo(5, 125)};
      $('four_go_to_btn_2').innerHTML = "b$150"; $('four_go_to_btn_2').onclick = function () {goTo(5, 150)};
      $('four_go_to_btn_3').innerHTML = "b$200"; $('four_go_to_btn_3').onclick = function () {goTo(5, 200)};
      $('four_go_to_btn_4').innerHTML = "+15 to b$300"; $('four_go_to_btn_4').onclick = function () {goTo(5, 300)};
      if(equalUnits) {
        letsShow('place_four_dble_box'); letsUnmask('four_dbl_press_btn_2');
        $('four_dbl_press_btn_1').innerHTML = "b$150e 4 &amp; 10"; $('four_dbl_press_btn_1').onclick = function () {doubleUnitPress(5, 150)};
        $('four_dbl_press_btn_2').innerHTML = "+15 to b$200e 4 &amp; 10"; $('four_dbl_press_btn_2').onclick = function () {doubleUnitPress(5, 200)};
      }
      break;
    case ((amt >= 101) && (amt <= 104)):
      $('four_go_to_btn_1').innerHTML = "b$125"; $('four_go_to_btn_1').onclick = function () {goTo(5, 125)};
      $('four_go_to_btn_2').innerHTML = "b$150"; $('four_go_to_btn_2').onclick = function () {goTo(5, 150)};
      $('four_go_to_btn_3').innerHTML = "b$200"; $('four_go_to_btn_3').onclick = function () {goTo(5, 200)};
      $('four_go_to_btn_4').innerHTML = "b$250"; $('four_go_to_btn_4').onclick = function () {goTo(5, 250)};
      break;
    case ((amt == 105) || (amt == 110) || (amt == 115) || (amt == 120)):
      letsHide('four_pay_disclaimer');
      $('four_go_to_btn_1').innerHTML = "b$150"; $('four_go_to_btn_1').onclick = function () {goTo(5, 150)};
      $('four_go_to_btn_2').innerHTML = "b$200"; $('four_go_to_btn_2').onclick = function () {goTo(5, 200)};
      $('four_go_to_btn_3').innerHTML = "b$250"; $('four_go_to_btn_3').onclick = function () {goTo(5, 250)};
      $('four_go_to_btn_4').innerHTML = "b$300"; $('four_go_to_btn_4').onclick = function () {goTo(5, 300)};
      break;
    case ((amt >= 106) && (amt <= 109)):
    case ((amt >= 111) && (amt <= 114)):
    case ((amt >= 116) && (amt <= 119)):
    case ((amt >= 121) && (amt <= 124)):
      $('four_go_to_btn_1').innerHTML = "b$150"; $('four_go_to_btn_1').onclick = function () {goTo(5, 150)};
      $('four_go_to_btn_2').innerHTML = "b$200"; $('four_go_to_btn_2').onclick = function () {goTo(5, 200)};
      $('four_go_to_btn_3').innerHTML = "b$250"; $('four_go_to_btn_3').onclick = function () {goTo(5, 250)};
      $('four_go_to_btn_4').innerHTML = "b$300"; $('four_go_to_btn_4').onclick = function () {goTo(5, 300)};
      break;
    case (amt == 125):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons'); lineUp('four_press_btn_2'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$150"; $('four_go_to_btn_1').onclick = function () {goTo(5, 150)};
      $('four_go_to_btn_2').innerHTML = "b$200"; $('four_go_to_btn_2').onclick = function () {goTo(5, 200)};
      $('four_go_to_btn_3').innerHTML = "b$250"; $('four_go_to_btn_3').onclick = function () {goTo(5, 250)};
      $('four_go_to_btn_4').innerHTML = "b$350"; $('four_go_to_btn_4').onclick = function () {goTo(5, 350)};
      break;
    case ((amt >= 126) && (amt <= 134)):
      $('four_go_to_btn_1').innerHTML = "b$150"; $('four_go_to_btn_1').onclick = function () {goTo(5, 150)};
      $('four_go_to_btn_2').innerHTML = "b$200"; $('four_go_to_btn_2').onclick = function () {goTo(5, 200)};
      $('four_go_to_btn_3').innerHTML = "b$250"; $('four_go_to_btn_3').onclick = function () {goTo(5, 250)};
      $('four_go_to_btn_4').innerHTML = "b$350"; $('four_go_to_btn_4').onclick = function () {goTo(5, 350)};
      break;
    case ((amt == 135) || (amt == 149)):
      $('four_go_to_btn_1').innerHTML = "b$150"; $('four_go_to_btn_1').onclick = function () {goTo(5, 150)};
      $('four_go_to_btn_2').innerHTML = "b$200"; $('four_go_to_btn_2').onclick = function () {goTo(5, 200)};
      $('four_go_to_btn_3').innerHTML = "b$300"; $('four_go_to_btn_3').onclick = function () {goTo(5, 300)};
      $('four_go_to_btn_4').innerHTML = "b$400"; $('four_go_to_btn_4').onclick = function () {goTo(5, 400)};
      break;
    case (amt == 150):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons'); lineUp('four_press_btn_2'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$200"; $('four_go_to_btn_1').onclick = function () {goTo(5, 200)};
      $('four_go_to_btn_2').innerHTML = "b$250"; $('four_go_to_btn_2').onclick = function () {goTo(5, 250)};
      $('four_go_to_btn_3').innerHTML = "b$400"; $('four_go_to_btn_3').onclick = function () {goTo(5, 400)};
      $('four_go_to_btn_4').innerHTML = "+21 to b$450"; $('four_go_to_btn_4').onclick = function () {goTo(5, 450)};
      if(equalUnits) {
        letsShow('place_four_dble_box'); letsUnmask('four_dbl_press_btn_2');
        $('four_dbl_press_btn_1').innerHTML = "b$200e 4 &amp; 10"; $('four_dbl_press_btn_1').onclick = function () {doubleUnitPress(5, 200)};
        $('four_dbl_press_btn_2').innerHTML = "b$250e 4 &amp; 10"; $('four_dbl_press_btn_2').onclick = function () {doubleUnitPress(5, 250)};
      }
      break;
    case ((amt >= 151) && (amt <= 174)):
      $('four_go_to_btn_1').innerHTML = "b$200"; $('four_go_to_btn_1').onclick = function () {goTo(5, 200)};
      $('four_go_to_btn_2').innerHTML = "b$250"; $('four_go_to_btn_2').onclick = function () {goTo(5, 250)};
      $('four_go_to_btn_3').innerHTML = "b$400"; $('four_go_to_btn_3').onclick = function () {goTo(5, 400)};
      $('four_go_to_btn_4').innerHTML = "b$450"; $('four_go_to_btn_4').onclick = function () {goTo(5, 450)};
      break;
    case (amt == 175):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons'); lineUp('four_press_btn_2'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$200"; $('four_go_to_btn_1').onclick = function () {goTo(5, 200)};
      $('four_go_to_btn_2').innerHTML = "b$300"; $('four_go_to_btn_2').onclick = function () {goTo(5, 300)};
      $('four_go_to_btn_3').innerHTML = "b$400"; $('four_go_to_btn_3').onclick = function () {goTo(5, 400)};
      $('four_go_to_btn_4').innerHTML = "b$500"; $('four_go_to_btn_4').onclick = function () {goTo(5, 500)};
      break;
    case ((amt >= 176) && (amt <= 199)):
      $('four_go_to_btn_1').innerHTML = "b$200"; $('four_go_to_btn_1').onclick = function () {goTo(5, 200)};
      $('four_go_to_btn_2').innerHTML = "b$300"; $('four_go_to_btn_2').onclick = function () {goTo(5, 300)};
      $('four_go_to_btn_3').innerHTML = "b$400"; $('four_go_to_btn_3').onclick = function () {goTo(5, 400)};
      $('four_go_to_btn_4').innerHTML = "b$500"; $('four_go_to_btn_4').onclick = function () {goTo(5, 500)};
      break;
    case (amt == 200):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$300"; $('four_go_to_btn_1').onclick = function () {goTo(5, 300)};
      $('four_go_to_btn_2').innerHTML = "b$400"; $('four_go_to_btn_2').onclick = function () {goTo(5, 400)};
      $('four_go_to_btn_3').innerHTML = "b$500"; $('four_go_to_btn_3').onclick = function () {goTo(5, 500)};
      $('four_go_to_btn_4').innerHTML = "+30 to b$600"; $('four_go_to_btn_4').onclick = function () {goTo(5, 600)};
      if(equalUnits) {
        letsShow('place_four_dble_box');
        $('four_dbl_press_btn_1').innerHTML = "b$250e 4 &amp; 10"; $('four_dbl_press_btn_1').onclick = function () {doubleUnitPress(5, 250)};
      }
      break;
    case ((amt >= 201) && (amt <= 224)):
      $('four_go_to_btn_1').innerHTML = "b$250"; $('four_go_to_btn_1').onclick = function () {goTo(5, 250)};
      $('four_go_to_btn_2').innerHTML = "b$300"; $('four_go_to_btn_2').onclick = function () {goTo(5, 300)};
      $('four_go_to_btn_3').innerHTML = "b$400"; $('four_go_to_btn_3').onclick = function () {goTo(5, 400)};
      $('four_go_to_btn_4').innerHTML = "b$500"; $('four_go_to_btn_4').onclick = function () {goTo(5, 500)};
      break;
    case (amt == 225):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons'); lineUp('four_press_btn_2'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$300"; $('four_go_to_btn_1').onclick = function () {goTo(5, 300)};
      $('four_go_to_btn_2').innerHTML = "b$400"; $('four_go_to_btn_2').onclick = function () {goTo(5, 400)};
      $('four_go_to_btn_3').innerHTML = "b$500"; $('four_go_to_btn_3').onclick = function () {goTo(5, 500)};
      $('four_go_to_btn_4').innerHTML = "b$600"; $('four_go_to_btn_4').onclick = function () {goTo(5, 600)};
      break;
    case ((amt >= 226) && (amt <= 249)):
      $('four_go_to_btn_1').innerHTML = "b$300"; $('four_go_to_btn_1').onclick = function () {goTo(5, 300)};
      $('four_go_to_btn_2').innerHTML = "b$400"; $('four_go_to_btn_2').onclick = function () {goTo(5, 400)};
      $('four_go_to_btn_3').innerHTML = "b$500"; $('four_go_to_btn_3').onclick = function () {goTo(5, 500)};
      $('four_go_to_btn_4').innerHTML = "b$600"; $('four_go_to_btn_4').onclick = function () {goTo(5, 600)};
      break;
    case (amt == 250):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$400"; $('four_go_to_btn_1').onclick = function () {goTo(5, 400)};
      $('four_go_to_btn_2').innerHTML = "b$500"; $('four_go_to_btn_2').onclick = function () {goTo(5, 500)};
      $('four_go_to_btn_3').innerHTML = "b$600"; $('four_go_to_btn_3').onclick = function () {goTo(5, 600)};
      $('four_go_to_btn_4').innerHTML = "+36 to b$750"; $('four_go_to_btn_4').onclick = function () {goTo(5, 750)};
      break;
    case ((amt >= 251) && (amt <= 299)):
      $('four_go_to_btn_1').innerHTML = "b$400"; $('four_go_to_btn_1').onclick = function () {goTo(5, 400)};
      $('four_go_to_btn_2').innerHTML = "b$500"; $('four_go_to_btn_2').onclick = function () {goTo(5, 500)};
      $('four_go_to_btn_3').innerHTML = "b$600"; $('four_go_to_btn_3').onclick = function () {goTo(5, 600)};
      $('four_go_to_btn_4').innerHTML = "b$700"; $('four_go_to_btn_4').onclick = function () {goTo(5, 700)};
      break;
    case (amt == 300):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$400"; $('four_go_to_btn_1').onclick = function () {goTo(5, 400)};
      $('four_go_to_btn_2').innerHTML = "b$500"; $('four_go_to_btn_2').onclick = function () {goTo(5, 500)};
      $('four_go_to_btn_3').innerHTML = "b$750"; $('four_go_to_btn_3').onclick = function () {goTo(5, 750)};
      $('four_go_to_btn_4').innerHTML = "+45 to b$900"; $('four_go_to_btn_4').onclick = function () {goTo(5, 900)};
      break;
    case ((amt >= 301) && (amt <= 349)):
      $('four_go_to_btn_1').innerHTML = "b$400"; $('four_go_to_btn_1').onclick = function () {goTo(5, 400)};
      $('four_go_to_btn_2').innerHTML = "b$500"; $('four_go_to_btn_2').onclick = function () {goTo(5, 500)};
      $('four_go_to_btn_3').innerHTML = "b$750"; $('four_go_to_btn_3').onclick = function () {goTo(5, 750)};
      $('four_go_to_btn_4').innerHTML = "b$800"; $('four_go_to_btn_4').onclick = function () {goTo(5, 800)};
      break;
    case (amt == 350):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$400"; $('four_go_to_btn_1').onclick = function () {goTo(5, 400)};
      $('four_go_to_btn_2').innerHTML = "b$500"; $('four_go_to_btn_2').onclick = function () {goTo(5, 500)};
      $('four_go_to_btn_3').innerHTML = "b$750"; $('four_go_to_btn_3').onclick = function () {goTo(5, 750)};
      $('four_go_to_btn_4').innerHTML = "b$1,000"; $('four_go_to_btn_4').onclick = function () {goTo(5, 1000)};
      break;
    case ((amt >= 351) && (amt <= 399)):
    case ((amt >= 401) && (amt <= 449)):
    case ((amt >= 451) && (amt <= 499)):
      $('four_go_to_btn_1').innerHTML = "b$500"; $('four_go_to_btn_1').onclick = function () {goTo(5, 500)};
      $('four_go_to_btn_2').innerHTML = "b$600"; $('four_go_to_btn_2').onclick = function () {goTo(5, 600)};
      $('four_go_to_btn_3').innerHTML = "b$750"; $('four_go_to_btn_3').onclick = function () {goTo(5, 750)};
      $('four_go_to_btn_4').innerHTML = "b$1,000"; $('four_go_to_btn_4').onclick = function () {goTo(5, 1000)};
      break;
    case ((amt == 400) && (amt == 450)):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$500"; $('four_go_to_btn_1').onclick = function () {goTo(5, 500)};
      $('four_go_to_btn_2').innerHTML = "b$600"; $('four_go_to_btn_2').onclick = function () {goTo(5, 600)};
      $('four_go_to_btn_3').innerHTML = "b$750"; $('four_go_to_btn_3').onclick = function () {goTo(5, 750)};
      $('four_go_to_btn_4').innerHTML = "b$1,000"; $('four_go_to_btn_4').onclick = function () {goTo(5, 1000)};
      break;
    case (amt == 500):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$600"; $('four_go_to_btn_1').onclick = function () {goTo(5, 600)};
      $('four_go_to_btn_2').innerHTML = "b$750"; $('four_go_to_btn_2').onclick = function () {goTo(5, 750)};
      $('four_go_to_btn_3').innerHTML = "b$1,000"; $('four_go_to_btn_3').onclick = function () {goTo(5, 1000)};
      $('four_go_to_btn_4').innerHTML = "+75 to b$1,500"; $('four_go_to_btn_4').onclick = function () {goTo(5, 1500)};
      break;
    case ((amt >= 501) && (amt <= 599)):
      $('four_go_to_btn_1').innerHTML = "b$600"; $('four_go_to_btn_1').onclick = function () {goTo(5, 600)};
      $('four_go_to_btn_2').innerHTML = "b$750"; $('four_go_to_btn_2').onclick = function () {goTo(5, 750)};
      $('four_go_to_btn_3').innerHTML = "b$800"; $('four_go_to_btn_3').onclick = function () {goTo(5, 800)};
      $('four_go_to_btn_4').innerHTML = "b$1,000"; $('four_go_to_btn_4').onclick = function () {goTo(5, 1000)};
      break;
    case (amt == 600):
      letsHide('four_pay_disclaimer');
      $('four_go_to_btn_1').innerHTML = "b$600"; $('four_go_to_btn_1').onclick = function () {goTo(5, 600)};
      $('four_go_to_btn_2').innerHTML = "b$750"; $('four_go_to_btn_2').onclick = function () {goTo(5, 750)};
      $('four_go_to_btn_3').innerHTML = "b$1,000"; $('four_go_to_btn_3').onclick = function () {goTo(5, 1000)};
      $('four_go_to_btn_4').innerHTML = "b$1,500"; $('four_go_to_btn_4').onclick = function () {goTo(5, 1500)};
      break;
    case ((amt >= 601) && (amt <= 699)):
      $('four_go_to_btn_1').innerHTML = "b$600"; $('four_go_to_btn_1').onclick = function () {goTo(5, 600)};
      $('four_go_to_btn_2').innerHTML = "b$750"; $('four_go_to_btn_2').onclick = function () {goTo(5, 750)};
      $('four_go_to_btn_3').innerHTML = "b$1,000"; $('four_go_to_btn_3').onclick = function () {goTo(5, 1000)};
      $('four_go_to_btn_4').innerHTML = "b$1,500"; $('four_go_to_btn_4').onclick = function () {goTo(5, 1500)};
      break;
    case ((amt == 700) || (amt == 750) || (amt == 800)):
      letsHide('four_pay_disclaimer');
      $('four_go_to_btn_1').innerHTML = "b$900"; $('four_go_to_btn_1').onclick = function () {goTo(5, 900)};
      $('four_go_to_btn_2').innerHTML = "b$1,000"; $('four_go_to_btn_2').onclick = function () {goTo(5, 1000)};
      $('four_go_to_btn_3').innerHTML = "b$1,500"; $('four_go_to_btn_3').onclick = function () {goTo(5, 1500)};
      $('four_go_to_btn_4').innerHTML = "b$2,000"; $('four_go_to_btn_4').onclick = function () {goTo(5, 2000)};
      break;
    case ((amt >= 701) && (amt <= 749)):
    case ((amt >= 751) && (amt <= 799)):
    case ((amt >= 801) && (amt <= 899)):
      $('four_go_to_btn_1').innerHTML = "b$900"; $('four_go_to_btn_1').onclick = function () {goTo(5, 900)};
      $('four_go_to_btn_2').innerHTML = "b$1,000"; $('four_go_to_btn_2').onclick = function () {goTo(5, 1000)};
      $('four_go_to_btn_3').innerHTML = "b$1,500"; $('four_go_to_btn_3').onclick = function () {goTo(5, 1500)};
      $('four_go_to_btn_4').innerHTML = "b$2,000"; $('four_go_to_btn_4').onclick = function () {goTo(5, 2000)};
      break;
    case (amt == 900):
      letsHide('four_pay_disclaimer');
      $('four_go_to_btn_1').innerHTML = "b$1,000"; $('four_go_to_btn_1').onclick = function () {goTo(5, 1000)};
      $('four_go_to_btn_2').innerHTML = "b$1,500"; $('four_go_to_btn_2').onclick = function () {goTo(5, 1500)};
      $('four_go_to_btn_3').innerHTML = "b$2,000"; $('four_go_to_btn_3').onclick = function () {goTo(5, 2000)};
      $('four_go_to_btn_4').innerHTML = "b$2,500"; $('four_go_to_btn_4').onclick = function () {goTo(5, 2500)};
      break;
    case ((amt >= 901) && (amt <= 999)):
      $('four_go_to_btn_1').innerHTML = "b$1,000"; $('four_go_to_btn_1').onclick = function () {goTo(5, 1000)};
      $('four_go_to_btn_2').innerHTML = "b$1,500"; $('four_go_to_btn_2').onclick = function () {goTo(5, 1500)};
      $('four_go_to_btn_3').innerHTML = "b$2,000"; $('four_go_to_btn_3').onclick = function () {goTo(5, 2000)};
      $('four_go_to_btn_4').innerHTML = "b$2,500"; $('four_go_to_btn_4').onclick = function () {goTo(5, 2500)};
      break;
    case (amt == 1000):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$1,500"; $('four_go_to_btn_1').onclick = function () {goTo(5, 1500)};
      $('four_go_to_btn_2').innerHTML = "b$2,000"; $('four_go_to_btn_2').onclick = function () {goTo(5, 2000)};
      $('four_go_to_btn_3').innerHTML = "b$2,500"; $('four_go_to_btn_3').onclick = function () {goTo(5, 2500)};
      $('four_go_to_btn_4').innerHTML = "+150 to b$3,000"; $('four_go_to_btn_4').onclick = function () {goTo(5, 3000)};
      break;
    case ((amt >= 1001) && (amt <= 1049)):
      letsHide('four_go_to_btn_4');
      $('four_go_to_btn_1').innerHTML = "b$1,500"; $('four_go_to_btn_1').onclick = function () {goTo(5, 1500)};
      $('four_go_to_btn_2').innerHTML = "b$2,000"; $('four_go_to_btn_2').onclick = function () {goTo(5, 2000)};
      $('four_go_to_btn_3').innerHTML = "b$2,500"; $('four_go_to_btn_3').onclick = function () {goTo(5, 2500)};
      break;
    case ((amt >= 1050) && (amt <= 1499)):
      $('four_go_to_btn_1').innerHTML = "b$1,500"; $('four_go_to_btn_1').onclick = function () {goTo(5, 1500)};
      $('four_go_to_btn_2').innerHTML = "b$2,000"; $('four_go_to_btn_2').onclick = function () {goTo(5, 2000)};
      $('four_go_to_btn_3').innerHTML = "b$2,500"; $('four_go_to_btn_3').onclick = function () {goTo(5, 2500)};
      $('four_go_to_btn_4').innerHTML = "b$3,000"; $('four_go_to_btn_4').onclick = function () {goTo(5, 3000)};
      break;
    case (amt == 1500):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$2,500"; $('four_go_to_btn_1').onclick = function () {goTo(5, 2500)};
      $('four_go_to_btn_2').innerHTML = "b$3,000"; $('four_go_to_btn_2').onclick = function () {goTo(5, 3000)};
      $('four_go_to_btn_3').innerHTML = "b$3,500"; $('four_go_to_btn_3').onclick = function () {goTo(5, 3500)};
      $('four_go_to_btn_4').innerHTML = "b$4,000"; $('four_go_to_btn_4').onclick = function () {goTo(5, 4000)};
      break;
    case ((amt >= 1501) && (amt <= 1999)):
      $('four_go_to_btn_1').innerHTML = "b$2,500"; $('four_go_to_btn_1').onclick = function () {goTo(5, 2500)};
      $('four_go_to_btn_2').innerHTML = "b$3,000"; $('four_go_to_btn_2').onclick = function () {goTo(5, 3000)};
      $('four_go_to_btn_3').innerHTML = "b$3,500"; $('four_go_to_btn_3').onclick = function () {goTo(5, 3500)};
      $('four_go_to_btn_4').innerHTML = "b$4,000"; $('four_go_to_btn_4').onclick = function () {goTo(5, 4000)};
      break;
    case (amt == 2000):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$2,500"; $('four_go_to_btn_1').onclick = function () {goTo(5, 2500)};
      $('four_go_to_btn_2').innerHTML = "b$3,000"; $('four_go_to_btn_2').onclick = function () {goTo(5, 3000)};
      $('four_go_to_btn_3').innerHTML = "b$3,500"; $('four_go_to_btn_3').onclick = function () {goTo(5, 3500)};
      $('four_go_to_btn_4').innerHTML = "b$4,000"; $('four_go_to_btn_4').onclick = function () {goTo(5, 4000)};
      letsShow('four_tbl_max_btn');
      break;
    case ((amt >= 2001) && (amt <= 2499)):
      $('four_go_to_btn_1').innerHTML = "b$2,500"; $('four_go_to_btn_1').onclick = function () {goTo(5, 2500)};
      $('four_go_to_btn_2').innerHTML = "b$3,000"; $('four_go_to_btn_2').onclick = function () {goTo(5, 3000)};
      $('four_go_to_btn_3').innerHTML = "b$3,500"; $('four_go_to_btn_3').onclick = function () {goTo(5, 3500)};
      $('four_go_to_btn_4').innerHTML = "b$4,000"; $('four_go_to_btn_4').onclick = function () {goTo(5, 4000)};
      letsShow('four_tbl_max_btn');
      break;
    case (amt == 2500):
      letsHide('four_pay_disclaimer');
      letsShow('four_press_buttons'); lineUp('four_press_btn_3');
      $('four_go_to_btn_1').innerHTML = "b$3,000"; $('four_go_to_btn_1').onclick = function () {goTo(5, 3000)};
      $('four_go_to_btn_2').innerHTML = "b$3,500"; $('four_go_to_btn_2').onclick = function () {goTo(5, 3500)};
      $('four_go_to_btn_3').innerHTML = "b$4,000"; $('four_go_to_btn_3').onclick = function () {goTo(5, 4000)};
      $('four_go_to_btn_4').innerHTML = "b$4,500"; $('four_go_to_btn_4').onclick = function () {goTo(5, 4500)};
      letsShow('four_tbl_max_btn');
      break;
    case ((amt >= 2501) && (amt <= 2999)):
      $('four_go_to_btn_1').innerHTML = "b$3,000"; $('four_go_to_btn_1').onclick = function () {goTo(5, 3000)};
      $('four_go_to_btn_2').innerHTML = "b$3,500"; $('four_go_to_btn_2').onclick = function () {goTo(5, 3500)};
      $('four_go_to_btn_3').innerHTML = "b$4,000"; $('four_go_to_btn_3').onclick = function () {goTo(5, 4000)};
      $('four_go_to_btn_4').innerHTML = "b$4,500"; $('four_go_to_btn_4').onclick = function () {goTo(5, 4500)};
      letsShow('four_tbl_max_btn');
      break;
    case (amt == 3000):
      letsHide('four_pay_disclaimer');
      letsHide('four_go_to_btn_4');
      $('four_go_to_btn_1').innerHTML = "b$3,500"; $('four_go_to_btn_1').onclick = function () {goTo(5, 3000)};
      $('four_go_to_btn_2').innerHTML = "b$4,000"; $('four_go_to_btn_2').onclick = function () {goTo(5, 3500)};
      $('four_go_to_btn_3').innerHTML = "b$4,500"; $('four_go_to_btn_3').onclick = function () {goTo(5, 4000)};
      letsShow('four_tbl_max_btn');
      break;
    case ((amt >= 3001) && (amt <= 3499)):
      $('four_go_to_btn_1').innerHTML = "b$3,500"; $('four_go_to_btn_1').onclick = function () {goTo(5, 3000)};
      $('four_go_to_btn_2').innerHTML = "b$4,000"; $('four_go_to_btn_2').onclick = function () {goTo(5, 3500)};
      $('four_go_to_btn_3').innerHTML = "b$4,500"; $('four_go_to_btn_3').onclick = function () {goTo(5, 4000)};
      letsShow('four_tbl_max_btn');
      break;
    case (amt == 3500):
      letsHide('four_pay_disclaimer');
      letsHide('four_go_to_btn_3'); letsHide('four_go_to_btn_4');
      $('four_go_to_btn_1').innerHTML = "b$4,000"; $('four_go_to_btn_1').onclick = function () {goTo(5, 4000)};
      $('four_go_to_btn_2').innerHTML = "b$4,500"; $('four_go_to_btn_2').onclick = function () {goTo(5, 4500)};
      letsShow('four_tbl_max_btn');
      break;
    case ((amt >= 3501) && (amt <= 3999)):
      letsHide('four_go_to_btn_3'); letsHide('four_go_to_btn_4');
      $('four_go_to_btn_1').innerHTML = "b$4,000"; $('four_go_to_btn_1').onclick = function () {goTo(5, 4000)};
      $('four_go_to_btn_2').innerHTML = "b$4,500"; $('four_go_to_btn_2').onclick = function () {goTo(5, 4500)};
      letsShow('four_tbl_max_btn');
      break;
    case (amt == 4000):
      letsHide('four_pay_disclaimer');
      letsHide('four_go_to_btn_2'); letsHide('four_go_to_btn_3'); letsHide('four_go_to_btn_4');
      $('four_go_to_btn_1').innerHTML = "b$4,500"; $('four_go_to_btn_1').onclick = function () {goTo(5, 4500)};
      letsShow('four_tbl_max_btn');
      break;
    case ((amt >= 4001) && (amt <= 4499)):
      letsHide('four_go_to_btn_2'); letsHide('four_go_to_btn_3'); letsHide('four_go_to_btn_4');
      $('four_go_to_btn_1').innerHTML = "b$4,500"; $('four_go_to_btn_1').onclick = function () {goTo(5, 4500)};
      letsShow('four_tbl_max_btn');
      break;
    case (amt == 4500):
      letsHide('four_pay_disclaimer');
      letsHide('four_go_to_buttons');
      letsShow('four_tbl_max_btn');
      break;
    case ((amt >= 4501) && (amt <= 4999)):
      letsHide('four_go_to_buttons');
      letsShow('four_tbl_max_btn');
      break;
    case (amt == 5000):
      $('four_pay_disclaimer').innerHTML = "You hit at table max!! If you want to put even more on the table you can start making Come bets and double dip your way up to max Come bet and max Odds! Another... $20,000 ($5K with $15K odds) to win 35K plus your 10K here is a 45K potential max win on the 4. That's when we get Come Bets which are coming soon.";
      letsHide('four_go_to_buttons')
    default: return
  }
}
function showPlaceFiveBtns (amt) {
  letsShow('five_pay_disclaimer');
  $('five_pay_disclaimer').innerHTML = "Try and stick to bets in normal increments. Use the 'Go to ' menu for normal betting amounts.";
  letsHide('five_press_buttons');
  letsHide('five_press_btn_1'); letsHide('five_press_btn_2'); letsHide('five_press_btn_3'); letsHide('five_press_btn_4');
  lineUp('five_go_to_btn_3'); lineUp('five_go_to_btn_4');
  letsHide('five_tbl_max_btn');
  letsHide('place_five_dble_box');
  letsMask('five_dbl_press_btn_2');
  letsHide('five_dble_btn_box_two');
  letsMask('five_dbl_press_btn_4');
  var equalUnits = theFive.placeBet == theNine.placeBet;
  switch (true) {
    case (amt == 5):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons');
      lineUp('five_press_btn_1'); lineUp('five_press_btn_3'); lineUp('five_press_btn_4');
      letsHide('five_go_to_btn_3'); letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$10"; $('five_go_to_btn_1').onclick = function () {goTo(6, 10)};
      $('five_go_to_btn_2').innerHTML = "+3 to $15"; $('five_go_to_btn_2').onclick = function () {goTo(6, 15)};
      if(equalUnits) {
        letsShow('place_five_dble_box');
        $('five_dbl_press_btn_1').innerHTML = "+3 to $10e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 10)};
      }
      break;
    case (amt == 10):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons');
      lineUp('five_press_btn_1'); lineUp('five_press_btn_3'); lineUp('five_press_btn_4');
      letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$15"; $('five_go_to_btn_1').onclick = function () {goTo(6, 15)};
      $('five_go_to_btn_2').innerHTML = "$20"; $('five_go_to_btn_2').onclick = function () {goTo(6, 20)};
      $('five_go_to_btn_3').innerHTML = "+ 1 to $25"; $('five_go_to_btn_3').onclick = function () {goTo(6, 25)};
      if(equalUnits) {
        letsShow('place_five_dble_box');
        $('five_dbl_press_btn_1').innerHTML = "$15e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 15)};
      }
      break;
    case (amt == 15): 
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons');
      lineUp('five_press_btn_1'); lineUp('five_press_btn_3'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$20"; $('five_go_to_btn_1').onclick = function () {goTo(6, 20)};
      $('five_go_to_btn_2').innerHTML = "$25"; $('five_go_to_btn_2').onclick = function () {goTo(6, 25)};
      $('five_go_to_btn_3').innerHTML = "$30"; $('five_go_to_btn_3').onclick = function () {goTo(6, 30)};
      $('five_go_to_btn_4').innerHTML = "$35"; $('five_go_to_btn_4').onclick = function () {goTo(6, 35)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$20e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 20)};
        $('five_dbl_press_btn_2').innerHTML = "$25e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 25)};
      }
      break;
    case (amt == 20):
      letsHide('five_pay_disclaimer'); 
      letsShow('five_press_buttons');
      lineUp('five_press_btn_1'); lineUp('five_press_btn_3'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$25"; $('five_go_to_btn_1').onclick = function () {goTo(6, 25)};
      $('five_go_to_btn_2').innerHTML = "$30"; $('five_go_to_btn_2').onclick = function () {goTo(6, 30)};
      $('five_go_to_btn_3').innerHTML = "$35"; $('five_go_to_btn_3').onclick = function () {goTo(6, 35)};
      $('five_go_to_btn_4').innerHTML = "+2 to $50"; $('five_go_to_btn_4').onclick = function () {goTo(6, 50)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$25e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 25)};
        $('five_dbl_press_btn_2').innerHTML = "$30e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 30)};
        letsShow('five_dble_btn_box_two');
        $('five_dbl_press_btn_3').innerHTML = "+2 to $35e 5 &amp; 9"; $('five_dbl_press_btn_3').onclick = function () {doubleUnitPress(6, 35)};
      }
      break;
    case (amt == 25):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons');
      lineUp('five_press_btn_1'); lineUp('five_press_btn_2'); lineUp('five_press_btn_3'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$30"; $('five_go_to_btn_1').onclick = function () {goTo(6, 30)};
      $('five_go_to_btn_2').innerHTML = "$35"; $('five_go_to_btn_2').onclick = function () {goTo(6, 35)};
      $('five_go_to_btn_3').innerHTML = "$50"; $('five_go_to_btn_3').onclick = function () {goTo(6, 50)};
      $('five_go_to_btn_4').innerHTML = "$60"; $('five_go_to_btn_4').onclick = function () {goTo(6, 60)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$30e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 30)};
        $('five_dbl_press_btn_2').innerHTML = "$35e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 35)};
        letsShow('five_dble_btn_box_two'); letsUnmask('five_dbl_press_btn_4');
        $('five_dbl_press_btn_3').innerHTML = "$40e 5 &amp; 9"; $('five_dbl_press_btn_3').onclick = function () {doubleUnitPress(6, 40)};
        $('five_dbl_press_btn_4').innerHTML = "+5 to $45e 5 &amp; 9"; $('five_dbl_press_btn_4').onclick = function () {doubleUnitPress(6, 45)};
      }
      break;
    case (amt == 30):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons');
      lineUp('five_press_btn_1'); lineUp('five_press_btn_3'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$35"; $('five_go_to_btn_1').onclick = function () {goTo(6, 35)};
      $('five_go_to_btn_2').innerHTML = "$50"; $('five_go_to_btn_2').onclick = function () {goTo(6, 50)};
      $('five_go_to_btn_3').innerHTML = "$60"; $('five_go_to_btn_3').onclick = function () {goTo(6, 60)};
      $('five_go_to_btn_4').innerHTML = "+3 to $75"; $('five_go_to_btn_4').onclick = function () {goTo(6, 75)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$35e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 35)};
        $('five_dbl_press_btn_2').innerHTML = "$40e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 40)};
        letsShow('five_dble_btn_box_two'); letsUnmask('five_dbl_press_btn_4');
        $('five_dbl_press_btn_3').innerHTML = "$45e 5 &amp; 9"; $('five_dbl_press_btn_3').onclick = function () {doubleUnitPress(6, 45)};
        $('five_dbl_press_btn_4').innerHTML = "$50e 5 &amp; 9"; $('five_dbl_press_btn_4').onclick = function () {doubleUnitPress(6, 50)};
      }
      break;
    case (amt == 35):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons');
      lineUp('five_press_btn_1'); lineUp('five_press_btn_3'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$40"; $('five_go_to_btn_1').onclick = function () {goTo(6, 40)};
      $('five_go_to_btn_2').innerHTML = "$50"; $('five_go_to_btn_2').onclick = function () {goTo(6, 50)};
      $('five_go_to_btn_3').innerHTML = "$60"; $('five_go_to_btn_3').onclick = function () {goTo(6, 60)};
      $('five_go_to_btn_4').innerHTML = "$75"; $('five_go_to_btn_4').onclick = function () {goTo(6, 75)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$40e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 40)};
        $('five_dbl_press_btn_2').innerHTML = "$45e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 45)};
        letsShow('five_dble_btn_box_two'); letsUnmask('five_dbl_press_btn_4');
        $('five_dbl_press_btn_3').innerHTML = "$50e 5 &amp; 9"; $('five_dbl_press_btn_3').onclick = function () {doubleUnitPress(6, 50)};
        $('five_dbl_press_btn_4').innerHTML = "+1 to $60e 5 &amp; 9"; $('five_dbl_press_btn_4').onclick = function () {doubleUnitPress(6, 60)};
      }
      break;
    case (amt == 40):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons');
      lineUp('five_press_btn_1'); lineUp('five_press_btn_3'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$50"; $('five_go_to_btn_1').onclick = function () {goTo(6, 50)};
      $('five_go_to_btn_2').innerHTML = "$60"; $('five_go_to_btn_2').onclick = function () {goTo(6, 60)};
      $('five_go_to_btn_3').innerHTML = "$75"; $('five_go_to_btn_3').onclick = function () {goTo(6, 75)};
      $('five_go_to_btn_4').innerHTML = "+4 to $100"; $('five_go_to_btn_4').onclick = function () {goTo(6, 100)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$45e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 45)};
        $('five_dbl_press_btn_2').innerHTML = "$50e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 50)};
        letsShow('five_dble_btn_box_two');
        $('five_dbl_press_btn_3').innerHTML = "$60e 5 &amp; 9"; $('five_dbl_press_btn_3').onclick = function () {doubleUnitPress(6, 60)};
      }
      break;
    case (amt == 45):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons');
      lineUp('five_press_btn_1'); lineUp('five_press_btn_3'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$50"; $('five_go_to_btn_1').onclick = function () {goTo(6, 50)};
      $('five_go_to_btn_2').innerHTML = "$60"; $('five_go_to_btn_2').onclick = function () {goTo(6, 60)};
      $('five_go_to_btn_3').innerHTML = "$75"; $('five_go_to_btn_3').onclick = function () {goTo(6, 75)};
      $('five_go_to_btn_4').innerHTML = "$100"; $('five_go_to_btn_4').onclick = function () {goTo(6, 100)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$50e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 50)};
        $('five_dbl_press_btn_2').innerHTML = "$60e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 60)};
        letsShow('five_dble_btn_box_two');
        $('five_dbl_press_btn_3').innerHTML = "$75e 5 &amp; 9"; $('five_dbl_press_btn_3').onclick = function () {doubleUnitPress(6, 75)};
      }
      break;
    case (amt == 50):
      letsHide('five_pay_disclaimer'); 
      letsShow('five_press_buttons');
      lineUp('five_press_btn_1'); lineUp('five_press_btn_2'); lineUp('five_press_btn_3'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$60"; $('five_go_to_btn_1').onclick = function () {goTo(6, 60)};
      $('five_go_to_btn_2').innerHTML = "$75"; $('five_go_to_btn_2').onclick = function () {goTo(6, 75)};
      $('five_go_to_btn_3').innerHTML = "$100"; $('five_go_to_btn_3').onclick = function () {goTo(6, 100)};
      $('five_go_to_btn_4').innerHTML = "+5 to $125"; $('five_go_to_btn_4').onclick = function () {goTo(6, 125)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$60e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 60)};
        $('five_dbl_press_btn_2').innerHTML = "$75e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 75)};
      }
      break;
    case (amt == 55):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons');
      lineUp('five_press_btn_1'); lineUp('five_press_btn_3'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$60"; $('five_go_to_btn_1').onclick = function () {goTo(6, 60)};
      $('five_go_to_btn_2').innerHTML = "$75"; $('five_go_to_btn_2').onclick = function () {goTo(6, 75)};
      $('five_go_to_btn_3').innerHTML = "$100"; $('five_go_to_btn_3').onclick = function () {goTo(6, 100)};
      $('five_go_to_btn_4').innerHTML = "$125"; $('five_go_to_btn_4').onclick = function () {goTo(6, 125)};
      break;
    case (amt == 60):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons');
      lineUp('five_press_btn_1'); lineUp('five_press_btn_3'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$75"; $('five_go_to_btn_1').onclick = function () {goTo(6, 75)};
      $('five_go_to_btn_2').innerHTML = "$100"; $('five_go_to_btn_2').onclick = function () {goTo(6, 100)};
      $('five_go_to_btn_3').innerHTML = "$125"; $('five_go_to_btn_3').onclick = function () {goTo(6, 125)};
      $('five_go_to_btn_4').innerHTML = "+6 to $150"; $('five_go_to_btn_4').onclick = function () {goTo(6, 150)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$75e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 75)};
        $('five_dbl_press_btn_2').innerHTML = "$100e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 100)};
      }
      break;
    case ((amt == 65) || (amt == 70)):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons');
      lineUp('five_press_btn_1'); lineUp('five_press_btn_3'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$75"; $('five_go_to_btn_1').onclick = function () {goTo(6, 75)};
      $('five_go_to_btn_2').innerHTML = "$100"; $('five_go_to_btn_2').onclick = function () {goTo(6, 100)};
      $('five_go_to_btn_3').innerHTML = "$125"; $('five_go_to_btn_3').onclick = function () {goTo(6, 125)};
      $('five_go_to_btn_4').innerHTML = "$150"; $('five_go_to_btn_4').onclick = function () {goTo(6, 150)};
      break;
    case (amt == 75):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons');
      lineUp('five_press_btn_1'); lineUp('five_press_btn_2'); lineUp('five_press_btn_3'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$100"; $('five_go_to_btn_1').onclick = function () {goTo(6, 100)};
      $('five_go_to_btn_2').innerHTML = "$125"; $('five_go_to_btn_2').onclick = function () {goTo(6, 125)};
      $('five_go_to_btn_3').innerHTML = "$150"; $('five_go_to_btn_3').onclick = function () {goTo(6, 150)};
      $('five_go_to_btn_4').innerHTML = "$175"; $('five_go_to_btn_4').onclick = function () {goTo(6, 175)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$100e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 100)};
        $('five_dbl_press_btn_2').innerHTML = "$125e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 125)};
      }
      break;
    case (amt == 80):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons');
      lineUp('five_press_btn_1'); lineUp('five_press_btn_3'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$100"; $('five_go_to_btn_1').onclick = function () {goTo(6, 100)};
      $('five_go_to_btn_2').innerHTML = "$125"; $('five_go_to_btn_2').onclick = function () {goTo(6, 125)};
      $('five_go_to_btn_3').innerHTML = "$150"; $('five_go_to_btn_3').onclick = function () {goTo(6, 150)};
      $('five_go_to_btn_4').innerHTML = "+8 to $200"; $('five_go_to_btn_4').onclick = function () {goTo(6, 200)};
      break;
    case ((amt == 85) || (amt == 90) || (amt == 95)):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons');
      lineUp('five_press_btn_1'); lineUp('five_press_btn_3'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$100"; $('five_go_to_btn_1').onclick = function () {goTo(6, 100)};
      $('five_go_to_btn_2').innerHTML = "$125"; $('five_go_to_btn_2').onclick = function () {goTo(6, 125)};
      $('five_go_to_btn_3').innerHTML = "$150"; $('five_go_to_btn_3').onclick = function () {goTo(6, 150)};
      $('five_go_to_btn_4').innerHTML = "$200"; $('five_go_to_btn_4').onclick = function () {goTo(6, 200)};
      break;
    case (amt == 100):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons');
      lineUp('five_press_btn_2'); lineUp('five_press_btn_3'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$125"; $('five_go_to_btn_1').onclick = function () {goTo(6, 125)};
      $('five_go_to_btn_2').innerHTML = "$150"; $('five_go_to_btn_2').onclick = function () {goTo(6, 150)};
      $('five_go_to_btn_3').innerHTML = "$200"; $('five_go_to_btn_3').onclick = function () {goTo(6, 200)};
      $('five_go_to_btn_4').innerHTML = "+10 to $250"; $('five_go_to_btn_4').onclick = function () {goTo(6, 250)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$125e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 125)};
        $('five_dbl_press_btn_2').innerHTML = "$150e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 150)};
      }
      break;
    case (amt == 105):
      $('five_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " five is if you are full pressing from a lower amount. If not, you should be pressing by $25 or $50. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$125"; $('five_go_to_btn_1').onclick = function () {goTo(6, 125)};
      $('five_go_to_btn_2').innerHTML = "$150"; $('five_go_to_btn_2').onclick = function () {goTo(6, 150)};
      $('five_go_to_btn_3').innerHTML = "$200"; $('five_go_to_btn_3').onclick = function () {goTo(6, 200)};
      $('five_go_to_btn_4').innerHTML = "$250"; $('five_go_to_btn_4').onclick = function () {goTo(6, 250)};
      break;
    case (amt == 110):
      $('five_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      $('five_go_to_btn_1').innerHTML = "$125"; $('five_go_to_btn_1').onclick = function () {goTo(6, 125)};
      $('five_go_to_btn_2').innerHTML = "$150"; $('five_go_to_btn_2').onclick = function () {goTo(6, 150)};
      $('five_go_to_btn_3').innerHTML = "$200"; $('five_go_to_btn_3').onclick = function () {goTo(6, 200)};
      $('five_go_to_btn_4').innerHTML = "$250"; $('five_go_to_btn_4').onclick = function () {goTo(6, 250)};
      break;
    case (amt == 115):
      $('five_go_to_btn_1').innerHTML = "$125"; $('five_go_to_btn_1').onclick = function () {goTo(6, 125)};
      $('five_go_to_btn_2').innerHTML = "$150"; $('five_go_to_btn_2').onclick = function () {goTo(6, 150)};
      $('five_go_to_btn_3').innerHTML = "$200"; $('five_go_to_btn_3').onclick = function () {goTo(6, 200)};
      $('five_go_to_btn_4').innerHTML = "$250"; $('five_go_to_btn_4').onclick = function () {goTo(6, 250)};
      break;
    case (amt == 120):
      $('five_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Full pressers can shoot for the stars. Otherwise, you should be pressing by $25 or $50. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$125"; $('five_go_to_btn_1').onclick = function () {goTo(6, 125)};
      $('five_go_to_btn_2').innerHTML = "$150"; $('five_go_to_btn_2').onclick = function () {goTo(6, 150)};
      $('five_go_to_btn_3').innerHTML = "$200"; $('five_go_to_btn_3').onclick = function () {goTo(6, 200)};
      $('five_go_to_btn_4').innerHTML = "$250"; $('five_go_to_btn_4').onclick = function () {goTo(6, 250)};
      break;
    case (amt == 125):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons'); lineUp('five_press_btn_2'); lineUp('five_press_btn_3');
      $('five_go_to_btn_1').innerHTML = "$150"; $('five_go_to_btn_1').onclick = function () {goTo(6, 150)};
      $('five_go_to_btn_2').innerHTML = "$200"; $('five_go_to_btn_2').onclick = function () {goTo(6, 200)};
      $('five_go_to_btn_3').innerHTML = "$250"; $('five_go_to_btn_3').onclick = function () {goTo(6, 250)};
      $('five_go_to_btn_4').innerHTML = "$300"; $('five_go_to_btn_4').onclick = function () {goTo(6, 300)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$150e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 150)};
        $('five_dbl_press_btn_2').innerHTML = "$200e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 200)};
      }
      break;
    case ((amt == 130) || (amt == 140)):
      $('five_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Full pressers can shoot for the stars. Otherwise, you should be pressing by $25 or $50. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$150"; $('five_go_to_btn_1').onclick = function () {goTo(6, 150)};
      $('five_go_to_btn_2').innerHTML = "$200"; $('five_go_to_btn_2').onclick = function () {goTo(6, 200)};
      $('five_go_to_btn_3').innerHTML = "$250"; $('five_go_to_btn_3').onclick = function () {goTo(6, 250)};
      $('five_go_to_btn_4').innerHTML = "$300"; $('five_go_to_btn_4').onclick = function () {goTo(6, 300)};
      break;
    case ((amt == 135) || (amt == 145)):
      $('five_go_to_btn_1').innerHTML = "$150"; $('five_go_to_btn_1').onclick = function () {goTo(6, 150)};
      $('five_go_to_btn_2').innerHTML = "$200"; $('five_go_to_btn_2').onclick = function () {goTo(6, 200)};
      $('five_go_to_btn_3').innerHTML = "$250"; $('five_go_to_btn_3').onclick = function () {goTo(6, 250)};
      $('five_go_to_btn_4').innerHTML = "$300"; $('five_go_to_btn_4').onclick = function () {goTo(6, 300)};
      break;
    case (amt == 150):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons'); lineUp('five_press_btn_2'); lineUp('five_press_btn_3');
      $('five_go_to_btn_1').innerHTML = "$200"; $('five_go_to_btn_1').onclick = function () {goTo(6, 200)};
      $('five_go_to_btn_2').innerHTML = "$250"; $('five_go_to_btn_2').onclick = function () {goTo(6, 250)};
      $('five_go_to_btn_3').innerHTML = "$300"; $('five_go_to_btn_3').onclick = function () {goTo(6, 300)};
      $('five_go_to_btn_4').innerHTML = "$350"; $('five_go_to_btn_4').onclick = function () {goTo(6, 350)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$200e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 200)};
        $('five_dbl_press_btn_2').innerHTML = "$250e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 250)};
      }
      break;
    case ((amt == 155) || (amt == 165)):
      $('five_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " five is if you are full pressing from a lower amount. If not, you should be pressing by $25 or $50. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$200"; $('five_go_to_btn_1').onclick = function () {goTo(6, 200)};
      $('five_go_to_btn_2').innerHTML = "$250"; $('five_go_to_btn_2').onclick = function () {goTo(6, 250)};
      $('five_go_to_btn_3').innerHTML = "$300"; $('five_go_to_btn_3').onclick = function () {goTo(6, 300)};
      $('five_go_to_btn_4').innerHTML = "$350"; $('five_go_to_btn_4').onclick = function () {goTo(6, 350)};
      break;
    case (amt == 160):
      $('five_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      $('five_go_to_btn_1').innerHTML = "$200"; $('five_go_to_btn_1').onclick = function () {goTo(6, 200)};
      $('five_go_to_btn_2').innerHTML = "$250"; $('five_go_to_btn_2').onclick = function () {goTo(6, 250)};
      $('five_go_to_btn_3').innerHTML = "$300"; $('five_go_to_btn_3').onclick = function () {goTo(6, 300)};
      $('five_go_to_btn_4').innerHTML = "$350"; $('five_go_to_btn_4').onclick = function () {goTo(6, 350)};
      break;
    case (amt == 170):
      $('five_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      $('five_go_to_btn_1').innerHTML = "$200"; $('five_go_to_btn_1').onclick = function () {goTo(6, 200)};
      $('five_go_to_btn_2').innerHTML = "$250"; $('five_go_to_btn_2').onclick = function () {goTo(6, 250)};
      $('five_go_to_btn_3').innerHTML = "$350"; $('five_go_to_btn_3').onclick = function () {goTo(6, 350)};
      $('five_go_to_btn_4').innerHTML = "$400"; $('five_go_to_btn_4').onclick = function () {goTo(6, 400)};
      break;
    case (amt == 175):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons'); lineUp('five_press_btn_2'); lineUp('five_press_btn_3');
      $('five_go_to_btn_1').innerHTML = "$200"; $('five_go_to_btn_1').onclick = function () {goTo(6, 200)};
      $('five_go_to_btn_2').innerHTML = "$250"; $('five_go_to_btn_2').onclick = function () {goTo(6, 250)};
      $('five_go_to_btn_3').innerHTML = "$350"; $('five_go_to_btn_3').onclick = function () {goTo(6, 350)};
      $('five_go_to_btn_4').innerHTML = "$400"; $('five_go_to_btn_4').onclick = function () {goTo(6, 400)};
      break;
    case (amt == 180):
      $('five_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Full pressers can shoot for the stars. Otherwise, you should be pressing by $25 or $50. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$200"; $('five_go_to_btn_1').onclick = function () {goTo(6, 200)};
      $('five_go_to_btn_2').innerHTML = "$250"; $('five_go_to_btn_2').onclick = function () {goTo(6, 250)};
      $('five_go_to_btn_3').innerHTML = "$350"; $('five_go_to_btn_3').onclick = function () {goTo(6, 350)};
      $('five_go_to_btn_4').innerHTML = "$400"; $('five_go_to_btn_4').onclick = function () {goTo(6, 400)};
      break;
    case (amt == 185):
      $('five_go_to_btn_1').innerHTML = "$200"; $('five_go_to_btn_1').onclick = function () {goTo(6, 200)};
      $('five_go_to_btn_2').innerHTML = "$250"; $('five_go_to_btn_2').onclick = function () {goTo(6, 250)};
      $('five_go_to_btn_3').innerHTML = "$350"; $('five_go_to_btn_3').onclick = function () {goTo(6, 350)};
      $('five_go_to_btn_4').innerHTML = "$400"; $('five_go_to_btn_4').onclick = function () {goTo(6, 400)};
      break;
    case (amt == 190): 
      $('five_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Full pressers can shoot for the stars. Otherwise, you should be pressing by $25 or $50. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$200"; $('five_go_to_btn_1').onclick = function () {goTo(6, 200)};
      $('five_go_to_btn_2').innerHTML = "$250"; $('five_go_to_btn_2').onclick = function () {goTo(6, 250)};
      $('five_go_to_btn_3').innerHTML = "$350"; $('five_go_to_btn_3').onclick = function () {goTo(6, 350)};
      $('five_go_to_btn_4').innerHTML = "$450"; $('five_go_to_btn_4').onclick = function () {goTo(6, 450)};
      break;
    case ((amt == 195) || (amt == 205)):
      $('five_go_to_btn_1').innerHTML = "$200"; $('five_go_to_btn_1').onclick = function () {goTo(6, 200)};
      $('five_go_to_btn_2').innerHTML = "$250"; $('five_go_to_btn_2').onclick = function () {goTo(6, 250)};
      $('five_go_to_btn_3').innerHTML = "$350"; $('five_go_to_btn_3').onclick = function () {goTo(6, 350)};
      $('five_go_to_btn_4').innerHTML = "$450"; $('five_go_to_btn_4').onclick = function () {goTo(6, 450)};
      break;
    case (amt == 200):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons'); lineUp('five_press_btn_3'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$250"; $('five_go_to_btn_1').onclick = function () {goTo(6, 250)};
      $('five_go_to_btn_2').innerHTML = "$300"; $('five_go_to_btn_2').onclick = function () {goTo(6, 300)};
      $('five_go_to_btn_3').innerHTML = "$400"; $('five_go_to_btn_3').onclick = function () {goTo(6, 400)};
      $('five_go_to_btn_4').innerHTML = "+20 to $500"; $('five_go_to_btn_4').onclick = function () {goTo(6, 500)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$250e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 250)};
        $('five_dbl_press_btn_2').innerHTML = "$300e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 300)};
        letsShow('five_dble_btn_box_two');
        $('five_dbl_press_btn_3').innerHTML = "+20 to $350e 5 &amp; 9"; $('five_dbl_press_btn_3').onclick = function () {doubleUnitPress(6, 350)};
      }
      break;
    case ((amt == 210) || (amt == 220) || (amt == 230) || (amt == 235) || (amt == 245)):
      $('five_go_to_btn_1').innerHTML = "$250"; $('five_go_to_btn_1').onclick = function () {goTo(6, 250)};
      $('five_go_to_btn_2').innerHTML = "$300"; $('five_go_to_btn_2').onclick = function () {goTo(6, 300)};
      $('five_go_to_btn_3').innerHTML = "$350"; $('five_go_to_btn_3').onclick = function () {goTo(6, 350)};
      $('five_go_to_btn_4').innerHTML = "$500"; $('five_go_to_btn_4').onclick = function () {goTo(6, 500)};
      break;
    case ((amt == 215) || (amt == 225) || (amt == 240)):
      $('five_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " five is if you are full pressing from a lower amount. If not, you should be pressing by $50 or $100. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$250"; $('five_go_to_btn_1').onclick = function () {goTo(6, 250)};
      $('five_go_to_btn_2').innerHTML = "$300"; $('five_go_to_btn_2').onclick = function () {goTo(6, 300)};
      $('five_go_to_btn_3').innerHTML = "$350"; $('five_go_to_btn_3').onclick = function () {goTo(6, 350)};
      $('five_go_to_btn_4').innerHTML = "$500"; $('five_go_to_btn_4').onclick = function () {goTo(6, 500)};
      break;
    case (amt == 250):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons'); lineUp('five_press_btn_3'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$300"; $('five_go_to_btn_1').onclick = function () {goTo(6, 300)};
      $('five_go_to_btn_2').innerHTML = "$350"; $('five_go_to_btn_2').onclick = function () {goTo(6, 350)};
      $('five_go_to_btn_3').innerHTML = "$500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 500)};
      $('five_go_to_btn_4').innerHTML = "$600"; $('five_go_to_btn_4').onclick = function () {goTo(6, 600)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$300e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 300)};
        $('five_dbl_press_btn_2').innerHTML = "$350e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 350)};
        letsShow('five_dble_btn_box_two');
        $('five_dbl_press_btn_3').innerHTML = "$400e 5 &amp; 9"; $('five_dbl_press_btn_3').onclick = function () {doubleUnitPress(6, 400)};
      }
      break;
    case ((amt >= 255) && (amt <= 280)):
      $('five_go_to_btn_1').innerHTML = "$300"; $('five_go_to_btn_1').onclick = function () {goTo(6, 300)};
      $('five_go_to_btn_2').innerHTML = "$350"; $('five_go_to_btn_2').onclick = function () {goTo(6, 350)};
      $('five_go_to_btn_3').innerHTML = "$500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 500)};
      $('five_go_to_btn_4').innerHTML = "$600"; $('five_go_to_btn_4').onclick = function () {goTo(6, 600)};
      break;
    case (amt == 285):
      $('five_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " five is if you are full pressing from a lower amount. If not, you should be pressing by $50 or $100. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$300"; $('five_go_to_btn_1').onclick = function () {goTo(6, 300)};
      $('five_go_to_btn_2').innerHTML = "$350"; $('five_go_to_btn_2').onclick = function () {goTo(6, 350)};
      $('five_go_to_btn_3').innerHTML = "$500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 500)};
      $('five_go_to_btn_4').innerHTML = "$600"; $('five_go_to_btn_4').onclick = function () {goTo(6, 600)};
      break;
    case ((amt == 290) || (amt == 295)):
      $('five_go_to_btn_1').innerHTML = "$300"; $('five_go_to_btn_1').onclick = function () {goTo(6, 300)};
      $('five_go_to_btn_2').innerHTML = "$350"; $('five_go_to_btn_2').onclick = function () {goTo(6, 350)};
      $('five_go_to_btn_3').innerHTML = "$500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 500)};
      $('five_go_to_btn_4').innerHTML = "$600"; $('five_go_to_btn_4').onclick = function () {goTo(6, 600)};
      break;
    case (amt == 300):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons'); lineUp('five_press_btn_3');
      $('five_go_to_btn_1').innerHTML = "$350"; $('five_go_to_btn_1').onclick = function () {goTo(6, 350)};
      $('five_go_to_btn_2').innerHTML = "$400"; $('five_go_to_btn_2').onclick = function () {goTo(6, 400)};
      $('five_go_to_btn_3').innerHTML = "$500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 500)};
      $('five_go_to_btn_4').innerHTML = "+30 to $750"; $('five_go_to_btn_4').onclick = function () {goTo(6, 750)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$350e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 350)};
        $('five_dbl_press_btn_2').innerHTML = "$400e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 400)};
        letsShow('five_dble_btn_box_two');
        $('five_dbl_press_btn_3').innerHTML = "$500e 5 &amp; 9"; $('five_dbl_press_btn_3').onclick = function () {doubleUnitPress(6, 500)};
      }
      break;
    case (amt == 305):
      $('five_go_to_btn_1').innerHTML = "$350"; $('five_go_to_btn_1').onclick = function () {goTo(6, 350)};
      $('five_go_to_btn_2').innerHTML = "$500"; $('five_go_to_btn_2').onclick = function () {goTo(6, 500)};
      $('five_go_to_btn_3').innerHTML = "$600"; $('five_go_to_btn_3').onclick = function () {goTo(6, 600)};
      $('five_go_to_btn_4').innerHTML = "$700"; $('five_go_to_btn_4').onclick = function () {goTo(6, 700)};
      break;
    case (amt == 310):
      $('five_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " five is if you are full pressing from a lower amount. If not, you should be pressing by $50 or $100. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$350"; $('five_go_to_btn_1').onclick = function () {goTo(6, 350)};
      $('five_go_to_btn_2').innerHTML = "$500"; $('five_go_to_btn_2').onclick = function () {goTo(6, 500)};
      $('five_go_to_btn_3').innerHTML = "$600"; $('five_go_to_btn_3').onclick = function () {goTo(6, 600)};
      $('five_go_to_btn_4').innerHTML = "$700"; $('five_go_to_btn_4').onclick = function () {goTo(6, 700)};
      break;
    case ((amt == 315) || (amt == 320) || (amt == 325) || (amt == 330) || (amt == 340) || (amt == 345)):
      $('five_go_to_btn_1').innerHTML = "$350"; $('five_go_to_btn_1').onclick = function () {goTo(6, 350)};
      $('five_go_to_btn_2').innerHTML = "$500"; $('five_go_to_btn_2').onclick = function () {goTo(6, 500)};
      $('five_go_to_btn_3').innerHTML = "$600"; $('five_go_to_btn_3').onclick = function () {goTo(6, 600)};
      $('five_go_to_btn_4').innerHTML = "$750"; $('five_go_to_btn_4').onclick = function () {goTo(6, 750)};
      break;
    case (amt == 335):
      $('five_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " five is if you are full pressing from a lower amount. If not, you should be pressing by $50 or $100. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$350"; $('five_go_to_btn_1').onclick = function () {goTo(6, 350)};
      $('five_go_to_btn_2').innerHTML = "$500"; $('five_go_to_btn_2').onclick = function () {goTo(6, 500)};
      $('five_go_to_btn_3').innerHTML = "$600"; $('five_go_to_btn_3').onclick = function () {goTo(6, 600)};
      $('five_go_to_btn_4').innerHTML = "$750"; $('five_go_to_btn_4').onclick = function () {goTo(6, 750)};
      break;
    case (amt == 350):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons'); lineUp('five_press_btn_3');
      $('five_go_to_btn_1').innerHTML = "$400"; $('five_go_to_btn_1').onclick = function () {goTo(6, 400)};
      $('five_go_to_btn_2').innerHTML = "$500"; $('five_go_to_btn_2').onclick = function () {goTo(6, 500)};
      $('five_go_to_btn_3').innerHTML = "$600"; $('five_go_to_btn_3').onclick = function () {goTo(6, 600)};
      $('five_go_to_btn_4').innerHTML = "$750"; $('five_go_to_btn_4').onclick = function () {goTo(6, 750)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$400e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 400)};
        $('five_dbl_press_btn_2').innerHTML = "$500e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 500)};
        letsShow('five_dble_btn_box_two');
        $('five_dbl_press_btn_3').innerHTML = "$+10 $600e 5 &amp; 9"; $('five_dbl_press_btn_3').onclick = function () {doubleUnitPress(6, 600)};
      }
      break;
    case ((amt >= 355) && (amt <= 365)):
    case ((amt >= 375) && (amt <= 390)):
      $('five_go_to_btn_1').innerHTML = "$400"; $('five_go_to_btn_1').onclick = function () {goTo(6, 400)};
      $('five_go_to_btn_2').innerHTML = "$500"; $('five_go_to_btn_2').onclick = function () {goTo(6, 500)};
      $('five_go_to_btn_3').innerHTML = "$600"; $('five_go_to_btn_3').onclick = function () {goTo(6, 600)};
      $('five_go_to_btn_4').innerHTML = "$750"; $('five_go_to_btn_4').onclick = function () {goTo(6, 750)};
      break;
    case ((amt == 370) || (amt == 395)):
      $('five_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " five is if you are full pressing from a lower amount. If not, you should be pressing by $50 or $100. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$400"; $('five_go_to_btn_1').onclick = function () {goTo(6, 400)};
      $('five_go_to_btn_2').innerHTML = "$500"; $('five_go_to_btn_2').onclick = function () {goTo(6, 500)};
      $('five_go_to_btn_3').innerHTML = "$600"; $('five_go_to_btn_3').onclick = function () {goTo(6, 600)};
      $('five_go_to_btn_4').innerHTML = "$750"; $('five_go_to_btn_4').onclick = function () {goTo(6, 750)};
      break;
    case (amt == 400):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons'); lineUp('five_press_btn_3');
      $('five_go_to_btn_1').innerHTML = "$500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 500)};
      $('five_go_to_btn_2').innerHTML = "$600"; $('five_go_to_btn_2').onclick = function () {goTo(6, 600)};
      $('five_go_to_btn_3').innerHTML = "$750"; $('five_go_to_btn_3').onclick = function () {goTo(6, 750)};
      $('five_go_to_btn_4').innerHTML = "+40 to $1,000"; $('five_go_to_btn_4').onclick = function () {goTo(6, 1000)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$500e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 500)};
        $('five_dbl_press_btn_2').innerHTML = "$600e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 600)}; 
      }
      break;
    case ((amt == 405) || (amt == 410) || (amt == 415)):
      $('five_go_to_btn_1').innerHTML = "$450"; $('five_go_to_btn_1').onclick = function () {goTo(6, 450)};
      $('five_go_to_btn_2').innerHTML = "$500"; $('five_go_to_btn_2').onclick = function () {goTo(6, 500)};
      $('five_go_to_btn_3').innerHTML = "$600"; $('five_go_to_btn_3').onclick = function () {goTo(6, 600)};
      $('five_go_to_btn_4').innerHTML = "$750"; $('five_go_to_btn_4').onclick = function () {goTo(6, 750)};
      break;
    case ((amt == 420) || (amt == 425)):
    case ((amt >= 435) && (amt <= 445)):
    case ((amt >= 460) && (amt <= 475)):
    case ((amt >= 485) && (amt <= 495)):
      $('five_go_to_btn_1').innerHTML = "$500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 500)};
      $('five_go_to_btn_2').innerHTML = "$600"; $('five_go_to_btn_2').onclick = function () {goTo(6, 600)};
      $('five_go_to_btn_3').innerHTML = "$750"; $('five_go_to_btn_3').onclick = function () {goTo(6, 750)};
      $('five_go_to_btn_4').innerHTML = "$1,000"; $('five_go_to_btn_4').onclick = function () {goTo(6, 1000)};
      break;
    case ((amt == 430) || (amt == 455) || (amt == 480)):
      $('five_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " five is if you are full pressing from a lower amount. If not, you should be pressing by $50 or $100. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 500)};
      $('five_go_to_btn_2').innerHTML = "$600"; $('five_go_to_btn_2').onclick = function () {goTo(6, 600)};
      $('five_go_to_btn_3').innerHTML = "$750"; $('five_go_to_btn_3').onclick = function () {goTo(6, 750)};
      $('five_go_to_btn_4').innerHTML = "$1,000"; $('five_go_to_btn_4').onclick = function () {goTo(6, 1000)};
      break;
    case (amt == 450):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons'); lineUp('five_press_btn_3');
      $('five_go_to_btn_1').innerHTML = "$500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 500)};
      $('five_go_to_btn_2').innerHTML = "$600"; $('five_go_to_btn_2').onclick = function () {goTo(6, 600)};
      $('five_go_to_btn_3').innerHTML = "$750"; $('five_go_to_btn_3').onclick = function () {goTo(6, 750)};
      $('five_go_to_btn_4').innerHTML = "$1,000"; $('five_go_to_btn_4').onclick = function () {goTo(6, 1000)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$500e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 500)};
        $('five_dbl_press_btn_2').innerHTML = "$600e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 600)}; 
        letsShow('five_dble_btn_box_two');
        $('five_dbl_press_btn_3').innerHTML = "$750e 5 &amp; 9"; $('five_dbl_press_btn_3').onclick = function () {doubleUnitPress(6, 750)};
      }
      break;
    case (amt == 500):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons'); lineUp('five_press_btn_3');
      $('five_go_to_btn_1').innerHTML = "$600"; $('five_go_to_btn_1').onclick = function () {goTo(6, 600)};
      $('five_go_to_btn_2').innerHTML = "$750"; $('five_go_to_btn_2').onclick = function () {goTo(6, 750)};
      $('five_go_to_btn_3').innerHTML = "$900"; $('five_go_to_btn_3').onclick = function () {goTo(6, 900)};
      $('five_go_to_btn_4').innerHTML = "$1,000"; $('five_go_to_btn_4').onclick = function () {goTo(6, 1000)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$600e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 600)};
        $('five_dbl_press_btn_2').innerHTML = "$750e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 750)}; 
      }
      break;
    case ((amt == 505) || (amt == 510)):
    case ((amt >= 520) && (amt <= 535)):
    case ((amt >= 545) && (amt <= 570)):
    case ((amt >= 580) && (amt <= 595)):
      $('five_go_to_btn_1').innerHTML = "$600"; $('five_go_to_btn_1').onclick = function () {goTo(6, 600)};
      $('five_go_to_btn_2').innerHTML = "$750"; $('five_go_to_btn_2').onclick = function () {goTo(6, 750)};
      $('five_go_to_btn_3').innerHTML = "$900"; $('five_go_to_btn_3').onclick = function () {goTo(6, 900)};
      $('five_go_to_btn_4').innerHTML = "$1,000"; $('five_go_to_btn_4').onclick = function () {goTo(6, 1000)};
      break;
    case ((amt == 515) || (amt == 540) || (amt == 575)):
      $('five_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " five is if you are full pressing from a lower amount. If not, you should be pressing by $50 or $100. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$600"; $('five_go_to_btn_1').onclick = function () {goTo(6, 600)};
      $('five_go_to_btn_2').innerHTML = "$750"; $('five_go_to_btn_2').onclick = function () {goTo(6, 750)};
      $('five_go_to_btn_3').innerHTML = "$900"; $('five_go_to_btn_3').onclick = function () {goTo(6, 900)};
      $('five_go_to_btn_4').innerHTML = "$1,000"; $('five_go_to_btn_4').onclick = function () {goTo(6, 1000)};
      break;
    case (amt == 600):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$750"; $('five_go_to_btn_1').onclick = function () {goTo(6, 750)};
      $('five_go_to_btn_2').innerHTML = "$900"; $('five_go_to_btn_2').onclick = function () {goTo(6, 900)};
      $('five_go_to_btn_3').innerHTML = "$1,000"; $('five_go_to_btn_3').onclick = function () {goTo(6, 1000)};
      $('five_go_to_btn_4').innerHTML = "+60 to $1,500"; $('five_go_to_btn_4').onclick = function () {goTo(6, 1500)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$750e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 750)};
        $('five_dbl_press_btn_2').innerHTML = "$1,000e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 1000)}; 
      }
      break;
    case ((amt >= 605) && (amt <= 620)):
      letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$750"; $('five_go_to_btn_1').onclick = function () {goTo(6, 750)};
      $('five_go_to_btn_2').innerHTML = "$900"; $('five_go_to_btn_2').onclick = function () {goTo(6, 900)};
      $('five_go_to_btn_3').innerHTML = "$1,000"; $('five_go_to_btn_3').onclick = function () {goTo(6, 1000)};
      break;
    case ((amt >= 625) && (amt <= 675)):
    case ((amt >= 685) && (amt <= 695)):
    case ((amt >= 705) && (amt <= 735)):
    case (amt == 745):
      $('five_go_to_btn_1').innerHTML = "$750"; $('five_go_to_btn_1').onclick = function () {goTo(6, 750)};
      $('five_go_to_btn_2').innerHTML = "$900"; $('five_go_to_btn_2').onclick = function () {goTo(6, 900)};
      $('five_go_to_btn_3').innerHTML = "$1,000"; $('five_go_to_btn_3').onclick = function () {goTo(6, 1000)};
      $('five_go_to_btn_4').innerHTML = "$1,500"; $('five_go_to_btn_4').onclick = function () {goTo(6, 1500)};
      break;
    case (amt == 680):
      $('five_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " five is if you are full pressing from a lower amount. If not, you should be pressing by $50 or $100. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$750"; $('five_go_to_btn_1').onclick = function () {goTo(6, 750)};
      $('five_go_to_btn_2').innerHTML = "$900"; $('five_go_to_btn_2').onclick = function () {goTo(6, 900)};
      $('five_go_to_btn_3').innerHTML = "$1,000"; $('five_go_to_btn_3').onclick = function () {goTo(6, 1000)};
      $('five_go_to_btn_4').innerHTML = "$1,500"; $('five_go_to_btn_4').onclick = function () {goTo(6, 1500)};
      break;
    case (amt == 700):
      $('five_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$750"; $('five_go_to_btn_1').onclick = function () {goTo(6, 750)};
      $('five_go_to_btn_2').innerHTML = "$1,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 1000)};
      $('five_go_to_btn_3').innerHTML = "$1,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 1500)};
      break;
    case (amt == 740):
      $('five_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " five is if you are full pressing from a lower amount. If not, you should be pressing by at least $100. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$750"; $('five_go_to_btn_1').onclick = function () {goTo(6, 750)};
      $('five_go_to_btn_2').innerHTML = "$1,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 1000)};
      $('five_go_to_btn_3').innerHTML = "$1,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 1500)};
      break;
    case (amt == 750):
      letsHide('five_pay_disclaimer');
      letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$900"; $('five_go_to_btn_1').onclick = function () {goTo(6, 900)};
      $('five_go_to_btn_2').innerHTML = "$1,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 1000)};
      $('five_go_to_btn_3').innerHTML = "$1,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 1500)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); 
        $('five_dbl_press_btn_1').innerHTML = "$1,000e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 1000)}; 
      }
      break;
    case ((amt >= 755) && (amt <= 795)):
    case ((amt >= 805) && (amt <= 830)):
      letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$900"; $('five_go_to_btn_1').onclick = function () {goTo(6, 900)};
      $('five_go_to_btn_2').innerHTML = "$1,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 1000)};
      $('five_go_to_btn_3').innerHTML = "$1,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 1500)};
      break;
    case (amt == 800):
      $('five_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Full pressers can shoot for the stars. Otherwise, you should be pressing by $25 or $50. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$900"; $('five_go_to_btn_1').onclick = function () {goTo(6, 900)};
      $('five_go_to_btn_2').innerHTML = "$1,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 1000)};
      $('five_go_to_btn_3').innerHTML = "$1,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 1500)};
      break;
    case ((amt >= 835) && (amt <= 880)):
    case ((amt == 890) || (amt == 895)):
    case ((amt >= 905) && (amt <= 940)):
    case ((amt >= 950) && (amt <= 995)):
      letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$1,000"; $('five_go_to_btn_1').onclick = function () {goTo(6, 1000)};
      $('five_go_to_btn_2').innerHTML = "$1,500"; $('five_go_to_btn_2').onclick = function () {goTo(6, 1500)};
      $('five_go_to_btn_3').innerHTML = "$2,000"; $('five_go_to_btn_3').onclick = function () {goTo(6, 2000)};
      break;
    case ((amt == 885) || (amt == 945)):
      $('five_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " five is if you are full pressing from a lower amount. If not, you should be pressing by at least $100 or $500. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$1,000"; $('five_go_to_btn_1').onclick = function () {goTo(6, 1000)};
      $('five_go_to_btn_2').innerHTML = "$1,500"; $('five_go_to_btn_2').onclick = function () {goTo(6, 1500)};
      $('five_go_to_btn_3').innerHTML = "$2,000"; $('five_go_to_btn_3').onclick = function () {goTo(6, 2000)};
      break;
    case (amt == 900):
      letsHide('five_pay_disclaimer');
      letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$1,000"; $('five_go_to_btn_1').onclick = function () {goTo(6, 1000)};
      $('five_go_to_btn_2').innerHTML = "$1,500"; $('five_go_to_btn_2').onclick = function () {goTo(6, 1500)};
      $('five_go_to_btn_3').innerHTML = "$2,000"; $('five_go_to_btn_3').onclick = function () {goTo(6, 2000)};
      break;
    case (amt == 1000):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons'); lineUp('five_press_btn_3');
      letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$1,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 1500)};
      $('five_go_to_btn_2').innerHTML = "$2,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 2000)};
      $('five_go_to_btn_3').innerHTML = "+100 to $2,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 2500)};
      if(equalUnits) {
        letsShow('place_five_dble_box');
        $('five_dbl_press_btn_1').innerHTML = "$1,500e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 1500)};
      }
      break;
    case ((amt >= 1005) && (amt <= 1025)):
    case ((amt == 1035) || (amt == 1040)):
      letsHide('five_go_to_btn_3'); letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$1,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 1500)};
      $('five_go_to_btn_2').innerHTML = "$2,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 2000)};
      break;
    case (amt == 1030):
      $('five_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " five is if you are full pressing from a lower amount. If not, you should probably be pressing by $500 or so. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      letsHide('five_go_to_btn_3'); letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$1,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 1500)};
      $('five_go_to_btn_2').innerHTML = "$2,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 2000)};
      break;
    case ((amt >= 1045) && (amt <= 1085)):
    case ((amt >= 1095) && (amt <= 1145)):
    case ((amt >= 1155) && (amt <= 1230)):
    case ((amt == 1240) || (amt == 1245)):
      letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$1,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 1500)};
      $('five_go_to_btn_2').innerHTML = "$2,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 2000)};
      $('five_go_to_btn_3').innerHTML = "$2,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 2500)};
      break;
    case ((amt == 1090) || (amt == 1150) || (amt == 1235)):
      $('five_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " five is if you are full pressing from a lower amount. If not, you should probably be pressing by $500 or so. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$1,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 1500)};
      $('five_go_to_btn_2').innerHTML = "$2,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 2000)};
      $('five_go_to_btn_3').innerHTML = "$2,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 2500)};
      break;
    case ((amt >= 1250) && (amt <= 1290)):
    case ((amt >= 1300) && (amt <= 1375)):
    case ((amt >= 1385) && (amt <= 1435)):
    case ((amt >= 1445) && (amt <= 1495)):
      $('five_go_to_btn_1').innerHTML = "$1,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 1500)};
      $('five_go_to_btn_2').innerHTML = "$2,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 2000)};
      $('five_go_to_btn_3').innerHTML = "$2,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 2500)};
      $('five_go_to_btn_4').innerHTML = "$3,000"; $('five_go_to_btn_4').onclick = function () {goTo(6, 3000)};
      break;
    case (amt == 1440):
      $('five_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " five is if you are full pressing from a lower amount. If not, you should be pressing by $25 or $50. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$1,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 1500)};
      $('five_go_to_btn_2').innerHTML = "$2,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 2000)};
      $('five_go_to_btn_3').innerHTML = "$2,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 2500)};
      $('five_go_to_btn_4').innerHTML = "$3,000"; $('five_go_to_btn_4').onclick = function () {goTo(6, 3000)};
      break;
    case ((amt == 1295) || (amt == 1380)):
      $('five_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " five is if you are full pressing from a lower amount. If not, you should probably be pressing by $500 or so. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$1,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 1500)};
      $('five_go_to_btn_2').innerHTML = "$2,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 2000)};
      $('five_go_to_btn_3').innerHTML = "$2,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 2500)};
      $('five_go_to_btn_4').innerHTML = "$3,000"; $('five_go_to_btn_4').onclick = function () {goTo(6, 3000)};
      break;
    case (amt == 1500):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons'); lineUp('five_press_btn_3');
      $('five_go_to_btn_1').innerHTML = "$2,000"; $('five_go_to_btn_1').onclick = function () {goTo(6, 2000)};
      $('five_go_to_btn_2').innerHTML = "$2,500"; $('five_go_to_btn_2').onclick = function () {goTo(6, 2500)};
      $('five_go_to_btn_3').innerHTML = "$3,000"; $('five_go_to_btn_3').onclick = function () {goTo(6, 3000)};
      $('five_go_to_btn_4').innerHTML = "$3,500"; $('five_go_to_btn_4').onclick = function () {goTo(6, 3500)};
      if(equalUnits) {
        letsShow('place_five_dble_box'); letsUnmask('five_dbl_press_btn_2');
        $('five_dbl_press_btn_1').innerHTML = "$2,000e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(6, 2000)};
        $('five_dbl_press_btn_2').innerHTML = "$2,500e 5 &amp; 9"; $('five_dbl_press_btn_2').onclick = function () {doubleUnitPress(6, 2500)};
      }
      break;
    case ((amt >= 1505) && (amt <= 1625)):
    case ((amt >= 1635) && (amt <= 1665)):
      $('five_go_to_btn_1').innerHTML = "$2,000"; $('five_go_to_btn_1').onclick = function () {goTo(6, 2000)};
      $('five_go_to_btn_2').innerHTML = "$2,500"; $('five_go_to_btn_2').onclick = function () {goTo(6, 2500)};
      $('five_go_to_btn_3').innerHTML = "$3,000"; $('five_go_to_btn_3').onclick = function () {goTo(6, 3000)};
      $('five_go_to_btn_4').innerHTML = "$3,500"; $('five_go_to_btn_4').onclick = function () {goTo(6, 3500)};
      break;
    case (amt == 1630):
      $('five_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " five is if you are full pressing from a lower amount. If not, you should probably be pressing by $500 or so. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$2,000"; $('five_go_to_btn_1').onclick = function () {goTo(6, 2000)};
      $('five_go_to_btn_2').innerHTML = "$2,500"; $('five_go_to_btn_2').onclick = function () {goTo(6, 2500)};
      $('five_go_to_btn_3').innerHTML = "$3,000"; $('five_go_to_btn_3').onclick = function () {goTo(6, 3000)};
      $('five_go_to_btn_4').innerHTML = "$3,500"; $('five_go_to_btn_4').onclick = function () {goTo(6, 3500)};
      break;
    case ((amt >= 1670) && (amt <= 1770)):
    case ((amt >= 1780) && (amt <= 1795)):
    case ((amt >= 1805) && (amt <= 1870)):
      $('five_go_to_btn_1').innerHTML = "$2,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 2500)};
      $('five_go_to_btn_2').innerHTML = "$3,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 3000)};
      $('five_go_to_btn_3').innerHTML = "$3,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 3500)};
      $('five_go_to_btn_4').innerHTML = "$4,000"; $('five_go_to_btn_4').onclick = function () {goTo(6, 4000)};
      break;
    case (amt == 1800):
      $('five_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      $('five_go_to_btn_1').innerHTML = "$2,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 2500)};
      $('five_go_to_btn_2').innerHTML = "$3,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 3000)};
      $('five_go_to_btn_3').innerHTML = "$3,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 3500)};
      $('five_go_to_btn_4').innerHTML = "$4,000"; $('five_go_to_btn_4').onclick = function () {goTo(6, 4000)};
      break;
    case (amt == 1775):
      $('five_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " five is if you are full pressing from a lower amount. If not, you should probably be pressing by $500 or so. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$2,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 2500)};
      $('five_go_to_btn_2').innerHTML = "$3,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 3000)};
      $('five_go_to_btn_3').innerHTML = "$3,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 3500)};
      $('five_go_to_btn_4').innerHTML = "$4,000"; $('five_go_to_btn_4').onclick = function () {goTo(6, 4000)};
      break;
    case ((amt >= 1875) && (amt <= 1915)):
    case ((amt >= 1925) && (amt <= 1995)):
    case ((amt >= 2005) && (amt <= 2080)):
      $('five_go_to_btn_1').innerHTML = "$2,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 2500)};
      $('five_go_to_btn_2').innerHTML = "$3,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 3000)};
      $('five_go_to_btn_3').innerHTML = "$3,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 3500)};
      $('five_go_to_btn_4').innerHTML = "$4,500"; $('five_go_to_btn_4').onclick = function () {goTo(6, 4500)};
      break;
    case (amt == 1920):
      $('five_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " five is if you are full pressing from a lower amount. If not, you should probably be pressing by $500 or so. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('five_press_buttons'); lineUp('five_press_btn_4');
      $('five_go_to_btn_1').innerHTML = "$2,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 2500)};
      $('five_go_to_btn_2').innerHTML = "$3,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 3000)};
      $('five_go_to_btn_3').innerHTML = "$3,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 3500)};
      $('five_go_to_btn_4').innerHTML = "$4,500"; $('five_go_to_btn_4').onclick = function () {goTo(6, 4500)};
      break;
    case (amt == 2000):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons'); lineUp('five_press_btn_3');
      $('five_go_to_btn_1').innerHTML = "$2,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 2500)};
      $('five_go_to_btn_2').innerHTML = "$3,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 3000)};
      $('five_go_to_btn_3').innerHTML = "$3,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 3500)};
      $('five_go_to_btn_4').innerHTML = "$4,500"; $('five_go_to_btn_4').onclick = function () {goTo(6, 4500)};
      if(equalUnits) {
        letsShow('place_five_dble_box');
        $('five_dbl_press_btn_1').innerHTML = "$2,500e 5 &amp; 9"; $('five_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 2500)};
      }
      break;
    case ((amt >= 2085) && (amt <= 2115)):
    case ((amt >= 2125) && (amt <= 2260)):
    case ((amt >= 2270) && (amt <= 2465)):
    case ((amt >= 2475) && (amt <= 2495)):
      $('five_go_to_btn_1').innerHTML = "$2,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 2500)};
      $('five_go_to_btn_2').innerHTML = "$3,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 3000)};
      $('five_go_to_btn_3').innerHTML = "$3,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 3500)};
      $('five_go_to_btn_4').innerHTML = "$4,000"; $('five_go_to_btn_4').onclick = function () {goTo(6, 4000)};
      letsShow('five_tbl_max_btn');
      break;
    case ((amt == 2265) || (amt == 2120) || (amt == 2470)):
      $('five_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      $('five_go_to_btn_1').innerHTML = "$2,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 2500)};
      $('five_go_to_btn_2').innerHTML = "$3,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 3000)};
      $('five_go_to_btn_3').innerHTML = "$3,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 3500)};
      $('five_go_to_btn_4').innerHTML = "$4,000"; $('five_go_to_btn_4').onclick = function () {goTo(6, 4000)};
      letsShow('five_tbl_max_btn');
      break;
    case (amt == 2500):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons'); lineUp('five_press_btn_3');
      $('five_go_to_btn_1').innerHTML = "$3,000"; $('five_go_to_btn_1').onclick = function () {goTo(6, 3000)};
      $('five_go_to_btn_2').innerHTML = "$3,500"; $('five_go_to_btn_2').onclick = function () {goTo(6, 3500)};
      $('five_go_to_btn_3').innerHTML = "$4,000"; $('five_go_to_btn_3').onclick = function () {goTo(6, 4000)};
      $('five_go_to_btn_4').innerHTML = "$4,500"; $('five_go_to_btn_4').onclick = function () {goTo(6, 4500)};
      letsShow('five_tbl_max_btn');
      break;
    case ((amt >= 2505) && (amt <= 2610)):
    case ((amt >= 2620) && (amt <= 2755)):
    case ((amt >= 2765) && (amt <= 2955)):
    case ((amt >= 2965) && (amt <= 2995)):
      letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$3,000"; $('five_go_to_btn_1').onclick = function () {goTo(6, 3000)};
      $('five_go_to_btn_2').innerHTML = "$3,500"; $('five_go_to_btn_2').onclick = function () {goTo(6, 3500)};
      $('five_go_to_btn_3').innerHTML = "$4,000"; $('five_go_to_btn_3').onclick = function () {goTo(6, 4000)};
      letsShow('five_tbl_max_btn');
      break;
    case ((amt == 2615) || (amt == 2760) || (amt == 2960)):
      $('five_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$3,000"; $('five_go_to_btn_1').onclick = function () {goTo(6, 3000)};
      $('five_go_to_btn_2').innerHTML = "$3,500"; $('five_go_to_btn_2').onclick = function () {goTo(6, 3500)};
      $('five_go_to_btn_3').innerHTML = "$4,000"; $('five_go_to_btn_3').onclick = function () {goTo(6, 4000)};
      letsShow('five_tbl_max_btn');
      break;
    case (amt == 3000):
      letsHide('five_pay_disclaimer');
      letsShow('five_press_buttons'); lineUp('five_press_btn_3');
      letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$3,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 3500)};
      $('five_go_to_btn_2').innerHTML = "$4,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 4000)};
      $('five_go_to_btn_3').innerHTML = "$4,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 4500)};
      letsShow('five_tbl_max_btn');
      break;
    case ((amt >= 3005) && (amt <= 3100)):
    case ((amt >= 3110) && (amt <= 3305)):
    case ((amt >= 3315) && (amt <= 3450)):
    case ((amt >= 3460) && (amt <= 3495)):
      letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$3,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 3500)};
      $('five_go_to_btn_2').innerHTML = "$4,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 4000)};
      $('five_go_to_btn_3').innerHTML = "$4,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 4500)};
      letsShow('five_tbl_max_btn');
      break;
    case ((amt == 3105) || (amt == 3310) || (amt == 3455)): 
      $('five_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$3,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 3500)};
      $('five_go_to_btn_2').innerHTML = "$4,000"; $('five_go_to_btn_2').onclick = function () {goTo(6, 4000)};
      $('five_go_to_btn_3').innerHTML = "$4,500"; $('five_go_to_btn_3').onclick = function () {goTo(6, 4500)};
      letsShow('five_tbl_max_btn');
      break;
    case (amt == 3500):
      letsHide('five_pay_disclaimer');
      letsHide('five_go_to_btn_3'); letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$4,000"; $('five_go_to_btn_1').onclick = function () {goTo(6, 4000)};
      $('five_go_to_btn_2').innerHTML = "$4,500"; $('five_go_to_btn_2').onclick = function () {goTo(6, 4500)};
      letsShow('five_tbl_max_btn');
      break;
    case ((amt >= 3505) && (amt <= 3905)):
    case ((amt >= 3915) && (amt <= 3995)):
      letsHide('five_go_to_btn_3'); letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$4,000"; $('five_go_to_btn_1').onclick = function () {goTo(6, 4000)};
      $('five_go_to_btn_2').innerHTML = "$4,500"; $('five_go_to_btn_2').onclick = function () {goTo(6, 4500)};
      letsShow('five_tbl_max_btn');
      break;
    case (amt == 3910):
      $('five_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      letsHide('five_go_to_btn_3'); letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$4,000"; $('five_go_to_btn_1').onclick = function () {goTo(6, 4000)};
      $('five_go_to_btn_2').innerHTML = "$4,500"; $('five_go_to_btn_2').onclick = function () {goTo(6, 4500)};
      letsShow('five_tbl_max_btn');
      break;
    case (amt == 4000):
      letsHide('five_pay_disclaimer');
      letsHide('five_go_to_btn_2'); letsHide('five_go_to_btn_3'); letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$4,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 4500)};
      letsShow('five_tbl_max_btn');
      break;
    case ((amt >= 4005) && (amt <= 4255)):
    case ((amt >= 4265) && (amt <= 4495)):
      letsHide('five_go_to_btn_2'); letsHide('five_go_to_btn_3'); letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$4,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 4500)};
      letsShow('five_tbl_max_btn');
      break;
    case (amt == 4260):
      $('five_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      letsHide('five_go_to_btn_2'); letsHide('five_go_to_btn_3'); letsHide('five_go_to_btn_4');
      $('five_go_to_btn_1').innerHTML = "$4,500"; $('five_go_to_btn_1').onclick = function () {goTo(6, 4500)};
      letsShow('five_tbl_max_btn');
      break;
    case (amt == 4500):
      letsHide('five_pay_disclaimer');
      letsHide('five_go_to_buttons');
      letsShow('five_tbl_max_btn');
      break;
    case ((amt >= 4505) && (amt <= 4600)):
    case ((amt >= 4610) && (amt <= 4995)):
      letsHide('five_go_to_buttons');
      letsShow('five_tbl_max_btn');
      break;
    case (amt == 4605):
      $('five_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      letsHide('five_go_to_buttons');
      letsShow('five_tbl_max_btn');
      break;
    case (amt == 5000):
      $('five_pay_disclaimer').innerHTML = "You hit at table max!! If you want to put even more on the table you can start making Come bets and double dip your way up to max Come bet and max Odds! Another... $25,000 ($5K with $20K odds ) to win 35K plus your 7K here is a 42K potential max win on the 5. That's when we get Come Bets which are coming soon.";
      letsHide('five_go_to_buttons');
      break;
    default: return
  }
}
function showPlaceSixBtns (amt) {
  letsShow('six_pay_disclaimer');
  $('six_pay_disclaimer').innerHTML = "Try and stick to bets in normal increments. Use the 'Go to ' menu for normal betting amounts.";
  letsHide('six_press_buttons');
  letsHide('six_press_btn_1'); letsHide('six_press_btn_2'); letsHide('six_press_btn_3'); letsHide('six_press_btn_4');
  lineUp('six_go_to_btn_3'); lineUp('six_go_to_btn_4');
  letsHide('six_tbl_max_btn');
  letsHide('place_six_dble_box');
  letsMask('six_dbl_press_btn_2');
  letsHide('six_dble_btn_box_two');
  letsMask('six_dbl_press_btn_4');
  var equalUnits = theSix.placeBet == theEight.placeBet;
  switch (true) {
    case (amt == 6):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons');
      lineUp('six_press_btn_1'); lineUp('six_press_btn_3'); lineUp('six_press_btn_4');
      letsHide('six_go_to_btn_3'); letsHide('six_go_to_btn_4');
      $('six_go_to_btn_1').innerHTML = "$12"; $('six_go_to_btn_1').onclick = function () {goTo(7, 12)};
      $('six_go_to_btn_2').innerHTML = "+5 to $18"; $('six_go_to_btn_2').onclick = function () {goTo(7, 18)};
      if(equalUnits) {
        letsShow('place_six_dble_box');
        $('six_dbl_press_btn_1').innerHTML = "+5 to $12e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 12)};
      }
      break;
    case (amt == 12):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons');
      lineUp('six_press_btn_1'); lineUp('six_press_btn_3'); lineUp('six_press_btn_4');
      letsHide('six_go_to_btn_4');
      $('six_go_to_btn_1').innerHTML = "$18"; $('six_go_to_btn_1').onclick = function () {goTo(7, 18)};
      $('six_go_to_btn_2').innerHTML = "$24"; $('six_go_to_btn_2').onclick = function () {goTo(7, 24)};
      $('six_go_to_btn_3').innerHTML = "+4 to $30"; $('six_go_to_btn_3').onclick = function () {goTo(7, 30)};
      if(equalUnits) {
        letsShow('place_six_dble_box');
        $('six_dbl_press_btn_1').innerHTML = "$18e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 18)};
      }
      break;
    case (amt == 18): 
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons');
      lineUp('six_press_btn_1'); lineUp('six_press_btn_3'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$24"; $('six_go_to_btn_1').onclick = function () {goTo(7, 24)};
      $('six_go_to_btn_2').innerHTML = "$30"; $('six_go_to_btn_2').onclick = function () {goTo(7, 30)};
      $('six_go_to_btn_3').innerHTML = "$36"; $('six_go_to_btn_3').onclick = function () {goTo(7, 36)};
      $('six_go_to_btn_4').innerHTML = "+4 to $42"; $('six_go_to_btn_4').onclick = function () {goTo(7, 42)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$24e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 24)};
        $('six_dbl_press_btn_2').innerHTML = "+3 to $30e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 30)};
      }
      break;
    case (amt == 24):
      letsHide('six_pay_disclaimer'); 
      letsShow('six_press_buttons');
      lineUp('six_press_btn_1'); lineUp('six_press_btn_3'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$36"; $('six_go_to_btn_1').onclick = function () {goTo(7, 36)};
      $('six_go_to_btn_2').innerHTML = "$42"; $('six_go_to_btn_2').onclick = function () {goTo(7, 42)};
      $('six_go_to_btn_3').innerHTML = "$48"; $('six_go_to_btn_3').onclick = function () {goTo(7, 48)};
      $('six_go_to_btn_4').innerHTML = "+2 to $54"; $('six_go_to_btn_4').onclick = function () {goTo(7, 54)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$30e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 30)};
        $('six_dbl_press_btn_2').innerHTML = "$36e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 36)};
      }
      break;
    case (amt == 30):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons');
      lineUp('six_press_btn_1'); lineUp('six_press_btn_2'); lineUp('six_press_btn_3'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$42"; $('six_go_to_btn_1').onclick = function () {goTo(7, 42)};
      $('six_go_to_btn_2').innerHTML = "$48"; $('six_go_to_btn_2').onclick = function () {goTo(7, 48)};
      $('six_go_to_btn_3').innerHTML = "$54"; $('six_go_to_btn_3').onclick = function () {goTo(7, 54)};
      $('six_go_to_btn_4').innerHTML = "+1 to $66"; $('six_go_to_btn_4').onclick = function () {goTo(7, 66)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$36e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 36)};
        $('six_dbl_press_btn_2').innerHTML = "$42e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 42)};
        letsShow('six_dble_btn_box_two');
        $('six_dbl_press_btn_3').innerHTML = "+1 to $48e 6 &amp; 8"; $('six_dbl_press_btn_3').onclick = function () {doubleUnitPress(7, 48)};
      }
      break;
    case (amt == 36):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons');
      lineUp('six_press_btn_1'); lineUp('six_press_btn_3'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$48"; $('six_go_to_btn_1').onclick = function () {goTo(7, 48)};
      $('six_go_to_btn_2').innerHTML = "$54"; $('six_go_to_btn_2').onclick = function () {goTo(7, 54)};
      $('six_go_to_btn_3').innerHTML = "$60"; $('six_go_to_btn_3').onclick = function () {goTo(7, 60)};
      $('six_go_to_btn_4').innerHTML = "$66"; $('six_go_to_btn_4').onclick = function () {goTo(7, 66)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$42e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 42)};
        $('six_dbl_press_btn_2').innerHTML = "$48e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 48)};
        letsShow('six_dble_btn_box_two');
        $('six_dbl_press_btn_3').innerHTML = "+6 to $60e 6 &amp; 8"; $('six_dbl_press_btn_3').onclick = function () {doubleUnitPress(7, 60)};
      }
      break;
    case (amt == 42):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons');
      lineUp('six_press_btn_1'); lineUp('six_press_btn_3'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$54"; $('six_go_to_btn_1').onclick = function () {goTo(7, 54)};
      $('six_go_to_btn_2').innerHTML = "$60"; $('six_go_to_btn_2').onclick = function () {goTo(7, 60)};
      $('six_go_to_btn_3').innerHTML = "$72"; $('six_go_to_btn_3').onclick = function () {goTo(7, 72)};
      $('six_go_to_btn_4').innerHTML = "$78"; $('six_go_to_btn_4').onclick = function () {goTo(7, 78)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$48e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 48)};
        $('six_dbl_press_btn_2').innerHTML = "$54e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 54)};
        letsShow('six_dble_btn_box_two');
        $('six_dbl_press_btn_3').innerHTML = "$60e 6 &amp; 8"; $('six_dbl_press_btn_3').onclick = function () {doubleUnitPress(7, 60)};
      }
      break;
    case (amt == 48):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons');
      lineUp('six_press_btn_1'); lineUp('six_press_btn_3'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$60"; $('six_go_to_btn_1').onclick = function () {goTo(7, 60)};
      $('six_go_to_btn_2').innerHTML = "$72"; $('six_go_to_btn_2').onclick = function () {goTo(7, 72)};
      $('six_go_to_btn_3').innerHTML = "$90"; $('six_go_to_btn_3').onclick = function () {goTo(7, 90)};
      $('six_go_to_btn_4').innerHTML = "$102"; $('six_go_to_btn_4').onclick = function () {goTo(7, 102)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$54e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 54)};
        $('six_dbl_press_btn_2').innerHTML = "$60e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 60)};
        letsShow('six_dble_btn_box_two'); letsUnmask('six_dbl_press_btn_4');
        $('six_dbl_press_btn_3').innerHTML = "$72e 6 &amp; 8"; $('six_dbl_press_btn_3').onclick = function () {doubleUnitPress(7, 72)};
        $('six_dbl_press_btn_4').innerHTML = " +4 to $78e 6 &amp; 8"; $('six_dbl_press_btn_3').onclick = function () {doubleUnitPress(7, 78)};
      }
      break;
    case (amt == 54):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons');
      lineUp('six_press_btn_1'); lineUp('six_press_btn_3'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$60"; $('six_go_to_btn_1').onclick = function () {goTo(7, 60)};
      $('six_go_to_btn_2').innerHTML = "$72"; $('six_go_to_btn_2').onclick = function () {goTo(7, 72)};
      $('six_go_to_btn_3').innerHTML = "$90"; $('six_go_to_btn_3').onclick = function () {goTo(7, 90)};
      $('six_go_to_btn_4').innerHTML = "+3 to $120"; $('six_go_to_btn_4').onclick = function () {goTo(7, 120)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$60e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 60)};
        $('six_dbl_press_btn_2').innerHTML = "$72e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 72)};
        letsShow('six_dble_btn_box_two');
        $('six_dbl_press_btn_3').innerHTML = "$78e 6 &amp; 8"; $('six_dbl_press_btn_3').onclick = function () {doubleUnitPress(7, 78)};
      }
      break;
    case (amt == 60):
      letsHide('six_pay_disclaimer'); 
      letsShow('six_press_buttons');
      lineUp('six_press_btn_1'); lineUp('six_press_btn_2'); lineUp('six_press_btn_3'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$72"; $('six_go_to_btn_1').onclick = function () {goTo(7, 72)};
      $('six_go_to_btn_2').innerHTML = "$78"; $('six_go_to_btn_2').onclick = function () {goTo(7, 78)};
      $('six_go_to_btn_3').innerHTML = "$90"; $('six_go_to_btn_3').onclick = function () {goTo(7, 90)};
      $('six_go_to_btn_4').innerHTML = "$120"; $('six_go_to_btn_4').onclick = function () {goTo(7, 120)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$72e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 72)};
        $('six_dbl_press_btn_2').innerHTML = "$78e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 78)};
        letsShow('six_dble_btn_box_two');
        $('six_dbl_press_btn_3').innerHTML = "$90e 6 &amp; 8"; $('six_dbl_press_btn_3').onclick = function () {doubleUnitPress(7, 90)};
      }
      break;
    case (amt == 66):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons');
      lineUp('six_press_btn_1'); lineUp('six_press_btn_3'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$78"; $('six_go_to_btn_1').onclick = function () {goTo(7, 78)};
      $('six_go_to_btn_2').innerHTML = "$90"; $('six_go_to_btn_2').onclick = function () {goTo(7, 90)};
      $('six_go_to_btn_3').innerHTML = "$120"; $('six_go_to_btn_3').onclick = function () {goTo(7, 120)};
      $('six_go_to_btn_4').innerHTML = "+7 to $150"; $('six_go_to_btn_4').onclick = function () {goTo(7, 150)};
      break;
    case (amt == 72):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons');
      lineUp('six_press_btn_1'); lineUp('six_press_btn_3'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$90"; $('six_go_to_btn_1').onclick = function () {goTo(7, 90)};
      $('six_go_to_btn_2').innerHTML = "$102"; $('six_go_to_btn_2').onclick = function () {goTo(7, 102)};
      $('six_go_to_btn_3').innerHTML = "$120"; $('six_go_to_btn_3').onclick = function () {goTo(7, 120)};
      $('six_go_to_btn_4').innerHTML = "$150"; $('six_go_to_btn_4').onclick = function () {goTo(7, 150)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$78e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 78)};
        $('six_dbl_press_btn_2').innerHTML = "$90e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 90)};
      }
      break;
    case (amt == 78):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons');
      lineUp('six_press_btn_1'); lineUp('six_press_btn_3'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$90"; $('six_go_to_btn_1').onclick = function () {goTo(7, 90)};
      $('six_go_to_btn_2').innerHTML = "$102"; $('six_go_to_btn_2').onclick = function () {goTo(7, 102)};
      $('six_go_to_btn_3').innerHTML = "$120"; $('six_go_to_btn_3').onclick = function () {goTo(7, 120)};
      $('six_go_to_btn_4').innerHTML = "$150"; $('six_go_to_btn_4').onclick = function () {goTo(7, 150)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$90e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 90)};
        $('six_dbl_press_btn_2').innerHTML = "$120e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 120)};
      }
      break;
    case (amt == 84):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons');
      lineUp('six_press_btn_1'); lineUp('six_press_btn_3'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$90"; $('six_go_to_btn_1').onclick = function () {goTo(7, 90)};
      $('six_go_to_btn_2').innerHTML = "$102"; $('six_go_to_btn_2').onclick = function () {goTo(7, 102)};
      $('six_go_to_btn_3').innerHTML = "$120"; $('six_go_to_btn_3').onclick = function () {goTo(7, 120)};
      $('six_go_to_btn_4').innerHTML = "$150"; $('six_go_to_btn_4').onclick = function () {goTo(7, 150)};
      break;
    case (amt == 90):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons');
      lineUp('six_press_btn_1'); lineUp('six_press_btn_2'); lineUp('six_press_btn_3'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$102"; $('six_go_to_btn_1').onclick = function () {goTo(7, 102)};
      $('six_go_to_btn_2').innerHTML = "$120"; $('six_go_to_btn_2').onclick = function () {goTo(7, 120)};
      $('six_go_to_btn_3').innerHTML = "$150"; $('six_go_to_btn_3').onclick = function () {goTo(7, 150)};
      $('six_go_to_btn_4').innerHTML = "$180"; $('six_go_to_btn_4').onclick = function () {goTo(7, 180)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$120e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 120)};
        $('six_dbl_press_btn_2').innerHTML = "+15 to $150e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 150)};
      }
      break;
    case (amt == 96):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons');
      lineUp('six_press_btn_1'); lineUp('six_press_btn_3'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$120"; $('six_go_to_btn_1').onclick = function () {goTo(7, 120)};
      $('six_go_to_btn_2').innerHTML = "$150"; $('six_go_to_btn_2').onclick = function () {goTo(7, 150)};
      $('six_go_to_btn_3').innerHTML = "$180"; $('six_go_to_btn_3').onclick = function () {goTo(7, 180)};
      $('six_go_to_btn_4').innerHTML = "+2 to $210"; $('six_go_to_btn_4').onclick = function () {goTo(7, 210)};
      break;
    case (amt == 102):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$120"; $('six_go_to_btn_1').onclick = function () {goTo(7, 120)};
      $('six_go_to_btn_2').innerHTML = "$150"; $('six_go_to_btn_2').onclick = function () {goTo(7, 150)};
      $('six_go_to_btn_3').innerHTML = "$180"; $('six_go_to_btn_3').onclick = function () {goTo(7, 180)};
      $('six_go_to_btn_4').innerHTML = "$210"; $('six_go_to_btn_4').onclick = function () {goTo(7, 210)};
      break;
    case (amt == 108):
      $('six_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      $('six_go_to_btn_1').innerHTML = "$120"; $('six_go_to_btn_1').onclick = function () {goTo(7, 120)};
      $('six_go_to_btn_2').innerHTML = "$150"; $('six_go_to_btn_2').onclick = function () {goTo(7, 150)};
      $('six_go_to_btn_3').innerHTML = "$180"; $('six_go_to_btn_3').onclick = function () {goTo(7, 180)};
      $('six_go_to_btn_4').innerHTML = "$210"; $('six_go_to_btn_4').onclick = function () {goTo(7, 210)};
      break;
    case (amt == 114):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$120"; $('six_go_to_btn_1').onclick = function () {goTo(7, 120)};
      $('six_go_to_btn_2').innerHTML = "$150"; $('six_go_to_btn_2').onclick = function () {goTo(7, 150)};
      $('six_go_to_btn_3').innerHTML = "$180"; $('six_go_to_btn_3').onclick = function () {goTo(7, 180)};
      $('six_go_to_btn_4').innerHTML = "$240"; $('six_go_to_btn_4').onclick = function () {goTo(7, 240)};
      break;
    case (amt == 120):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons');
      lineUp('six_press_btn_1'); lineUp('six_press_btn_2'); lineUp('six_press_btn_3');
      $('six_go_to_btn_1').innerHTML = "$150"; $('six_go_to_btn_1').onclick = function () {goTo(7, 150)};
      $('six_go_to_btn_2').innerHTML = "$180"; $('six_go_to_btn_2').onclick = function () {goTo(7, 180)};
      $('six_go_to_btn_3').innerHTML = "$210"; $('six_go_to_btn_3').onclick = function () {goTo(7, 210)};
      $('six_go_to_btn_4').innerHTML = "$240"; $('six_go_to_btn_4').onclick = function () {goTo(7, 240)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$150e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 150)};
        $('six_dbl_press_btn_2').innerHTML = "$180e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 180)};
      }
      break;
    case ((amt == 126) || (amt == 138)):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$150"; $('six_go_to_btn_1').onclick = function () {goTo(7, 150)};
      $('six_go_to_btn_2').innerHTML = "$180"; $('six_go_to_btn_2').onclick = function () {goTo(7, 180)};
      $('six_go_to_btn_3').innerHTML = "$210"; $('six_go_to_btn_3').onclick = function () {goTo(7, 210)};
      $('six_go_to_btn_4').innerHTML = "$240"; $('six_go_to_btn_4').onclick = function () {goTo(7, 240)};
      break;
    case (amt == 132):
      $('six_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      $('six_go_to_btn_1').innerHTML = "$150"; $('six_go_to_btn_1').onclick = function () {goTo(7, 150)};
      $('six_go_to_btn_2').innerHTML = "$180"; $('six_go_to_btn_2').onclick = function () {goTo(7, 180)};
      $('six_go_to_btn_3').innerHTML = "$210"; $('six_go_to_btn_3').onclick = function () {goTo(7, 210)};
      $('six_go_to_btn_4').innerHTML = "$240"; $('six_go_to_btn_4').onclick = function () {goTo(7, 240)};
      break;
    case (amt == 144):
      $('six_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      $('six_go_to_btn_1').innerHTML = "$150"; $('six_go_to_btn_1').onclick = function () {goTo(7, 150)};
      $('six_go_to_btn_2').innerHTML = "$180"; $('six_go_to_btn_2').onclick = function () {goTo(7, 180)};
      $('six_go_to_btn_3').innerHTML = "$240"; $('six_go_to_btn_3').onclick = function () {goTo(7, 240)};
      $('six_go_to_btn_4').innerHTML = "$300"; $('six_go_to_btn_4').onclick = function () {goTo(7, 300)};
      break;
    case (amt == 150):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons');
      lineUp('six_press_btn_2'); lineUp('six_press_btn_3');
      $('six_go_to_btn_1').innerHTML = "$150"; $('six_go_to_btn_1').onclick = function () {goTo(7, 150)};
      $('six_go_to_btn_2').innerHTML = "$180"; $('six_go_to_btn_2').onclick = function () {goTo(7, 180)};
      $('six_go_to_btn_3').innerHTML = "$210"; $('six_go_to_btn_3').onclick = function () {goTo(7, 210)};
      $('six_go_to_btn_4').innerHTML = "$240"; $('six_go_to_btn_4').onclick = function () {goTo(7, 240)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$180e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 180)};
        $('six_dbl_press_btn_2').innerHTML = "$210e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 210)};
        letsShow('six_dble_btn_box_two');
        $('six_dbl_press_btn_3').innerHTML = "+5 to $240e 6 &amp; 8"; $('six_dbl_press_btn_3').onclick = function () {doubleUnitPress(7, 240)};
      }
      break;
    case (amt == 156):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$180"; $('six_go_to_btn_1').onclick = function () {goTo(7, 180)};
      $('six_go_to_btn_2').innerHTML = "$210"; $('six_go_to_btn_2').onclick = function () {goTo(7, 210)};
      $('six_go_to_btn_3').innerHTML = "$240"; $('six_go_to_btn_3').onclick = function () {goTo(7, 240)};
      $('six_go_to_btn_4').innerHTML = "$300"; $('six_go_to_btn_4').onclick = function () {goTo(7, 300)};
      break;
    case (amt == 162):
      $('six_go_to_btn_1').innerHTML = "$180"; $('six_go_to_btn_1').onclick = function () {goTo(7, 180)};
      $('six_go_to_btn_2').innerHTML = "$210"; $('six_go_to_btn_2').onclick = function () {goTo(7, 210)};
      $('six_go_to_btn_3').innerHTML = "$240"; $('six_go_to_btn_3').onclick = function () {goTo(7, 240)};
      $('six_go_to_btn_4').innerHTML = "$300"; $('six_go_to_btn_4').onclick = function () {goTo(7, 300)};
      break;
    case (amt == 168):
      $('six_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Full pressers can shoot for the stars. Otherwise, you should be pressing by $120 or $300. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$180"; $('six_go_to_btn_1').onclick = function () {goTo(7, 180)};
      $('six_go_to_btn_2').innerHTML = "$240"; $('six_go_to_btn_2').onclick = function () {goTo(7, 240)};
      $('six_go_to_btn_3').innerHTML = "$300"; $('six_go_to_btn_3').onclick = function () {goTo(7, 300)};
      $('six_go_to_btn_4').innerHTML = "$360"; $('six_go_to_btn_4').onclick = function () {goTo(7, 360)};
      break;
    case (amt == 174):
      $('six_go_to_btn_1').innerHTML = "$180"; $('six_go_to_btn_1').onclick = function () {goTo(7, 180)};
      $('six_go_to_btn_2').innerHTML = "$240"; $('six_go_to_btn_2').onclick = function () {goTo(7, 240)};
      $('six_go_to_btn_3').innerHTML = "$300"; $('six_go_to_btn_3').onclick = function () {goTo(7, 300)};
      $('six_go_to_btn_4').innerHTML = "$360"; $('six_go_to_btn_4').onclick = function () {goTo(7, 360)};
      break;
    case (amt == 180):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons');
      lineUp('six_press_btn_2'); lineUp('six_press_btn_3'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$180"; $('six_go_to_btn_1').onclick = function () {goTo(7, 180)};
      $('six_go_to_btn_2').innerHTML = "$210"; $('six_go_to_btn_2').onclick = function () {goTo(7, 210)};
      $('six_go_to_btn_3').innerHTML = "$240"; $('six_go_to_btn_3').onclick = function () {goTo(7, 240)};
      $('six_go_to_btn_4').innerHTML = "$300"; $('six_go_to_btn_4').onclick = function () {goTo(7, 300)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$210e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 210)};
        $('six_dbl_press_btn_2').innerHTML = "$240e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 240)};
        letsShow('six_dble_btn_box_two');
        $('six_dbl_press_btn_3').innerHTML = "+30 to $300e 6 &amp; 8"; $('six_dbl_press_btn_3').onclick = function () {doubleUnitPress(7, 300)};
      }
      break;
    case (amt == 186):
      $('six_go_to_btn_1').innerHTML = "$210"; $('six_go_to_btn_1').onclick = function () {goTo(7, 210)};
      $('six_go_to_btn_2').innerHTML = "$240"; $('six_go_to_btn_2').onclick = function () {goTo(7, 240)};
      $('six_go_to_btn_3').innerHTML = "$300"; $('six_go_to_btn_3').onclick = function () {goTo(7, 300)};
      $('six_go_to_btn_4').innerHTML = "$360"; $('six_go_to_btn_4').onclick = function () {goTo(7, 360)};
      break;
    case (amt == 192):
      $('six_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Full pressers can shoot for the stars. Otherwise, you should be pressing by $120 or $300. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$210"; $('six_go_to_btn_1').onclick = function () {goTo(7, 210)};
      $('six_go_to_btn_2').innerHTML = "$240"; $('six_go_to_btn_2').onclick = function () {goTo(7, 240)};
      $('six_go_to_btn_3').innerHTML = "$300"; $('six_go_to_btn_3').onclick = function () {goTo(7, 300)};
      $('six_go_to_btn_4').innerHTML = "$360"; $('six_go_to_btn_4').onclick = function () {goTo(7, 360)};
      break;
    case (amt == 198):
      $('six_go_to_btn_1').innerHTML = "$240"; $('six_go_to_btn_1').onclick = function () {goTo(7, 240)};
      $('six_go_to_btn_2').innerHTML = "$300"; $('six_go_to_btn_2').onclick = function () {goTo(7, 300)};
      $('six_go_to_btn_3').innerHTML = "$360"; $('six_go_to_btn_3').onclick = function () {goTo(7, 360)};
      $('six_go_to_btn_4').innerHTML = "$420"; $('six_go_to_btn_4').onclick = function () {goTo(7, 420)};
      break;
    case (amt == 204):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$240"; $('six_go_to_btn_1').onclick = function () {goTo(7, 240)};
      $('six_go_to_btn_2').innerHTML = "$300"; $('six_go_to_btn_2').onclick = function () {goTo(7, 300)};
      $('six_go_to_btn_3').innerHTML = "$360"; $('six_go_to_btn_3').onclick = function () {goTo(7, 360)};
      $('six_go_to_btn_4').innerHTML = "$420"; $('six_go_to_btn_4').onclick = function () {goTo(7, 420)};
      break;
    case (amt == 210):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons');
      lineUp('six_press_btn_2'); lineUp('six_press_btn_3');
      $('six_go_to_btn_1').innerHTML = "$300"; $('six_go_to_btn_1').onclick = function () {goTo(7, 300)};
      $('six_go_to_btn_2').innerHTML = "$360"; $('six_go_to_btn_2').onclick = function () {goTo(7, 360)};
      $('six_go_to_btn_3').innerHTML = "$420"; $('six_go_to_btn_3').onclick = function () {goTo(7, 420)};
      $('six_go_to_btn_4').innerHTML = "$450"; $('six_go_to_btn_4').onclick = function () {goTo(7, 450)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$240e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 240)};
        $('six_dbl_press_btn_2').innerHTML = "$300e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 300)};
      }
      break;
    case (amt == 216):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$300"; $('six_go_to_btn_1').onclick = function () {goTo(7, 300)};
      $('six_go_to_btn_2').innerHTML = "$360"; $('six_go_to_btn_2').onclick = function () {goTo(7, 360)};
      $('six_go_to_btn_3').innerHTML = "$420"; $('six_go_to_btn_3').onclick = function () {goTo(7, 420)};
      $('six_go_to_btn_4').innerHTML = "$450"; $('six_go_to_btn_4').onclick = function () {goTo(7, 450)};
      break;
    case ((amt == 222) || (amt == 228) || (amt == 234)):
      $('six_go_to_btn_1').innerHTML = "$300"; $('six_go_to_btn_1').onclick = function () {goTo(7, 300)};
      $('six_go_to_btn_2').innerHTML = "$360"; $('six_go_to_btn_2').onclick = function () {goTo(7, 360)};
      $('six_go_to_btn_3').innerHTML = "$420"; $('six_go_to_btn_3').onclick = function () {goTo(7, 420)};
      $('six_go_to_btn_4').innerHTML = "$480"; $('six_go_to_btn_4').onclick = function () {goTo(7, 480)};
      break;
    case (amt == 240):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons');
      lineUp('six_press_btn_2'); lineUp('six_press_btn_3');
      $('six_go_to_btn_1').innerHTML = "$300"; $('six_go_to_btn_1').onclick = function () {goTo(7, 300)};
      $('six_go_to_btn_2').innerHTML = "$360"; $('six_go_to_btn_2').onclick = function () {goTo(7, 360)};
      $('six_go_to_btn_3').innerHTML = "$420"; $('six_go_to_btn_3').onclick = function () {goTo(7, 420)};
      $('six_go_to_btn_4').innerHTML = "$480"; $('six_go_to_btn_4').onclick = function () {goTo(7, 480)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$300e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 300)};
        $('six_dbl_press_btn_2').innerHTML = "$360e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 360)};
      }
      break;
    case (amt == 246):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$300"; $('six_go_to_btn_1').onclick = function () {goTo(7, 300)};
      $('six_go_to_btn_2').innerHTML = "$360"; $('six_go_to_btn_2').onclick = function () {goTo(7, 360)};
      $('six_go_to_btn_3').innerHTML = "$420"; $('six_go_to_btn_3').onclick = function () {goTo(7, 420)};
      $('six_go_to_btn_4').innerHTML = "$480"; $('six_go_to_btn_4').onclick = function () {goTo(7, 480)};
      break;
    case ((amt >= 252) && (amt <= 264)):
      $('six_go_to_btn_1').innerHTML = "$300"; $('six_go_to_btn_1').onclick = function () {goTo(7, 300)};
      $('six_go_to_btn_2').innerHTML = "$360"; $('six_go_to_btn_2').onclick = function () {goTo(7, 360)};
      $('six_go_to_btn_3').innerHTML = "$480"; $('six_go_to_btn_3').onclick = function () {goTo(7, 480)};
      $('six_go_to_btn_4').innerHTML = "$540"; $('six_go_to_btn_4').onclick = function () {goTo(7, 540)};
      break;
    case (amt == 270):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons');
      lineUp('six_press_btn_2'); lineUp('six_press_btn_3'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$300"; $('six_go_to_btn_1').onclick = function () {goTo(7, 300)};
      $('six_go_to_btn_2').innerHTML = "$360"; $('six_go_to_btn_2').onclick = function () {goTo(7, 360)};
      $('six_go_to_btn_3').innerHTML = "$480"; $('six_go_to_btn_3').onclick = function () {goTo(7, 480)};
      $('six_go_to_btn_4').innerHTML = "$540"; $('six_go_to_btn_4').onclick = function () {goTo(7, 540)};
      break;
    case (amt == 276):
      $('six_go_to_btn_1').innerHTML = "$300"; $('six_go_to_btn_1').onclick = function () {goTo(7, 300)};
      $('six_go_to_btn_2').innerHTML = "$360"; $('six_go_to_btn_2').onclick = function () {goTo(7, 360)};
      $('six_go_to_btn_3').innerHTML = "$480"; $('six_go_to_btn_3').onclick = function () {goTo(7, 480)};
      $('six_go_to_btn_4').innerHTML = "$540"; $('six_go_to_btn_4').onclick = function () {goTo(7, 540)};
      break;
    case ((amt == 282) || (amt == 288)):
      $('six_go_to_btn_1').innerHTML = "$360"; $('six_go_to_btn_1').onclick = function () {goTo(7, 360)};
      $('six_go_to_btn_2').innerHTML = "$480"; $('six_go_to_btn_2').onclick = function () {goTo(7, 480)};
      $('six_go_to_btn_3').innerHTML = "$540"; $('six_go_to_btn_3').onclick = function () {goTo(7, 540)};
      $('six_go_to_btn_4').innerHTML = "$600"; $('six_go_to_btn_4').onclick = function () {goTo(7, 600)};
      break;
    case (amt == 294):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$360"; $('six_go_to_btn_1').onclick = function () {goTo(7, 360)};
      $('six_go_to_btn_2').innerHTML = "$480"; $('six_go_to_btn_2').onclick = function () {goTo(7, 480)};
      $('six_go_to_btn_3').innerHTML = "$540"; $('six_go_to_btn_3').onclick = function () {goTo(7, 540)};
      $('six_go_to_btn_4').innerHTML = "$600"; $('six_go_to_btn_4').onclick = function () {goTo(7, 600)};
      break;
    case (amt == 300):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons'); lineUp('six_press_btn_3');
      $('six_go_to_btn_1').innerHTML = "$360"; $('six_go_to_btn_1').onclick = function () {goTo(7, 360)};
      $('six_go_to_btn_2').innerHTML = "$420"; $('six_go_to_btn_2').onclick = function () {goTo(7, 420)};
      $('six_go_to_btn_3').innerHTML = "$480"; $('six_go_to_btn_3').onclick = function () {goTo(7, 480)};
      $('six_go_to_btn_4').innerHTML = "$540"; $('six_go_to_btn_4').onclick = function () {goTo(7, 540)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$360e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 360)};
        $('six_dbl_press_btn_2').innerHTML = "$420e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 420)};
        letsShow('six_dble_btn_box_two'); letsUnmask('six_dbl_press_btn_4');
        $('six_dbl_press_btn_3').innerHTML = "$450e 6 &amp; 8"; $('six_dbl_press_btn_3').onclick = function () {doubleUnitPress(7, 450)};
        $('six_dbl_press_btn_4').innerHTML = "+10 to $480e 6 &amp; 8"; $('six_dbl_press_btn_4').onclick = function () {doubleUnitPress(7, 480)};
      }
      break;
    case ((amt >= 306) && (amt <= 330)):
      $('six_go_to_btn_1').innerHTML = "$360"; $('six_go_to_btn_1').onclick = function () {goTo(7, 360)};
      $('six_go_to_btn_2').innerHTML = "$480"; $('six_go_to_btn_2').onclick = function () {goTo(7, 480)};
      $('six_go_to_btn_3').innerHTML = "$540"; $('six_go_to_btn_3').onclick = function () {goTo(7, 540)};
      $('six_go_to_btn_4').innerHTML = "$600"; $('six_go_to_btn_4').onclick = function () {goTo(7, 600)};
      break;
    case (amt == 336):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$360"; $('six_go_to_btn_1').onclick = function () {goTo(7, 360)};
      $('six_go_to_btn_2').innerHTML = "$480"; $('six_go_to_btn_2').onclick = function () {goTo(7, 480)};
      $('six_go_to_btn_3').innerHTML = "$600"; $('six_go_to_btn_3').onclick = function () {goTo(7, 600)};
      $('six_go_to_btn_4').innerHTML = "$720"; $('six_go_to_btn_4').onclick = function () {goTo(7, 720)};
      break;
    case ((amt >= 342) && (amt <= 354)):
      $('six_go_to_btn_1').innerHTML = "$360"; $('six_go_to_btn_1').onclick = function () {goTo(7, 360)};
      $('six_go_to_btn_2').innerHTML = "$480"; $('six_go_to_btn_2').onclick = function () {goTo(7, 480)};
      $('six_go_to_btn_3').innerHTML = "$600"; $('six_go_to_btn_3').onclick = function () {goTo(7, 600)};
      $('six_go_to_btn_4').innerHTML = "$720"; $('six_go_to_btn_4').onclick = function () {goTo(7, 720)};
      break;
    case (amt == 360):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons'); lineUp('six_press_btn_3'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$420"; $('six_go_to_btn_1').onclick = function () {goTo(7, 420)};
      $('six_go_to_btn_2').innerHTML = "$540"; $('six_go_to_btn_2').onclick = function () {goTo(7, 540)};
      $('six_go_to_btn_3').innerHTML = "$600"; $('six_go_to_btn_3').onclick = function () {goTo(7, 600)};
      $('six_go_to_btn_4').innerHTML = "$780"; $('six_go_to_btn_4').onclick = function () {goTo(7, 780)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$420e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 420)};
        $('six_dbl_press_btn_2').innerHTML = "$450e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 450)};
        letsShow('six_dble_btn_box_two'); letsUnmask('six_dbl_press_btn_4');
        $('six_dbl_press_btn_3').innerHTML = "$480e 6 &amp; 8"; $('six_dbl_press_btn_3').onclick = function () {doubleUnitPress(7, 480)};
        $('six_dbl_press_btn_4').innerHTML = "$600e 6 &amp; 8"; $('six_dbl_press_btn_4').onclick = function () {doubleUnitPress(7, 600)};
      }
      break;
    case ((amt >= 366) && (amt <= 384)):
    case ((amt >= 396) && (amt <= 408)):
      $('six_go_to_btn_1').innerHTML = "$420"; $('six_go_to_btn_1').onclick = function () {goTo(7, 420)};
      $('six_go_to_btn_2').innerHTML = "$540"; $('six_go_to_btn_2').onclick = function () {goTo(7, 540)};
      $('six_go_to_btn_3').innerHTML = "$600"; $('six_go_to_btn_3').onclick = function () {goTo(7, 600)};
      $('six_go_to_btn_4').innerHTML = "$780"; $('six_go_to_btn_4').onclick = function () {goTo(7, 780)};
      break;
    case ((amt == 390) || (amt == 414)):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$420"; $('six_go_to_btn_1').onclick = function () {goTo(7, 420)};
      $('six_go_to_btn_2').innerHTML = "$540"; $('six_go_to_btn_2').onclick = function () {goTo(7, 540)};
      $('six_go_to_btn_3').innerHTML = "$600"; $('six_go_to_btn_3').onclick = function () {goTo(7, 600)};
      $('six_go_to_btn_4').innerHTML = "$780"; $('six_go_to_btn_4').onclick = function () {goTo(7, 780)};
      break;
    case (amt == 420):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons'); lineUp('six_press_btn_3');
      $('six_go_to_btn_1').innerHTML = "$540"; $('six_go_to_btn_1').onclick = function () {goTo(7, 540)};
      $('six_go_to_btn_2').innerHTML = "$600"; $('six_go_to_btn_2').onclick = function () {goTo(7, 600)};
      $('six_go_to_btn_3').innerHTML = "$780"; $('six_go_to_btn_3').onclick = function () {goTo(7, 780)};
      $('six_go_to_btn_4').innerHTML = "$900"; $('six_go_to_btn_4').onclick = function () {goTo(7, 900)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$450e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 450)};
        $('six_dbl_press_btn_2').innerHTML = "$480e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 480)};
        letsShow('six_dble_btn_box_two');
        $('six_dbl_press_btn_3').innerHTML = "$600e 6 &amp; 8"; $('six_dbl_press_btn_3').onclick = function () {doubleUnitPress(7, 600)};
      }
      break;
    case ((amt == 426) || (amt == 432) || (amt == 444)):
    case ((amt == 456) || (amt == 462) || (amt == 474) || (amt == 534)):
    case ((amt >= 486) && (amt <= 522)):
      $('six_go_to_btn_1').innerHTML = "$540"; $('six_go_to_btn_1').onclick = function () {goTo(7, 540)};
      $('six_go_to_btn_2').innerHTML = "$600"; $('six_go_to_btn_2').onclick = function () {goTo(7, 600)};
      $('six_go_to_btn_3').innerHTML = "$780"; $('six_go_to_btn_3').onclick = function () {goTo(7, 780)};
      $('six_go_to_btn_4').innerHTML = "$900"; $('six_go_to_btn_4').onclick = function () {goTo(7, 900)};
      break;
    case ((amt == 438) || (amt == 468) || (amt == 528)):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$540"; $('six_go_to_btn_1').onclick = function () {goTo(7, 540)};
      $('six_go_to_btn_2').innerHTML = "$600"; $('six_go_to_btn_2').onclick = function () {goTo(7, 600)};
      $('six_go_to_btn_3').innerHTML = "$780"; $('six_go_to_btn_3').onclick = function () {goTo(7, 780)};
      $('six_go_to_btn_4').innerHTML = "$900"; $('six_go_to_btn_4').onclick = function () {goTo(7, 900)};
      break;
    case (amt == 450):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons'); lineUp('six_press_btn_2'); lineUp('six_press_btn_3');
      $('six_go_to_btn_1').innerHTML = "$540"; $('six_go_to_btn_1').onclick = function () {goTo(7, 540)};
      $('six_go_to_btn_2').innerHTML = "$600"; $('six_go_to_btn_2').onclick = function () {goTo(7, 600)};
      $('six_go_to_btn_3').innerHTML = "$780"; $('six_go_to_btn_3').onclick = function () {goTo(7, 780)};
      $('six_go_to_btn_4').innerHTML = "$900"; $('six_go_to_btn_4').onclick = function () {goTo(7, 900)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$480e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 480)};
        $('six_dbl_press_btn_2').innerHTML = "$600e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 600)};
      }
      break;
    case (amt == 480):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons'); lineUp('six_press_btn_3');
      $('six_go_to_btn_1').innerHTML = "$540"; $('six_go_to_btn_1').onclick = function () {goTo(7, 540)};
      $('six_go_to_btn_2').innerHTML = "$600"; $('six_go_to_btn_2').onclick = function () {goTo(7, 600)};
      $('six_go_to_btn_3').innerHTML = "$780"; $('six_go_to_btn_3').onclick = function () {goTo(7, 780)};
      $('six_go_to_btn_4').innerHTML = "$900"; $('six_go_to_btn_4').onclick = function () {goTo(7, 900)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$600e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 600)};
        $('six_dbl_press_btn_2').innerHTML = "$720e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 720)};
      }
      break;
    case (amt == 540):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons'); lineUp('six_press_btn_3');
      $('six_go_to_btn_1').innerHTML = "$600"; $('six_go_to_btn_1').onclick = function () {goTo(7, 600)};
      $('six_go_to_btn_2').innerHTML = "$720"; $('six_go_to_btn_2').onclick = function () {goTo(7, 720)};
      $('six_go_to_btn_3').innerHTML = "$780"; $('six_go_to_btn_3').onclick = function () {goTo(7, 780)};
      $('six_go_to_btn_4').innerHTML = "$900"; $('six_go_to_btn_4').onclick = function () {goTo(7, 900)};
      break;
    case ((amt == 546) || (amt == 552)):
      $('six_go_to_btn_1').innerHTML = "$600"; $('six_go_to_btn_1').onclick = function () {goTo(7, 600)};
      $('six_go_to_btn_2').innerHTML = "$720"; $('six_go_to_btn_2').onclick = function () {goTo(7, 720)};
      $('six_go_to_btn_3').innerHTML = "$780"; $('six_go_to_btn_3').onclick = function () {goTo(7, 780)};
      $('six_go_to_btn_4').innerHTML = "$900"; $('six_go_to_btn_4').onclick = function () {goTo(7, 900)};
      break;
    case ((amt >= 558) && (amt <= 576)):
    case ((amt == 588) || (amt == 594)):
      $('six_go_to_btn_1').innerHTML = "$600"; $('six_go_to_btn_1').onclick = function () {goTo(7, 600)};
      $('six_go_to_btn_2').innerHTML = "$780"; $('six_go_to_btn_2').onclick = function () {goTo(7, 780)};
      $('six_go_to_btn_3').innerHTML = "$900"; $('six_go_to_btn_3').onclick = function () {goTo(7, 900)};
      $('six_go_to_btn_4').innerHTML = "$1,200"; $('six_go_to_btn_4').onclick = function () {goTo(7, 1200)};
      break;
    case (amt == 582):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$600"; $('six_go_to_btn_1').onclick = function () {goTo(7, 600)};
      $('six_go_to_btn_2').innerHTML = "$780"; $('six_go_to_btn_2').onclick = function () {goTo(7, 780)};
      $('six_go_to_btn_3').innerHTML = "$900"; $('six_go_to_btn_3').onclick = function () {goTo(7, 900)};
      $('six_go_to_btn_4').innerHTML = "$1,200"; $('six_go_to_btn_4').onclick = function () {goTo(7, 1200)};
      break;
    case (amt == 600):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons'); lineUp('six_press_btn_3');
      $('six_go_to_btn_1').innerHTML = "$780"; $('six_go_to_btn_1').onclick = function () {goTo(7, 780)};
      $('six_go_to_btn_2').innerHTML = "$900"; $('six_go_to_btn_2').onclick = function () {goTo(7, 900)};
      $('six_go_to_btn_3').innerHTML = "$960"; $('six_go_to_btn_3').onclick = function () {goTo(7, 960)};
      $('six_go_to_btn_4').innerHTML = "$1,200"; $('six_go_to_btn_4').onclick = function () {goTo(7, 1200)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$720e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 720)};
        $('six_dbl_press_btn_2').innerHTML = "$780e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 780)};
        letsShow('six_dble_btn_box_two');
        $('six_dbl_press_btn_3').innerHTML = "$900e 6 &amp; 8"; $('six_dbl_press_btn_3').onclick = function () {doubleUnitPress(7, 900)};
      }
      break;
    case ((amt >= 606) && (amt <= 630)):
    case ((amt >= 642) && (amt <= 690)):
      $('six_go_to_btn_1').innerHTML = "$780"; $('six_go_to_btn_1').onclick = function () {goTo(7, 780)};
      $('six_go_to_btn_2').innerHTML = "$900"; $('six_go_to_btn_2').onclick = function () {goTo(7, 900)};
      $('six_go_to_btn_3').innerHTML = "$960"; $('six_go_to_btn_3').onclick = function () {goTo(7, 960)};
      $('six_go_to_btn_4').innerHTML = "$1,200"; $('six_go_to_btn_4').onclick = function () {goTo(7, 1200)};
      break;
    case (amt == 636):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by $60 or $120. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$780"; $('six_go_to_btn_1').onclick = function () {goTo(7, 780)};
      $('six_go_to_btn_2').innerHTML = "$900"; $('six_go_to_btn_2').onclick = function () {goTo(7, 900)};
      $('six_go_to_btn_3').innerHTML = "$960"; $('six_go_to_btn_3').onclick = function () {goTo(7, 960)};
      $('six_go_to_btn_4').innerHTML = "$1,200"; $('six_go_to_btn_4').onclick = function () {goTo(7, 1200)};
      break;
    case ((amt >= 696) && (amt <= 714)):
    case ((amt >= 732) && (amt <= 744)):
    case ((amt >= 756) && (amt <= 774)):
      $('six_go_to_btn_1').innerHTML = "$780"; $('six_go_to_btn_1').onclick = function () {goTo(7, 780)};
      $('six_go_to_btn_2').innerHTML = "$900"; $('six_go_to_btn_2').onclick = function () {goTo(7, 900)};
      $('six_go_to_btn_3').innerHTML = "$1,200"; $('six_go_to_btn_3').onclick = function () {goTo(7, 1200)};
      $('six_go_to_btn_4').innerHTML = "$1,500"; $('six_go_to_btn_4').onclick = function () {goTo(7, 1500)};
      break;
    case (amt == 720):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons'); lineUp('six_press_btn_2');
      $('six_go_to_btn_1').innerHTML = "$780"; $('six_go_to_btn_1').onclick = function () {goTo(7, 780)};
      $('six_go_to_btn_2').innerHTML = "$900"; $('six_go_to_btn_2').onclick = function () {goTo(7, 900)};
      $('six_go_to_btn_3').innerHTML = "$1,200"; $('six_go_to_btn_3').onclick = function () {goTo(7, 1200)};
      $('six_go_to_btn_4').innerHTML = "$1,500"; $('six_go_to_btn_4').onclick = function () {goTo(7, 1500)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$780e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 780)};
        $('six_dbl_press_btn_2').innerHTML = "$900e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 900)};
      }
      break;
    case (amt == 726):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by $60 or $120. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$780"; $('six_go_to_btn_1').onclick = function () {goTo(7, 780)};
      $('six_go_to_btn_2').innerHTML = "$900"; $('six_go_to_btn_2').onclick = function () {goTo(7, 900)};
      $('six_go_to_btn_3').innerHTML = "$1,200"; $('six_go_to_btn_3').onclick = function () {goTo(7, 1200)};
      $('six_go_to_btn_4').innerHTML = "$1,500"; $('six_go_to_btn_4').onclick = function () {goTo(7, 1500)};
      break;
    case (amt == 750):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons'); lineUp('six_press_btn_2'); lineUp('six_press_btn_3');
      $('six_go_to_btn_1').innerHTML = "$780"; $('six_go_to_btn_1').onclick = function () {goTo(7, 780)};
      $('six_go_to_btn_2').innerHTML = "$900"; $('six_go_to_btn_2').onclick = function () {goTo(7, 900)};
      $('six_go_to_btn_3').innerHTML = "$1,200"; $('six_go_to_btn_3').onclick = function () {goTo(7, 1200)};
      $('six_go_to_btn_4').innerHTML = "$1,500"; $('six_go_to_btn_4').onclick = function () {goTo(7, 1500)};
      break;
    case (amt == 780):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$900"; $('six_go_to_btn_1').onclick = function () {goTo(7, 900)};
      $('six_go_to_btn_2').innerHTML = "$960"; $('six_go_to_btn_2').onclick = function () {goTo(7, 960)};
      $('six_go_to_btn_3').innerHTML = "$1,200"; $('six_go_to_btn_3').onclick = function () {goTo(7, 1200)};
      $('six_go_to_btn_4').innerHTML = "$1,500"; $('six_go_to_btn_4').onclick = function () {goTo(7, 1500)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$900e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 900)};
        $('six_dbl_press_btn_2').innerHTML = "1,200e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 1200)};
      }
      break;
    case ((amt >= 786) && (amt <= 828)):
      $('six_go_to_btn_1').innerHTML = "$900"; $('six_go_to_btn_1').onclick = function () {goTo(7, 900)};
      $('six_go_to_btn_2').innerHTML = "$960"; $('six_go_to_btn_2').onclick = function () {goTo(7, 960)};
      $('six_go_to_btn_3').innerHTML = "$1,200"; $('six_go_to_btn_3').onclick = function () {goTo(7, 1200)};
      $('six_go_to_btn_4').innerHTML = "$1,500"; $('six_go_to_btn_4').onclick = function () {goTo(7, 1500)};
      break;
    case (amt == 834):
    case ((amt >= 846) && (amt <= 888)):
      $('six_go_to_btn_1').innerHTML = "$900"; $('six_go_to_btn_1').onclick = function () {goTo(7, 900)};
      $('six_go_to_btn_2').innerHTML = "$1,200"; $('six_go_to_btn_2').onclick = function () {goTo(7, 1200)};
      $('six_go_to_btn_3').innerHTML = "$1,500"; $('six_go_to_btn_3').onclick = function () {goTo(7, 1500)};
      $('six_go_to_btn_4').innerHTML = "$1,800"; $('six_go_to_btn_4').onclick = function () {goTo(7, 1800)};
      break;
    case (amt == 840):
      $('six_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Full pressers can shoot for the stars. Otherwise, you should be pressing by $120 or $300. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$900"; $('six_go_to_btn_1').onclick = function () {goTo(7, 900)};
      $('six_go_to_btn_2').innerHTML = "$1,200"; $('six_go_to_btn_2').onclick = function () {goTo(7, 1200)};
      $('six_go_to_btn_3').innerHTML = "$1,500"; $('six_go_to_btn_3').onclick = function () {goTo(7, 1500)};
      $('six_go_to_btn_4').innerHTML = "$1,800"; $('six_go_to_btn_4').onclick = function () {goTo(7, 1800)};
      break;
    case (amt == 894):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by $120 or $300. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$900"; $('six_go_to_btn_1').onclick = function () {goTo(7, 900)};
      $('six_go_to_btn_2').innerHTML = "$1,200"; $('six_go_to_btn_2').onclick = function () {goTo(7, 1200)};
      $('six_go_to_btn_3').innerHTML = "$1,500"; $('six_go_to_btn_3').onclick = function () {goTo(7, 1500)};
      $('six_go_to_btn_4').innerHTML = "$1,800"; $('six_go_to_btn_4').onclick = function () {goTo(7, 1800)};
      break;
    case (amt == 900):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons'); lineUp('six_press_btn_3');
      $('six_go_to_btn_1').innerHTML = "$960"; $('six_go_to_btn_1').onclick = function () {goTo(7, 960)};
      $('six_go_to_btn_2').innerHTML = "$1,200"; $('six_go_to_btn_2').onclick = function () {goTo(7, 1200)};
      $('six_go_to_btn_3').innerHTML = "$1,500"; $('six_go_to_btn_3').onclick = function () {goTo(7, 1500)};
      $('six_go_to_btn_4').innerHTML = "$1,800"; $('six_go_to_btn_4').onclick = function () {goTo(7, 1800)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$1,200e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 1200)};
        $('six_dbl_press_btn_2').innerHTML = "+150 to $1,500e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 1500)};
      }
      break;
    case ((amt >= 906) && (amt <= 942)):
    case (amt == 954):
      $('six_go_to_btn_1').innerHTML = "$960"; $('six_go_to_btn_1').onclick = function () {goTo(7, 960)};
      $('six_go_to_btn_2').innerHTML = "$1,200"; $('six_go_to_btn_2').onclick = function () {goTo(7, 1200)};
      $('six_go_to_btn_3').innerHTML = "$1,500"; $('six_go_to_btn_3').onclick = function () {goTo(7, 1500)};
      $('six_go_to_btn_4').innerHTML = "$1,800"; $('six_go_to_btn_4').onclick = function () {goTo(7, 1800)};
      break;
    case (amt == 948):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by $120 or $300. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$960"; $('six_go_to_btn_1').onclick = function () {goTo(7, 960)};
      $('six_go_to_btn_2').innerHTML = "$1,200"; $('six_go_to_btn_2').onclick = function () {goTo(7, 1200)};
      $('six_go_to_btn_3').innerHTML = "$1,500"; $('six_go_to_btn_3').onclick = function () {goTo(7, 1500)};
      $('six_go_to_btn_4').innerHTML = "$1,800"; $('six_go_to_btn_4').onclick = function () {goTo(7, 1800)};
      break;
    case (amt == 960):
      $('six_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      $('six_go_to_btn_1').innerHTML = "$1,200"; $('six_go_to_btn_1').onclick = function () {goTo(7, 1200)};
      $('six_go_to_btn_2').innerHTML = "$1,500"; $('six_go_to_btn_2').onclick = function () {goTo(7, 1500)};
      $('six_go_to_btn_3').innerHTML = "$1,800"; $('six_go_to_btn_3').onclick = function () {goTo(7, 1800)};
      $('six_go_to_btn_4').innerHTML = "+24 to $2,100"; $('six_go_to_btn_4').onclick = function () {goTo(7, 2100)};
      break;
    case (amt == 966):
      $('six_go_to_btn_1').innerHTML = "$1,200"; $('six_go_to_btn_1').onclick = function () {goTo(7, 1200)};
      $('six_go_to_btn_2').innerHTML = "$1,500"; $('six_go_to_btn_2').onclick = function () {goTo(7, 1500)};
      $('six_go_to_btn_3').innerHTML = "$1,800"; $('six_go_to_btn_3').onclick = function () {goTo(7, 1800)};
      $('six_go_to_btn_4').innerHTML = "+12 to $2,100"; $('six_go_to_btn_4').onclick = function () {goTo(7, 2100)};
      break;
    case ((amt >= 972) && (amt <= 1008)):
    case ((amt >= 1020) && (amt <= 1074)):
    case ((amt >= 1086) && (amt <= 1104)):
      $('six_go_to_btn_1').innerHTML = "$1,200"; $('six_go_to_btn_1').onclick = function () {goTo(7, 1200)};
      $('six_go_to_btn_2').innerHTML = "$1,500"; $('six_go_to_btn_2').onclick = function () {goTo(7, 1500)};
      $('six_go_to_btn_3').innerHTML = "$1,800"; $('six_go_to_btn_3').onclick = function () {goTo(7, 1800)};
      $('six_go_to_btn_4').innerHTML = "$2,100"; $('six_go_to_btn_4').onclick = function () {goTo(7, 2100)};
      break;
    case (amt == 1014):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by $120 or $300. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$1,200"; $('six_go_to_btn_1').onclick = function () {goTo(7, 1200)};
      $('six_go_to_btn_2').innerHTML = "$1,500"; $('six_go_to_btn_2').onclick = function () {goTo(7, 1500)};
      $('six_go_to_btn_3').innerHTML = "$1,800"; $('six_go_to_btn_3').onclick = function () {goTo(7, 1800)};
      $('six_go_to_btn_4').innerHTML = "$2,100"; $('six_go_to_btn_4').onclick = function () {goTo(7, 2100)};
      break;
    case (amt == 1080):
      $('six_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      $('six_go_to_btn_1').innerHTML = "$1,200"; $('six_go_to_btn_1').onclick = function () {goTo(7, 1200)};
      $('six_go_to_btn_2').innerHTML = "$1,500"; $('six_go_to_btn_2').onclick = function () {goTo(7, 1500)};
      $('six_go_to_btn_3').innerHTML = "$1,800"; $('six_go_to_btn_3').onclick = function () {goTo(7, 1800)};
      $('six_go_to_btn_4').innerHTML = "$2,100"; $('six_go_to_btn_4').onclick = function () {goTo(7, 2100)};
      break;
    case ((amt >= 1110) && (amt <= 1134)):
    case ((amt >= 1146) && (amt <= 1194)):
    case ((amt >= 1206) && (amt <= 1254)):
    case ((amt >= 1266) && (amt <= 1290)):
      $('six_go_to_btn_1').innerHTML = "$1,500"; $('six_go_to_btn_1').onclick = function () {goTo(7, 1500)};
      $('six_go_to_btn_2').innerHTML = "$1,800"; $('six_go_to_btn_2').onclick = function () {goTo(7, 1800)};
      $('six_go_to_btn_3').innerHTML = "$2,100"; $('six_go_to_btn_3').onclick = function () {goTo(7, 2100)};
      $('six_go_to_btn_4').innerHTML = "$2,400"; $('six_go_to_btn_4').onclick = function () {goTo(7, 2400)};
      break;
    case ((amt == 1140) || (amt == 1260)):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by about $300. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$1,500"; $('six_go_to_btn_1').onclick = function () {goTo(7, 1500)};
      $('six_go_to_btn_2').innerHTML = "$1,800"; $('six_go_to_btn_2').onclick = function () {goTo(7, 1800)};
      $('six_go_to_btn_3').innerHTML = "$2,100"; $('six_go_to_btn_3').onclick = function () {goTo(7, 2100)};
      $('six_go_to_btn_4').innerHTML = "$2,400"; $('six_go_to_btn_4').onclick = function () {goTo(7, 2400)};
      break;
    case (amt == 1200):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons'); lineUp('six_press_btn_3');
      $('six_go_to_btn_1').innerHTML = "$1,500"; $('six_go_to_btn_1').onclick = function () {goTo(7, 1500)};
      $('six_go_to_btn_2').innerHTML = "$1,800"; $('six_go_to_btn_2').onclick = function () {goTo(7, 1800)};
      $('six_go_to_btn_3').innerHTML = "$2,100"; $('six_go_to_btn_3').onclick = function () {goTo(7, 2100)};
      $('six_go_to_btn_4').innerHTML = "$2,400"; $('six_go_to_btn_4').onclick = function () {goTo(7, 2400)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$1,500e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 1500)};
        $('six_dbl_press_btn_2').innerHTML = "$1,800e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 1800)};
      }
      break;
    case ((amt >= 1296) && (amt <= 1368)):
    case (amt == 1380):
      $('six_go_to_btn_1').innerHTML = "$1,500"; $('six_go_to_btn_1').onclick = function () {goTo(7, 1500)};
      $('six_go_to_btn_2').innerHTML = "$1,800"; $('six_go_to_btn_2').onclick = function () {goTo(7, 1800)};
      $('six_go_to_btn_3').innerHTML = "$2,100"; $('six_go_to_btn_3').onclick = function () {goTo(7, 2100)};
      $('six_go_to_btn_4').innerHTML = "$2,400"; $('six_go_to_btn_4').onclick = function () {goTo(7, 2400)};
      break;
    case (amt == 1374):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by about $300. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$1,500"; $('six_go_to_btn_1').onclick = function () {goTo(7, 1500)};
      $('six_go_to_btn_2').innerHTML = "$1,800"; $('six_go_to_btn_2').onclick = function () {goTo(7, 1800)};
      $('six_go_to_btn_3').innerHTML = "$2,100"; $('six_go_to_btn_3').onclick = function () {goTo(7, 2100)};
      $('six_go_to_btn_4').innerHTML = "$2,400"; $('six_go_to_btn_4').onclick = function () {goTo(7, 2400)};
      break;
    case ((amt >= 1386) && (amt <= 1494)):
    case ((amt >= 1506) && (amt <= 1566)):
    case ((amt >= 1578) && (amt <= 1656)):
      $('six_go_to_btn_1').innerHTML = "$1,800"; $('six_go_to_btn_1').onclick = function () {goTo(7, 1800)};
      $('six_go_to_btn_2').innerHTML = "$2,100"; $('six_go_to_btn_2').onclick = function () {goTo(7, 2100)};
      $('six_go_to_btn_3').innerHTML = "$2,400"; $('six_go_to_btn_3').onclick = function () {goTo(7, 2400)};
      $('six_go_to_btn_4').innerHTML = "$3,000"; $('six_go_to_btn_4').onclick = function () {goTo(7, 3000)};
      break;
    case (amt == 1500):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons'); lineUp('six_press_btn_3');
      $('six_go_to_btn_1').innerHTML = "$1,800"; $('six_go_to_btn_1').onclick = function () {goTo(7, 1800)};
      $('six_go_to_btn_2').innerHTML = "$2,100"; $('six_go_to_btn_2').onclick = function () {goTo(7, 2100)};
      $('six_go_to_btn_3').innerHTML = "$2,400"; $('six_go_to_btn_3').onclick = function () {goTo(7, 2400)};
      $('six_go_to_btn_4').innerHTML = "$3,000"; $('six_go_to_btn_4').onclick = function () {goTo(7, 3000)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$1,800e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 1800)};
        $('six_dbl_press_btn_2').innerHTML = "$2,100e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 2100)};
        letsShow('six_dble_btn_box_two');
        $('six_dbl_press_btn_3').innerHTML = "+50 to $2,400e 6 &amp; 8"; $('six_dbl_press_btn_3').onclick = function () {doubleUnitPress(7, 2400)};
      }
      break;
    case (amt == 1572):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by about $300. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$1,800"; $('six_go_to_btn_1').onclick = function () {goTo(7, 1800)};
      $('six_go_to_btn_2').innerHTML = "$2,100"; $('six_go_to_btn_2').onclick = function () {goTo(7, 2100)};
      $('six_go_to_btn_3').innerHTML = "$2,400"; $('six_go_to_btn_3').onclick = function () {goTo(7, 2400)};
      $('six_go_to_btn_4').innerHTML = "$3,000"; $('six_go_to_btn_4').onclick = function () {goTo(7, 3000)};
      break;
    case ((amt >= 1662) && (amt <= 1680)):
    case ((amt >= 1692) && (amt <= 1794)):
    case ((amt >= 1806) && (amt <= 1812)):
    case ((amt >= 1824) && (amt <= 1926)):
    case (amt == 1938):
      $('six_go_to_btn_1').innerHTML = "$2,100"; $('six_go_to_btn_1').onclick = function () {goTo(7, 2100)};
      $('six_go_to_btn_2').innerHTML = "$2,400"; $('six_go_to_btn_2').onclick = function () {goTo(7, 2400)};
      $('six_go_to_btn_3').innerHTML = "$3,000"; $('six_go_to_btn_3').onclick = function () {goTo(7, 3000)};
      $('six_go_to_btn_4').innerHTML = "$3,600"; $('six_go_to_btn_4').onclick = function () {goTo(7, 3600)};
      break;
    case ((amt == 1686) || (amt == 1818) || (amt == 1932)):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by about $300. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$2,100"; $('six_go_to_btn_1').onclick = function () {goTo(7, 2100)};
      $('six_go_to_btn_2').innerHTML = "$2,400"; $('six_go_to_btn_2').onclick = function () {goTo(7, 2400)};
      $('six_go_to_btn_3').innerHTML = "$3,000"; $('six_go_to_btn_3').onclick = function () {goTo(7, 3000)};
      $('six_go_to_btn_4').innerHTML = "$3,600"; $('six_go_to_btn_4').onclick = function () {goTo(7, 3600)};
      break;
    case (amt == 1800):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons'); lineUp('six_press_btn_3');
      $('six_go_to_btn_1').innerHTML = "$2,100"; $('six_go_to_btn_1').onclick = function () {goTo(7, 2100)};
      $('six_go_to_btn_2').innerHTML = "$2,400"; $('six_go_to_btn_2').onclick = function () {goTo(7, 2400)};
      $('six_go_to_btn_3').innerHTML = "$3,000"; $('six_go_to_btn_3').onclick = function () {goTo(7, 3000)};
      $('six_go_to_btn_4').innerHTML = "$3,600"; $('six_go_to_btn_4').onclick = function () {goTo(7, 3600)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$2,100e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 2100)};
        $('six_dbl_press_btn_2').innerHTML = "$2,400e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 2400)};
        letsShow('six_dble_btn_box_two');
        $('six_dbl_press_btn_3').innerHTML = "+50 to $2,400e 6 &amp; 8"; $('six_dbl_press_btn_3').onclick = function () {doubleUnitPress(7, 2400)};
      }
      break;
    case ((amt >= 1944) && (amt <= 2046)):
    case ((amt >= 2058) && (amt <= 2076)):
      $('six_go_to_btn_1').innerHTML = "$2,400"; $('six_go_to_btn_1').onclick = function () {goTo(7, 2400)};
      $('six_go_to_btn_2').innerHTML = "$3,000"; $('six_go_to_btn_2').onclick = function () {goTo(7, 3000)};
      $('six_go_to_btn_3').innerHTML = "$3,600"; $('six_go_to_btn_3').onclick = function () {goTo(7, 3600)};
      $('six_go_to_btn_4').innerHTML = "$4,200"; $('six_go_to_btn_4').onclick = function () {goTo(7, 4200)};
      break;
    case (amt == 2052):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by $300 or $600. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$2,400"; $('six_go_to_btn_1').onclick = function () {goTo(7, 2400)};
      $('six_go_to_btn_2').innerHTML = "$3,000"; $('six_go_to_btn_2').onclick = function () {goTo(7, 3000)};
      $('six_go_to_btn_3').innerHTML = "$3,600"; $('six_go_to_btn_3').onclick = function () {goTo(7, 3600)};
      $('six_go_to_btn_4').innerHTML = "$4,200"; $('six_go_to_btn_4').onclick = function () {goTo(7, 4200)};
      break;
    case ((amt >= 2082) && (amt <= 2094)):
    case ((amt >= 2106) && (amt <= 2190)):
    case ((amt >= 2202) && (amt <= 2214)):
      $('six_go_to_btn_1').innerHTML = "$3,000"; $('six_go_to_btn_1').onclick = function () {goTo(7, 3000)};
      $('six_go_to_btn_2').innerHTML = "$3,600"; $('six_go_to_btn_2').onclick = function () {goTo(7, 3600)};
      $('six_go_to_btn_3').innerHTML = "$4,200"; $('six_go_to_btn_3').onclick = function () {goTo(7, 4200)};
      $('six_go_to_btn_4').innerHTML = "$4,500"; $('six_go_to_btn_4').onclick = function () {goTo(7, 4500)};
      break;
    case (amt == 2100):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons'); lineUp('six_press_btn_3');
      $('six_go_to_btn_1').innerHTML = "$3,000"; $('six_go_to_btn_1').onclick = function () {goTo(7, 3000)};
      $('six_go_to_btn_2').innerHTML = "$3,600"; $('six_go_to_btn_2').onclick = function () {goTo(7, 3600)};
      $('six_go_to_btn_3').innerHTML = "$4,200"; $('six_go_to_btn_3').onclick = function () {goTo(7, 4200)};
      $('six_go_to_btn_4').innerHTML = "$4,500"; $('six_go_to_btn_4').onclick = function () {goTo(7, 4500)};
      if(equalUnits) {
        letsShow('place_six_dble_box'); letsUnmask('six_dbl_press_btn_2');
        $('six_dbl_press_btn_1').innerHTML = "$2,400e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 2400)};
        $('six_dbl_press_btn_2').innerHTML = "$3,000e 6 &amp; 8"; $('six_dbl_press_btn_2').onclick = function () {doubleUnitPress(7, 3000)};
      }
      break;
    case (amt == 2196):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by $300 or $600. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$3,000"; $('six_go_to_btn_1').onclick = function () {goTo(7, 3000)};
      $('six_go_to_btn_2').innerHTML = "$3,600"; $('six_go_to_btn_2').onclick = function () {goTo(7, 3600)};
      $('six_go_to_btn_3').innerHTML = "$4,200"; $('six_go_to_btn_3').onclick = function () {goTo(7, 4200)};
      $('six_go_to_btn_4').innerHTML = "$4,500"; $('six_go_to_btn_4').onclick = function () {goTo(7, 4500)};
      break;
    case ((amt >= 2220) && (amt <= 2394)):
    case ((amt >= 2406) && (amt <= 2460)):
    case ((amt >= 2472) && (amt <= 2490)):
      $('six_go_to_btn_1').innerHTML = "$3,000"; $('six_go_to_btn_1').onclick = function () {goTo(7, 3000)};
      $('six_go_to_btn_2').innerHTML = "$3,600"; $('six_go_to_btn_2').onclick = function () {goTo(7, 3600)};
      $('six_go_to_btn_3').innerHTML = "$4,200"; $('six_go_to_btn_3').onclick = function () {goTo(7, 4200)};
      $('six_go_to_btn_4').innerHTML = "$4,800"; $('six_go_to_btn_4').onclick = function () {goTo(7, 4800)};
      break;
    case (amt == 2400):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons'); lineUp('six_press_btn_3');
      $('six_go_to_btn_1').innerHTML = "$3,000"; $('six_go_to_btn_1').onclick = function () {goTo(7, 3000)};
      $('six_go_to_btn_2').innerHTML = "$3,600"; $('six_go_to_btn_2').onclick = function () {goTo(7, 3600)};
      $('six_go_to_btn_3').innerHTML = "$4,200"; $('six_go_to_btn_3').onclick = function () {goTo(7, 4200)};
      $('six_go_to_btn_4').innerHTML = "$4,800"; $('six_go_to_btn_4').onclick = function () {goTo(7, 4800)};
      if(equalUnits) {
        letsShow('place_six_dble_box');
        $('six_dbl_press_btn_1').innerHTML = "$3,000e 6 &amp; 8"; $('six_dbl_press_btn_1').onclick = function () {doubleUnitPress(7, 3000)};
      }
      break;
    case (amt == 2466):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by $300 or $600. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$3,000"; $('six_go_to_btn_1').onclick = function () {goTo(7, 3000)};
      $('six_go_to_btn_2').innerHTML = "$3,600"; $('six_go_to_btn_2').onclick = function () {goTo(7, 3600)};
      $('six_go_to_btn_3').innerHTML = "$4,200"; $('six_go_to_btn_3').onclick = function () {goTo(7, 4200)};
      $('six_go_to_btn_4').innerHTML = "$4,800"; $('six_go_to_btn_4').onclick = function () {goTo(7, 4800)};
      break;
    case ((amt >= 2496) && (amt <= 2724)):
    case ((amt >= 2736) && (amt <= 2766)):
      $('six_go_to_btn_1').innerHTML = "$3,000"; $('six_go_to_btn_1').onclick = function () {goTo(7, 3000)};
      $('six_go_to_btn_2').innerHTML = "$3,600"; $('six_go_to_btn_2').onclick = function () {goTo(7, 3600)};
      $('six_go_to_btn_3').innerHTML = "$4,800"; $('six_go_to_btn_3').onclick = function () {goTo(7, 4800)};
      $('six_go_to_btn_4').innerHTML = "$5,400"; $('six_go_to_btn_4').onclick = function () {goTo(7, 5400)};
      break;
    case (amt == 2730):
      $('six_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " six is if you are full pressing from a lower amount. If not, you should be pressing by $300 or $600. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('six_press_buttons'); lineUp('six_press_btn_4');
      $('six_go_to_btn_1').innerHTML = "$3,000"; $('six_go_to_btn_1').onclick = function () {goTo(7, 3000)};
      $('six_go_to_btn_2').innerHTML = "$3,600"; $('six_go_to_btn_2').onclick = function () {goTo(7, 3600)};
      $('six_go_to_btn_3').innerHTML = "$4,800"; $('six_go_to_btn_3').onclick = function () {goTo(7, 4800)};
      $('six_go_to_btn_4').innerHTML = "$5,400"; $('six_go_to_btn_4').onclick = function () {goTo(7, 5400)};
      break;
    case ((amt >= 2772) && (amt <= 2970)):
    case ((amt >= 2982) && (amt <= 2994)):
      $('six_go_to_btn_1').innerHTML = "$3,000"; $('six_go_to_btn_1').onclick = function () {goTo(7, 3000)};
      $('six_go_to_btn_2').innerHTML = "$3,600"; $('six_go_to_btn_2').onclick = function () {goTo(7, 3600)};
      $('six_go_to_btn_3').innerHTML = "$4,800"; $('six_go_to_btn_3').onclick = function () {goTo(7, 4800)};
      $('six_go_to_btn_4').innerHTML = "$5,400"; $('six_go_to_btn_4').onclick = function () {goTo(7, 5400)};
      letsShow('six_tbl_max_btn');
      break;
    case (amt == 2976):
      $('six_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      $('six_go_to_btn_1').innerHTML = "$3,000"; $('six_go_to_btn_1').onclick = function () {goTo(7, 3000)};
      $('six_go_to_btn_2').innerHTML = "$3,600"; $('six_go_to_btn_2').onclick = function () {goTo(7, 3600)};
      $('six_go_to_btn_3').innerHTML = "$4,800"; $('six_go_to_btn_3').onclick = function () {goTo(7, 4800)};
      $('six_go_to_btn_4').innerHTML = "$5,400"; $('six_go_to_btn_4').onclick = function () {goTo(7, 5400)};
      letsShow('six_tbl_max_btn');
      break;
    case (amt == 3000):
      letsHide('six_pay_disclaimer');
      letsShow('six_press_buttons'); lineUp('six_press_btn_3');
      $('six_go_to_btn_1').innerHTML = "$3,600"; $('six_go_to_btn_1').onclick = function () {goTo(7, 3600)};
      $('six_go_to_btn_2').innerHTML = "$4,200"; $('six_go_to_btn_2').onclick = function () {goTo(7, 4200)};
      $('six_go_to_btn_3').innerHTML = "$4,800"; $('six_go_to_btn_3').onclick = function () {goTo(7, 4800)};
      $('six_go_to_btn_4').innerHTML = "$5,400"; $('six_go_to_btn_4').onclick = function () {goTo(7, 5400)};
      letsShow('six_tbl_max_btn');
      break;
    case ((amt >= 3006) && (amt <= 3396)):
    case ((amt >= 3408) && (amt <= 3594)):
      $('six_go_to_btn_1').innerHTML = "$3,600"; $('six_go_to_btn_1').onclick = function () {goTo(7, 3600)};
      $('six_go_to_btn_2').innerHTML = "$4,200"; $('six_go_to_btn_2').onclick = function () {goTo(7, 4200)};
      $('six_go_to_btn_3').innerHTML = "$4,800"; $('six_go_to_btn_3').onclick = function () {goTo(7, 4800)};
      $('six_go_to_btn_4').innerHTML = "$5,400"; $('six_go_to_btn_4').onclick = function () {goTo(7, 5400)};
      letsShow('six_tbl_max_btn');
      break;
    case (amt == 3402):
      $('six_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      $('six_go_to_btn_1').innerHTML = "$3,600"; $('six_go_to_btn_1').onclick = function () {goTo(7, 3600)};
      $('six_go_to_btn_2').innerHTML = "$4,200"; $('six_go_to_btn_2').onclick = function () {goTo(7, 4200)};
      $('six_go_to_btn_3').innerHTML = "$4,800"; $('six_go_to_btn_3').onclick = function () {goTo(7, 4800)};
      $('six_go_to_btn_4').innerHTML = "$5,400"; $('six_go_to_btn_4').onclick = function () {goTo(7, 5400)};
      letsShow('six_tbl_max_btn');
      break;
    case (amt == 3600):
      letsHide('six_pay_disclaimer');
      $('six_go_to_btn_1').innerHTML = "$4,200"; $('six_go_to_btn_1').onclick = function () {goTo(7, 4200)};
      $('six_go_to_btn_2').innerHTML = "$4,500"; $('six_go_to_btn_2').onclick = function () {goTo(7, 4500)};
      $('six_go_to_btn_3').innerHTML = "$4,800"; $('six_go_to_btn_3').onclick = function () {goTo(7, 4800)};
      $('six_go_to_btn_4').innerHTML = "$5,400"; $('six_go_to_btn_4').onclick = function () {goTo(7, 5400)};
      letsShow('six_tbl_max_btn');
      break;
    case ((amt >= 3606) && (amt <= 3642)):
    case ((amt >= 3654) && (amt <= 3930)):
    case ((amt >= 3942) && (amt <= 4176)):
    case ((amt >= 4188) && (amt <= 4194)):
      $('six_go_to_btn_1').innerHTML = "$4,200"; $('six_go_to_btn_1').onclick = function () {goTo(7, 4200)};
      $('six_go_to_btn_2').innerHTML = "$4,500"; $('six_go_to_btn_2').onclick = function () {goTo(7, 4500)};
      $('six_go_to_btn_3').innerHTML = "$4,800"; $('six_go_to_btn_3').onclick = function () {goTo(7, 4800)};
      $('six_go_to_btn_4').innerHTML = "$5,400"; $('six_go_to_btn_4').onclick = function () {goTo(7, 5400)};
      letsShow('six_tbl_max_btn');
      break;
    case ((amt == 3648) || (amt == 3936) || (amt == 4182)):
      $('six_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      $('six_go_to_btn_1').innerHTML = "$4,200"; $('six_go_to_btn_1').onclick = function () {goTo(7, 4200)};
      $('six_go_to_btn_2').innerHTML = "$4,500"; $('six_go_to_btn_2').onclick = function () {goTo(7, 4500)};
      $('six_go_to_btn_3').innerHTML = "$4,800"; $('six_go_to_btn_3').onclick = function () {goTo(7, 4800)};
      $('six_go_to_btn_4').innerHTML = "$5,400"; $('six_go_to_btn_4').onclick = function () {goTo(7, 5400)};
      letsShow('six_tbl_max_btn');
      break;
    case (amt == 4200):
      letsHide('six_pay_disclaimer');
      $('six_go_to_btn_1').innerHTML = "$4,500"; $('six_go_to_btn_1').onclick = function () {goTo(7, 4500)};
      $('six_go_to_btn_2').innerHTML = "$4,800"; $('six_go_to_btn_2').onclick = function () {goTo(7, 4800)};
      $('six_go_to_btn_3').innerHTML = "$5,100"; $('six_go_to_btn_3').onclick = function () {goTo(7, 5100)};
      $('six_go_to_btn_4').innerHTML = "$5,400"; $('six_go_to_btn_4').onclick = function () {goTo(7, 5400)};
      letsShow('six_tbl_max_btn');
      break;
    case ((amt >= 4206) && (amt <= 4440)):
    case ((amt >= 4452) && (amt <= 4494)):
      $('six_go_to_btn_1').innerHTML = "$4,500"; $('six_go_to_btn_1').onclick = function () {goTo(7, 4500)};
      $('six_go_to_btn_2').innerHTML = "$4,800"; $('six_go_to_btn_2').onclick = function () {goTo(7, 4800)};
      $('six_go_to_btn_3').innerHTML = "$5,100"; $('six_go_to_btn_3').onclick = function () {goTo(7, 5100)};
      $('six_go_to_btn_4').innerHTML = "$5,400"; $('six_go_to_btn_4').onclick = function () {goTo(7, 5400)};
      letsShow('six_tbl_max_btn');
      break;
    case (amt == 4446):
      $('six_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      $('six_go_to_btn_1').innerHTML = "$4,500"; $('six_go_to_btn_1').onclick = function () {goTo(7, 4500)};
      $('six_go_to_btn_2').innerHTML = "$4,800"; $('six_go_to_btn_2').onclick = function () {goTo(7, 4800)};
      $('six_go_to_btn_3').innerHTML = "$5,100"; $('six_go_to_btn_3').onclick = function () {goTo(7, 5100)};
      $('six_go_to_btn_4').innerHTML = "$5,400"; $('six_go_to_btn_4').onclick = function () {goTo(7, 5400)};
      letsShow('six_tbl_max_btn');
      break;
    case (amt == 4500):
      letsHide('six_pay_disclaimer');
      $('six_go_to_btn_1').innerHTML = "$4,800"; $('six_go_to_btn_1').onclick = function () {goTo(7, 4800)};
      $('six_go_to_btn_2').innerHTML = "$5,100"; $('six_go_to_btn_2').onclick = function () {goTo(7, 5100)};
      $('six_go_to_btn_3').innerHTML = "$5,400"; $('six_go_to_btn_3').onclick = function () {goTo(7, 5400)};
      $('six_go_to_btn_4').innerHTML = "$5,700"; $('six_go_to_btn_4').onclick = function () {goTo(7, 5700)};
      letsShow('six_tbl_max_btn');
      break;
    case ((amt >= 4506) && (amt <= 4752)):
    case ((amt >= 4764) && (amt <= 4794)):
      $('six_go_to_btn_1').innerHTML = "$4,800"; $('six_go_to_btn_1').onclick = function () {goTo(7, 4800)};
      $('six_go_to_btn_2').innerHTML = "$5,100"; $('six_go_to_btn_2').onclick = function () {goTo(7, 5100)};
      $('six_go_to_btn_3').innerHTML = "$5,400"; $('six_go_to_btn_3').onclick = function () {goTo(7, 5400)};
      $('six_go_to_btn_4').innerHTML = "$5,700"; $('six_go_to_btn_4').onclick = function () {goTo(7, 5700)};
      letsShow('six_tbl_max_btn');
      break;
    case (amt == 4758):
      $('six_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      $('six_go_to_btn_1').innerHTML = "$4,800"; $('six_go_to_btn_1').onclick = function () {goTo(7, 4800)};
      $('six_go_to_btn_2').innerHTML = "$5,100"; $('six_go_to_btn_2').onclick = function () {goTo(7, 5100)};
      $('six_go_to_btn_3').innerHTML = "$5,400"; $('six_go_to_btn_3').onclick = function () {goTo(7, 5400)};
      $('six_go_to_btn_4').innerHTML = "$5,700"; $('six_go_to_btn_4').onclick = function () {goTo(7, 5700)};
      letsShow('six_tbl_max_btn');
      break;
    case (amt == 4800):
      letsHide('six_pay_disclaimer');
      letsHide('six_go_to_btn_3'); letsHide('six_go_to_btn_4');
      $('six_go_to_btn_1').innerHTML = "$5,400"; $('six_go_to_btn_1').onclick = function () {goTo(7, 5400)};
      $('six_go_to_btn_2').innerHTML = "$5,700"; $('six_go_to_btn_2').onclick = function () {goTo(7, 5700)};
      letsShow('six_tbl_max_btn');
      break;
    case ((amt >= 4806) && (amt <= 5334)):
    case ((amt >= 5346) && (amt <= 5394)):
      letsHide('six_go_to_btn_3'); letsHide('six_go_to_btn_4');
      $('six_go_to_btn_1').innerHTML = "$5,400"; $('six_go_to_btn_1').onclick = function () {goTo(7, 5400)};
      $('six_go_to_btn_2').innerHTML = "$5,700"; $('six_go_to_btn_2').onclick = function () {goTo(7, 5700)};
      letsShow('six_tbl_max_btn');
      break;
    case (amt == 5340):
      $('six_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      letsHide('six_go_to_btn_3'); letsHide('six_go_to_btn_4');
      $('six_go_to_btn_1').innerHTML = "$5,400"; $('six_go_to_btn_1').onclick = function () {goTo(7, 5400)};
      $('six_go_to_btn_2').innerHTML = "$5,700"; $('six_go_to_btn_2').onclick = function () {goTo(7, 5700)};
      letsShow('six_tbl_max_btn');
      break;
    case (amt == 5400):
      letsHide('six_pay_disclaimer');
      letsHide('six_go_to_btn_2'); letsHide('six_go_to_btn_3'); letsHide('six_go_to_btn_4');
      $('six_go_to_btn_1').innerHTML = "$5,700"; $('six_go_to_btn_1').onclick = function () {goTo(7, 5700)};
      letsShow('six_tbl_max_btn');
      break;
    case ((amt >= 5406) && (amt <= 5904)):
    case ((amt >= 5916) && (amt <= 5994)):
      letsHide('six_go_to_buttons');
      letsShow('six_tbl_max_btn');
      break;
    case (amt == 5910):
      $('six_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      letsHide('six_go_to_buttons');
      letsShow('six_tbl_max_btn');
      break;
    case (amt == 6000):
      $('six_pay_disclaimer').innerHTML = "You hit at table max!! If you want to put even more on the table you can start making Come bets and double dip your way up to max Come bet and max Odds! Another... $30,000 ($5K with $25K odds ) to win 35K plus your 7K here is a 42K potential max win on the 6. That's when we get Come Bets which are coming soon.";
      letsHide('six_go_to_buttons');
      break;
    default: return
  }
}
function showPlaceEightBtns (amt) {
  letsShow('eight_pay_disclaimer');
  $('eight_pay_disclaimer').innerHTML = "Try and stick to bets in normal increments. Use the 'Go to ' menu for normal betting amounts.";
  letsHide('eight_press_buttons');
  letsHide('eight_press_btn_1'); letsHide('eight_press_btn_2'); letsHide('eight_press_btn_3'); letsHide('eight_press_btn_4');
  lineUp('eight_go_to_btn_3'); lineUp('eight_go_to_btn_4');
  letsHide('eight_tbl_max_btn');
  letsHide('place_eight_dble_box');
  letsMask('eight_dbl_press_btn_2');
  letsHide('eight_dble_btn_box_two');
  letsMask('eight_dbl_press_btn_4');
  var equalUnits = theSix.placeBet == theEight.placeBet;
  switch (true) {
    case (amt == 6):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_1'); lineUp('eight_press_btn_3'); lineUp('eight_press_btn_4');
      letsHide('eight_go_to_btn_3'); letsHide('eight_go_to_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$12"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 12)};
      $('eight_go_to_btn_2').innerHTML = "+5 to $18"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 18)};
      if(equalUnits) {
        letsShow('place_eight_dble_box');
        $('eight_dbl_press_btn_1').innerHTML = "+5 to $12e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 12)};
      }
      break;
    case (amt == 12):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_1'); lineUp('eight_press_btn_3'); lineUp('eight_press_btn_4');
      letsHide('eight_go_to_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$18"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 18)};
      $('eight_go_to_btn_2').innerHTML = "$24"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 24)};
      $('eight_go_to_btn_3').innerHTML = "+4 to $30"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 30)};
      if(equalUnits) {
        letsShow('place_eight_dble_box');
        $('eight_dbl_press_btn_1').innerHTML = "$18e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 18)};
      }
      break;
    case (amt == 18): 
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_1'); lineUp('eight_press_btn_3'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$24"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 24)};
      $('eight_go_to_btn_2').innerHTML = "$30"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 30)};
      $('eight_go_to_btn_3').innerHTML = "$36"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 36)};
      $('eight_go_to_btn_4').innerHTML = "+4 to $42"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 42)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$24e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 24)};
        $('eight_dbl_press_btn_2').innerHTML = "+3 to $30e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 30)};
      }
      break;
    case (amt == 24):
      letsHide('eight_pay_disclaimer'); 
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_1'); lineUp('eight_press_btn_3'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$36"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 36)};
      $('eight_go_to_btn_2').innerHTML = "$42"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 42)};
      $('eight_go_to_btn_3').innerHTML = "$48"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 48)};
      $('eight_go_to_btn_4').innerHTML = "+2 to $54"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 54)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$30e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 30)};
        $('eight_dbl_press_btn_2').innerHTML = "$36e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 36)};
      }
      break;
    case (amt == 30):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_1'); lineUp('eight_press_btn_2'); lineUp('eight_press_btn_3'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$42"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 42)};
      $('eight_go_to_btn_2').innerHTML = "$48"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 48)};
      $('eight_go_to_btn_3').innerHTML = "$54"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 54)};
      $('eight_go_to_btn_4').innerHTML = "+1 to $66"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 66)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$36e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 36)};
        $('eight_dbl_press_btn_2').innerHTML = "$42e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 42)};
        letsShow('eight_dble_btn_box_two');
        $('eight_dbl_press_btn_3').innerHTML = "+1 to $48e 6 &amp; 8"; $('eight_dbl_press_btn_3').onclick = function () {doubleUnitPress(8, 48)};
      }
      break;
    case (amt == 36):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_1'); lineUp('eight_press_btn_3'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$48"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 48)};
      $('eight_go_to_btn_2').innerHTML = "$54"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 54)};
      $('eight_go_to_btn_3').innerHTML = "$60"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 60)};
      $('eight_go_to_btn_4').innerHTML = "$66"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 66)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$42e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 42)};
        $('eight_dbl_press_btn_2').innerHTML = "$48e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 48)};
        letsShow('eight_dble_btn_box_two');
        $('eight_dbl_press_btn_3').innerHTML = "+6 to $60e 6 &amp; 8"; $('eight_dbl_press_btn_3').onclick = function () {doubleUnitPress(8, 60)};
      }
      break;
    case (amt == 42):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_1'); lineUp('eight_press_btn_3'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$54"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 54)};
      $('eight_go_to_btn_2').innerHTML = "$60"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 60)};
      $('eight_go_to_btn_3').innerHTML = "$72"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 72)};
      $('eight_go_to_btn_4').innerHTML = "$78"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 78)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$48e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 48)};
        $('eight_dbl_press_btn_2').innerHTML = "$54e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 54)};
        letsShow('eight_dble_btn_box_two');
        $('eight_dbl_press_btn_3').innerHTML = "$60e 6 &amp; 8"; $('eight_dbl_press_btn_3').onclick = function () {doubleUnitPress(8, 60)};
      }
      break;
    case (amt == 48):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_1'); lineUp('eight_press_btn_3'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$60"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 60)};
      $('eight_go_to_btn_2').innerHTML = "$72"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 72)};
      $('eight_go_to_btn_3').innerHTML = "$90"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 90)};
      $('eight_go_to_btn_4').innerHTML = "$102"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 102)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$54e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 54)};
        $('eight_dbl_press_btn_2').innerHTML = "$60e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 60)};
        letsShow('eight_dble_btn_box_two'); letsUnmask('eight_dbl_press_btn_4');
        $('eight_dbl_press_btn_3').innerHTML = "$72e 6 &amp; 8"; $('eight_dbl_press_btn_3').onclick = function () {doubleUnitPress(8, 72)};
        $('eight_dbl_press_btn_4').innerHTML = " +4 to $78e 6 &amp; 8"; $('eight_dbl_press_btn_3').onclick = function () {doubleUnitPress(8, 78)};
      }
      break;
    case (amt == 54):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_1'); lineUp('eight_press_btn_3'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$60"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 60)};
      $('eight_go_to_btn_2').innerHTML = "$72"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 72)};
      $('eight_go_to_btn_3').innerHTML = "$90"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 90)};
      $('eight_go_to_btn_4').innerHTML = "+3 to $120"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 120)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$60e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 60)};
        $('eight_dbl_press_btn_2').innerHTML = "$72e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 72)};
        letsShow('eight_dble_btn_box_two');
        $('eight_dbl_press_btn_3').innerHTML = "$78e 6 &amp; 8"; $('eight_dbl_press_btn_3').onclick = function () {doubleUnitPress(8, 78)};
      }
      break;
    case (amt == 60):
      letsHide('eight_pay_disclaimer'); 
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_1'); lineUp('eight_press_btn_2'); lineUp('eight_press_btn_3'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$72"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 72)};
      $('eight_go_to_btn_2').innerHTML = "$78"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 78)};
      $('eight_go_to_btn_3').innerHTML = "$90"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 90)};
      $('eight_go_to_btn_4').innerHTML = "$120"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 120)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$72e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 72)};
        $('eight_dbl_press_btn_2').innerHTML = "$78e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 78)};
        letsShow('eight_dble_btn_box_two');
        $('eight_dbl_press_btn_3').innerHTML = "$90e 6 &amp; 8"; $('eight_dbl_press_btn_3').onclick = function () {doubleUnitPress(8, 90)};
      }
      break;
    case (amt == 66):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_1'); lineUp('eight_press_btn_3'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$78"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 78)};
      $('eight_go_to_btn_2').innerHTML = "$90"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 90)};
      $('eight_go_to_btn_3').innerHTML = "$120"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 120)};
      $('eight_go_to_btn_4').innerHTML = "+7 to $150"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 150)};
      break;
    case (amt == 72):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_1'); lineUp('eight_press_btn_3'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$90"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 90)};
      $('eight_go_to_btn_2').innerHTML = "$102"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 102)};
      $('eight_go_to_btn_3').innerHTML = "$120"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 120)};
      $('eight_go_to_btn_4').innerHTML = "$150"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 150)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$78e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 78)};
        $('eight_dbl_press_btn_2').innerHTML = "$90e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 90)};
      }
      break;
    case (amt == 78):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_1'); lineUp('eight_press_btn_3'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$90"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 90)};
      $('eight_go_to_btn_2').innerHTML = "$102"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 102)};
      $('eight_go_to_btn_3').innerHTML = "$120"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 120)};
      $('eight_go_to_btn_4').innerHTML = "$150"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 150)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$90e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 90)};
        $('eight_dbl_press_btn_2').innerHTML = "$120e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 120)};
      }
      break;
    case (amt == 84):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_1'); lineUp('eight_press_btn_3'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$90"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 90)};
      $('eight_go_to_btn_2').innerHTML = "$102"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 102)};
      $('eight_go_to_btn_3').innerHTML = "$120"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 120)};
      $('eight_go_to_btn_4').innerHTML = "$150"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 150)};
      break;
    case (amt == 90):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_1'); lineUp('eight_press_btn_2'); lineUp('eight_press_btn_3'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$102"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 102)};
      $('eight_go_to_btn_2').innerHTML = "$120"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 120)};
      $('eight_go_to_btn_3').innerHTML = "$150"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 150)};
      $('eight_go_to_btn_4').innerHTML = "$180"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 180)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$120e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 120)};
        $('eight_dbl_press_btn_2').innerHTML = "+15 to $150e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 150)};
      }
      break;
    case (amt == 96):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_1'); lineUp('eight_press_btn_3'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$120"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 120)};
      $('eight_go_to_btn_2').innerHTML = "$150"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 150)};
      $('eight_go_to_btn_3').innerHTML = "$180"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 180)};
      $('eight_go_to_btn_4').innerHTML = "+2 to $210"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 210)};
      break;
    case (amt == 102):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$120"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 120)};
      $('eight_go_to_btn_2').innerHTML = "$150"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 150)};
      $('eight_go_to_btn_3').innerHTML = "$180"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 180)};
      $('eight_go_to_btn_4').innerHTML = "$210"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 210)};
      break;
    case (amt == 108):
      $('eight_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      $('eight_go_to_btn_1').innerHTML = "$120"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 120)};
      $('eight_go_to_btn_2').innerHTML = "$150"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 150)};
      $('eight_go_to_btn_3').innerHTML = "$180"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 180)};
      $('eight_go_to_btn_4').innerHTML = "$210"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 210)};
      break;
    case (amt == 114):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$120"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 120)};
      $('eight_go_to_btn_2').innerHTML = "$150"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 150)};
      $('eight_go_to_btn_3').innerHTML = "$180"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 180)};
      $('eight_go_to_btn_4').innerHTML = "$240"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 240)};
      break;
    case (amt == 120):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_1'); lineUp('eight_press_btn_2'); lineUp('eight_press_btn_3');
      $('eight_go_to_btn_1').innerHTML = "$150"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 150)};
      $('eight_go_to_btn_2').innerHTML = "$180"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 180)};
      $('eight_go_to_btn_3').innerHTML = "$210"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 210)};
      $('eight_go_to_btn_4').innerHTML = "$240"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 240)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$150e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 150)};
        $('eight_dbl_press_btn_2').innerHTML = "$180e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 180)};
      }
      break;
    case ((amt == 126) || (amt == 138)):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$150"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 150)};
      $('eight_go_to_btn_2').innerHTML = "$180"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 180)};
      $('eight_go_to_btn_3').innerHTML = "$210"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 210)};
      $('eight_go_to_btn_4').innerHTML = "$240"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 240)};
      break;
    case (amt == 132):
      $('eight_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      $('eight_go_to_btn_1').innerHTML = "$150"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 150)};
      $('eight_go_to_btn_2').innerHTML = "$180"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 180)};
      $('eight_go_to_btn_3').innerHTML = "$210"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 210)};
      $('eight_go_to_btn_4').innerHTML = "$240"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 240)};
      break;
    case (amt == 144):
      $('eight_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      $('eight_go_to_btn_1').innerHTML = "$150"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 150)};
      $('eight_go_to_btn_2').innerHTML = "$180"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 180)};
      $('eight_go_to_btn_3').innerHTML = "$240"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 240)};
      $('eight_go_to_btn_4').innerHTML = "$300"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 300)};
      break;
    case (amt == 150):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_2'); lineUp('eight_press_btn_3');
      $('eight_go_to_btn_1').innerHTML = "$150"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 150)};
      $('eight_go_to_btn_2').innerHTML = "$180"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 180)};
      $('eight_go_to_btn_3').innerHTML = "$210"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 210)};
      $('eight_go_to_btn_4').innerHTML = "$240"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 240)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$180e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 180)};
        $('eight_dbl_press_btn_2').innerHTML = "$210e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 210)};
        letsShow('eight_dble_btn_box_two');
        $('eight_dbl_press_btn_3').innerHTML = "+5 to $240e 6 &amp; 8"; $('eight_dbl_press_btn_3').onclick = function () {doubleUnitPress(8, 240)};
      }
      break;
    case (amt == 156):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$180"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 180)};
      $('eight_go_to_btn_2').innerHTML = "$210"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 210)};
      $('eight_go_to_btn_3').innerHTML = "$240"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 240)};
      $('eight_go_to_btn_4').innerHTML = "$300"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 300)};
      break;
    case (amt == 162):
      $('eight_go_to_btn_1').innerHTML = "$180"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 180)};
      $('eight_go_to_btn_2').innerHTML = "$210"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 210)};
      $('eight_go_to_btn_3').innerHTML = "$240"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 240)};
      $('eight_go_to_btn_4').innerHTML = "$300"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 300)};
      break;
    case (amt == 168):
      $('eight_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Full pressers can shoot for the stars. Otherwise, you should be pressing by $120 or $300. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$180"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 180)};
      $('eight_go_to_btn_2').innerHTML = "$240"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 240)};
      $('eight_go_to_btn_3').innerHTML = "$300"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 300)};
      $('eight_go_to_btn_4').innerHTML = "$360"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 360)};
      break;
    case (amt == 174):
      $('eight_go_to_btn_1').innerHTML = "$180"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 180)};
      $('eight_go_to_btn_2').innerHTML = "$240"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 240)};
      $('eight_go_to_btn_3').innerHTML = "$300"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 300)};
      $('eight_go_to_btn_4').innerHTML = "$360"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 360)};
      break;
    case (amt == 180):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_2'); lineUp('eight_press_btn_3'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$180"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 180)};
      $('eight_go_to_btn_2').innerHTML = "$210"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 210)};
      $('eight_go_to_btn_3').innerHTML = "$240"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 240)};
      $('eight_go_to_btn_4').innerHTML = "$300"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 300)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$210e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 210)};
        $('eight_dbl_press_btn_2').innerHTML = "$240e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 240)};
        letsShow('eight_dble_btn_box_two');
        $('eight_dbl_press_btn_3').innerHTML = "+30 to $300e 6 &amp; 8"; $('eight_dbl_press_btn_3').onclick = function () {doubleUnitPress(8, 300)};
      }
      break;
    case (amt == 186):
      $('eight_go_to_btn_1').innerHTML = "$210"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 210)};
      $('eight_go_to_btn_2').innerHTML = "$240"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 240)};
      $('eight_go_to_btn_3').innerHTML = "$300"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 300)};
      $('eight_go_to_btn_4').innerHTML = "$360"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 360)};
      break;
    case (amt == 192):
      $('eight_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Full pressers can shoot for the stars. Otherwise, you should be pressing by $120 or $300. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$210"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 210)};
      $('eight_go_to_btn_2').innerHTML = "$240"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 240)};
      $('eight_go_to_btn_3').innerHTML = "$300"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 300)};
      $('eight_go_to_btn_4').innerHTML = "$360"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 360)};
      break;
    case (amt == 198):
      $('eight_go_to_btn_1').innerHTML = "$240"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 240)};
      $('eight_go_to_btn_2').innerHTML = "$300"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 300)};
      $('eight_go_to_btn_3').innerHTML = "$360"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 360)};
      $('eight_go_to_btn_4').innerHTML = "$420"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 420)};
      break;
    case (amt == 204):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$240"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 240)};
      $('eight_go_to_btn_2').innerHTML = "$300"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 300)};
      $('eight_go_to_btn_3').innerHTML = "$360"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 360)};
      $('eight_go_to_btn_4').innerHTML = "$420"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 420)};
      break;
    case (amt == 210):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_2'); lineUp('eight_press_btn_3');
      $('eight_go_to_btn_1').innerHTML = "$300"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 300)};
      $('eight_go_to_btn_2').innerHTML = "$360"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 360)};
      $('eight_go_to_btn_3').innerHTML = "$420"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 420)};
      $('eight_go_to_btn_4').innerHTML = "$450"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 450)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$240e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 240)};
        $('eight_dbl_press_btn_2').innerHTML = "$300e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 300)};
      }
      break;
    case (amt == 216):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$300"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 300)};
      $('eight_go_to_btn_2').innerHTML = "$360"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 360)};
      $('eight_go_to_btn_3').innerHTML = "$420"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 420)};
      $('eight_go_to_btn_4').innerHTML = "$450"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 450)};
      break;
    case ((amt == 222) || (amt == 228) || (amt == 234)):
      $('eight_go_to_btn_1').innerHTML = "$300"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 300)};
      $('eight_go_to_btn_2').innerHTML = "$360"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 360)};
      $('eight_go_to_btn_3').innerHTML = "$420"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 420)};
      $('eight_go_to_btn_4').innerHTML = "$480"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 480)};
      break;
    case (amt == 240):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_2'); lineUp('eight_press_btn_3');
      $('eight_go_to_btn_1').innerHTML = "$300"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 300)};
      $('eight_go_to_btn_2').innerHTML = "$360"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 360)};
      $('eight_go_to_btn_3').innerHTML = "$420"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 420)};
      $('eight_go_to_btn_4').innerHTML = "$480"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 480)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$300e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 300)};
        $('eight_dbl_press_btn_2').innerHTML = "$360e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 360)};
      }
      break;
    case (amt == 246):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$300"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 300)};
      $('eight_go_to_btn_2').innerHTML = "$360"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 360)};
      $('eight_go_to_btn_3').innerHTML = "$420"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 420)};
      $('eight_go_to_btn_4').innerHTML = "$480"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 480)};
      break;
    case ((amt >= 252) && (amt <= 264)):
      $('eight_go_to_btn_1').innerHTML = "$300"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 300)};
      $('eight_go_to_btn_2').innerHTML = "$360"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 360)};
      $('eight_go_to_btn_3').innerHTML = "$480"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 480)};
      $('eight_go_to_btn_4').innerHTML = "$540"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 540)};
      break;
    case (amt == 270):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons');
      lineUp('eight_press_btn_2'); lineUp('eight_press_btn_3'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$300"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 300)};
      $('eight_go_to_btn_2').innerHTML = "$360"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 360)};
      $('eight_go_to_btn_3').innerHTML = "$480"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 480)};
      $('eight_go_to_btn_4').innerHTML = "$540"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 540)};
      break;
    case (amt == 276):
      $('eight_go_to_btn_1').innerHTML = "$300"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 300)};
      $('eight_go_to_btn_2').innerHTML = "$360"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 360)};
      $('eight_go_to_btn_3').innerHTML = "$480"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 480)};
      $('eight_go_to_btn_4').innerHTML = "$540"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 540)};
      break;
    case ((amt == 282) || (amt == 288)):
      $('eight_go_to_btn_1').innerHTML = "$360"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 360)};
      $('eight_go_to_btn_2').innerHTML = "$480"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 480)};
      $('eight_go_to_btn_3').innerHTML = "$540"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 540)};
      $('eight_go_to_btn_4').innerHTML = "$600"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 600)};
      break;
    case (amt == 294):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$360"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 360)};
      $('eight_go_to_btn_2').innerHTML = "$480"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 480)};
      $('eight_go_to_btn_3').innerHTML = "$540"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 540)};
      $('eight_go_to_btn_4').innerHTML = "$600"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 600)};
      break;
    case (amt == 300):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_3');
      $('eight_go_to_btn_1').innerHTML = "$360"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 360)};
      $('eight_go_to_btn_2').innerHTML = "$420"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 420)};
      $('eight_go_to_btn_3').innerHTML = "$480"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 480)};
      $('eight_go_to_btn_4').innerHTML = "$540"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 540)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$360e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 360)};
        $('eight_dbl_press_btn_2').innerHTML = "$420e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 420)};
        letsShow('eight_dble_btn_box_two'); letsUnmask('eight_dbl_press_btn_4');
        $('eight_dbl_press_btn_3').innerHTML = "$450e 6 &amp; 8"; $('eight_dbl_press_btn_3').onclick = function () {doubleUnitPress(8, 450)};
        $('eight_dbl_press_btn_4').innerHTML = "+10 to $480e 6 &amp; 8"; $('eight_dbl_press_btn_4').onclick = function () {doubleUnitPress(8, 480)};
      }
      break;
    case ((amt >= 306) && (amt <= 330)):
      $('eight_go_to_btn_1').innerHTML = "$360"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 360)};
      $('eight_go_to_btn_2').innerHTML = "$480"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 480)};
      $('eight_go_to_btn_3').innerHTML = "$540"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 540)};
      $('eight_go_to_btn_4').innerHTML = "$600"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 600)};
      break;
    case (amt == 336):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$360"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 360)};
      $('eight_go_to_btn_2').innerHTML = "$480"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 480)};
      $('eight_go_to_btn_3').innerHTML = "$600"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 600)};
      $('eight_go_to_btn_4').innerHTML = "$720"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 720)};
      break;
    case ((amt >= 342) && (amt <= 354)):
      $('eight_go_to_btn_1').innerHTML = "$360"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 360)};
      $('eight_go_to_btn_2').innerHTML = "$480"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 480)};
      $('eight_go_to_btn_3').innerHTML = "$600"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 600)};
      $('eight_go_to_btn_4').innerHTML = "$720"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 720)};
      break;
    case (amt == 360):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_3'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$420"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 420)};
      $('eight_go_to_btn_2').innerHTML = "$540"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 540)};
      $('eight_go_to_btn_3').innerHTML = "$600"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 600)};
      $('eight_go_to_btn_4').innerHTML = "$780"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 780)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$420e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 420)};
        $('eight_dbl_press_btn_2').innerHTML = "$450e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 450)};
        letsShow('eight_dble_btn_box_two'); letsUnmask('eight_dbl_press_btn_4');
        $('eight_dbl_press_btn_3').innerHTML = "$480e 6 &amp; 8"; $('eight_dbl_press_btn_3').onclick = function () {doubleUnitPress(8, 480)};
        $('eight_dbl_press_btn_4').innerHTML = "$600e 6 &amp; 8"; $('eight_dbl_press_btn_4').onclick = function () {doubleUnitPress(8, 600)};
      }
      break;
    case ((amt >= 366) && (amt <= 384)):
    case ((amt >= 396) && (amt <= 408)):
      $('eight_go_to_btn_1').innerHTML = "$420"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 420)};
      $('eight_go_to_btn_2').innerHTML = "$540"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 540)};
      $('eight_go_to_btn_3').innerHTML = "$600"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 600)};
      $('eight_go_to_btn_4').innerHTML = "$780"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 780)};
      break;
    case ((amt == 390) || (amt == 414)):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$420"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 420)};
      $('eight_go_to_btn_2').innerHTML = "$540"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 540)};
      $('eight_go_to_btn_3').innerHTML = "$600"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 600)};
      $('eight_go_to_btn_4').innerHTML = "$780"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 780)};
      break;
    case (amt == 420):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_3');
      $('eight_go_to_btn_1').innerHTML = "$540"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 540)};
      $('eight_go_to_btn_2').innerHTML = "$600"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 600)};
      $('eight_go_to_btn_3').innerHTML = "$780"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 780)};
      $('eight_go_to_btn_4').innerHTML = "$900"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 900)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$450e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 450)};
        $('eight_dbl_press_btn_2').innerHTML = "$480e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 480)};
        letsShow('eight_dble_btn_box_two');
        $('eight_dbl_press_btn_3').innerHTML = "$600e 6 &amp; 8"; $('eight_dbl_press_btn_3').onclick = function () {doubleUnitPress(8, 600)};
      }
      break;
    case ((amt == 426) || (amt == 432) || (amt == 444)):
    case ((amt == 456) || (amt == 462) || (amt == 474) || (amt == 534)):
    case ((amt >= 486) && (amt <= 522)):
      $('eight_go_to_btn_1').innerHTML = "$540"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 540)};
      $('eight_go_to_btn_2').innerHTML = "$600"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 600)};
      $('eight_go_to_btn_3').innerHTML = "$780"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 780)};
      $('eight_go_to_btn_4').innerHTML = "$900"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 900)};
      break;
    case ((amt == 438) || (amt == 468) || (amt == 528)):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$540"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 540)};
      $('eight_go_to_btn_2').innerHTML = "$600"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 600)};
      $('eight_go_to_btn_3').innerHTML = "$780"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 780)};
      $('eight_go_to_btn_4').innerHTML = "$900"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 900)};
      break;
    case (amt == 450):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_2'); lineUp('eight_press_btn_3');
      $('eight_go_to_btn_1').innerHTML = "$540"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 540)};
      $('eight_go_to_btn_2').innerHTML = "$600"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 600)};
      $('eight_go_to_btn_3').innerHTML = "$780"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 780)};
      $('eight_go_to_btn_4').innerHTML = "$900"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 900)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$480e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 480)};
        $('eight_dbl_press_btn_2').innerHTML = "$600e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 600)};
      }
      break;
    case (amt == 480):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_3');
      $('eight_go_to_btn_1').innerHTML = "$540"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 540)};
      $('eight_go_to_btn_2').innerHTML = "$600"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 600)};
      $('eight_go_to_btn_3').innerHTML = "$780"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 780)};
      $('eight_go_to_btn_4').innerHTML = "$900"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 900)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$600e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 600)};
        $('eight_dbl_press_btn_2').innerHTML = "$720e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 720)};
      }
      break;
    case (amt == 540):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_3');
      $('eight_go_to_btn_1').innerHTML = "$600"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 600)};
      $('eight_go_to_btn_2').innerHTML = "$720"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 720)};
      $('eight_go_to_btn_3').innerHTML = "$780"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 780)};
      $('eight_go_to_btn_4').innerHTML = "$900"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 900)};
      break;
    case ((amt == 546) || (amt == 552)):
      $('eight_go_to_btn_1').innerHTML = "$600"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 600)};
      $('eight_go_to_btn_2').innerHTML = "$720"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 720)};
      $('eight_go_to_btn_3').innerHTML = "$780"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 780)};
      $('eight_go_to_btn_4').innerHTML = "$900"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 900)};
      break;
    case ((amt >= 558) && (amt <= 576)):
    case ((amt == 588) || (amt == 594)):
      $('eight_go_to_btn_1').innerHTML = "$600"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 600)};
      $('eight_go_to_btn_2').innerHTML = "$780"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 780)};
      $('eight_go_to_btn_3').innerHTML = "$900"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 900)};
      $('eight_go_to_btn_4').innerHTML = "$1,200"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 1200)};
      break;
    case (amt == 582):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by $30 or $60. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$600"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 600)};
      $('eight_go_to_btn_2').innerHTML = "$780"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 780)};
      $('eight_go_to_btn_3').innerHTML = "$900"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 900)};
      $('eight_go_to_btn_4').innerHTML = "$1,200"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 1200)};
      break;
    case (amt == 600):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_3');
      $('eight_go_to_btn_1').innerHTML = "$780"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 780)};
      $('eight_go_to_btn_2').innerHTML = "$900"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 900)};
      $('eight_go_to_btn_3').innerHTML = "$960"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 960)};
      $('eight_go_to_btn_4').innerHTML = "$1,200"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 1200)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$720e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 720)};
        $('eight_dbl_press_btn_2').innerHTML = "$780e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 780)};
        letsShow('eight_dble_btn_box_two');
        $('eight_dbl_press_btn_3').innerHTML = "$900e 6 &amp; 8"; $('eight_dbl_press_btn_3').onclick = function () {doubleUnitPress(8, 900)};
      }
      break;
    case ((amt >= 606) && (amt <= 630)):
    case ((amt >= 642) && (amt <= 690)):
      $('eight_go_to_btn_1').innerHTML = "$780"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 780)};
      $('eight_go_to_btn_2').innerHTML = "$900"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 900)};
      $('eight_go_to_btn_3').innerHTML = "$960"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 960)};
      $('eight_go_to_btn_4').innerHTML = "$1,200"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 1200)};
      break;
    case (amt == 636):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by $60 or $120. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$780"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 780)};
      $('eight_go_to_btn_2').innerHTML = "$900"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 900)};
      $('eight_go_to_btn_3').innerHTML = "$960"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 960)};
      $('eight_go_to_btn_4').innerHTML = "$1,200"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 1200)};
      break;
    case ((amt >= 696) && (amt <= 714)):
    case ((amt >= 732) && (amt <= 744)):
    case ((amt >= 756) && (amt <= 774)):
      $('eight_go_to_btn_1').innerHTML = "$780"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 780)};
      $('eight_go_to_btn_2').innerHTML = "$900"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 900)};
      $('eight_go_to_btn_3').innerHTML = "$1,200"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 1200)};
      $('eight_go_to_btn_4').innerHTML = "$1,500"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 1500)};
      break;
    case (amt == 720):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_2');
      $('eight_go_to_btn_1').innerHTML = "$780"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 780)};
      $('eight_go_to_btn_2').innerHTML = "$900"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 900)};
      $('eight_go_to_btn_3').innerHTML = "$1,200"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 1200)};
      $('eight_go_to_btn_4').innerHTML = "$1,500"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 1500)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$780e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 780)};
        $('eight_dbl_press_btn_2').innerHTML = "$900e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 900)};
      }
      break;
    case (amt == 726):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by $60 or $120. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$780"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 780)};
      $('eight_go_to_btn_2').innerHTML = "$900"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 900)};
      $('eight_go_to_btn_3').innerHTML = "$1,200"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 1200)};
      $('eight_go_to_btn_4').innerHTML = "$1,500"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 1500)};
      break;
    case (amt == 750):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_2'); lineUp('eight_press_btn_3');
      $('eight_go_to_btn_1').innerHTML = "$780"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 780)};
      $('eight_go_to_btn_2').innerHTML = "$900"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 900)};
      $('eight_go_to_btn_3').innerHTML = "$1,200"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 1200)};
      $('eight_go_to_btn_4').innerHTML = "$1,500"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 1500)};
      break;
    case (amt == 780):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$900"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 900)};
      $('eight_go_to_btn_2').innerHTML = "$960"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 960)};
      $('eight_go_to_btn_3').innerHTML = "$1,200"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 1200)};
      $('eight_go_to_btn_4').innerHTML = "$1,500"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 1500)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$900e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 900)};
        $('eight_dbl_press_btn_2').innerHTML = "1,200e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 1200)};
      }
      break;
    case ((amt >= 786) && (amt <= 828)):
      $('eight_go_to_btn_1').innerHTML = "$900"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 900)};
      $('eight_go_to_btn_2').innerHTML = "$960"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 960)};
      $('eight_go_to_btn_3').innerHTML = "$1,200"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 1200)};
      $('eight_go_to_btn_4').innerHTML = "$1,500"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 1500)};
      break;
    case (amt == 834):
    case ((amt >= 846) && (amt <= 888)):
      $('eight_go_to_btn_1').innerHTML = "$900"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 900)};
      $('eight_go_to_btn_2').innerHTML = "$1,200"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 1200)};
      $('eight_go_to_btn_3').innerHTML = "$1,500"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 1500)};
      $('eight_go_to_btn_4').innerHTML = "$1,800"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 1800)};
      break;
    case (amt == 840):
      $('eight_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Full pressers can shoot for the stars. Otherwise, you should be pressing by $120 or $300. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$900"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 900)};
      $('eight_go_to_btn_2').innerHTML = "$1,200"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 1200)};
      $('eight_go_to_btn_3').innerHTML = "$1,500"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 1500)};
      $('eight_go_to_btn_4').innerHTML = "$1,800"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 1800)};
      break;
    case (amt == 894):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by $120 or $300. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$900"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 900)};
      $('eight_go_to_btn_2').innerHTML = "$1,200"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 1200)};
      $('eight_go_to_btn_3').innerHTML = "$1,500"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 1500)};
      $('eight_go_to_btn_4').innerHTML = "$1,800"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 1800)};
      break;
    case (amt == 900):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_3');
      $('eight_go_to_btn_1').innerHTML = "$960"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 960)};
      $('eight_go_to_btn_2').innerHTML = "$1,200"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 1200)};
      $('eight_go_to_btn_3').innerHTML = "$1,500"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 1500)};
      $('eight_go_to_btn_4').innerHTML = "$1,800"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 1800)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$1,200e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 1200)};
        $('eight_dbl_press_btn_2').innerHTML = "+150 to $1,500e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 1500)};
      }
      break;
    case ((amt >= 906) && (amt <= 942)):
    case (amt == 954):
      $('eight_go_to_btn_1').innerHTML = "$960"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 960)};
      $('eight_go_to_btn_2').innerHTML = "$1,200"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 1200)};
      $('eight_go_to_btn_3').innerHTML = "$1,500"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 1500)};
      $('eight_go_to_btn_4').innerHTML = "$1,800"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 1800)};
      break;
    case (amt == 948):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by $120 or $300. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$960"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 960)};
      $('eight_go_to_btn_2').innerHTML = "$1,200"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 1200)};
      $('eight_go_to_btn_3').innerHTML = "$1,500"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 1500)};
      $('eight_go_to_btn_4').innerHTML = "$1,800"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 1800)};
      break;
    case (amt == 960):
      $('eight_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      $('eight_go_to_btn_1').innerHTML = "$1,200"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 1200)};
      $('eight_go_to_btn_2').innerHTML = "$1,500"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 1500)};
      $('eight_go_to_btn_3').innerHTML = "$1,800"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 1800)};
      $('eight_go_to_btn_4').innerHTML = "+24 to $2,100"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 2100)};
      break;
    case (amt == 966):
      $('eight_go_to_btn_1').innerHTML = "$1,200"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 1200)};
      $('eight_go_to_btn_2').innerHTML = "$1,500"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 1500)};
      $('eight_go_to_btn_3').innerHTML = "$1,800"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 1800)};
      $('eight_go_to_btn_4').innerHTML = "+12 to $2,100"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 2100)};
      break;
    case ((amt >= 972) && (amt <= 1008)):
    case ((amt >= 1020) && (amt <= 1074)):
    case ((amt >= 1086) && (amt <= 1104)):
      $('eight_go_to_btn_1').innerHTML = "$1,200"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 1200)};
      $('eight_go_to_btn_2').innerHTML = "$1,500"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 1500)};
      $('eight_go_to_btn_3').innerHTML = "$1,800"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 1800)};
      $('eight_go_to_btn_4').innerHTML = "$2,100"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 2100)};
      break;
    case (amt == 1014):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by $120 or $300. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$1,200"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 1200)};
      $('eight_go_to_btn_2').innerHTML = "$1,500"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 1500)};
      $('eight_go_to_btn_3').innerHTML = "$1,800"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 1800)};
      $('eight_go_to_btn_4').innerHTML = "$2,100"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 2100)};
      break;
    case (amt == 1080):
      $('eight_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      $('eight_go_to_btn_1').innerHTML = "$1,200"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 1200)};
      $('eight_go_to_btn_2').innerHTML = "$1,500"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 1500)};
      $('eight_go_to_btn_3').innerHTML = "$1,800"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 1800)};
      $('eight_go_to_btn_4').innerHTML = "$2,100"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 2100)};
      break;
    case ((amt >= 1110) && (amt <= 1134)):
    case ((amt >= 1146) && (amt <= 1194)):
    case ((amt >= 1206) && (amt <= 1254)):
    case ((amt >= 1266) && (amt <= 1290)):
      $('eight_go_to_btn_1').innerHTML = "$1,500"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 1500)};
      $('eight_go_to_btn_2').innerHTML = "$1,800"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 1800)};
      $('eight_go_to_btn_3').innerHTML = "$2,100"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 2100)};
      $('eight_go_to_btn_4').innerHTML = "$2,400"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 2400)};
      break;
    case ((amt == 1140) || (amt == 1260)):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by about $300. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$1,500"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 1500)};
      $('eight_go_to_btn_2').innerHTML = "$1,800"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 1800)};
      $('eight_go_to_btn_3').innerHTML = "$2,100"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 2100)};
      $('eight_go_to_btn_4').innerHTML = "$2,400"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 2400)};
      break;
    case (amt == 1200):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_3');
      $('eight_go_to_btn_1').innerHTML = "$1,500"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 1500)};
      $('eight_go_to_btn_2').innerHTML = "$1,800"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 1800)};
      $('eight_go_to_btn_3').innerHTML = "$2,100"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 2100)};
      $('eight_go_to_btn_4').innerHTML = "$2,400"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 2400)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$1,500e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 1500)};
        $('eight_dbl_press_btn_2').innerHTML = "$1,800e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 1800)};
      }
      break;
    case ((amt >= 1296) && (amt <= 1368)):
    case (amt == 1380):
      $('eight_go_to_btn_1').innerHTML = "$1,500"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 1500)};
      $('eight_go_to_btn_2').innerHTML = "$1,800"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 1800)};
      $('eight_go_to_btn_3').innerHTML = "$2,100"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 2100)};
      $('eight_go_to_btn_4').innerHTML = "$2,400"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 2400)};
      break;
    case (amt == 1374):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by about $300. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$1,500"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 1500)};
      $('eight_go_to_btn_2').innerHTML = "$1,800"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 1800)};
      $('eight_go_to_btn_3').innerHTML = "$2,100"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 2100)};
      $('eight_go_to_btn_4').innerHTML = "$2,400"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 2400)};
      break;
    case ((amt >= 1386) && (amt <= 1494)):
    case ((amt >= 1506) && (amt <= 1566)):
    case ((amt >= 1578) && (amt <= 1656)):
      $('eight_go_to_btn_1').innerHTML = "$1,800"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 1800)};
      $('eight_go_to_btn_2').innerHTML = "$2,100"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 2100)};
      $('eight_go_to_btn_3').innerHTML = "$2,400"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 2400)};
      $('eight_go_to_btn_4').innerHTML = "$3,000"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 3000)};
      break;
    case (amt == 1500):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_3');
      $('eight_go_to_btn_1').innerHTML = "$1,800"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 1800)};
      $('eight_go_to_btn_2').innerHTML = "$2,100"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 2100)};
      $('eight_go_to_btn_3').innerHTML = "$2,400"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 2400)};
      $('eight_go_to_btn_4').innerHTML = "$3,000"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 3000)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$1,800e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 1800)};
        $('eight_dbl_press_btn_2').innerHTML = "$2,100e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 2100)};
        letsShow('eight_dble_btn_box_two');
        $('eight_dbl_press_btn_3').innerHTML = "+50 to $2,400e 6 &amp; 8"; $('eight_dbl_press_btn_3').onclick = function () {doubleUnitPress(8, 2400)};
      }
      break;
    case (amt == 1572):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by about $300. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$1,800"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 1800)};
      $('eight_go_to_btn_2').innerHTML = "$2,100"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 2100)};
      $('eight_go_to_btn_3').innerHTML = "$2,400"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 2400)};
      $('eight_go_to_btn_4').innerHTML = "$3,000"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 3000)};
      break;
    case ((amt >= 1662) && (amt <= 1680)):
    case ((amt >= 1692) && (amt <= 1794)):
    case ((amt >= 1806) && (amt <= 1812)):
    case ((amt >= 1824) && (amt <= 1926)):
    case (amt == 1938):
      $('eight_go_to_btn_1').innerHTML = "$2,100"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 2100)};
      $('eight_go_to_btn_2').innerHTML = "$2,400"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 2400)};
      $('eight_go_to_btn_3').innerHTML = "$3,000"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 3000)};
      $('eight_go_to_btn_4').innerHTML = "$3,600"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 3600)};
      break;
    case ((amt == 1686) || (amt == 1818) || (amt == 1932)):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by about $300. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$2,100"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 2100)};
      $('eight_go_to_btn_2').innerHTML = "$2,400"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 2400)};
      $('eight_go_to_btn_3').innerHTML = "$3,000"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 3000)};
      $('eight_go_to_btn_4').innerHTML = "$3,600"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 3600)};
      break;
    case (amt == 1800):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_3');
      $('eight_go_to_btn_1').innerHTML = "$2,100"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 2100)};
      $('eight_go_to_btn_2').innerHTML = "$2,400"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 2400)};
      $('eight_go_to_btn_3').innerHTML = "$3,000"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 3000)};
      $('eight_go_to_btn_4').innerHTML = "$3,600"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 3600)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$2,100e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 2100)};
        $('eight_dbl_press_btn_2').innerHTML = "$2,400e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 2400)};
        letsShow('eight_dble_btn_box_two');
        $('eight_dbl_press_btn_3').innerHTML = "+50 to $2,400e 6 &amp; 8"; $('eight_dbl_press_btn_3').onclick = function () {doubleUnitPress(8, 2400)};
      }
      break;
    case ((amt >= 1944) && (amt <= 2046)):
    case ((amt >= 2058) && (amt <= 2076)):
      $('eight_go_to_btn_1').innerHTML = "$2,400"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 2400)};
      $('eight_go_to_btn_2').innerHTML = "$3,000"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 3000)};
      $('eight_go_to_btn_3').innerHTML = "$3,600"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 3600)};
      $('eight_go_to_btn_4').innerHTML = "$4,200"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 4200)};
      break;
    case (amt == 2052):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by $300 or $600. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$2,400"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 2400)};
      $('eight_go_to_btn_2').innerHTML = "$3,000"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 3000)};
      $('eight_go_to_btn_3').innerHTML = "$3,600"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 3600)};
      $('eight_go_to_btn_4').innerHTML = "$4,200"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 4200)};
      break;
    case ((amt >= 2082) && (amt <= 2094)):
    case ((amt >= 2106) && (amt <= 2190)):
    case ((amt >= 2202) && (amt <= 2214)):
      $('eight_go_to_btn_1').innerHTML = "$3,000"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 3000)};
      $('eight_go_to_btn_2').innerHTML = "$3,600"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 3600)};
      $('eight_go_to_btn_3').innerHTML = "$4,200"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 4200)};
      $('eight_go_to_btn_4').innerHTML = "$4,500"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 4500)};
      break;
    case (amt == 2100):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_3');
      $('eight_go_to_btn_1').innerHTML = "$3,000"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 3000)};
      $('eight_go_to_btn_2').innerHTML = "$3,600"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 3600)};
      $('eight_go_to_btn_3').innerHTML = "$4,200"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 4200)};
      $('eight_go_to_btn_4').innerHTML = "$4,500"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 4500)};
      if(equalUnits) {
        letsShow('place_eight_dble_box'); letsUnmask('eight_dbl_press_btn_2');
        $('eight_dbl_press_btn_1').innerHTML = "$2,400e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 2400)};
        $('eight_dbl_press_btn_2').innerHTML = "$3,000e 6 &amp; 8"; $('eight_dbl_press_btn_2').onclick = function () {doubleUnitPress(8, 3000)};
      }
      break;
    case (amt == 2196):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by $300 or $600. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$3,000"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 3000)};
      $('eight_go_to_btn_2').innerHTML = "$3,600"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 3600)};
      $('eight_go_to_btn_3').innerHTML = "$4,200"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 4200)};
      $('eight_go_to_btn_4').innerHTML = "$4,500"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 4500)};
      break;
    case ((amt >= 2220) && (amt <= 2394)):
    case ((amt >= 2406) && (amt <= 2460)):
    case ((amt >= 2472) && (amt <= 2490)):
      $('eight_go_to_btn_1').innerHTML = "$3,000"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 3000)};
      $('eight_go_to_btn_2').innerHTML = "$3,600"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 3600)};
      $('eight_go_to_btn_3').innerHTML = "$4,200"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 4200)};
      $('eight_go_to_btn_4').innerHTML = "$4,800"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 4800)};
      break;
    case (amt == 2400):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_3');
      $('eight_go_to_btn_1').innerHTML = "$3,000"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 3000)};
      $('eight_go_to_btn_2').innerHTML = "$3,600"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 3600)};
      $('eight_go_to_btn_3').innerHTML = "$4,200"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 4200)};
      $('eight_go_to_btn_4').innerHTML = "$4,800"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 4800)};
      if(equalUnits) {
        letsShow('place_eight_dble_box');
        $('eight_dbl_press_btn_1').innerHTML = "$3,000e 6 &amp; 8"; $('eight_dbl_press_btn_1').onclick = function () {doubleUnitPress(8, 3000)};
      }
      break;
    case (amt == 2466):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by $300 or $600. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$3,000"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 3000)};
      $('eight_go_to_btn_2').innerHTML = "$3,600"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 3600)};
      $('eight_go_to_btn_3').innerHTML = "$4,200"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 4200)};
      $('eight_go_to_btn_4').innerHTML = "$4,800"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 4800)};
      break;
    case ((amt >= 2496) && (amt <= 2724)):
    case ((amt >= 2736) && (amt <= 2766)):
      $('eight_go_to_btn_1').innerHTML = "$3,000"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 3000)};
      $('eight_go_to_btn_2').innerHTML = "$3,600"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 3600)};
      $('eight_go_to_btn_3').innerHTML = "$4,800"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 4800)};
      $('eight_go_to_btn_4').innerHTML = "$5,400"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 5400)};
      break;
    case (amt == 2730):
      $('eight_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " eight is if you are full pressing from a lower amount. If not, you should be pressing by $300 or $600. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$3,000"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 3000)};
      $('eight_go_to_btn_2').innerHTML = "$3,600"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 3600)};
      $('eight_go_to_btn_3').innerHTML = "$4,800"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 4800)};
      $('eight_go_to_btn_4').innerHTML = "$5,400"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 5400)};
      break;
    case ((amt >= 2772) && (amt <= 2970)):
    case ((amt >= 2982) && (amt <= 2994)):
      $('eight_go_to_btn_1').innerHTML = "$3,000"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 3000)};
      $('eight_go_to_btn_2').innerHTML = "$3,600"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 3600)};
      $('eight_go_to_btn_3').innerHTML = "$4,800"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 4800)};
      $('eight_go_to_btn_4').innerHTML = "$5,400"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 5400)};
      letsShow('eight_tbl_max_btn');
      break;
    case (amt == 2976):
      $('eight_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      $('eight_go_to_btn_1').innerHTML = "$3,000"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 3000)};
      $('eight_go_to_btn_2').innerHTML = "$3,600"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 3600)};
      $('eight_go_to_btn_3').innerHTML = "$4,800"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 4800)};
      $('eight_go_to_btn_4').innerHTML = "$5,400"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 5400)};
      letsShow('eight_tbl_max_btn');
      break;
    case (amt == 3000):
      letsHide('eight_pay_disclaimer');
      letsShow('eight_press_buttons'); lineUp('eight_press_btn_3');
      $('eight_go_to_btn_1').innerHTML = "$3,600"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 3600)};
      $('eight_go_to_btn_2').innerHTML = "$4,200"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 4200)};
      $('eight_go_to_btn_3').innerHTML = "$4,800"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 4800)};
      $('eight_go_to_btn_4').innerHTML = "$5,400"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 5400)};
      letsShow('eight_tbl_max_btn');
      break;
    case ((amt >= 3006) && (amt <= 3396)):
    case ((amt >= 3408) && (amt <= 3594)):
      $('eight_go_to_btn_1').innerHTML = "$3,600"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 3600)};
      $('eight_go_to_btn_2').innerHTML = "$4,200"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 4200)};
      $('eight_go_to_btn_3').innerHTML = "$4,800"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 4800)};
      $('eight_go_to_btn_4').innerHTML = "$5,400"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 5400)};
      letsShow('eight_tbl_max_btn');
      break;
    case (amt == 3402):
      $('eight_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      $('eight_go_to_btn_1').innerHTML = "$3,600"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 3600)};
      $('eight_go_to_btn_2').innerHTML = "$4,200"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 4200)};
      $('eight_go_to_btn_3').innerHTML = "$4,800"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 4800)};
      $('eight_go_to_btn_4').innerHTML = "$5,400"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 5400)};
      letsShow('eight_tbl_max_btn');
      break;
    case (amt == 3600):
      letsHide('eight_pay_disclaimer');
      $('eight_go_to_btn_1').innerHTML = "$4,200"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 4200)};
      $('eight_go_to_btn_2').innerHTML = "$4,500"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 4500)};
      $('eight_go_to_btn_3').innerHTML = "$4,800"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 4800)};
      $('eight_go_to_btn_4').innerHTML = "$5,400"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 5400)};
      letsShow('eight_tbl_max_btn');
      break;
    case ((amt >= 3606) && (amt <= 3642)):
    case ((amt >= 3654) && (amt <= 3930)):
    case ((amt >= 3942) && (amt <= 4176)):
    case ((amt >= 4188) && (amt <= 4194)):
      $('eight_go_to_btn_1').innerHTML = "$4,200"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 4200)};
      $('eight_go_to_btn_2').innerHTML = "$4,500"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 4500)};
      $('eight_go_to_btn_3').innerHTML = "$4,800"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 4800)};
      $('eight_go_to_btn_4').innerHTML = "$5,400"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 5400)};
      letsShow('eight_tbl_max_btn');
      break;
    case ((amt == 3648) || (amt == 3936) || (amt == 4182)):
      $('eight_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      $('eight_go_to_btn_1').innerHTML = "$4,200"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 4200)};
      $('eight_go_to_btn_2').innerHTML = "$4,500"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 4500)};
      $('eight_go_to_btn_3').innerHTML = "$4,800"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 4800)};
      $('eight_go_to_btn_4').innerHTML = "$5,400"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 5400)};
      letsShow('eight_tbl_max_btn');
      break;
    case (amt == 4200):
      letsHide('eight_pay_disclaimer');
      $('eight_go_to_btn_1').innerHTML = "$4,500"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 4500)};
      $('eight_go_to_btn_2').innerHTML = "$4,800"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 4800)};
      $('eight_go_to_btn_3').innerHTML = "$5,100"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 5100)};
      $('eight_go_to_btn_4').innerHTML = "$5,400"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 5400)};
      letsShow('eight_tbl_max_btn');
      break;
    case ((amt >= 4206) && (amt <= 4440)):
    case ((amt >= 4452) && (amt <= 4494)):
      $('eight_go_to_btn_1').innerHTML = "$4,500"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 4500)};
      $('eight_go_to_btn_2').innerHTML = "$4,800"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 4800)};
      $('eight_go_to_btn_3').innerHTML = "$5,100"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 5100)};
      $('eight_go_to_btn_4').innerHTML = "$5,400"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 5400)};
      letsShow('eight_tbl_max_btn');
      break;
    case (amt == 4446):
      $('eight_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      $('eight_go_to_btn_1').innerHTML = "$4,500"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 4500)};
      $('eight_go_to_btn_2').innerHTML = "$4,800"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 4800)};
      $('eight_go_to_btn_3').innerHTML = "$5,100"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 5100)};
      $('eight_go_to_btn_4').innerHTML = "$5,400"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 5400)};
      letsShow('eight_tbl_max_btn');
      break;
    case (amt == 4500):
      letsHide('eight_pay_disclaimer');
      $('eight_go_to_btn_1').innerHTML = "$4,800"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 4800)};
      $('eight_go_to_btn_2').innerHTML = "$5,100"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 5100)};
      $('eight_go_to_btn_3').innerHTML = "$5,400"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 5400)};
      $('eight_go_to_btn_4').innerHTML = "$5,700"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 5700)};
      letsShow('eight_tbl_max_btn');
      break;
    case ((amt >= 4506) && (amt <= 4752)):
    case ((amt >= 4764) && (amt <= 4794)):
      $('eight_go_to_btn_1').innerHTML = "$4,800"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 4800)};
      $('eight_go_to_btn_2').innerHTML = "$5,100"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 5100)};
      $('eight_go_to_btn_3').innerHTML = "$5,400"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 5400)};
      $('eight_go_to_btn_4').innerHTML = "$5,700"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 5700)};
      letsShow('eight_tbl_max_btn');
      break;
    case (amt == 4758):
      $('eight_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      $('eight_go_to_btn_1').innerHTML = "$4,800"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 4800)};
      $('eight_go_to_btn_2').innerHTML = "$5,100"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 5100)};
      $('eight_go_to_btn_3').innerHTML = "$5,400"; $('eight_go_to_btn_3').onclick = function () {goTo(8, 5400)};
      $('eight_go_to_btn_4').innerHTML = "$5,700"; $('eight_go_to_btn_4').onclick = function () {goTo(8, 5700)};
      letsShow('eight_tbl_max_btn');
      break;
    case (amt == 4800):
      letsHide('eight_pay_disclaimer');
      letsHide('eight_go_to_btn_3'); letsHide('eight_go_to_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$5,400"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 5400)};
      $('eight_go_to_btn_2').innerHTML = "$5,700"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 5700)};
      letsShow('eight_tbl_max_btn');
      break;
    case ((amt >= 4806) && (amt <= 5334)):
    case ((amt >= 5346) && (amt <= 5394)):
      letsHide('eight_go_to_btn_3'); letsHide('eight_go_to_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$5,400"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 5400)};
      $('eight_go_to_btn_2').innerHTML = "$5,700"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 5700)};
      letsShow('eight_tbl_max_btn');
      break;
    case (amt == 5340):
      $('eight_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      letsHide('eight_go_to_btn_3'); letsHide('eight_go_to_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$5,400"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 5400)};
      $('eight_go_to_btn_2').innerHTML = "$5,700"; $('eight_go_to_btn_2').onclick = function () {goTo(8, 5700)};
      letsShow('eight_tbl_max_btn');
      break;
    case (amt == 5400):
      letsHide('eight_pay_disclaimer');
      letsHide('eight_go_to_btn_2'); letsHide('eight_go_to_btn_3'); letsHide('eight_go_to_btn_4');
      $('eight_go_to_btn_1').innerHTML = "$5,700"; $('eight_go_to_btn_1').onclick = function () {goTo(8, 5700)};
      letsShow('eight_tbl_max_btn');
      break;
    case ((amt >= 5406) && (amt <= 5904)):
    case ((amt >= 5916) && (amt <= 5994)):
      letsHide('eight_go_to_buttons');
      letsShow('eight_tbl_max_btn');
      break;
    case (amt == 5910):
      $('eight_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      letsHide('eight_go_to_buttons');
      letsShow('eight_tbl_max_btn');
      break;
    case (amt == 6000):
      $('eight_pay_disclaimer').innerHTML = "You hit at table max!! If you want to put even more on the table you can start making Come bets and double dip your way up to max Come bet and max Odds! Another... $30,000 ($5K with $25K odds ) to win 35K plus your 7K here is a 42K potential max win on the 6. That's when we get Come Bets which are coming soon.";
      letsHide('eight_go_to_buttons');
      break;
    default: return
  }
}
function showPlaceNineBtns (amt) {
  letsShow('nine_pay_disclaimer');
  $('nine_pay_disclaimer').innerHTML = "Try and stick to bets in normal increments. Use the 'Go to ' menu for normal betting amounts.";
  letsHide('nine_press_buttons');
  letsHide('nine_press_btn_1'); letsHide('nine_press_btn_2'); letsHide('nine_press_btn_3'); letsHide('nine_press_btn_4');
  lineUp('nine_go_to_btn_3'); lineUp('nine_go_to_btn_4');
  letsHide('nine_tbl_max_btn');
  letsHide('place_nine_dble_box');
  letsMask('nine_dbl_press_btn_2');
  letsHide('nine_dble_btn_box_two');
  letsMask('nine_dbl_press_btn_4');
  var equalUnits = theFive.placeBet == theNine.placeBet;
  switch (true) {
    case (amt == 5):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons');
      lineUp('nine_press_btn_1'); lineUp('nine_press_btn_3'); lineUp('nine_press_btn_4');
      letsHide('nine_go_to_btn_3'); letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$10"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 10)};
      $('nine_go_to_btn_2').innerHTML = "+3 to $15"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 15)};
      if(equalUnits) {
        letsShow('place_nine_dble_box');
        $('nine_dbl_press_btn_1').innerHTML = "+3 to $10e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 10)};
      }
      break;
    case (amt == 10):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons');
      lineUp('nine_press_btn_1'); lineUp('nine_press_btn_3'); lineUp('nine_press_btn_4');
      letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$15"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 15)};
      $('nine_go_to_btn_2').innerHTML = "$20"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 20)};
      $('nine_go_to_btn_3').innerHTML = "+ 1 to $25"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 25)};
      if(equalUnits) {
        letsShow('place_nine_dble_box');
        $('nine_dbl_press_btn_1').innerHTML = "$15e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 15)};
      }
      break;
    case (amt == 15): 
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons');
      lineUp('nine_press_btn_1'); lineUp('nine_press_btn_3'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$20"; $('nine_go_to_btn_1').onclick = function () {goTo(9,20)};
      $('nine_go_to_btn_2').innerHTML = "$25"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 25)};
      $('nine_go_to_btn_3').innerHTML = "$30"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 30)};
      $('nine_go_to_btn_4').innerHTML = "$35"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 35)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$20e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 20)};
        $('nine_dbl_press_btn_2').innerHTML = "$25e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 25)};
      }
      break;
    case (amt == 20):
      letsHide('nine_pay_disclaimer'); 
      letsShow('nine_press_buttons');
      lineUp('nine_press_btn_1'); lineUp('nine_press_btn_3'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$25"; $('nine_go_to_btn_1').onclick = function () {goTo(9,25)};
      $('nine_go_to_btn_2').innerHTML = "$30"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 30)};
      $('nine_go_to_btn_3').innerHTML = "$35"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 35)};
      $('nine_go_to_btn_4').innerHTML = "+2 to $50"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 50)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$25e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 25)};
        $('nine_dbl_press_btn_2').innerHTML = "$30e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 30)};
        letsShow('nine_dble_btn_box_two');
        $('nine_dbl_press_btn_3').innerHTML = "+2 to $35e 5 &amp; 9"; $('nine_dbl_press_btn_3').onclick = function () {doubleUnitPress(9, 35)};
      }
      break;
    case (amt == 25):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons');
      lineUp('nine_press_btn_1'); lineUp('nine_press_btn_2'); lineUp('nine_press_btn_3'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$30"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 30)};
      $('nine_go_to_btn_2').innerHTML = "$35"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 35)};
      $('nine_go_to_btn_3').innerHTML = "$50"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 50)};
      $('nine_go_to_btn_4').innerHTML = "$60"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 60)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$30e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 30)};
        $('nine_dbl_press_btn_2').innerHTML = "$35e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 35)};
        letsShow('nine_dble_btn_box_two'); letsUnmask('nine_dbl_press_btn_4');
        $('nine_dbl_press_btn_3').innerHTML = "$40e 5 &amp; 9"; $('nine_dbl_press_btn_3').onclick = function () {doubleUnitPress(9, 40)};
        $('nine_dbl_press_btn_4').innerHTML = "+5 to $45e 5 &amp; 9"; $('nine_dbl_press_btn_4').onclick = function () {doubleUnitPress(9, 45)};
      }
      break;
    case (amt == 30):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons');
      lineUp('nine_press_btn_1'); lineUp('nine_press_btn_3'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$35"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 35)};
      $('nine_go_to_btn_2').innerHTML = "$50"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 50)};
      $('nine_go_to_btn_3').innerHTML = "$60"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 60)};
      $('nine_go_to_btn_4').innerHTML = "+3 to $75"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 75)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$35e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 35)};
        $('nine_dbl_press_btn_2').innerHTML = "$40e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 40)};
        letsShow('nine_dble_btn_box_two'); letsUnmask('nine_dbl_press_btn_4');
        $('nine_dbl_press_btn_3').innerHTML = "$45e 5 &amp; 9"; $('nine_dbl_press_btn_3').onclick = function () {doubleUnitPress(9, 45)};
        $('nine_dbl_press_btn_4').innerHTML = "$50e 5 &amp; 9"; $('nine_dbl_press_btn_4').onclick = function () {doubleUnitPress(9, 50)};
      }
      break;
    case (amt == 35):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons');
      lineUp('nine_press_btn_1'); lineUp('nine_press_btn_3'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$40"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 40)};
      $('nine_go_to_btn_2').innerHTML = "$50"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 50)};
      $('nine_go_to_btn_3').innerHTML = "$60"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 60)};
      $('nine_go_to_btn_4').innerHTML = "$75"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 75)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$40e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 40)};
        $('nine_dbl_press_btn_2').innerHTML = "$45e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 45)};
        letsShow('nine_dble_btn_box_two'); letsUnmask('nine_dbl_press_btn_4');
        $('nine_dbl_press_btn_3').innerHTML = "$50e 5 &amp; 9"; $('nine_dbl_press_btn_3').onclick = function () {doubleUnitPress(9, 50)};
        $('nine_dbl_press_btn_4').innerHTML = "+1 to $60e 5 &amp; 9"; $('nine_dbl_press_btn_4').onclick = function () {doubleUnitPress(9, 60)};
      }
      break;
    case (amt == 40):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons');
      lineUp('nine_press_btn_1'); lineUp('nine_press_btn_3'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$50"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 50)};
      $('nine_go_to_btn_2').innerHTML = "$60"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 60)};
      $('nine_go_to_btn_3').innerHTML = "$75"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 75)};
      $('nine_go_to_btn_4').innerHTML = "+4 to $100"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 100)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$45e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 45)};
        $('nine_dbl_press_btn_2').innerHTML = "$50e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 50)};
        letsShow('nine_dble_btn_box_two');
        $('nine_dbl_press_btn_3').innerHTML = "$60e 5 &amp; 9"; $('nine_dbl_press_btn_3').onclick = function () {doubleUnitPress(9, 60)};
      }
      break;
    case (amt == 45):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons');
      lineUp('nine_press_btn_1'); lineUp('nine_press_btn_3'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$50"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 50)};
      $('nine_go_to_btn_2').innerHTML = "$60"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 60)};
      $('nine_go_to_btn_3').innerHTML = "$75"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 75)};
      $('nine_go_to_btn_4').innerHTML = "$100"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 100)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$50e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 50)};
        $('nine_dbl_press_btn_2').innerHTML = "$60e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 60)};
        letsShow('nine_dble_btn_box_two');
        $('nine_dbl_press_btn_3').innerHTML = "$75e 5 &amp; 9"; $('nine_dbl_press_btn_3').onclick = function () {doubleUnitPress(9, 75)};
      }
      break;
    case (amt == 50):
      letsHide('nine_pay_disclaimer'); 
      letsShow('nine_press_buttons');
      lineUp('nine_press_btn_1'); lineUp('nine_press_btn_2'); lineUp('nine_press_btn_3'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$60"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 60)};
      $('nine_go_to_btn_2').innerHTML = "$75"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 75)};
      $('nine_go_to_btn_3').innerHTML = "$100"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 100)};
      $('nine_go_to_btn_4').innerHTML = "+5 to $125"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 125)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$60e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 60)};
        $('nine_dbl_press_btn_2').innerHTML = "$75e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 75)};
      }
      break;
    case (amt == 55):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons');
      lineUp('nine_press_btn_1'); lineUp('nine_press_btn_3'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$60"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 60)};
      $('nine_go_to_btn_2').innerHTML = "$75"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 75)};
      $('nine_go_to_btn_3').innerHTML = "$100"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 100)};
      $('nine_go_to_btn_4').innerHTML = "$125"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 125)};
      break;
    case (amt == 60):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons');
      lineUp('nine_press_btn_1'); lineUp('nine_press_btn_3'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$75"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 75)};
      $('nine_go_to_btn_2').innerHTML = "$100"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 100)};
      $('nine_go_to_btn_3').innerHTML = "$125"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 125)};
      $('nine_go_to_btn_4').innerHTML = "+6 to $150"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 150)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$75e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 75)};
        $('nine_dbl_press_btn_2').innerHTML = "$100e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 100)};
      }
      break;
    case ((amt == 65) || (amt == 70)):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons');
      lineUp('nine_press_btn_1'); lineUp('nine_press_btn_3'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$75"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 75)};
      $('nine_go_to_btn_2').innerHTML = "$100"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 100)};
      $('nine_go_to_btn_3').innerHTML = "$125"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 125)};
      $('nine_go_to_btn_4').innerHTML = "$150"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 150)};
      break;
    case (amt == 75):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons');
      lineUp('nine_press_btn_1'); lineUp('nine_press_btn_2'); lineUp('nine_press_btn_3'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$100"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 100)};
      $('nine_go_to_btn_2').innerHTML = "$125"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 125)};
      $('nine_go_to_btn_3').innerHTML = "$150"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 150)};
      $('nine_go_to_btn_4').innerHTML = "$175"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 175)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$100e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 100)};
        $('nine_dbl_press_btn_2').innerHTML = "$125e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 125)};
      }
      break;
    case (amt == 80):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons');
      lineUp('nine_press_btn_1'); lineUp('nine_press_btn_3'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$100"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 100)};
      $('nine_go_to_btn_2').innerHTML = "$125"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 125)};
      $('nine_go_to_btn_3').innerHTML = "$150"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 150)};
      $('nine_go_to_btn_4').innerHTML = "+8 to $200"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 200)};
      break;
    case ((amt == 85) || (amt == 90) || (amt == 95)):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons');
      lineUp('nine_press_btn_1'); lineUp('nine_press_btn_3'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$100"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 100)};
      $('nine_go_to_btn_2').innerHTML = "$125"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 125)};
      $('nine_go_to_btn_3').innerHTML = "$150"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 150)};
      $('nine_go_to_btn_4').innerHTML = "$200"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 200)};
      break;
    case (amt == 100):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons');
      lineUp('nine_press_btn_2'); lineUp('nine_press_btn_3'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$125"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 125)};
      $('nine_go_to_btn_2').innerHTML = "$150"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 150)};
      $('nine_go_to_btn_3').innerHTML = "$200"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 200)};
      $('nine_go_to_btn_4').innerHTML = "+10 to $250"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 250)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$125e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 125)};
        $('nine_dbl_press_btn_2').innerHTML = "$150e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 150)};
      }
      break;
    case (amt == 105):
      $('nine_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " nine is if you are full pressing from a lower amount. If not, you should be pressing by $25 or $50. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$125"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 125)};
      $('nine_go_to_btn_2').innerHTML = "$150"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 150)};
      $('nine_go_to_btn_3').innerHTML = "$200"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 200)};
      $('nine_go_to_btn_4').innerHTML = "$250"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 250)};
      break;
    case (amt == 110):
      $('nine_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      $('nine_go_to_btn_1').innerHTML = "$125"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 125)};
      $('nine_go_to_btn_2').innerHTML = "$150"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 150)};
      $('nine_go_to_btn_3').innerHTML = "$200"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 200)};
      $('nine_go_to_btn_4').innerHTML = "$250"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 250)};
      break;
    case (amt == 115):
      $('nine_go_to_btn_1').innerHTML = "$125"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 125)};
      $('nine_go_to_btn_2').innerHTML = "$150"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 150)};
      $('nine_go_to_btn_3').innerHTML = "$200"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 200)};
      $('nine_go_to_btn_4').innerHTML = "$250"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 250)};
      break;
    case (amt == 120):
      $('nine_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Full pressers can shoot for the stars. Otherwise, you should be pressing by $25 or $50. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$125"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 125)};
      $('nine_go_to_btn_2').innerHTML = "$150"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 150)};
      $('nine_go_to_btn_3').innerHTML = "$200"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 200)};
      $('nine_go_to_btn_4').innerHTML = "$250"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 250)};
      break;
    case (amt == 125):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_2'); lineUp('nine_press_btn_3');
      $('nine_go_to_btn_1').innerHTML = "$150"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 150)};
      $('nine_go_to_btn_2').innerHTML = "$200"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 200)};
      $('nine_go_to_btn_3').innerHTML = "$250"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 250)};
      $('nine_go_to_btn_4').innerHTML = "$300"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 300)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$150e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 150)};
        $('nine_dbl_press_btn_2').innerHTML = "$200e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 200)};
      }
      break;
    case ((amt == 130) || (amt == 140)):
      $('nine_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Full pressers can shoot for the stars. Otherwise, you should be pressing by $25 or $50. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$150"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 150)};
      $('nine_go_to_btn_2').innerHTML = "$200"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 200)};
      $('nine_go_to_btn_3').innerHTML = "$250"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 250)};
      $('nine_go_to_btn_4').innerHTML = "$300"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 300)};
      break;
    case ((amt == 135) || (amt == 145)):
      $('nine_go_to_btn_1').innerHTML = "$150"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 150)};
      $('nine_go_to_btn_2').innerHTML = "$200"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 200)};
      $('nine_go_to_btn_3').innerHTML = "$250"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 250)};
      $('nine_go_to_btn_4').innerHTML = "$300"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 300)};
      break;
    case (amt == 150):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_2'); lineUp('nine_press_btn_3');
      $('nine_go_to_btn_1').innerHTML = "$200"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 200)};
      $('nine_go_to_btn_2').innerHTML = "$250"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 250)};
      $('nine_go_to_btn_3').innerHTML = "$300"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 300)};
      $('nine_go_to_btn_4').innerHTML = "$350"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 350)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$200e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 200)};
        $('nine_dbl_press_btn_2').innerHTML = "$250e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 250)};
      }
      break;
    case ((amt == 155) || (amt == 165)):
      $('nine_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " nine is if you are full pressing from a lower amount. If not, you should be pressing by $25 or $50. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$200"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 200)};
      $('nine_go_to_btn_2').innerHTML = "$250"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 250)};
      $('nine_go_to_btn_3').innerHTML = "$300"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 300)};
      $('nine_go_to_btn_4').innerHTML = "$350"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 350)};
      break;
    case (amt == 160):
      $('nine_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      $('nine_go_to_btn_1').innerHTML = "$200"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 200)};
      $('nine_go_to_btn_2').innerHTML = "$250"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 250)};
      $('nine_go_to_btn_3').innerHTML = "$300"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 300)};
      $('nine_go_to_btn_4').innerHTML = "$350"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 350)};
      break;
    case (amt == 170):
      $('nine_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      $('nine_go_to_btn_1').innerHTML = "$200"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 200)};
      $('nine_go_to_btn_2').innerHTML = "$250"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 250)};
      $('nine_go_to_btn_3').innerHTML = "$350"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 350)};
      $('nine_go_to_btn_4').innerHTML = "$400"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 400)};
      break;
    case (amt == 175):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_2'); lineUp('nine_press_btn_3');
      $('nine_go_to_btn_1').innerHTML = "$200"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 200)};
      $('nine_go_to_btn_2').innerHTML = "$250"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 250)};
      $('nine_go_to_btn_3').innerHTML = "$350"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 350)};
      $('nine_go_to_btn_4').innerHTML = "$400"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 400)};
      break;
    case (amt == 180):
      $('nine_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Full pressers can shoot for the stars. Otherwise, you should be pressing by $25 or $50. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$200"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 200)};
      $('nine_go_to_btn_2').innerHTML = "$250"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 250)};
      $('nine_go_to_btn_3').innerHTML = "$350"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 350)};
      $('nine_go_to_btn_4').innerHTML = "$400"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 400)};
      break;
    case (amt == 185):
      $('nine_go_to_btn_1').innerHTML = "$200"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 200)};
      $('nine_go_to_btn_2').innerHTML = "$250"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 250)};
      $('nine_go_to_btn_3').innerHTML = "$350"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 350)};
      $('nine_go_to_btn_4').innerHTML = "$400"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 400)};
      break;
    case (amt == 190): 
      $('nine_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Full pressers can shoot for the stars. Otherwise, you should be pressing by $25 or $50. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$200"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 200)};
      $('nine_go_to_btn_2').innerHTML = "$250"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 250)};
      $('nine_go_to_btn_3').innerHTML = "$350"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 350)};
      $('nine_go_to_btn_4').innerHTML = "$450"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 450)};
      break;
    case ((amt == 195) || (amt == 205)):
      $('nine_go_to_btn_1').innerHTML = "$200"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 200)};
      $('nine_go_to_btn_2').innerHTML = "$250"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 250)};
      $('nine_go_to_btn_3').innerHTML = "$350"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 350)};
      $('nine_go_to_btn_4').innerHTML = "$450"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 450)};
      break;
    case (amt == 200):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_3'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$250"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 250)};
      $('nine_go_to_btn_2').innerHTML = "$300"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 300)};
      $('nine_go_to_btn_3').innerHTML = "$400"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 400)};
      $('nine_go_to_btn_4').innerHTML = "+20 to $500"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 500)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$250e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 250)};
        $('nine_dbl_press_btn_2').innerHTML = "$300e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 300)};
        letsShow('nine_dble_btn_box_two');
        $('nine_dbl_press_btn_3').innerHTML = "+20 to $350e 5 &amp; 9"; $('nine_dbl_press_btn_3').onclick = function () {doubleUnitPress(9, 350)};
      }
      break;
    case ((amt == 210) || (amt == 220) || (amt == 230) || (amt == 235) || (amt == 245)):
      $('nine_go_to_btn_1').innerHTML = "$250"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 250)};
      $('nine_go_to_btn_2').innerHTML = "$300"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 300)};
      $('nine_go_to_btn_3').innerHTML = "$350"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 350)};
      $('nine_go_to_btn_4').innerHTML = "$500"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 500)};
      break;
    case ((amt == 215) || (amt == 225) || (amt == 240)):
      $('nine_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " nine is if you are full pressing from a lower amount. If not, you should be pressing by $50 or $100. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$250"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 250)};
      $('nine_go_to_btn_2').innerHTML = "$300"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 300)};
      $('nine_go_to_btn_3').innerHTML = "$350"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 350)};
      $('nine_go_to_btn_4').innerHTML = "$500"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 500)};
      break;
    case (amt == 250):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_3'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$300"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 300)};
      $('nine_go_to_btn_2').innerHTML = "$350"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 350)};
      $('nine_go_to_btn_3').innerHTML = "$500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 500)};
      $('nine_go_to_btn_4').innerHTML = "$600"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 600)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$300e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 300)};
        $('nine_dbl_press_btn_2').innerHTML = "$350e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 350)};
        letsShow('nine_dble_btn_box_two');
        $('nine_dbl_press_btn_3').innerHTML = "$400e 5 &amp; 9"; $('nine_dbl_press_btn_3').onclick = function () {doubleUnitPress(9, 400)};
      }
      break;
    case ((amt >= 255) && (amt <= 280)):
      $('nine_go_to_btn_1').innerHTML = "$300"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 300)};
      $('nine_go_to_btn_2').innerHTML = "$350"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 350)};
      $('nine_go_to_btn_3').innerHTML = "$500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 500)};
      $('nine_go_to_btn_4').innerHTML = "$600"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 600)};
      break;
    case (amt == 285):
      $('nine_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " nine is if you are full pressing from a lower amount. If not, you should be pressing by $50 or $100. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$300"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 300)};
      $('nine_go_to_btn_2').innerHTML = "$350"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 350)};
      $('nine_go_to_btn_3').innerHTML = "$500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 500)};
      $('nine_go_to_btn_4').innerHTML = "$600"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 600)};
      break;
    case ((amt == 290) || (amt == 295)):
      $('nine_go_to_btn_1').innerHTML = "$300"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 300)};
      $('nine_go_to_btn_2').innerHTML = "$350"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 350)};
      $('nine_go_to_btn_3').innerHTML = "$500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 500)};
      $('nine_go_to_btn_4').innerHTML = "$600"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 600)};
      break;
    case (amt == 300):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_3');
      $('nine_go_to_btn_1').innerHTML = "$350"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 350)};
      $('nine_go_to_btn_2').innerHTML = "$400"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 400)};
      $('nine_go_to_btn_3').innerHTML = "$500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 500)};
      $('nine_go_to_btn_4').innerHTML = "+30 to $750"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 750)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$350e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 350)};
        $('nine_dbl_press_btn_2').innerHTML = "$400e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 400)};
        letsShow('nine_dble_btn_box_two');
        $('nine_dbl_press_btn_3').innerHTML = "$500e 5 &amp; 9"; $('nine_dbl_press_btn_3').onclick = function () {doubleUnitPress(9, 500)};
      }
      break;
    case (amt == 305):
      $('nine_go_to_btn_1').innerHTML = "$350"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 350)};
      $('nine_go_to_btn_2').innerHTML = "$500"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 500)};
      $('nine_go_to_btn_3').innerHTML = "$600"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 600)};
      $('nine_go_to_btn_4').innerHTML = "$700"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 700)};
      break;
    case (amt == 310):
      $('nine_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " nine is if you are full pressing from a lower amount. If not, you should be pressing by $50 or $100. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$350"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 350)};
      $('nine_go_to_btn_2').innerHTML = "$500"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 500)};
      $('nine_go_to_btn_3').innerHTML = "$600"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 600)};
      $('nine_go_to_btn_4').innerHTML = "$700"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 700)};
      break;
    case ((amt == 315) || (amt == 320) || (amt == 325) || (amt == 330) || (amt == 340) || (amt == 345)):
      $('nine_go_to_btn_1').innerHTML = "$350"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 350)};
      $('nine_go_to_btn_2').innerHTML = "$500"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 500)};
      $('nine_go_to_btn_3').innerHTML = "$600"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 600)};
      $('nine_go_to_btn_4').innerHTML = "$750"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 750)};
      break;
    case (amt == 335):
      $('nine_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " nine is if you are full pressing from a lower amount. If not, you should be pressing by $50 or $100. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$350"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 350)};
      $('nine_go_to_btn_2').innerHTML = "$500"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 500)};
      $('nine_go_to_btn_3').innerHTML = "$600"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 600)};
      $('nine_go_to_btn_4').innerHTML = "$750"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 750)};
      break;
    case (amt == 350):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_3');
      $('nine_go_to_btn_1').innerHTML = "$400"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 400)};
      $('nine_go_to_btn_2').innerHTML = "$500"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 500)};
      $('nine_go_to_btn_3').innerHTML = "$600"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 600)};
      $('nine_go_to_btn_4').innerHTML = "$750"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 750)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$400e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 400)};
        $('nine_dbl_press_btn_2').innerHTML = "$500e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 500)};
        letsShow('nine_dble_btn_box_two');
        $('nine_dbl_press_btn_3').innerHTML = "$+10 $600e 5 &amp; 9"; $('nine_dbl_press_btn_3').onclick = function () {doubleUnitPress(9, 600)};
      }
      break;
    case ((amt >= 355) && (amt <= 365)):
    case ((amt >= 375) && (amt <= 390)):
      $('nine_go_to_btn_1').innerHTML = "$400"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 400)};
      $('nine_go_to_btn_2').innerHTML = "$500"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 500)};
      $('nine_go_to_btn_3').innerHTML = "$600"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 600)};
      $('nine_go_to_btn_4').innerHTML = "$750"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 750)};
      break;
    case ((amt == 370) || (amt == 395)):
      $('nine_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " nine is if you are full pressing from a lower amount. If not, you should be pressing by $50 or $100. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$400"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 400)};
      $('nine_go_to_btn_2').innerHTML = "$500"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 500)};
      $('nine_go_to_btn_3').innerHTML = "$600"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 600)};
      $('nine_go_to_btn_4').innerHTML = "$750"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 750)};
      break;
    case (amt == 400):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_3');
      $('nine_go_to_btn_1').innerHTML = "$500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 500)};
      $('nine_go_to_btn_2').innerHTML = "$600"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 600)};
      $('nine_go_to_btn_3').innerHTML = "$750"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 750)};
      $('nine_go_to_btn_4').innerHTML = "+40 to $1,000"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 1000)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$500e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 500)};
        $('nine_dbl_press_btn_2').innerHTML = "$600e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 600)}; 
      }
      break;
    case ((amt == 405) || (amt == 410) || (amt == 415)):
      $('nine_go_to_btn_1').innerHTML = "$450"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 450)};
      $('nine_go_to_btn_2').innerHTML = "$500"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 500)};
      $('nine_go_to_btn_3').innerHTML = "$600"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 600)};
      $('nine_go_to_btn_4').innerHTML = "$750"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 750)};
      break;
    case ((amt == 420) || (amt == 425)):
    case ((amt >= 435) && (amt <= 445)):
    case ((amt >= 460) && (amt <= 475)):
    case ((amt >= 485) && (amt <= 495)):
      $('nine_go_to_btn_1').innerHTML = "$500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 500)};
      $('nine_go_to_btn_2').innerHTML = "$600"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 600)};
      $('nine_go_to_btn_3').innerHTML = "$750"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 750)};
      $('nine_go_to_btn_4').innerHTML = "$1,000"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 1000)};
      break;
    case ((amt == 430) || (amt == 455) || (amt == 480)):
      $('nine_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " nine is if you are full pressing from a lower amount. If not, you should be pressing by $50 or $100. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 500)};
      $('nine_go_to_btn_2').innerHTML = "$600"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 600)};
      $('nine_go_to_btn_3').innerHTML = "$750"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 750)};
      $('nine_go_to_btn_4').innerHTML = "$1,000"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 1000)};
      break;
    case (amt == 450):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_3');
      $('nine_go_to_btn_1').innerHTML = "$500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 500)};
      $('nine_go_to_btn_2').innerHTML = "$600"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 600)};
      $('nine_go_to_btn_3').innerHTML = "$750"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 750)};
      $('nine_go_to_btn_4').innerHTML = "$1,000"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 1000)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$500e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 500)};
        $('nine_dbl_press_btn_2').innerHTML = "$600e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 600)}; 
        letsShow('nine_dble_btn_box_two');
        $('nine_dbl_press_btn_3').innerHTML = "$750e 5 &amp; 9"; $('nine_dbl_press_btn_3').onclick = function () {doubleUnitPress(9, 750)};
      }
      break;
    case (amt == 500):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_3');
      $('nine_go_to_btn_1').innerHTML = "$600"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 600)};
      $('nine_go_to_btn_2').innerHTML = "$750"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 750)};
      $('nine_go_to_btn_3').innerHTML = "$900"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 900)};
      $('nine_go_to_btn_4').innerHTML = "$1,000"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 1000)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$600e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 600)};
        $('nine_dbl_press_btn_2').innerHTML = "$750e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 750)}; 
      }
      break;
    case ((amt == 505) || (amt == 510)):
    case ((amt >= 520) && (amt <= 535)):
    case ((amt >= 545) && (amt <= 570)):
    case ((amt >= 580) && (amt <= 595)):
      $('nine_go_to_btn_1').innerHTML = "$600"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 600)};
      $('nine_go_to_btn_2').innerHTML = "$750"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 750)};
      $('nine_go_to_btn_3').innerHTML = "$900"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 900)};
      $('nine_go_to_btn_4').innerHTML = "$1,000"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 1000)};
      break;
    case ((amt == 515) || (amt == 540) || (amt == 575)):
      $('nine_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " nine is if you are full pressing from a lower amount. If not, you should be pressing by $50 or $100. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$600"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 600)};
      $('nine_go_to_btn_2').innerHTML = "$750"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 750)};
      $('nine_go_to_btn_3').innerHTML = "$900"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 900)};
      $('nine_go_to_btn_4').innerHTML = "$1,000"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 1000)};
      break;
    case (amt == 600):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$750"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 750)};
      $('nine_go_to_btn_2').innerHTML = "$900"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 900)};
      $('nine_go_to_btn_3').innerHTML = "$1,000"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 1000)};
      $('nine_go_to_btn_4').innerHTML = "+60 to $1,500"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 1500)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$750e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 750)};
        $('nine_dbl_press_btn_2').innerHTML = "$1,000e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 1000)}; 
      }
      break;
    case ((amt >= 605) && (amt <= 620)):
      letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$750"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 750)};
      $('nine_go_to_btn_2').innerHTML = "$900"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 900)};
      $('nine_go_to_btn_3').innerHTML = "$1,000"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 1000)};
      break;
    case ((amt >= 625) && (amt <= 675)):
    case ((amt >= 685) && (amt <= 695)):
    case ((amt >= 705) && (amt <= 735)):
    case (amt == 745):
      $('nine_go_to_btn_1').innerHTML = "$750"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 750)};
      $('nine_go_to_btn_2').innerHTML = "$900"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 900)};
      $('nine_go_to_btn_3').innerHTML = "$1,000"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 1000)};
      $('nine_go_to_btn_4').innerHTML = "$1,500"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 1500)};
      break;
    case (amt == 680):
      $('nine_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " nine is if you are full pressing from a lower amount. If not, you should be pressing by $50 or $100. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$750"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 750)};
      $('nine_go_to_btn_2').innerHTML = "$900"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 900)};
      $('nine_go_to_btn_3').innerHTML = "$1,000"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 1000)};
      $('nine_go_to_btn_4').innerHTML = "$1,500"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 1500)};
      break;
    case (amt == 700):
      $('nine_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$750"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 750)};
      $('nine_go_to_btn_2').innerHTML = "$1,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 1000)};
      $('nine_go_to_btn_3').innerHTML = "$1,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 1500)};
      break;
    case (amt == 740):
      $('nine_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " nine is if you are full pressing from a lower amount. If not, you should be pressing by at least $100. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$750"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 750)};
      $('nine_go_to_btn_2').innerHTML = "$1,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 1000)};
      $('nine_go_to_btn_3').innerHTML = "$1,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 1500)};
      break;
    case (amt == 750):
      letsHide('nine_pay_disclaimer');
      letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$900"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 900)};
      $('nine_go_to_btn_2').innerHTML = "$1,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 1000)};
      $('nine_go_to_btn_3').innerHTML = "$1,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 1500)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); 
        $('nine_dbl_press_btn_1').innerHTML = "$1,000e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 1000)}; 
      }
      break;
    case ((amt >= 755) && (amt <= 795)):
    case ((amt >= 805) && (amt <= 830)):
      letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$900"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 900)};
      $('nine_go_to_btn_2').innerHTML = "$1,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 1000)};
      $('nine_go_to_btn_3').innerHTML = "$1,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 1500)};
      break;
    case (amt == 800):
      $('nine_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Full pressers can shoot for the stars. Otherwise, you should be pressing by $25 or $50. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$900"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 900)};
      $('nine_go_to_btn_2').innerHTML = "$1,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 1000)};
      $('nine_go_to_btn_3').innerHTML = "$1,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 1500)};
      break;
    case ((amt >= 835) && (amt <= 880)):
    case ((amt == 890) || (amt == 895)):
    case ((amt >= 905) && (amt <= 940)):
    case ((amt >= 950) && (amt <= 995)):
      letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$1,000"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 1000)};
      $('nine_go_to_btn_2').innerHTML = "$1,500"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 1500)};
      $('nine_go_to_btn_3').innerHTML = "$2,000"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 2000)};
      break;
    case ((amt == 885) || (amt == 945)):
      $('nine_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " nine is if you are full pressing from a lower amount. If not, you should be pressing by at least $100 or $500. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$1,000"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 1000)};
      $('nine_go_to_btn_2').innerHTML = "$1,500"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 1500)};
      $('nine_go_to_btn_3').innerHTML = "$2,000"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 2000)};
      break;
    case (amt == 900):
      letsHide('nine_pay_disclaimer');
      letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$1,000"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 1000)};
      $('nine_go_to_btn_2').innerHTML = "$1,500"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 1500)};
      $('nine_go_to_btn_3').innerHTML = "$2,000"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 2000)};
      break;
    case (amt == 1000):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_3');
      letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$1,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 1500)};
      $('nine_go_to_btn_2').innerHTML = "$2,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 2000)};
      $('nine_go_to_btn_3').innerHTML = "+100 to $2,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 2500)};
      if(equalUnits) {
        letsShow('place_nine_dble_box');
        $('nine_dbl_press_btn_1').innerHTML = "$1,500e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 1500)};
      }
      break;
    case ((amt >= 1005) && (amt <= 1025)):
    case ((amt == 1035) || (amt == 1040)):
      letsHide('nine_go_to_btn_3'); letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$1,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 1500)};
      $('nine_go_to_btn_2').innerHTML = "$2,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 2000)};
      break;
    case (amt == 1030):
      $('nine_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " nine is if you are full pressing from a lower amount. If not, you should probably be pressing by $500 or so. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      letsHide('nine_go_to_btn_3'); letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$1,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 1500)};
      $('nine_go_to_btn_2').innerHTML = "$2,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 2000)};
      break;
    case ((amt >= 1045) && (amt <= 1085)):
    case ((amt >= 1095) && (amt <= 1145)):
    case ((amt >= 1155) && (amt <= 1230)):
    case ((amt == 1240) || (amt == 1245)):
      letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$1,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 1500)};
      $('nine_go_to_btn_2').innerHTML = "$2,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 2000)};
      $('nine_go_to_btn_3').innerHTML = "$2,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 2500)};
      break;
    case ((amt == 1090) || (amt == 1150) || (amt == 1235)):
      $('nine_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " nine is if you are full pressing from a lower amount. If not, you should probably be pressing by $500 or so. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$1,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 1500)};
      $('nine_go_to_btn_2').innerHTML = "$2,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 2000)};
      $('nine_go_to_btn_3').innerHTML = "$2,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 2500)};
      break;
    case ((amt >= 1250) && (amt <= 1290)):
    case ((amt >= 1300) && (amt <= 1375)):
    case ((amt >= 1385) && (amt <= 1435)):
    case ((amt >= 1445) && (amt <= 1495)):
      $('nine_go_to_btn_1').innerHTML = "$1,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 1500)};
      $('nine_go_to_btn_2').innerHTML = "$2,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 2000)};
      $('nine_go_to_btn_3').innerHTML = "$2,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 2500)};
      $('nine_go_to_btn_4').innerHTML = "$3,000"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 3000)};
      break;
    case (amt == 1440):
      $('nine_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " nine is if you are full pressing from a lower amount. If not, you should be pressing by $25 or $50. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$1,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 1500)};
      $('nine_go_to_btn_2').innerHTML = "$2,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 2000)};
      $('nine_go_to_btn_3').innerHTML = "$2,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 2500)};
      $('nine_go_to_btn_4').innerHTML = "$3,000"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 3000)};
      break;
    case ((amt == 1295) || (amt == 1380)):
      $('nine_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " nine is if you are full pressing from a lower amount. If not, you should probably be pressing by $500 or so. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$1,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 1500)};
      $('nine_go_to_btn_2').innerHTML = "$2,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 2000)};
      $('nine_go_to_btn_3').innerHTML = "$2,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 2500)};
      $('nine_go_to_btn_4').innerHTML = "$3,000"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 3000)};
      break;
    case (amt == 1500):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_3');
      $('nine_go_to_btn_1').innerHTML = "$2,000"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 2000)};
      $('nine_go_to_btn_2').innerHTML = "$2,500"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 2500)};
      $('nine_go_to_btn_3').innerHTML = "$3,000"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 3000)};
      $('nine_go_to_btn_4').innerHTML = "$3,500"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 3500)};
      if(equalUnits) {
        letsShow('place_nine_dble_box'); letsUnmask('nine_dbl_press_btn_2');
        $('nine_dbl_press_btn_1').innerHTML = "$2,000e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 2000)};
        $('nine_dbl_press_btn_2').innerHTML = "$2,500e 5 &amp; 9"; $('nine_dbl_press_btn_2').onclick = function () {doubleUnitPress(9, 2500)};
      }
      break;
    case ((amt >= 1505) && (amt <= 1625)):
    case ((amt >= 1635) && (amt <= 1665)):
      $('nine_go_to_btn_1').innerHTML = "$2,000"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 2000)};
      $('nine_go_to_btn_2').innerHTML = "$2,500"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 2500)};
      $('nine_go_to_btn_3').innerHTML = "$3,000"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 3000)};
      $('nine_go_to_btn_4').innerHTML = "$3,500"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 3500)};
      break;
    case (amt == 1630):
      $('nine_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " nine is if you are full pressing from a lower amount. If not, you should probably be pressing by $500 or so. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$2,000"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 2000)};
      $('nine_go_to_btn_2').innerHTML = "$2,500"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 2500)};
      $('nine_go_to_btn_3').innerHTML = "$3,000"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 3000)};
      $('nine_go_to_btn_4').innerHTML = "$3,500"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 3500)};
      break;
    case ((amt >= 1670) && (amt <= 1770)):
    case ((amt >= 1780) && (amt <= 1795)):
    case ((amt >= 1805) && (amt <= 1870)):
      $('nine_go_to_btn_1').innerHTML = "$2,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 2500)};
      $('nine_go_to_btn_2').innerHTML = "$3,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 3000)};
      $('nine_go_to_btn_3').innerHTML = "$3,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 3500)};
      $('nine_go_to_btn_4').innerHTML = "$4,000"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 4000)};
      break;
    case (amt == 1800):
      $('nine_pay_disclaimer').innerHTML = "If only pressing, you should move to a normal amount now. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      $('nine_go_to_btn_1').innerHTML = "$2,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 2500)};
      $('nine_go_to_btn_2').innerHTML = "$3,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 3000)};
      $('nine_go_to_btn_3').innerHTML = "$3,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 3500)};
      $('nine_go_to_btn_4').innerHTML = "$4,000"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 4000)};
      break;
    case (amt == 1775):
      $('nine_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " nine is if you are full pressing from a lower amount. If not, you should probably be pressing by $500 or so. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$2,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 2500)};
      $('nine_go_to_btn_2').innerHTML = "$3,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 3000)};
      $('nine_go_to_btn_3').innerHTML = "$3,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 3500)};
      $('nine_go_to_btn_4').innerHTML = "$4,000"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 4000)};
      break;
    case ((amt >= 1875) && (amt <= 1915)):
    case ((amt >= 1925) && (amt <= 1995)):
    case ((amt >= 2005) && (amt <= 2080)):
      $('nine_go_to_btn_1').innerHTML = "$2,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 2500)};
      $('nine_go_to_btn_2').innerHTML = "$3,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 3000)};
      $('nine_go_to_btn_3').innerHTML = "$3,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 3500)};
      $('nine_go_to_btn_4').innerHTML = "$4,500"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 4500)};
      break;
    case (amt == 1920):
      $('nine_pay_disclaimer').innerHTML = "One reason to be at $" + amt + " nine is if you are full pressing from a lower amount. If not, you should probably be pressing by $500 or so. Try the bets in the 'Go to ' menus to help the game run more efficiently.";
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$2,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 2500)};
      $('nine_go_to_btn_2').innerHTML = "$3,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 3000)};
      $('nine_go_to_btn_3').innerHTML = "$3,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 3500)};
      $('nine_go_to_btn_4').innerHTML = "$4,500"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 4500)};
      break;
    case (amt == 2000):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_3');
      $('nine_go_to_btn_1').innerHTML = "$2,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 2500)};
      $('nine_go_to_btn_2').innerHTML = "$3,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 3000)};
      $('nine_go_to_btn_3').innerHTML = "$3,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 3500)};
      $('nine_go_to_btn_4').innerHTML = "$4,500"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 4500)};
      if(equalUnits) {
        letsShow('place_nine_dble_box');
        $('nine_dbl_press_btn_1').innerHTML = "$2,500e 5 &amp; 9"; $('nine_dbl_press_btn_1').onclick = function () {doubleUnitPress(9, 2500)};
      }
      break;
    case ((amt >= 2085) && (amt <= 2115)):
    case ((amt >= 2125) && (amt <= 2260)):
    case ((amt >= 2270) && (amt <= 2465)):
    case ((amt >= 2475) && (amt <= 2495)):
      $('nine_go_to_btn_1').innerHTML = "$2,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 2500)};
      $('nine_go_to_btn_2').innerHTML = "$3,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 3000)};
      $('nine_go_to_btn_3').innerHTML = "$3,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 3500)};
      $('nine_go_to_btn_4').innerHTML = "$4,000"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 4000)};
      letsShow('nine_tbl_max_btn');
      break;
    case ((amt == 2265) || (amt == 2120) || (amt == 2470)):
      $('nine_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      $('nine_go_to_btn_1').innerHTML = "$2,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 2500)};
      $('nine_go_to_btn_2').innerHTML = "$3,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 3000)};
      $('nine_go_to_btn_3').innerHTML = "$3,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 3500)};
      $('nine_go_to_btn_4').innerHTML = "$4,000"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 4000)};
      letsShow('nine_tbl_max_btn');
      break;
    case (amt == 2500):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_3');
      $('nine_go_to_btn_1').innerHTML = "$3,000"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 3000)};
      $('nine_go_to_btn_2').innerHTML = "$3,500"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 3500)};
      $('nine_go_to_btn_3').innerHTML = "$4,000"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 4000)};
      $('nine_go_to_btn_4').innerHTML = "$4,500"; $('nine_go_to_btn_4').onclick = function () {goTo(9, 4500)};
      letsShow('nine_tbl_max_btn');
      break;
    case ((amt >= 2505) && (amt <= 2610)):
    case ((amt >= 2620) && (amt <= 2755)):
    case ((amt >= 2765) && (amt <= 2955)):
    case ((amt >= 2965) && (amt <= 2995)):
      letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$3,000"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 3000)};
      $('nine_go_to_btn_2').innerHTML = "$3,500"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 3500)};
      $('nine_go_to_btn_3').innerHTML = "$4,000"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 4000)};
      letsShow('nine_tbl_max_btn');
      break;
    case ((amt == 2615) || (amt == 2760) || (amt == 2960)):
      $('nine_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$3,000"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 3000)};
      $('nine_go_to_btn_2').innerHTML = "$3,500"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 3500)};
      $('nine_go_to_btn_3').innerHTML = "$4,000"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 4000)};
      letsShow('nine_tbl_max_btn');
      break;
    case (amt == 3000):
      letsHide('nine_pay_disclaimer');
      letsShow('nine_press_buttons'); lineUp('nine_press_btn_3');
      letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$3,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 3500)};
      $('nine_go_to_btn_2').innerHTML = "$4,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 4000)};
      $('nine_go_to_btn_3').innerHTML = "$4,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 4500)};
      letsShow('nine_tbl_max_btn');
      break;
    case ((amt >= 3005) && (amt <= 3100)):
    case ((amt >= 3110) && (amt <= 3305)):
    case ((amt >= 3315) && (amt <= 3450)):
    case ((amt >= 3460) && (amt <= 3495)):
      letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$3,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 3500)};
      $('nine_go_to_btn_2').innerHTML = "$4,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 4000)};
      $('nine_go_to_btn_3').innerHTML = "$4,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 4500)};
      letsShow('nine_tbl_max_btn');
      break;
    case ((amt == 3105) || (amt == 3310) || (amt == 3455)): 
      $('nine_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$3,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 3500)};
      $('nine_go_to_btn_2').innerHTML = "$4,000"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 4000)};
      $('nine_go_to_btn_3').innerHTML = "$4,500"; $('nine_go_to_btn_3').onclick = function () {goTo(9, 4500)};
      letsShow('nine_tbl_max_btn');
      break;
    case (amt == 3500):
      letsHide('nine_pay_disclaimer');
      letsHide('nine_go_to_btn_3'); letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$4,000"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 4000)};
      $('nine_go_to_btn_2').innerHTML = "$4,500"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 4500)};
      letsShow('nine_tbl_max_btn');
      break;
    case ((amt >= 3505) && (amt <= 3905)):
    case ((amt >= 3915) && (amt <= 3995)):
      letsHide('nine_go_to_btn_3'); letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$4,000"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 4000)};
      $('nine_go_to_btn_2').innerHTML = "$4,500"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 4500)};
      letsShow('nine_tbl_max_btn');
      break;
    case (amt == 3910):
      $('nine_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      letsHide('nine_go_to_btn_3'); letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$4,000"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 4000)};
      $('nine_go_to_btn_2').innerHTML = "$4,500"; $('nine_go_to_btn_2').onclick = function () {goTo(9, 4500)};
      letsShow('nine_tbl_max_btn');
      break;
    case (amt == 4000):
      letsHide('nine_pay_disclaimer');
      letsHide('nine_go_to_btn_2'); letsHide('nine_go_to_btn_3'); letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$4,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 4500)};
      letsShow('nine_tbl_max_btn');
      break;
    case ((amt >= 4005) && (amt <= 4255)):
    case ((amt >= 4265) && (amt <= 4495)):
      letsHide('nine_go_to_btn_2'); letsHide('nine_go_to_btn_3'); letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$4,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 4500)};
      letsShow('nine_tbl_max_btn');
      break;
    case (amt == 4260):
      $('nine_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      letsHide('nine_go_to_btn_2'); letsHide('nine_go_to_btn_3'); letsHide('nine_go_to_btn_4');
      $('nine_go_to_btn_1').innerHTML = "$4,500"; $('nine_go_to_btn_1').onclick = function () {goTo(9, 4500)};
      letsShow('nine_tbl_max_btn');
      break;
    case (amt == 4500):
      letsHide('nine_pay_disclaimer');
      letsHide('nine_go_to_buttons');
      letsShow('nine_tbl_max_btn');
      break;
    case ((amt >= 4505) && (amt <= 4600)):
    case ((amt >= 4610) && (amt <= 4995)):
      letsHide('nine_go_to_buttons');
      letsShow('nine_tbl_max_btn');
      break;
    case (amt == 4605):
      $('nine_pay_disclaimer').innerHTML = "If you're full pressing then you're gonna hit table max right now!";
      letsHide('nine_go_to_buttons');
      letsShow('nine_tbl_max_btn');
      break;
    case (amt == 5000):
      $('nine_pay_disclaimer').innerHTML = "You hit at table max!! If you want to put even more on the table you can start making Come bets and double dip your way up to max Come bet and max Odds! Another... $25,000 ($5K with $20K odds ) to win 35K plus your 7K here is a 42K potential max win on the 9. That's when we get Come Bets which are coming soon.";
      letsHide('nine_go_to_buttons');
      break;
    default: return
  }
}
function showPlaceTenBtns (amt) {
  letsShow('ten_pay_disclaimer');
  $('ten_pay_disclaimer').innerHTML = "Try and stick to bets in normal increments. Use the 'Go to ' menu for normal betting amounts.";
  letsHide('ten_press_buttons');
  letsHide('ten_press_btn_1'); letsHide('ten_press_btn_2'); letsHide('ten_press_btn_3'); letsHide('ten_press_btn_4');
  lineUp('ten_go_to_btn_3'); lineUp('ten_go_to_btn_4');
  letsHide('ten_tbl_max_btn');
  letsHide('place_ten_dble_box');
  letsMask('ten_dbl_press_btn_2');
  letsHide('ten_dble_btn_box_two');
  letsMask('ten_dbl_press_btn_4');
  var equalUnits = theFour.placeBet == theTen.placeBet;
  if (theTen.hasBuy) {
    $('ten_same_bet_btn').innerHTML = "$" + (amt * 2) + " for $" + theTen.vig + " - Same Bet";
  }
  switch (true) {
    case (amt == 5):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons');
      lineUp('ten_press_btn_1'); lineUp('ten_press_btn_3');
      letsHide('ten_go_to_btn_3'); letsHide('ten_go_to_btn_4');
      $('ten_go_to_btn_1').innerHTML = "$10"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 10)};
      $('ten_go_to_btn_2').innerHTML = "+1 to $15"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 15)};
      if(equalUnits) {
        letsShow('place_ten_dble_box');
        $('ten_dbl_press_btn_1').innerHTML = "+1 to $10e 4 &amp; 10"; $('ten_dbl_press_btn_1').onclick = function () {doubleUnitPress(10, 10)};
      }
      break;
    case (amt == 10):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons');
      lineUp('ten_press_btn_1');
      letsHide('ten_go_to_btn_4');
      $('ten_go_to_btn_1').innerHTML = "$15"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 15)};
      $('ten_go_to_btn_2').innerHTML = "b$20"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 20)};
      $('ten_go_to_btn_3').innerHTML = "b$25"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 25)};
      if(equalUnits) {
        letsShow('place_ten_dble_box');
        $('ten_dbl_press_btn_1').innerHTML = "$15e 4 &amp; 10"; $('ten_dbl_press_btn_1').onclick = function () {doubleUnitPress(10, 15)};
      }
      break;
    case (amt == 15): 
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons');
      lineUp('ten_press_btn_1');
      $('ten_go_to_btn_1').innerHTML = "b$20"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 20)};
      $('ten_go_to_btn_2').innerHTML = "b$25"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 25)};
      $('ten_go_to_btn_3').innerHTML = "b$35"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 35)};
      $('ten_go_to_btn_4').innerHTML = "b$40"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 40)};
      if(equalUnits) {
        letsShow('place_ten_dble_box'); letsUnmask('ten_dbl_press_btn_2');
        $('ten_dbl_press_btn_1').innerHTML = "b$20e 4 &amp; 10"; $('ten_dbl_press_btn_1').onclick = function () {doubleUnitPress(10, 20)};
        $('ten_dbl_press_btn_2').innerHTML = "b$25e 4 &amp; 10"; $('ten_dbl_press_btn_2').onclick = function () {doubleUnitPress(10, 25)};
      }
      break;
    case (amt == 20):
      letsHide('ten_pay_disclaimer'); 
      letsShow('ten_press_buttons');
      lineUp('ten_press_btn_1'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$25"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 25)};
      $('ten_go_to_btn_2').innerHTML = "b$35"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 35)};
      $('ten_go_to_btn_3').innerHTML = "b$50"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 50)};
      $('ten_go_to_btn_4').innerHTML = "+3 to b$60"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 60)};
      if(equalUnits) {
        letsShow('place_ten_dble_box'); letsUnmask('ten_dbl_press_btn_2');
        $('ten_dbl_press_btn_1').innerHTML = "$25e 4 &amp; 10"; $('ten_dbl_press_btn_1').onclick = function () {doubleUnitPress(10, 25)};
        $('ten_dbl_press_btn_2').innerHTML = "$30e 4 &amp; 10"; $('ten_dbl_press_btn_2').onclick = function () {doubleUnitPress(10, 30)};
        letsShow('ten_dble_btn_box_two'); letsUnmask('ten_dbl_press_btn_4');
        $('ten_dbl_press_btn_3').innerHTML = "$35e 4 &amp; 10"; $('ten_dbl_press_btn_3').onclick = function () {doubleUnitPress(10, 35)};
        $('ten_dbl_press_btn_4').innerHTML = "+3 to $40e 4 &amp; 10"; $('ten_dbl_press_btn_4').onclick = function () {doubleUnitPress(10, 40)};
      }
      break;
    case ((amt >= 21) && (amt <= 24)):
      $('ten_go_to_btn_1').innerHTML = "b$25"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 25)};
      $('ten_go_to_btn_2').innerHTML = "b$30"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 30)};
      $('ten_go_to_btn_3').innerHTML = "b$40"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 40)};
      $('ten_go_to_btn_4').innerHTML = "b$50"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 50)};
      break;
    case (amt == 25):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons');
      lineUp('ten_press_btn_1'); lineUp('ten_press_btn_2'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$30"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 30)};
      $('ten_go_to_btn_2').innerHTML = "b$35"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 35)};
      $('ten_go_to_btn_3').innerHTML = "b$50"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 50)};
      $('ten_go_to_btn_4').innerHTML = "+3 to b$75"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 75)};
      if(equalUnits) {
        letsShow('place_ten_dble_box'); letsUnmask('ten_dbl_press_btn_2');
        $('ten_dbl_press_btn_1').innerHTML = "$30e 4 &amp; 10"; $('ten_dbl_press_btn_1').onclick = function () {doubleUnitPress(10, 30)};
        $('ten_dbl_press_btn_2').innerHTML = "$35e 4 &amp; 10"; $('ten_dbl_press_btn_2').onclick = function () {doubleUnitPress(10, 35)};
        letsShow('ten_dble_btn_box_two'); letsUnmask('ten_dbl_press_btn_4');
        $('ten_dbl_press_btn_3').innerHTML = "$40e 4 &amp; 10"; $('ten_dbl_press_btn_3').onclick = function () {doubleUnitPress(10, 40)};
        $('ten_dbl_press_btn_4').innerHTML = "+3 to $50e 4 &amp; 10"; $('ten_dbl_press_btn_4').onclick = function () {doubleUnitPress(10, 50)};
      }
      break;
    case ((amt >= 26) && (amt <= 29)):
      $('ten_go_to_btn_1').innerHTML = "b$30"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 30)};
      $('ten_go_to_btn_2').innerHTML = "b$35"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 35)};
      $('ten_go_to_btn_3').innerHTML = "b$50"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 50)};
      $('ten_go_to_btn_4').innerHTML = "b$60"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 60)};
      break;
    case (amt == 30):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons');
      lineUp('ten_press_btn_1'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$35"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 35)};
      $('ten_go_to_btn_2').innerHTML = "b$50"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 50)};
      $('ten_go_to_btn_3').innerHTML = "b$75"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 75)};
      $('ten_go_to_btn_4').innerHTML = "+3 to b$90"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 90)};
      if(equalUnits) {
        letsShow('place_ten_dble_box'); letsUnmask('ten_dbl_press_btn_2');
        $('ten_dbl_press_btn_1').innerHTML = "$35e 4 &amp; 10"; $('ten_dbl_press_btn_1').onclick = function () {doubleUnitPress(10, 35)};
        $('ten_dbl_press_btn_2').innerHTML = "$40e 4 &amp; 10"; $('ten_dbl_press_btn_2').onclick = function () {doubleUnitPress(10, 40)};
        letsShow('ten_dble_btn_box_two');
        $('ten_dbl_press_btn_3').innerHTML = "$50e 4 &amp; 10"; $('ten_dbl_press_btn_3').onclick = function () {doubleUnitPress(10, 50)};
      }
      break;
    case ((amt >= 31) && (amt <= 34)):
      $('ten_go_to_btn_1').innerHTML = "b$35"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 35)};
      $('ten_go_to_btn_2').innerHTML = "b$50"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 50)};
      $('ten_go_to_btn_3').innerHTML = "b$60"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 60)};
      $('ten_go_to_btn_4').innerHTML = "b$75"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 75)};
      break;
    case (amt == 35):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons');
      lineUp('ten_press_btn_1'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$40"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 40)};
      $('ten_go_to_btn_2').innerHTML = "b$50"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 50)};
      $('ten_go_to_btn_3').innerHTML = "b$75"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 75)};
      $('ten_go_to_btn_4').innerHTML = "b$100"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 100)};
      if(equalUnits) {
        letsShow('place_ten_dble_box'); letsUnmask('ten_dbl_press_btn_2');
        $('ten_dbl_press_btn_1').innerHTML = "$40e 4 &amp; 10"; $('ten_dbl_press_btn_1').onclick = function () {doubleUnitPress(10, 40)};
        $('ten_dbl_press_btn_2').innerHTML = "$50e 4 &amp; 10"; $('ten_dbl_press_btn_2').onclick = function () {doubleUnitPress(10, 50)};
      }
      break;
    case ((amt >= 36) && (amt <= 39)):
      $('ten_go_to_btn_1').innerHTML = "b$40"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 40)};
      $('ten_go_to_btn_2').innerHTML = "b$50"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 50)};
      $('ten_go_to_btn_3').innerHTML = "b$75"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 75)};
      $('ten_go_to_btn_4').innerHTML = "b$100"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 100)};
      break;
    case (amt == 40):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons');
      lineUp('ten_press_btn_1'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$50"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 50)};
      $('ten_go_to_btn_2').innerHTML = "b$75"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 75)};
      $('ten_go_to_btn_3').innerHTML = "b$100"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 100)};
      $('ten_go_to_btn_4').innerHTML = "+6 to b$120"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 120)};
      if(equalUnits) {
        letsShow('place_ten_dble_box'); letsUnmask('ten_dbl_press_btn_2');
        $('ten_dbl_press_btn_1').innerHTML = "$50e 4 &amp; 10"; $('ten_dbl_press_btn_1').onclick = function () {doubleUnitPress(10, 50)};
        $('ten_dbl_press_btn_2').innerHTML = "$75e 4 &amp; 10"; $('ten_dbl_press_btn_2').onclick = function () {doubleUnitPress(10, 75)};
      }
      break;
    case ((amt >= 41) && (amt <= 44)):
      $('ten_go_to_btn_1').innerHTML = "b$50"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 50)};
      $('ten_go_to_btn_2').innerHTML = "b$60"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 60)};
      $('ten_go_to_btn_3').innerHTML = "b$75"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 75)};
      $('ten_go_to_btn_4').innerHTML = "b$100"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 100)};
      break;
    case (amt == 45):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons');
      lineUp('ten_press_btn_1'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$50"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 50)};
      $('ten_go_to_btn_2').innerHTML = "b$75"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 75)};
      $('ten_go_to_btn_3').innerHTML = "b$100"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 100)};
      $('ten_go_to_btn_4').innerHTML = "b$125"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 125)};
      break;
    case ((amt >= 46) && (amt <= 49)):
      $('ten_go_to_btn_1').innerHTML = "b$50"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 50)};
      $('ten_go_to_btn_2').innerHTML = "b$75"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 75)};
      $('ten_go_to_btn_3').innerHTML = "b$100"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 100)};
      $('ten_go_to_btn_4').innerHTML = "b$125"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 125)};
      break;
    case (amt == 50):
      letsHide('ten_pay_disclaimer'); 
      letsShow('ten_press_buttons');
      lineUp('ten_press_btn_2'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$75"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 75)};
      $('ten_go_to_btn_2').innerHTML = "b$100"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 100)};
      $('ten_go_to_btn_3').innerHTML = "b$125"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 125)};
      if (money.extraVig == 0 ) {
        $('ten_go_to_btn_4').innerHTML = "+7 to b$150"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 150)};
      } else {
        $('ten_go_to_btn_4').innerHTML = "+6 to b$150"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 150)};
      }
      if(equalUnits) {
        letsShow('place_ten_dble_box'); letsUnmask('ten_dbl_press_btn_2');
        $('ten_dbl_press_btn_1').innerHTML = "$75e 4 &amp; 10"; $('ten_dbl_press_btn_1').onclick = function () {doubleUnitPress(10, 75)};
        if (money.extraVig == 0) {
          $('ten_dbl_press_btn_2').innerHTML = "+8 to $100e 4 &amp; 10"; $('ten_dbl_press_btn_2').onclick = function () {doubleUnitPress(10, 100)};
        } else {
          $('ten_dbl_press_btn_2').innerHTML = "+7 to $100e 4 &amp; 10"; $('ten_dbl_press_btn_2').onclick = function () {doubleUnitPress(10, 100)};
        }
      }
      break;
    case ((amt >= 51) && (amt <= 54)):
      $('ten_go_to_btn_1').innerHTML = "b$60"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 60)};
      $('ten_go_to_btn_2').innerHTML = "b$75"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 75)};
      $('ten_go_to_btn_3').innerHTML = "b$100"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 100)};
      $('ten_go_to_btn_4').innerHTML = "b$125"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 125)};
      break;
    case (amt == 55):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons');
      lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$75"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 75)};
      $('ten_go_to_btn_2').innerHTML = "b$100"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 100)};
      $('ten_go_to_btn_3').innerHTML = "b$125"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 125)};
      $('ten_go_to_btn_4').innerHTML = "b$150"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 150)};
      break;
    case ((amt >= 56) && (amt <= 59)):
      $('ten_go_to_btn_1').innerHTML = "b$75"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 75)};
      $('ten_go_to_btn_2').innerHTML = "b$100"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 100)};
      $('ten_go_to_btn_3').innerHTML = "b$125"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 125)};
      $('ten_go_to_btn_4').innerHTML = "b$150"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 150)};
      break;
    case (amt == 60):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons');
      lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$75"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 75)};
      $('ten_go_to_btn_2').innerHTML = "b$100"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 100)};
      $('ten_go_to_btn_3').innerHTML = "b$125"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 125)};
      $('ten_go_to_btn_4').innerHTML = "b$150"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 150)};
      break;
    case ((amt >= 61) && (amt <= 64)):
      $('ten_go_to_btn_1').innerHTML = "b$75"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 75)};
      $('ten_go_to_btn_2').innerHTML = "b$100"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 100)};
      $('ten_go_to_btn_3').innerHTML = "b$125"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 125)};
      $('ten_go_to_btn_4').innerHTML = "b$150"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 150)};
      break;
    case (amt == 65):
      letsHide('ten_pay_disclaimer');
      $('ten_go_to_btn_1').innerHTML = "b$75"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 75)};
      $('ten_go_to_btn_2').innerHTML = "b$100"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 100)};
      $('ten_go_to_btn_3').innerHTML = "b$125"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 125)};
      $('ten_go_to_btn_4').innerHTML = "b$150"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 150)};
      break;
    case ((amt >= 66) && (amt <= 69)):
      $('ten_go_to_btn_1').innerHTML = "b$75"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 75)};
      $('ten_go_to_btn_2').innerHTML = "b$100"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 100)};
      $('ten_go_to_btn_3').innerHTML = "b$125"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 125)};
      $('ten_go_to_btn_4').innerHTML = "b$150"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 150)};
      break;
    case (amt == 70):
      letsHide('ten_pay_disclaimer');
      $('ten_go_to_btn_1').innerHTML = "b$100"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 100)};
      $('ten_go_to_btn_2').innerHTML = "b$125"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 125)};
      $('ten_go_to_btn_3').innerHTML = "b$150"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 150)};
      $('ten_go_to_btn_4').innerHTML = "b$200"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 200)};
      break;
    case ((amt >= 71) && (amt <= 74)):
      $('ten_go_to_btn_1').innerHTML = "b$100"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 100)};
      $('ten_go_to_btn_2').innerHTML = "b$125"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 125)};
      $('ten_go_to_btn_3').innerHTML = "b$150"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 150)};
      $('ten_go_to_btn_4').innerHTML = "b$200"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 200)};
      break;
    case (amt == 75):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons');
      lineUp('ten_press_btn_2'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$100"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 100)};
      $('ten_go_to_btn_2').innerHTML = "b$125"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 125)};
      $('ten_go_to_btn_3').innerHTML = "b$150"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 150)};
      $('ten_go_to_btn_4').innerHTML = "b$200"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 200)};
      if(equalUnits) {
        letsShow('place_ten_dble_box'); letsUnmask('ten_dbl_press_btn_2');
        $('ten_dbl_press_btn_1').innerHTML = "$100e 4 &amp; 10"; $('ten_dbl_press_btn_1').onclick = function () {doubleUnitPress(10, 100)};
        $('ten_dbl_press_btn_2').innerHTML = "$125e 4 &amp; 10"; $('ten_dbl_press_btn_2').onclick = function () {doubleUnitPress(10, 125)};
        letsShow('ten_dble_btn_box_two');
        $('ten_dbl_press_btn_3').innerHTML = "+10 to $150e 4 &amp; 10"; $('ten_dbl_press_btn_3').onclick = function () {doubleUnitPress(10, 150)};
      }
      break;
    case ((amt >= 76) && (amt <= 79)):
      $('ten_go_to_btn_1').innerHTML = "b$100"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 100)};
      $('ten_go_to_btn_2').innerHTML = "b$125"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 125)};
      $('ten_go_to_btn_3').innerHTML = "b$150"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 150)};
      $('ten_go_to_btn_4').innerHTML = "b$200"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 200)};
      break;
    case ((amt == 80) || (amt == 85)):
      letsHide('ten_pay_disclaimer');
      $('ten_go_to_btn_1').innerHTML = "b$100"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 100)};
      $('ten_go_to_btn_2').innerHTML = "b$125"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 125)};
      $('ten_go_to_btn_3').innerHTML = "b$150"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 150)};
      $('ten_go_to_btn_4').innerHTML = "b$200"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 200)};
      break;
    case ((amt >= 81) && (amt <= 84)):
    case ((amt >= 86) && (amt <= 89)):
      $('ten_go_to_btn_1').innerHTML = "b$100"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 100)};
      $('ten_go_to_btn_2').innerHTML = "b$125"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 125)};
      $('ten_go_to_btn_3').innerHTML = "b$150"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 150)};
      $('ten_go_to_btn_4').innerHTML = "b$200"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 200)};
      break;
    case ((amt == 90) || (amt == 95)):
      letsHide('ten_pay_disclaimer');
      $('ten_go_to_btn_1').innerHTML = "b$100"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 100)};
      $('ten_go_to_btn_2').innerHTML = "b$125"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 125)};
      $('ten_go_to_btn_3').innerHTML = "b$200"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 200)};
      $('ten_go_to_btn_4').innerHTML = "b$250"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 250)};
      break;
    case ((amt >= 91) && (amt <= 94)):
    case ((amt >= 96) && (amt <= 99)):
      $('ten_go_to_btn_1').innerHTML = "b$100"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 100)};
      $('ten_go_to_btn_2').innerHTML = "b$125"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 125)};
      $('ten_go_to_btn_3').innerHTML = "b$200"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 200)};
      $('ten_go_to_btn_4').innerHTML = "b$250"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 250)};
      break;
    case (amt == 100):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons');
      lineUp('ten_press_btn_2'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$125"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 125)};
      $('ten_go_to_btn_2').innerHTML = "b$150"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 150)};
      $('ten_go_to_btn_3').innerHTML = "b$200"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 200)};
      $('ten_go_to_btn_4').innerHTML = "+15 to b$300"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 300)};
      if(equalUnits) {
        letsShow('place_ten_dble_box'); letsUnmask('ten_dbl_press_btn_2');
        $('ten_dbl_press_btn_1').innerHTML = "b$150e 4 &amp; 10"; $('ten_dbl_press_btn_1').onclick = function () {doubleUnitPress(10, 150)};
        $('ten_dbl_press_btn_2').innerHTML = "+15 to b$200e 4 &amp; 10"; $('ten_dbl_press_btn_2').onclick = function () {doubleUnitPress(10, 200)};
      }
      break;
    case ((amt >= 101) && (amt <= 104)):
      $('ten_go_to_btn_1').innerHTML = "b$125"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 125)};
      $('ten_go_to_btn_2').innerHTML = "b$150"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 150)};
      $('ten_go_to_btn_3').innerHTML = "b$200"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 200)};
      $('ten_go_to_btn_4').innerHTML = "b$250"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 250)};
      break;
    case ((amt == 105) || (amt == 110) || (amt == 115) || (amt == 120)):
      letsHide('ten_pay_disclaimer');
      $('ten_go_to_btn_1').innerHTML = "b$150"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 150)};
      $('ten_go_to_btn_2').innerHTML = "b$200"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 200)};
      $('ten_go_to_btn_3').innerHTML = "b$250"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 250)};
      $('ten_go_to_btn_4').innerHTML = "b$300"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 300)};
      break;
    case ((amt >= 106) && (amt <= 109)):
    case ((amt >= 111) && (amt <= 114)):
    case ((amt >= 116) && (amt <= 119)):
    case ((amt >= 121) && (amt <= 124)):
      $('ten_go_to_btn_1').innerHTML = "b$150"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 150)};
      $('ten_go_to_btn_2').innerHTML = "b$200"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 200)};
      $('ten_go_to_btn_3').innerHTML = "b$250"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 250)};
      $('ten_go_to_btn_4').innerHTML = "b$300"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 300)};
      break;
    case (amt == 125):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons'); lineUp('ten_press_btn_2'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$150"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 150)};
      $('ten_go_to_btn_2').innerHTML = "b$200"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 200)};
      $('ten_go_to_btn_3').innerHTML = "b$250"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 250)};
      $('ten_go_to_btn_4').innerHTML = "b$350"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 350)};
      break;
    case ((amt >= 126) && (amt <= 134)):
      $('ten_go_to_btn_1').innerHTML = "b$150"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 150)};
      $('ten_go_to_btn_2').innerHTML = "b$200"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 200)};
      $('ten_go_to_btn_3').innerHTML = "b$250"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 250)};
      $('ten_go_to_btn_4').innerHTML = "b$350"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 350)};
      break;
    case ((amt == 135) || (amt == 149)):
      $('ten_go_to_btn_1').innerHTML = "b$150"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 150)};
      $('ten_go_to_btn_2').innerHTML = "b$200"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 200)};
      $('ten_go_to_btn_3').innerHTML = "b$300"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 300)};
      $('ten_go_to_btn_4').innerHTML = "b$400"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 400)};
      break;
    case (amt == 150):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons'); lineUp('ten_press_btn_2'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$200"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 200)};
      $('ten_go_to_btn_2').innerHTML = "b$250"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 250)};
      $('ten_go_to_btn_3').innerHTML = "b$400"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 400)};
      $('ten_go_to_btn_4').innerHTML = "+21 to b$450"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 450)};
      if(equalUnits) {
        letsShow('place_ten_dble_box'); letsUnmask('ten_dbl_press_btn_2');
        $('ten_dbl_press_btn_1').innerHTML = "b$200e 4 &amp; 10"; $('ten_dbl_press_btn_1').onclick = function () {doubleUnitPress(10, 200)};
        $('ten_dbl_press_btn_2').innerHTML = "b$250e 4 &amp; 10"; $('ten_dbl_press_btn_2').onclick = function () {doubleUnitPress(10, 250)};
      }
      break;
    case ((amt >= 151) && (amt <= 174)):
      $('ten_go_to_btn_1').innerHTML = "b$200"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 200)};
      $('ten_go_to_btn_2').innerHTML = "b$250"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 250)};
      $('ten_go_to_btn_3').innerHTML = "b$400"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 400)};
      $('ten_go_to_btn_4').innerHTML = "b$450"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 450)};
      break;
    case (amt == 175):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons'); lineUp('ten_press_btn_2'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$200"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 200)};
      $('ten_go_to_btn_2').innerHTML = "b$300"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 300)};
      $('ten_go_to_btn_3').innerHTML = "b$400"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 400)};
      $('ten_go_to_btn_4').innerHTML = "b$500"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 500)};
      break;
    case ((amt >= 176) && (amt <= 199)):
      $('ten_go_to_btn_1').innerHTML = "b$200"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 200)};
      $('ten_go_to_btn_2').innerHTML = "b$300"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 300)};
      $('ten_go_to_btn_3').innerHTML = "b$400"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 400)};
      $('ten_go_to_btn_4').innerHTML = "b$500"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 500)};
      break;
    case (amt == 200):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$300"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 300)};
      $('ten_go_to_btn_2').innerHTML = "b$400"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 400)};
      $('ten_go_to_btn_3').innerHTML = "b$500"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 500)};
      $('ten_go_to_btn_4').innerHTML = "+30 to b$600"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 600)};
      if(equalUnits) {
        letsShow('place_ten_dble_box');
        $('ten_dbl_press_btn_1').innerHTML = "b$250e 4 &amp; 10"; $('ten_dbl_press_btn_1').onclick = function () {doubleUnitPress(10, 250)};
      }
      break;
    case ((amt >= 201) && (amt <= 224)):
      $('ten_go_to_btn_1').innerHTML = "b$250"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 250)};
      $('ten_go_to_btn_2').innerHTML = "b$300"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 300)};
      $('ten_go_to_btn_3').innerHTML = "b$400"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 400)};
      $('ten_go_to_btn_4').innerHTML = "b$500"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 500)};
      break;
    case (amt == 225):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons'); lineUp('ten_press_btn_2'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$300"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 300)};
      $('ten_go_to_btn_2').innerHTML = "b$400"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 400)};
      $('ten_go_to_btn_3').innerHTML = "b$500"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 500)};
      $('ten_go_to_btn_4').innerHTML = "b$600"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 600)};
      break;
    case ((amt >= 226) && (amt <= 249)):
      $('ten_go_to_btn_1').innerHTML = "b$300"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 300)};
      $('ten_go_to_btn_2').innerHTML = "b$400"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 400)};
      $('ten_go_to_btn_3').innerHTML = "b$500"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 500)};
      $('ten_go_to_btn_4').innerHTML = "b$600"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 600)};
      break;
    case (amt == 250):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$400"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 400)};
      $('ten_go_to_btn_2').innerHTML = "b$500"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 500)};
      $('ten_go_to_btn_3').innerHTML = "b$600"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 600)};
      $('ten_go_to_btn_4').innerHTML = "+36 to b$750"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 750)};
      break;
    case ((amt >= 251) && (amt <= 299)):
      $('ten_go_to_btn_1').innerHTML = "b$400"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 400)};
      $('ten_go_to_btn_2').innerHTML = "b$500"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 500)};
      $('ten_go_to_btn_3').innerHTML = "b$600"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 600)};
      $('ten_go_to_btn_4').innerHTML = "b$700"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 700)};
      break;
    case (amt == 300):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$400"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 400)};
      $('ten_go_to_btn_2').innerHTML = "b$500"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 500)};
      $('ten_go_to_btn_3').innerHTML = "b$750"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 750)};
      $('ten_go_to_btn_4').innerHTML = "+45 to b$900"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 900)};
      break;
    case ((amt >= 301) && (amt <= 349)):
      $('ten_go_to_btn_1').innerHTML = "b$400"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 400)};
      $('ten_go_to_btn_2').innerHTML = "b$500"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 500)};
      $('ten_go_to_btn_3').innerHTML = "b$750"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 750)};
      $('ten_go_to_btn_4').innerHTML = "b$800"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 800)};
      break;
    case (amt == 350):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$400"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 400)};
      $('ten_go_to_btn_2').innerHTML = "b$500"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 500)};
      $('ten_go_to_btn_3').innerHTML = "b$750"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 750)};
      $('ten_go_to_btn_4').innerHTML = "b$1,000"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 1000)};
      break;
    case ((amt >= 351) && (amt <= 399)):
    case ((amt >= 401) && (amt <= 449)):
    case ((amt >= 451) && (amt <= 499)):
      $('ten_go_to_btn_1').innerHTML = "b$500"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 500)};
      $('ten_go_to_btn_2').innerHTML = "b$600"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 600)};
      $('ten_go_to_btn_3').innerHTML = "b$750"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 750)};
      $('ten_go_to_btn_4').innerHTML = "b$1,000"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 1000)};
      break;
    case ((amt == 400) && (amt == 450)):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$500"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 500)};
      $('ten_go_to_btn_2').innerHTML = "b$600"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 600)};
      $('ten_go_to_btn_3').innerHTML = "b$750"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 750)};
      $('ten_go_to_btn_4').innerHTML = "b$1,000"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 1000)};
      break;
    case (amt == 500):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$600"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 600)};
      $('ten_go_to_btn_2').innerHTML = "b$750"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 750)};
      $('ten_go_to_btn_3').innerHTML = "b$1,000"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 1000)};
      $('ten_go_to_btn_4').innerHTML = "+75 to b$1,500"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 1500)};
      break;
    case ((amt >= 501) && (amt <= 599)):
      $('ten_go_to_btn_1').innerHTML = "b$600"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 600)};
      $('ten_go_to_btn_2').innerHTML = "b$750"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 750)};
      $('ten_go_to_btn_3').innerHTML = "b$800"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 800)};
      $('ten_go_to_btn_4').innerHTML = "b$1,000"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 1000)};
      break;
    case (amt == 600):
      letsHide('ten_pay_disclaimer');
      $('ten_go_to_btn_1').innerHTML = "b$600"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 600)};
      $('ten_go_to_btn_2').innerHTML = "b$750"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 750)};
      $('ten_go_to_btn_3').innerHTML = "b$1,000"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 1000)};
      $('ten_go_to_btn_4').innerHTML = "b$1,500"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 1500)};
      break;
    case ((amt >= 601) && (amt <= 699)):
      $('ten_go_to_btn_1').innerHTML = "b$600"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 600)};
      $('ten_go_to_btn_2').innerHTML = "b$750"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 750)};
      $('ten_go_to_btn_3').innerHTML = "b$1,000"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 1000)};
      $('ten_go_to_btn_4').innerHTML = "b$1,500"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 1500)};
      break;
    case ((amt == 700) || (amt == 750) || (amt == 800)):
      letsHide('ten_pay_disclaimer');
      $('ten_go_to_btn_1').innerHTML = "b$900"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 900)};
      $('ten_go_to_btn_2').innerHTML = "b$1,000"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 1000)};
      $('ten_go_to_btn_3').innerHTML = "b$1,500"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 1500)};
      $('ten_go_to_btn_4').innerHTML = "b$2,000"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 2000)};
      break;
    case ((amt >= 701) && (amt <= 749)):
    case ((amt >= 751) && (amt <= 799)):
    case ((amt >= 801) && (amt <= 899)):
      $('ten_go_to_btn_1').innerHTML = "b$900"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 900)};
      $('ten_go_to_btn_2').innerHTML = "b$1,000"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 1000)};
      $('ten_go_to_btn_3').innerHTML = "b$1,500"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 1500)};
      $('ten_go_to_btn_4').innerHTML = "b$2,000"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 2000)};
      break;
    case (amt == 900):
      letsHide('ten_pay_disclaimer');
      $('ten_go_to_btn_1').innerHTML = "b$1,000"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 1000)};
      $('ten_go_to_btn_2').innerHTML = "b$1,500"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 1500)};
      $('ten_go_to_btn_3').innerHTML = "b$2,000"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 2000)};
      $('ten_go_to_btn_4').innerHTML = "b$2,500"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 2500)};
      break;
    case ((amt >= 901) && (amt <= 999)):
      $('ten_go_to_btn_1').innerHTML = "b$1,000"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 1000)};
      $('ten_go_to_btn_2').innerHTML = "b$1,500"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 1500)};
      $('ten_go_to_btn_3').innerHTML = "b$2,000"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 2000)};
      $('ten_go_to_btn_4').innerHTML = "b$2,500"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 2500)};
      break;
    case (amt == 1000):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$1,500"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 1500)};
      $('ten_go_to_btn_2').innerHTML = "b$2,000"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 2000)};
      $('ten_go_to_btn_3').innerHTML = "b$2,500"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 2500)};
      $('ten_go_to_btn_4').innerHTML = "+150 to b$3,000"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 3000)};
      break;
    case ((amt >= 1001) && (amt <= 1049)):
      letsHide('ten_go_to_btn_4');
      $('ten_go_to_btn_1').innerHTML = "b$1,500"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 1500)};
      $('ten_go_to_btn_2').innerHTML = "b$2,000"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 2000)};
      $('ten_go_to_btn_3').innerHTML = "b$2,500"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 2500)};
      break;
    case ((amt >= 1050) && (amt <= 1499)):
      $('ten_go_to_btn_1').innerHTML = "b$1,500"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 1500)};
      $('ten_go_to_btn_2').innerHTML = "b$2,000"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 2000)};
      $('ten_go_to_btn_3').innerHTML = "b$2,500"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 2500)};
      $('ten_go_to_btn_4').innerHTML = "b$3,000"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 3000)};
      break;
    case (amt == 1500):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$2,500"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 2500)};
      $('ten_go_to_btn_2').innerHTML = "b$3,000"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 3000)};
      $('ten_go_to_btn_3').innerHTML = "b$3,500"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 3500)};
      $('ten_go_to_btn_4').innerHTML = "b$4,000"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 4000)};
      break;
    case ((amt >= 1501) && (amt <= 1999)):
      $('ten_go_to_btn_1').innerHTML = "b$2,500"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 2500)};
      $('ten_go_to_btn_2').innerHTML = "b$3,000"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 3000)};
      $('ten_go_to_btn_3').innerHTML = "b$3,500"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 3500)};
      $('ten_go_to_btn_4').innerHTML = "b$4,000"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 4000)};
      break;
    case (amt == 2000):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$2,500"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 2500)};
      $('ten_go_to_btn_2').innerHTML = "b$3,000"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 3000)};
      $('ten_go_to_btn_3').innerHTML = "b$3,500"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 3500)};
      $('ten_go_to_btn_4').innerHTML = "b$4,000"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 4000)};
      letsShow('ten_tbl_max_btn');
      break;
    case ((amt >= 2001) && (amt <= 2499)):
      $('ten_go_to_btn_1').innerHTML = "b$2,500"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 2500)};
      $('ten_go_to_btn_2').innerHTML = "b$3,000"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 3000)};
      $('ten_go_to_btn_3').innerHTML = "b$3,500"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 3500)};
      $('ten_go_to_btn_4').innerHTML = "b$4,000"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 4000)};
      letsShow('ten_tbl_max_btn');
      break;
    case (amt == 2500):
      letsHide('ten_pay_disclaimer');
      letsShow('ten_press_buttons'); lineUp('ten_press_btn_3');
      $('ten_go_to_btn_1').innerHTML = "b$3,000"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 3000)};
      $('ten_go_to_btn_2').innerHTML = "b$3,500"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 3500)};
      $('ten_go_to_btn_3').innerHTML = "b$4,000"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 4000)};
      $('ten_go_to_btn_4').innerHTML = "b$4,500"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 4500)};
      letsShow('ten_tbl_max_btn');
      break;
    case ((amt >= 2501) && (amt <= 2999)):
      $('ten_go_to_btn_1').innerHTML = "b$3,000"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 3000)};
      $('ten_go_to_btn_2').innerHTML = "b$3,500"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 3500)};
      $('ten_go_to_btn_3').innerHTML = "b$4,000"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 4000)};
      $('ten_go_to_btn_4').innerHTML = "b$4,500"; $('ten_go_to_btn_4').onclick = function () {goTo(10, 4500)};
      letsShow('ten_tbl_max_btn');
      break;
    case (amt == 3000):
      letsHide('ten_pay_disclaimer');
      letsHide('ten_go_to_btn_4');
      $('ten_go_to_btn_1').innerHTML = "b$3,500"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 3000)};
      $('ten_go_to_btn_2').innerHTML = "b$4,000"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 3500)};
      $('ten_go_to_btn_3').innerHTML = "b$4,500"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 4000)};
      letsShow('ten_tbl_max_btn');
      break;
    case ((amt >= 3001) && (amt <= 3499)):
      $('ten_go_to_btn_1').innerHTML = "b$3,500"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 3000)};
      $('ten_go_to_btn_2').innerHTML = "b$4,000"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 3500)};
      $('ten_go_to_btn_3').innerHTML = "b$4,500"; $('ten_go_to_btn_3').onclick = function () {goTo(10, 4000)};
      letsShow('ten_tbl_max_btn');
      break;
    case (amt == 3500):
      letsHide('ten_pay_disclaimer');
      letsHide('ten_go_to_btn_3'); letsHide('ten_go_to_btn_4');
      $('ten_go_to_btn_1').innerHTML = "b$4,000"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 4000)};
      $('ten_go_to_btn_2').innerHTML = "b$4,500"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 4500)};
      letsShow('ten_tbl_max_btn');
      break;
    case ((amt >= 3501) && (amt <= 3999)):
      letsHide('ten_go_to_btn_3'); letsHide('ten_go_to_btn_4');
      $('ten_go_to_btn_1').innerHTML = "b$4,000"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 4000)};
      $('ten_go_to_btn_2').innerHTML = "b$4,500"; $('ten_go_to_btn_2').onclick = function () {goTo(10, 4500)};
      letsShow('ten_tbl_max_btn');
      break;
    case (amt == 4000):
      letsHide('ten_pay_disclaimer');
      letsHide('ten_go_to_btn_2'); letsHide('ten_go_to_btn_3'); letsHide('ten_go_to_btn_4');
      $('ten_go_to_btn_1').innerHTML = "b$4,500"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 4500)};
      letsShow('ten_tbl_max_btn');
      break;
    case ((amt >= 4001) && (amt <= 4499)):
      letsHide('ten_go_to_btn_2'); letsHide('ten_go_to_btn_3'); letsHide('ten_go_to_btn_4');
      $('ten_go_to_btn_1').innerHTML = "b$4,500"; $('ten_go_to_btn_1').onclick = function () {goTo(10, 4500)};
      letsShow('ten_tbl_max_btn');
      break;
    case (amt == 4500):
      letsHide('ten_pay_disclaimer');
      letsHide('ten_go_to_buttons');
      letsShow('ten_tbl_max_btn');
      break;
    case ((amt >= 4501) && (amt <= 4999)):
      letsHide('ten_go_to_buttons');
      letsShow('ten_tbl_max_btn');
      break;
    case (amt == 5000):
      $('ten_pay_disclaimer').innerHTML = "You hit at table max!! If you want to put even more on the table you can start making Come bets and double dip your way up to max Come bet and max Odds! Another... $20,000 ($5K with $15K odds) to win 35K plus your 10K here is a 45K potential max win on the 10. That's when we get Come Bets which are coming soon.";
      letsHide('ten_go_to_buttons')
    default: return
  }
}

                                                                                      // Event Listeners

$('pl_bet_amount').addEventListener("keydown", function (event) {if (event.key === 'Enter') {betPassLine(parseInt($<HTMLInputElement>('pl_bet_amount').value));}});
$('pl_odds_bet_amount').addEventListener("keydown", function (event) {if (event.key === 'Enter') {betPassLineOdds(parseInt($<HTMLInputElement>('pl_odds_bet_amount').value));}});
$('field_bet_amount').addEventListener("keydown", function (event) {if (event.key === 'Enter') {theField.betIt(parseInt($<HTMLInputElement>('field_bet_amount').value));}});
$('field_bet_pay_menu_amount').addEventListener("keydown", function (event) {if (event.key === 'Enter') {rebetField(parseInt($<HTMLInputElement>('field_bet_pay_menu_amount').value));}});
$('place_four_amount').addEventListener("keydown", function (event) {if (event.key === 'Enter') {theFour.placeIt(parseInt($<HTMLInputElement>('place_four_amount').value));}});
$('buy_four_amount').addEventListener("keydown", function (event) {if (event.key === 'Enter') {theFour.buyIt(parseInt($<HTMLInputElement>('buy_four_amount').value));}});
$('place_five_amount').addEventListener("keydown", function (event) {if (event.key === 'Enter') {theFive.placeIt(parseInt($<HTMLInputElement>('place_five_amount').value));}});
$('place_six_amount').addEventListener("keydown", function (event) {if (event.key === 'Enter') {theSix.placeIt(parseInt($<HTMLInputElement>('place_six_amount').value));}});
$('place_eight_amount').addEventListener("keydown", function (event) {if (event.key === 'Enter') {theEight.placeIt(parseInt($<HTMLInputElement>('place_eight_amount').value));}});
$('place_nine_amount').addEventListener("keydown", function (event) {if (event.key === 'Enter') {theNine.placeIt(parseInt($<HTMLInputElement>('place_nine_amount').value));}});
$('place_ten_amount').addEventListener("keydown", function (event) {if (event.key === 'Enter') {theTen.placeIt(parseInt($<HTMLInputElement>('place_ten_amount').value));}});
$('buy_ten_amount').addEventListener("keydown", function (event) {if (event.key === 'Enter') {theTen.buyIt(parseInt($<HTMLInputElement>('buy_ten_amount').value));}});
$('each_six_eight_amt').addEventListener("keydown", function (event) {if (event.key === 'Enter') {betEach(68, parseInt($<HTMLInputElement>('each_six_eight_amt').value));}});
$('each_five_nine_amt').addEventListener("keydown", function (event) {if (event.key === 'Enter') {betEach(59, parseInt($<HTMLInputElement>('each_five_nine_amt').value));}});
$('each_four_ten_amt').addEventListener("keydown", function (event) {if (event.key === 'Enter') {betEach(410, parseInt($<HTMLInputElement>('each_four_ten_amt').value));}});
$('place_pay_four_amount').addEventListener("keydown", function (event) {if (event.key === 'Enter') {betSomethingElse(5);}});
$('place_pay_five_amount').addEventListener("keydown", function (event) {if (event.key === 'Enter') {betSomethingElse(6);}});
$('place_pay_six_amount').addEventListener("keydown", function (event) {if (event.key === 'Enter') {betSomethingElse(7);}});
$('place_pay_eight_amount').addEventListener("keydown", function (event) {if (event.key === 'Enter') {betSomethingElse(8);}});
$('place_pay_nine_amount').addEventListener("keydown", function (event) {if (event.key === 'Enter') {betSomethingElse(9);}});
$('place_pay_ten_amount').addEventListener("keydown", function (event) {if (event.key === 'Enter') {betSomethingElse(10);}});
window.addEventListener('load', ()  => {
  tableMaxComma = numCommas(limit.tableMax);
  $('money_in_rail').innerHTML = "$" + money.inRail;
  $('money_on_table').innerHTML = "$" + money.onTable;
  $('total_bankroll').innerHTML = "$" + money.bankRoll;
  $('max_bet').innerHTML = "$" + tableMaxComma;
  $('min_bet').innerHTML = "$" + limit.tableMin;
  money.adjustBank();
});

                                                                                      // Testing Area

function iRollTwoDice (dieA, dieB) {
  aRollHappened = true;
  return {
    firstDie: dieA,
    secondDie: dieB,
    total: dieA + dieB,
    hard: dieA === dieB,
  };
}
function iCreateRollObject (dieOne, dieTwo) {
  roll = iRollTwoDice(dieOne, dieTwo);
  rollTotal = roll.total; rollHard = roll.hard; theFirstDie = roll.firstDie; theSecondDie = roll.secondDie;
  isAPointNum = thePoints.includes(rollTotal);
  markingPoint = comeoutRoll && isAPointNum;
  pointMade = rollTotal === thePoint;
  boxRolled = !pointMade && intermediateRoll && isAPointNum;
  crapRolled = crapNumbers.includes(rollTotal);
  sevenOut = intermediateRoll && rollTotal === 7;
  naturalWinner = comeoutRoll && (rollTotal === 7 || rollTotal === 11);    
  naturalLoser = comeoutRoll && crapRolled;
}
function iShootDice (dieOne, dieTwo) {
  check.forBroke();
  if (brokeAsAJoke ) {
    $('button_two').style.display = "none";
    guide.sayYourBroke();
  } else {
    if (!hasPassLine) {
      alert.needPassLine();
    } else if (passLineWasPaid) {
      comeoutRoll ? notify.crWinner() : notify.pointWinner();
    } else if (theField.isOverMax) {
      alert.overInField()
    } else {
      iCreateRollObject(dieOne, dieTwo);
      incrementRoll();
      changeDice();
      guide.sayStickCall();
      determineRoll();
    }
  }
}
const testMe = {
  testOne: function () {
    $('test_me_1').innerHTML = "4Bet - " + theFour.placeBet;
    $('test_me_2').innerHTML = "4Vig " + theFour.vig;
    $('test_me_3').innerHTML = "10Bet " + theTen.placeBet;
    $('test_me_4').innerHTML = "10Vig " + theTen.vig;
    $('test_me_5').innerHTML = "ExtVig " + money.extraVig;
    $('test_me_6').innerHTML = "DblUnitCharge " + "ummm";
    $('test_me_7').innerHTML = "trueVig " + "ummm";
    $('test_me_8').innerHTML = "CrntVig " + "umm";
    $('test_me_9').innerHTML = "CrntVig " + "umm";
    $('test_me_10').innerHTML = "Total " + total.fourTenBets;
  },
  testTwo: function () {
    $('test_me_1').innerHTML = "moneyInRail: " + money.inRail;
    $('test_me_2').innerHTML = "moneyInLimbo: " + money.inPlaceLimbo;
    $('test_me_3').innerHTML = "existingBet: " + "ummm";
    $('test_me_4').innerHTML = "haveEnough:  " + haveEnough;
    $('test_me_5').innerHTML = "";
    $('test_me_6').innerHTML = "";
    $('test_me_7').innerHTML = "";
    $('test_me_8').innerHTML = "";
    $('test_me_9').innerHTML = "";
    $('test_me_10').innerHTML = "";
  },
  testFourTen: function () {
    $('test_me_1').innerHTML = "4Bet: " + theFour.placeBet;
    $('test_me_2').innerHTML = "4Vig: " + theFour.vig;
    $('test_me_3').innerHTML = "10Bet: " + theTen.placeBet;
    $('test_me_4').innerHTML = "10Vig: " + theTen.vig;
    $('test_me_5').innerHTML = "ExtVig: " + money.extraVig;
    $('test_me_6').innerHTML = "Total: " + total.fourTenBets;
    $('test_me_7').innerHTML = "";
    $('test_me_8').innerHTML = "";
    $('test_me_9').innerHTML = "";
    $('test_me_10').innerHTML = "aRollHappened: " + aRollHappened;
  }, 
  testNothing: function () {
    letsHide('test_me_1');
    letsHide('test_me_2');
    letsHide('test_me_3');
    letsHide('test_me_4');
    letsHide('test_me_5');
    letsHide('test_me_6');
    letsHide('test_me_7');
    letsHide('test_me_8');
    letsHide('test_me_9');
    letsHide('test_me_10');
    letsHide('test_me_11');
  },
  onStates: function () {
    $('test_me_1').innerHTML = "four.onStatus: " + theFour.onStatus;
    $('test_me_2').innerHTML = "five.onStatus: " + theFive.onStatus;
    $('test_me_3').innerHTML = "six.onStatus: " + theSix.onStatus;
    $('test_me_4').innerHTML = "eight.onStatus: " + theEight.onStatus;
    $('test_me_5').innerHTML = "nine.onStatus: " + theNine.onStatus;
    $('test_me_6').innerHTML = "ten.onStatus: " + theTen.onStatus;
    letsHide('test_me_7');
    letsHide('test_me_8');
    letsHide('test_me_9');
    letsHide('test_me_10');
  },
  aVariable: function (somethingToTest) {
    $('test_me_11').innerHTML = "Test is: " + somethingToTest;  
  }
}

function getPlaceBets () : number[] {
  return [theFour.placeBet, theFive.placeBet, theSix.placeBet, theEight.placeBet, theNine.placeBet, theTen.placeBet];
}
function letsHide(element) {$(element).style.display = "none";}
function letsMask(element) {$(element).style.visibility = "hidden";}
function letsShow(element) {$(element).style.display = "block";}
function letsUnmask(element) {$(element).style.visibility = "visible";}
function lineUp(element) {$(element).style.display = "inline-block";}

window['shootDice'] = shootDice;
window['hideBetMenu'] = hideBetMenu;
window['hideAllMenus'] = hideAllMenus;
window['showPreviousMenu'] = showPreviousMenu;
window['showBetMenu'] = showBetMenu;
window['showOffMenu'] = showOffMenu;
window['showDisclaimer'] = showDisclaimer;
window['betAll'] = betAll;
window['betMax'] = betMax;
window['removeBet'] = removeBet;
window['betSomethingElse'] = betSomethingElse;
window['betPassLine'] = betPassLine;
window['collectPassLine'] = collectPassLine;
window['betPassLineOdds'] = betPassLineOdds;
window['turnOnAllPlaceBets'] = turnOnAllPlaceBets;
window['turnOffAllPlaceBets'] = turnOffAllPlaceBets;
window['turnOnPlace'] = turnOnPlace;
window['turnOffPlace'] = turnOffPlace;
window['allPlaceBetsDown'] = allPlaceBetsDown;
window['placeFour'] = placeFour;
window['buyFour'] = buyFour;
window['placeFive'] = placeFive;
window['placeSix'] = placeSix;
window['placeEight'] = placeEight;
window['placeNine'] = placeNine;
window['placeTen'] = placeTen;
window['buyTen'] = buyTen;
window['openBetEachMenu'] = openBetEachMenu;
window['betEach'] = betEach;
window['openSpreadBetMenu'] = openSpreadBetMenu;
window['betAcrossIncluding'] = betAcrossIncluding;
window['betAcross'] = betAcross;
window['betInside'] = betInside;
window['betOutside'] = betOutside;
window['betUptown'] = betUptown;
window['betDowntown'] = betDowntown;
window['sameBet'] = sameBet;
window['sameAndDown'] = sameAndDown;
window['pressOneUnit'] = pressOneUnit;
window['pressFiveUnits'] = pressFiveUnits;
window['pressIt'] = pressIt;
window['fullPress'] = fullPress;
window['doubleUnitPress'] = doubleUnitPress;
window['goTo'] = goTo;
window['betField'] = betField;
window['collectAllField'] = collectAllField;
window['rebetField'] = rebetField;
window['stackField'] = stackField;
window['collectHalfField'] = collectHalfField;
window['collectThirdField'] = collectThirdField;
window['collectTwoThirdField'] = collectTwoThirdField;


//thePassLine.betIt(20);
//betAll(10);
//thePlaceBets.turnOff(5);
//theFour.placeIt(5);
//theFour.buyIt(681);
//theFive.placeIt(20);
//theSix.placeIt(18);
//theEight.placeIt(18);
//theNine.placeIt(20);
//theTen.placeIt(5)
//theField.betIt(5);
//bet.acrossIncluding(162);
//betEach(68, 30);
//letsShow('place_eight_bet_menu');
//thePlaceBets.turnOff(7);
//iShootDice(1, 3);
//iShootDice(1, 4);
//iShootDice(1, 5);
//iShootDice(4, 3);
//iShootDice(6, 2);
//iShootDice(6, 3);
//iShootDice(6, 4);
//iShootDice(6, 6);
//playerSays.fullPress(6);
//playerSays.doubleUnitPress(6, 50)
//thePassLine.betIt(5);
//passLineOdds.betIt(5);
//theSix.placeIt(900);
//theSix.placeIt(6);
//theTen.buyIt(50);
//betAll(10);
//thePlaceBets.turnOn(10);
//betAcross(26);
//thePlaceBets.turnOn(7);
//goTo(5, 150);
//doubleUnitPress(5, 100)
//iShootDice(1, 1);
//iShootDice(1, 3);
//iShootDice(1, 1);
//theField.collectTwoThird();
//iShootDice(1, 4);
//iShootDice(1, 5);
//iShootDice(4, 3);
//iShootDice(6, 2);
//iShootDice(6, 3);
//iShootDice(6, 4);
//playerSays.fullPress(6);
//playerSays.doubleUnitPress(6, 75);
//thePassLine.collectIt();
//thePlaceBets.turnOffAll();
//theEight.placeIt(12);
//iShootDice(3, 5);
//thePlaceBets.turnOffAll();
//thePlaceBets.turnOnAll();
//betPassLine(10);

//iShootDice(1, 4);
//passLineOdds.betIt(5);
//iShootDice(1, 5);

//testMe.aVariable(getPlaceBetAmounts[0]);
//testMe.testNothing();